var P0 = Object.defineProperty;
var M0 = (e, t, n) => t in e ? P0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var oa = (e, t, n) => (M0(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as U from "react";
import d, { useState as Ne, useRef as ve, useLayoutEffect as Oa, useEffect as je, Fragment as F0, useContext as mr, useCallback as Le, createContext as Ir, useMemo as Nn, useReducer as R0, Component as Pp, createElement as _0, createRef as N0, forwardRef as I0 } from "react";
import { css as _, styled as D, keyframes as L0, createGlobalStyle as Mp } from "styled-components";
import { useFocusRing as vt, useTooltip as j0, OverlayContainer as ku, mergeProps as xe, useTooltipTrigger as Bt, useFocusVisible as Fp, useOverlay as dn, usePreventScroll as Rp, useModal as Ou, useDialog as Bu, FocusScope as fn, useOption as _p, useListBoxSection as W0, useListBox as Np, DismissButton as Eo, useVisuallyHidden as Ip, useSelect as Y0, HiddenSelect as H0, useRadio as Lp, useId as ni, VisuallyHidden as Zn, useRadioGroup as jp, useOverlayTrigger as V0, useTab as z0, useTabList as K0, useSearchField as U0, useKeyboard as Jn, useSwitch as Wp, useMenuTrigger as Yp, useMenuItem as Hp, useFocus as q0, useHover as X0, useProgressBar as G0, useTextField as Vp, useFilter as Q0, useComboBox as Z0, useNumberField as J0 } from "react-aria";
import { OverlayProvider as TM } from "react-aria";
import * as zp from "react-dom";
import Tu, { flushSync as eg, findDOMNode as tg } from "react-dom";
import { useTooltipTriggerState as Tt, Section as rg, useSelectState as ng, Item as nn, useRadioGroupState as Kp, useOverlayTriggerState as ag, useTabListState as og, useSearchFieldState as ig, useToggleState as Up, useTreeState as qp, useMenuTriggerState as Xp, useComboBoxState as sg, useNumberFieldState as ug } from "react-stately";
var Gp = /* @__PURE__ */ ((e) => (e.frenchBlue = "#1070C0", e.yaleBlue = "#194F90", e.midnightBlue = "#15437A", e.slatePurple = "#615EA1", e.purpleRain = "#33308E", e.lilyWhite = "#E6f7FF", e.paradisoGreen = "#377D90", e.supernovaYellow = "#FCB723", e.yellowSea = "#EBAA1D", e.clownRed = "#ED1B2E", e.lavaRed = "#C60F1F", e.pigletPink = "#D44F99", e.plannerBlue = "#0888F2", e.plannerOrange = "#CB4E06", e.fokusRed = "#D23A3A", e.fokusPink = "#DA6464", e.fokusGreen = "#00A084", e.fokusOrange = "#EB6606", e.fokusPurple = "#915195", e.fokusGrassGreen = "#3F8530", e.white = "#FFFFFF", e.grey50 = "#F7F7F9", e.grey100 = "#EEEEF0", e.grey200 = "#E2E2E4", e.grey300 = "#D0D0D2", e.grey400 = "#ABABAD", e.grey500 = "#8A8A8C", e.grey600 = "#636365", e.grey700 = "#505052", e.grey800 = "#323234", e.grey900 = "#121214", e.black = "#000", e.paradisoGreenDark = "#2A5F6D", e))(Gp || {});
const y = Gp;
var Qp = /* @__PURE__ */ ((e) => (e.score75to100 = "#2F602E", e.score50to75 = "#229A3B", e.score25to50 = "#79C96F", e.score0to25 = "#C6E48B", e.completedWithoutScore = "#7BD9C8", e.ongoing = "#1070C0", e.needsReview = "#FCB723", e))(Qp || {});
const BP = Qp;
var Zp = /* @__PURE__ */ ((e) => (e.XXS = "0.25rem", e.XS = "0.5rem", e.S = "0.75rem", e.M = "1rem", e.L = "1.5rem", e.XL = "2rem", e.XXL = "2.5rem", e.XXXL = "3rem", e.XXXXL = "4rem", e.XXXXXL = "6rem", e.XXXXXXL = "8rem", e))(Zp || {});
const k = Zp;
var Jp = /* @__PURE__ */ ((e) => (e.fontFamily = "'Open Sans', sans-serif", e))(Jp || {});
const eh = Jp;
var th = /* @__PURE__ */ ((e) => (e.smallMax = "max-width: 47.9375rem", e.mediumMin = "min-width: 48rem", e.mediumMax = "max-width: 63.9375rem", e.largeMin = "min-width: 64rem", e.largeMax = "max-width: 84.9375rem", e.xlargeMin = "min-width: 85rem", e))(th || {});
const Fe = th, lg = _`
  &&,
  &&:link,
  &&:visited {
    color: ${y.frenchBlue};
  }

  &&:hover {
    color: ${y.yaleBlue};
  }

  &&:active {
    color: ${y.midnightBlue};
  }

  ${({ isDisabled: e }) => e && _`
      &&& {
        background-color: transparent; /* To override default disabled button background color */
      }
    `}
`, cg = _`
  &&,
  &&:link,
  &&:visited {
    color: ${y.black};
  }

  &&:hover {
    color: ${y.frenchBlue};
  }

  &&:active {
    color: ${y.black};
  }

  ${({ isDisabled: e }) => e && _`
      &&& {
        background-color: transparent; /* To override default disabled button background color */
      }
    `}
`, dg = ({ isFocusVisible: e }) => _`
  /* Hide outline when navigating with mouse or touch */
  &:focus {
    ${!e && "outline: 0;"};
  }
`, tt = dg, or = D.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.05em;
`, mt = "cubic-bezier(0.22, 1, 0.36, 1)", ai = _`
  transition: border-radius 0.125s ${mt};
`, fg = (e, t) => {
  if (!e)
    return !1;
  const n = /^(?:[a-z]+:)?\/\//i, r = /eedev|gleerupsportal|localhost/;
  return !!(e && n.test(e) && !r.test(e)) || !!t;
}, pg = ({
  onClick: e,
  href: t,
  openInternalLinkInNewTab: n,
  buttonRef: r,
  className: a,
  isDisabled: o,
  children: i,
  color: s,
  type: u,
  tabIndex: l,
  ...c
}) => {
  const f = fg(t, n), { isFocusVisible: p, focusProps: m, isFocused: v } = vt();
  return /* @__PURE__ */ d.createElement(d.Fragment, null, i({
    as: t ? "a" : void 0,
    isFocusVisible: p,
    isFocused: v,
    ref: r,
    disabled: t ? void 0 : o,
    isDisabled: o,
    href: t,
    target: f ? "_blank" : void 0,
    rel: f ? "noopener noreferrer" : void 0,
    className: a,
    onClick: e,
    color: s,
    type: u,
    tabIndex: l,
    ...m,
    ...c
  }));
}, Lr = pg, hg = _`
  &:link,
  &:visited {
    text-decoration: none;
  }

  &&::before {
    display: none; /* To remove link icon applied by contex global css*/
  }
`, oi = hg, yc = _`
  pointer-events: none;
  cursor: default;
  background-color: ${y.grey100};
  box-shadow: none;

  /* To really enforce the color on all inner elements */
  * {
    color: ${y.grey400} !important;
  }
`, vg = _`
  /* This is for regular button elements */
  &:disabled {
    ${yc}
  }

  /* This is for all other elements, like anchor and div elements */
  && {
    ${({ isDisabled: e }) => e && yc};
  }
`, pn = vg, mg = D.button`
  height: 1.5rem;
  max-width: 100%;
  margin: 0;
  padding: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  user-select: none;
  outline-offset: ${k.XS};
  ${oi};
  ${ai};
  ${tt};
  ${pn};

  ${({ color: e }) => {
  switch (e) {
    case "black":
      return cg;
    case "blue":
    default:
      return lg;
  }
}};

  /* Common styles for all variants*/
  ${({ isFocused: e, isFocusVisible: t }) => e && t && _`
      &&,
      &&:link,
      &&:visited {
        color: ${y.yaleBlue};
      }
    `};

  > svg {
    height: 1.5rem;
    width: 1.5rem;
    border: none;
    white-space: nowrap;
    position: relative;
    flex: 0 0 auto;
    fill: currentColor;
    ${({ rightAlignIcon: e }) => e ? _`
            margin-left: ${k.XS};
          ` : _`
            margin-right: ${k.XS};
          `};
  }
`, gg = D(or)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`, yg = ({ icon: e, children: t, rightAlignIcon: n = !1, ...r }) => /* @__PURE__ */ d.createElement(Lr, { ...r }, (a) => /* @__PURE__ */ d.createElement(mg, { ...a, rightAlignIcon: n }, !n && e, /* @__PURE__ */ d.createElement(gg, null, t), n && e)), bg = yg;
var qa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function wg(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Au = {}, rh = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(rh);
var We = rh.exports, nh = { exports: {} }, ah = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ah);
var Dg = ah.exports;
(function(e) {
  var t = Dg.default;
  function n(a) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
    return (n = function(u) {
      return u ? i : o;
    })(a);
  }
  function r(a, o) {
    if (!o && a && a.__esModule)
      return a;
    if (a === null || t(a) !== "object" && typeof a != "function")
      return {
        default: a
      };
    var i = n(o);
    if (i && i.has(a))
      return i.get(a);
    var s = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var l in a)
      if (l !== "default" && Object.prototype.hasOwnProperty.call(a, l)) {
        var c = u ? Object.getOwnPropertyDescriptor(a, l) : null;
        c && (c.get || c.set) ? Object.defineProperty(s, l, c) : s[l] = a[l];
      }
    return s.default = a, i && i.set(a, s), s;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(nh);
var Ye = nh.exports, $i = {};
function oh(e, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return e.apply(void 0, arguments) || t.apply(void 0, arguments);
  };
}
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ye.apply(this, arguments);
}
function ht(e) {
  "@babel/helpers - typeof";
  return ht = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ht(e);
}
function ki(e) {
  return e && ht(e) === "object" && e.constructor === Object;
}
function In(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, r = n.clone ? ye({}, e) : e;
  return ki(e) && ki(t) && Object.keys(t).forEach(function(a) {
    a !== "__proto__" && (ki(t[a]) && a in e ? r[a] = In(e[a], t[a], n) : r[a] = t[a]);
  }), r;
}
var Ps = { exports: {} }, Xa = { exports: {} }, Te = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bc;
function Cg() {
  if (bc)
    return Te;
  bc = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function x(B) {
    if (typeof B == "object" && B !== null) {
      var F = B.$$typeof;
      switch (F) {
        case t:
          switch (B = B.type, B) {
            case u:
            case l:
            case r:
            case o:
            case a:
            case f:
              return B;
            default:
              switch (B = B && B.$$typeof, B) {
                case s:
                case c:
                case v:
                case m:
                case i:
                  return B;
                default:
                  return F;
              }
          }
        case n:
          return F;
      }
    }
  }
  function O(B) {
    return x(B) === l;
  }
  return Te.AsyncMode = u, Te.ConcurrentMode = l, Te.ContextConsumer = s, Te.ContextProvider = i, Te.Element = t, Te.ForwardRef = c, Te.Fragment = r, Te.Lazy = v, Te.Memo = m, Te.Portal = n, Te.Profiler = o, Te.StrictMode = a, Te.Suspense = f, Te.isAsyncMode = function(B) {
    return O(B) || x(B) === u;
  }, Te.isConcurrentMode = O, Te.isContextConsumer = function(B) {
    return x(B) === s;
  }, Te.isContextProvider = function(B) {
    return x(B) === i;
  }, Te.isElement = function(B) {
    return typeof B == "object" && B !== null && B.$$typeof === t;
  }, Te.isForwardRef = function(B) {
    return x(B) === c;
  }, Te.isFragment = function(B) {
    return x(B) === r;
  }, Te.isLazy = function(B) {
    return x(B) === v;
  }, Te.isMemo = function(B) {
    return x(B) === m;
  }, Te.isPortal = function(B) {
    return x(B) === n;
  }, Te.isProfiler = function(B) {
    return x(B) === o;
  }, Te.isStrictMode = function(B) {
    return x(B) === a;
  }, Te.isSuspense = function(B) {
    return x(B) === f;
  }, Te.isValidElementType = function(B) {
    return typeof B == "string" || typeof B == "function" || B === r || B === l || B === o || B === a || B === f || B === p || typeof B == "object" && B !== null && (B.$$typeof === v || B.$$typeof === m || B.$$typeof === i || B.$$typeof === s || B.$$typeof === c || B.$$typeof === h || B.$$typeof === w || B.$$typeof === S || B.$$typeof === g);
  }, Te.typeOf = x, Te;
}
var Ae = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wc;
function Eg() {
  return wc || (wc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function x(ne) {
      return typeof ne == "string" || typeof ne == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ne === r || ne === l || ne === o || ne === a || ne === f || ne === p || typeof ne == "object" && ne !== null && (ne.$$typeof === v || ne.$$typeof === m || ne.$$typeof === i || ne.$$typeof === s || ne.$$typeof === c || ne.$$typeof === h || ne.$$typeof === w || ne.$$typeof === S || ne.$$typeof === g);
    }
    function O(ne) {
      if (typeof ne == "object" && ne !== null) {
        var be = ne.$$typeof;
        switch (be) {
          case t:
            var Pe = ne.type;
            switch (Pe) {
              case u:
              case l:
              case r:
              case o:
              case a:
              case f:
                return Pe;
              default:
                var Ve = Pe && Pe.$$typeof;
                switch (Ve) {
                  case s:
                  case c:
                  case v:
                  case m:
                  case i:
                    return Ve;
                  default:
                    return be;
                }
            }
          case n:
            return be;
        }
      }
    }
    var B = u, F = l, L = s, j = i, I = t, N = c, q = r, J = v, R = m, ae = n, H = o, oe = a, ue = f, me = !1;
    function V(ne) {
      return me || (me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(ne) || O(ne) === u;
    }
    function T(ne) {
      return O(ne) === l;
    }
    function C(ne) {
      return O(ne) === s;
    }
    function M(ne) {
      return O(ne) === i;
    }
    function P(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === t;
    }
    function W(ne) {
      return O(ne) === c;
    }
    function z(ne) {
      return O(ne) === r;
    }
    function K(ne) {
      return O(ne) === v;
    }
    function X(ne) {
      return O(ne) === m;
    }
    function G(ne) {
      return O(ne) === n;
    }
    function te(ne) {
      return O(ne) === o;
    }
    function se(ne) {
      return O(ne) === a;
    }
    function Z(ne) {
      return O(ne) === f;
    }
    Ae.AsyncMode = B, Ae.ConcurrentMode = F, Ae.ContextConsumer = L, Ae.ContextProvider = j, Ae.Element = I, Ae.ForwardRef = N, Ae.Fragment = q, Ae.Lazy = J, Ae.Memo = R, Ae.Portal = ae, Ae.Profiler = H, Ae.StrictMode = oe, Ae.Suspense = ue, Ae.isAsyncMode = V, Ae.isConcurrentMode = T, Ae.isContextConsumer = C, Ae.isContextProvider = M, Ae.isElement = P, Ae.isForwardRef = W, Ae.isFragment = z, Ae.isLazy = K, Ae.isMemo = X, Ae.isPortal = G, Ae.isProfiler = te, Ae.isStrictMode = se, Ae.isSuspense = Z, Ae.isValidElementType = x, Ae.typeOf = O;
  }()), Ae;
}
var Dc;
function Wa() {
  return Dc || (Dc = 1, process.env.NODE_ENV === "production" ? Xa.exports = Cg() : Xa.exports = Eg()), Xa.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Oi, Cc;
function ih() {
  if (Cc)
    return Oi;
  Cc = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Oi = a() ? Object.assign : function(o, i) {
    for (var s, u = r(o), l, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (u[f] = s[f]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          n.call(s, l[p]) && (u[l[p]] = s[l[p]]);
      }
    }
    return u;
  }, Oi;
}
var Bi, Ec;
function Pu() {
  if (Ec)
    return Bi;
  Ec = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Bi = e, Bi;
}
var Ti, xc;
function xg() {
  if (xc)
    return Ti;
  xc = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Pu(), n = {}, r = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, s, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var p = Error(
                (u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = o[c](i, c, u, s, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ti = a, Ti;
}
var Ai, Sc;
function Sg() {
  if (Sc)
    return Ai;
  Sc = 1;
  var e = Wa(), t = ih(), n = Pu(), r = xg(), a = Function.call.bind(Object.prototype.hasOwnProperty), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ai = function(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(V) {
      var T = V && (l && V[l] || V[c]);
      if (typeof T == "function")
        return T;
    }
    var p = "<<anonymous>>", m = {
      array: w("array"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: S(),
      arrayOf: x,
      element: O(),
      elementType: B(),
      instanceOf: F,
      node: N(),
      objectOf: j,
      oneOf: L,
      oneOfType: I,
      shape: q,
      exact: J
    };
    function v(V, T) {
      return V === T ? V !== 0 || 1 / V === 1 / T : V !== V && T !== T;
    }
    function g(V) {
      this.message = V, this.stack = "";
    }
    g.prototype = Error.prototype;
    function h(V) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, C = 0;
      function M(W, z, K, X, G, te, se) {
        if (X = X || p, te = te || K, se !== n) {
          if (u) {
            var Z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Z.name = "Invariant Violation", Z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ne = X + ":" + K;
            !T[ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            C < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[ne] = !0, C++);
          }
        }
        return z[K] == null ? W ? z[K] === null ? new g("The " + G + " `" + te + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new g("The " + G + " `" + te + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : V(z, K, X, G, te);
      }
      var P = M.bind(null, !1);
      return P.isRequired = M.bind(null, !0), P;
    }
    function w(V) {
      function T(C, M, P, W, z, K) {
        var X = C[M], G = H(X);
        if (G !== V) {
          var te = oe(X);
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + te + "` supplied to `" + P + "`, expected ") + ("`" + V + "`."));
        }
        return null;
      }
      return h(T);
    }
    function S() {
      return h(i);
    }
    function x(V) {
      function T(C, M, P, W, z) {
        if (typeof V != "function")
          return new g("Property `" + z + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var K = C[M];
        if (!Array.isArray(K)) {
          var X = H(K);
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + X + "` supplied to `" + P + "`, expected an array."));
        }
        for (var G = 0; G < K.length; G++) {
          var te = V(K, G, P, W, z + "[" + G + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return h(T);
    }
    function O() {
      function V(T, C, M, P, W) {
        var z = T[C];
        if (!s(z)) {
          var K = H(z);
          return new g("Invalid " + P + " `" + W + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(V);
    }
    function B() {
      function V(T, C, M, P, W) {
        var z = T[C];
        if (!e.isValidElementType(z)) {
          var K = H(z);
          return new g("Invalid " + P + " `" + W + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(V);
    }
    function F(V) {
      function T(C, M, P, W, z) {
        if (!(C[M] instanceof V)) {
          var K = V.name || p, X = me(C[M]);
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + X + "` supplied to `" + P + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return h(T);
    }
    function L(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function T(C, M, P, W, z) {
        for (var K = C[M], X = 0; X < V.length; X++)
          if (v(K, V[X]))
            return null;
        var G = JSON.stringify(V, function(se, Z) {
          var ne = oe(Z);
          return ne === "symbol" ? String(Z) : Z;
        });
        return new g("Invalid " + W + " `" + z + "` of value `" + String(K) + "` " + ("supplied to `" + P + "`, expected one of " + G + "."));
      }
      return h(T);
    }
    function j(V) {
      function T(C, M, P, W, z) {
        if (typeof V != "function")
          return new g("Property `" + z + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var K = C[M], X = H(K);
        if (X !== "object")
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + X + "` supplied to `" + P + "`, expected an object."));
        for (var G in K)
          if (a(K, G)) {
            var te = V(K, G, P, W, z + "." + G, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return h(T);
    }
    function I(V) {
      if (!Array.isArray(V))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var T = 0; T < V.length; T++) {
        var C = V[T];
        if (typeof C != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(C) + " at index " + T + "."
          ), i;
      }
      function M(P, W, z, K, X) {
        for (var G = 0; G < V.length; G++) {
          var te = V[G];
          if (te(P, W, z, K, X, n) == null)
            return null;
        }
        return new g("Invalid " + K + " `" + X + "` supplied to " + ("`" + z + "`."));
      }
      return h(M);
    }
    function N() {
      function V(T, C, M, P, W) {
        return R(T[C]) ? null : new g("Invalid " + P + " `" + W + "` supplied to " + ("`" + M + "`, expected a ReactNode."));
      }
      return h(V);
    }
    function q(V) {
      function T(C, M, P, W, z) {
        var K = C[M], X = H(K);
        if (X !== "object")
          return new g("Invalid " + W + " `" + z + "` of type `" + X + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var G in V) {
          var te = V[G];
          if (te) {
            var se = te(K, G, P, W, z + "." + G, n);
            if (se)
              return se;
          }
        }
        return null;
      }
      return h(T);
    }
    function J(V) {
      function T(C, M, P, W, z) {
        var K = C[M], X = H(K);
        if (X !== "object")
          return new g("Invalid " + W + " `" + z + "` of type `" + X + "` " + ("supplied to `" + P + "`, expected `object`."));
        var G = t({}, C[M], V);
        for (var te in G) {
          var se = V[te];
          if (!se)
            return new g(
              "Invalid " + W + " `" + z + "` key `" + te + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(C[M], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(V), null, "  ")
            );
          var Z = se(K, te, P, W, z + "." + te, n);
          if (Z)
            return Z;
        }
        return null;
      }
      return h(T);
    }
    function R(V) {
      switch (typeof V) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !V;
        case "object":
          if (Array.isArray(V))
            return V.every(R);
          if (V === null || s(V))
            return !0;
          var T = f(V);
          if (T) {
            var C = T.call(V), M;
            if (T !== V.entries) {
              for (; !(M = C.next()).done; )
                if (!R(M.value))
                  return !1;
            } else
              for (; !(M = C.next()).done; ) {
                var P = M.value;
                if (P && !R(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(V, T) {
      return V === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function H(V) {
      var T = typeof V;
      return Array.isArray(V) ? "array" : V instanceof RegExp ? "object" : ae(T, V) ? "symbol" : T;
    }
    function oe(V) {
      if (typeof V > "u" || V === null)
        return "" + V;
      var T = H(V);
      if (T === "object") {
        if (V instanceof Date)
          return "date";
        if (V instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function ue(V) {
      var T = oe(V);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function me(V) {
      return !V.constructor || !V.constructor.name ? p : V.constructor.name;
    }
    return m.checkPropTypes = r, m.resetWarningCache = r.resetWarningCache, m.PropTypes = m, m;
  }, Ai;
}
var Pi, $c;
function $g() {
  if ($c)
    return Pi;
  $c = 1;
  var e = Pu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Pi = function() {
    function r(i, s, u, l, c, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Pi;
}
if (process.env.NODE_ENV !== "production") {
  var kg = Wa(), Og = !0;
  Ps.exports = Sg()(kg.isElement, Og);
} else
  Ps.exports = $g()();
var Bg = Ps.exports;
const rt = /* @__PURE__ */ gr(Bg);
function Tg(e, t) {
  if (ht(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ht(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function sh(e) {
  var t = Tg(e, "string");
  return ht(t) === "symbol" ? t : String(t);
}
function le(e, t, n) {
  return t = sh(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ag = "exact-prop: ​";
function Pg(e) {
  return process.env.NODE_ENV === "production" ? e : ye({}, e, le({}, Ag, function(t) {
    var n = Object.keys(t).filter(function(r) {
      return !e.hasOwnProperty(r);
    });
    return n.length > 0 ? new Error("The following props are not supported: ".concat(n.map(function(r) {
      return "`".concat(r, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
function xo(e) {
  for (var t = "https://mui.com/production-error/?code=" + e, n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified Material-UI error #" + e + "; visit " + t + " for the full message.";
}
var Ms = { exports: {} }, Re = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kc;
function Mg() {
  if (kc)
    return Re;
  kc = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, a = 60114, o = 60109, i = 60110, s = 60112, u = 60113, l = 60120, c = 60115, f = 60116, p = 60121, m = 60122, v = 60117, g = 60129, h = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var w = Symbol.for;
    e = w("react.element"), t = w("react.portal"), n = w("react.fragment"), r = w("react.strict_mode"), a = w("react.profiler"), o = w("react.provider"), i = w("react.context"), s = w("react.forward_ref"), u = w("react.suspense"), l = w("react.suspense_list"), c = w("react.memo"), f = w("react.lazy"), p = w("react.block"), m = w("react.server.block"), v = w("react.fundamental"), g = w("react.debug_trace_mode"), h = w("react.legacy_hidden");
  }
  function S(R) {
    if (typeof R == "object" && R !== null) {
      var ae = R.$$typeof;
      switch (ae) {
        case e:
          switch (R = R.type, R) {
            case n:
            case a:
            case r:
            case u:
            case l:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case i:
                case s:
                case f:
                case c:
                case o:
                  return R;
                default:
                  return ae;
              }
          }
        case t:
          return ae;
      }
    }
  }
  var x = o, O = e, B = s, F = n, L = f, j = c, I = t, N = a, q = r, J = u;
  return Re.ContextConsumer = i, Re.ContextProvider = x, Re.Element = O, Re.ForwardRef = B, Re.Fragment = F, Re.Lazy = L, Re.Memo = j, Re.Portal = I, Re.Profiler = N, Re.StrictMode = q, Re.Suspense = J, Re.isAsyncMode = function() {
    return !1;
  }, Re.isConcurrentMode = function() {
    return !1;
  }, Re.isContextConsumer = function(R) {
    return S(R) === i;
  }, Re.isContextProvider = function(R) {
    return S(R) === o;
  }, Re.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, Re.isForwardRef = function(R) {
    return S(R) === s;
  }, Re.isFragment = function(R) {
    return S(R) === n;
  }, Re.isLazy = function(R) {
    return S(R) === f;
  }, Re.isMemo = function(R) {
    return S(R) === c;
  }, Re.isPortal = function(R) {
    return S(R) === t;
  }, Re.isProfiler = function(R) {
    return S(R) === a;
  }, Re.isStrictMode = function(R) {
    return S(R) === r;
  }, Re.isSuspense = function(R) {
    return S(R) === u;
  }, Re.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === n || R === a || R === g || R === r || R === u || R === l || R === h || typeof R == "object" && R !== null && (R.$$typeof === f || R.$$typeof === c || R.$$typeof === o || R.$$typeof === i || R.$$typeof === s || R.$$typeof === v || R.$$typeof === p || R[0] === m);
  }, Re.typeOf = S, Re;
}
var _e = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oc;
function Fg() {
  return Oc || (Oc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, a = 60114, o = 60109, i = 60110, s = 60112, u = 60113, l = 60120, c = 60115, f = 60116, p = 60121, m = 60122, v = 60117, g = 60129, h = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var w = Symbol.for;
      e = w("react.element"), t = w("react.portal"), n = w("react.fragment"), r = w("react.strict_mode"), a = w("react.profiler"), o = w("react.provider"), i = w("react.context"), s = w("react.forward_ref"), u = w("react.suspense"), l = w("react.suspense_list"), c = w("react.memo"), f = w("react.lazy"), p = w("react.block"), m = w("react.server.block"), v = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), g = w("react.debug_trace_mode"), w("react.offscreen"), h = w("react.legacy_hidden");
    }
    var S = !1;
    function x(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === n || Z === a || Z === g || Z === r || Z === u || Z === l || Z === h || S || typeof Z == "object" && Z !== null && (Z.$$typeof === f || Z.$$typeof === c || Z.$$typeof === o || Z.$$typeof === i || Z.$$typeof === s || Z.$$typeof === v || Z.$$typeof === p || Z[0] === m));
    }
    function O(Z) {
      if (typeof Z == "object" && Z !== null) {
        var ne = Z.$$typeof;
        switch (ne) {
          case e:
            var be = Z.type;
            switch (be) {
              case n:
              case a:
              case r:
              case u:
              case l:
                return be;
              default:
                var Pe = be && be.$$typeof;
                switch (Pe) {
                  case i:
                  case s:
                  case f:
                  case c:
                  case o:
                    return Pe;
                  default:
                    return ne;
                }
            }
          case t:
            return ne;
        }
      }
    }
    var B = i, F = o, L = e, j = s, I = n, N = f, q = c, J = t, R = a, ae = r, H = u, oe = !1, ue = !1;
    function me(Z) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(Z) {
      return ue || (ue = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(Z) {
      return O(Z) === i;
    }
    function C(Z) {
      return O(Z) === o;
    }
    function M(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function P(Z) {
      return O(Z) === s;
    }
    function W(Z) {
      return O(Z) === n;
    }
    function z(Z) {
      return O(Z) === f;
    }
    function K(Z) {
      return O(Z) === c;
    }
    function X(Z) {
      return O(Z) === t;
    }
    function G(Z) {
      return O(Z) === a;
    }
    function te(Z) {
      return O(Z) === r;
    }
    function se(Z) {
      return O(Z) === u;
    }
    _e.ContextConsumer = B, _e.ContextProvider = F, _e.Element = L, _e.ForwardRef = j, _e.Fragment = I, _e.Lazy = N, _e.Memo = q, _e.Portal = J, _e.Profiler = R, _e.StrictMode = ae, _e.Suspense = H, _e.isAsyncMode = me, _e.isConcurrentMode = V, _e.isContextConsumer = T, _e.isContextProvider = C, _e.isElement = M, _e.isForwardRef = P, _e.isFragment = W, _e.isLazy = z, _e.isMemo = K, _e.isPortal = X, _e.isProfiler = G, _e.isStrictMode = te, _e.isSuspense = se, _e.isValidElementType = x, _e.typeOf = O;
  }()), _e;
}
process.env.NODE_ENV === "production" ? Ms.exports = Mg() : Ms.exports = Fg();
var Bc = Ms.exports, Rg = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function _g(e) {
  var t = "".concat(e).match(Rg), n = t && t[1];
  return n || "";
}
function uh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return e.displayName || e.name || _g(e) || t;
}
function Tc(e, t, n) {
  var r = uh(t);
  return e.displayName || (r !== "" ? "".concat(n, "(").concat(r, ")") : n);
}
function ya(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return uh(e, "Component");
    if (ht(e) === "object")
      switch (e.$$typeof) {
        case Bc.ForwardRef:
          return Tc(e, e.render, "ForwardRef");
        case Bc.Memo:
          return Tc(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Fs(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : xo(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ng() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.reduce(function(r, a) {
    return a == null ? r : (process.env.NODE_ENV !== "production" && typeof a != "function" && console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var i = arguments.length, s = new Array(i), u = 0; u < i; u++)
        s[u] = arguments[u];
      r.apply(this, s), a.apply(this, s);
    });
  }, function() {
  });
}
function lh(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function nr(e, t) {
  if (e == null)
    return {};
  var n = lh(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var Rs = { exports: {} }, Mi, Ac;
function Mu() {
  if (Ac)
    return Mi;
  Ac = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Mi = e, Mi;
}
var Fi, Pc;
function ch() {
  return Pc || (Pc = 1, Fi = Function.call.bind(Object.prototype.hasOwnProperty)), Fi;
}
var Ri, Mc;
function Ig() {
  if (Mc)
    return Ri;
  Mc = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Mu(), n = {}, r = ch();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, s, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var p = Error(
                (u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = o[c](i, c, u, s, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ri = a, Ri;
}
var _i, Fc;
function Lg() {
  if (Fc)
    return _i;
  Fc = 1;
  var e = Wa(), t = ih(), n = Mu(), r = ch(), a = Ig(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return _i = function(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(T) {
      var C = T && (l && T[l] || T[c]);
      if (typeof C == "function")
        return C;
    }
    var p = "<<anonymous>>", m = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: S(),
      arrayOf: x,
      element: O(),
      elementType: B(),
      instanceOf: F,
      node: N(),
      objectOf: j,
      oneOf: L,
      oneOfType: I,
      shape: J,
      exact: R
    };
    function v(T, C) {
      return T === C ? T !== 0 || 1 / T === 1 / C : T !== T && C !== C;
    }
    function g(T, C) {
      this.message = T, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function h(T) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, M = 0;
      function P(z, K, X, G, te, se, Z) {
        if (G = G || p, se = se || X, Z !== n) {
          if (u) {
            var ne = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ne.name = "Invariant Violation", ne;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var be = G + ":" + X;
            !C[be] && // Avoid spamming the console because they are often not actionable except for lib authors
            M < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + se + "` prop on `" + G + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[be] = !0, M++);
          }
        }
        return K[X] == null ? z ? K[X] === null ? new g("The " + te + " `" + se + "` is marked as required " + ("in `" + G + "`, but its value is `null`.")) : new g("The " + te + " `" + se + "` is marked as required in " + ("`" + G + "`, but its value is `undefined`.")) : null : T(K, X, G, te, se);
      }
      var W = P.bind(null, !1);
      return W.isRequired = P.bind(null, !0), W;
    }
    function w(T) {
      function C(M, P, W, z, K, X) {
        var G = M[P], te = oe(G);
        if (te !== T) {
          var se = ue(G);
          return new g(
            "Invalid " + z + " `" + K + "` of type " + ("`" + se + "` supplied to `" + W + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return h(C);
    }
    function S() {
      return h(i);
    }
    function x(T) {
      function C(M, P, W, z, K) {
        if (typeof T != "function")
          return new g("Property `" + K + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var X = M[P];
        if (!Array.isArray(X)) {
          var G = oe(X);
          return new g("Invalid " + z + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected an array."));
        }
        for (var te = 0; te < X.length; te++) {
          var se = T(X, te, W, z, K + "[" + te + "]", n);
          if (se instanceof Error)
            return se;
        }
        return null;
      }
      return h(C);
    }
    function O() {
      function T(C, M, P, W, z) {
        var K = C[M];
        if (!s(K)) {
          var X = oe(K);
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + X + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(T);
    }
    function B() {
      function T(C, M, P, W, z) {
        var K = C[M];
        if (!e.isValidElementType(K)) {
          var X = oe(K);
          return new g("Invalid " + W + " `" + z + "` of type " + ("`" + X + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(T);
    }
    function F(T) {
      function C(M, P, W, z, K) {
        if (!(M[P] instanceof T)) {
          var X = T.name || p, G = V(M[P]);
          return new g("Invalid " + z + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected ") + ("instance of `" + X + "`."));
        }
        return null;
      }
      return h(C);
    }
    function L(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function C(M, P, W, z, K) {
        for (var X = M[P], G = 0; G < T.length; G++)
          if (v(X, T[G]))
            return null;
        var te = JSON.stringify(T, function(Z, ne) {
          var be = ue(ne);
          return be === "symbol" ? String(ne) : ne;
        });
        return new g("Invalid " + z + " `" + K + "` of value `" + String(X) + "` " + ("supplied to `" + W + "`, expected one of " + te + "."));
      }
      return h(C);
    }
    function j(T) {
      function C(M, P, W, z, K) {
        if (typeof T != "function")
          return new g("Property `" + K + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var X = M[P], G = oe(X);
        if (G !== "object")
          return new g("Invalid " + z + " `" + K + "` of type " + ("`" + G + "` supplied to `" + W + "`, expected an object."));
        for (var te in X)
          if (r(X, te)) {
            var se = T(X, te, W, z, K + "." + te, n);
            if (se instanceof Error)
              return se;
          }
        return null;
      }
      return h(C);
    }
    function I(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var C = 0; C < T.length; C++) {
        var M = T[C];
        if (typeof M != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + me(M) + " at index " + C + "."
          ), i;
      }
      function P(W, z, K, X, G) {
        for (var te = [], se = 0; se < T.length; se++) {
          var Z = T[se], ne = Z(W, z, K, X, G, n);
          if (ne == null)
            return null;
          ne.data && r(ne.data, "expectedType") && te.push(ne.data.expectedType);
        }
        var be = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new g("Invalid " + X + " `" + G + "` supplied to " + ("`" + K + "`" + be + "."));
      }
      return h(P);
    }
    function N() {
      function T(C, M, P, W, z) {
        return ae(C[M]) ? null : new g("Invalid " + W + " `" + z + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return h(T);
    }
    function q(T, C, M, P, W) {
      return new g(
        (T || "React class") + ": " + C + " type `" + M + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function J(T) {
      function C(M, P, W, z, K) {
        var X = M[P], G = oe(X);
        if (G !== "object")
          return new g("Invalid " + z + " `" + K + "` of type `" + G + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var te in T) {
          var se = T[te];
          if (typeof se != "function")
            return q(W, z, K, te, ue(se));
          var Z = se(X, te, W, z, K + "." + te, n);
          if (Z)
            return Z;
        }
        return null;
      }
      return h(C);
    }
    function R(T) {
      function C(M, P, W, z, K) {
        var X = M[P], G = oe(X);
        if (G !== "object")
          return new g("Invalid " + z + " `" + K + "` of type `" + G + "` " + ("supplied to `" + W + "`, expected `object`."));
        var te = t({}, M[P], T);
        for (var se in te) {
          var Z = T[se];
          if (r(T, se) && typeof Z != "function")
            return q(W, z, K, se, ue(Z));
          if (!Z)
            return new g(
              "Invalid " + z + " `" + K + "` key `" + se + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(M[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var ne = Z(X, se, W, z, K + "." + se, n);
          if (ne)
            return ne;
        }
        return null;
      }
      return h(C);
    }
    function ae(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(ae);
          if (T === null || s(T))
            return !0;
          var C = f(T);
          if (C) {
            var M = C.call(T), P;
            if (C !== T.entries) {
              for (; !(P = M.next()).done; )
                if (!ae(P.value))
                  return !1;
            } else
              for (; !(P = M.next()).done; ) {
                var W = P.value;
                if (W && !ae(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(T, C) {
      return T === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function oe(T) {
      var C = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : H(C, T) ? "symbol" : C;
    }
    function ue(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var C = oe(T);
      if (C === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function me(T) {
      var C = ue(T);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function V(T) {
      return !T.constructor || !T.constructor.name ? p : T.constructor.name;
    }
    return m.checkPropTypes = a, m.resetWarningCache = a.resetWarningCache, m.PropTypes = m, m;
  }, _i;
}
var Ni, Rc;
function jg() {
  if (Rc)
    return Ni;
  Rc = 1;
  var e = Mu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Ni = function() {
    function r(i, s, u, l, c, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Ni;
}
if (process.env.NODE_ENV !== "production") {
  var Wg = Wa(), Yg = !0;
  Rs.exports = Lg()(Wg.isElement, Yg);
} else
  Rs.exports = jg()();
var Hg = Rs.exports;
const Ut = /* @__PURE__ */ gr(Hg);
function dh(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = dh(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Vg() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = dh(e)) && (r && (r += " "), r += t);
  return r;
}
var zg = typeof Symbol == "function" && Symbol.for;
const Kg = zg ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var Ug = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function qg() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.disableGlobal, n = t === void 0 ? !1 : t, r = e.productionPrefix, a = r === void 0 ? "jss" : r, o = e.seed, i = o === void 0 ? "" : o, s = i === "" ? "" : "".concat(i, "-"), u = 0, l = function() {
    return u += 1, process.env.NODE_ENV !== "production" && u >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), u;
  };
  return function(c, f) {
    var p = f.options.name;
    if (p && p.indexOf("Mui") === 0 && !f.options.link && !n) {
      if (Ug.indexOf(c.key) !== -1)
        return "Mui-".concat(c.key);
      var m = "".concat(s).concat(p, "-").concat(c.key);
      return !f.options.theme[Kg] || i !== "" ? m : "".concat(m, "-").concat(l());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(s).concat(a).concat(l());
    var v = "".concat(c.key, "-").concat(l());
    return f.options.classNamePrefix ? "".concat(s).concat(f.options.classNamePrefix, "-").concat(v) : "".concat(s).concat(v);
  };
}
function Xg(e) {
  var t = e.theme, n = e.name, r = e.props;
  if (!t || !t.props || !t.props[n])
    return r;
  var a = t.props[n], o;
  for (o in a)
    r[o] === void 0 && (r[o] = a[o]);
  return r;
}
var Gg = process.env.NODE_ENV === "production";
function Nt(e, t) {
  if (!Gg) {
    if (e)
      return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var _c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Ya = (typeof window > "u" ? "undefined" : _c(window)) === "object" && (typeof document > "u" ? "undefined" : _c(document)) === "object" && document.nodeType === 9;
function Nc(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, sh(r.key), r);
  }
}
function Se(e, t, n) {
  return t && Nc(e.prototype, t), n && Nc(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function So(e, t) {
  return So = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, So(e, t);
}
function fh(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, So(e, t);
}
function de(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var Qg = {}.constructor;
function _s(e) {
  if (e == null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(_s);
  if (e.constructor !== Qg)
    return e;
  var t = {};
  for (var n in e)
    t[n] = _s(e[n]);
  return t;
}
function Fu(e, t, n) {
  e === void 0 && (e = "unnamed");
  var r = n.jss, a = _s(t), o = r.plugins.onCreateRule(e, a, n);
  return o || (e[0] === "@" && process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] Unknown rule " + e), null);
}
var Ic = function(t, n) {
  for (var r = "", a = 0; a < t.length && t[a] !== "!important"; a++)
    r && (r += n), r += t[a];
  return r;
}, Qr = function(t) {
  if (!Array.isArray(t))
    return t;
  var n = "";
  if (Array.isArray(t[0]))
    for (var r = 0; r < t.length && t[r] !== "!important"; r++)
      n && (n += ", "), n += Ic(t[r], " ");
  else
    n = Ic(t, ", ");
  return t[t.length - 1] === "!important" && (n += " !important"), n;
};
function ea(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function ia(e, t) {
  for (var n = "", r = 0; r < t; r++)
    n += "  ";
  return n + e;
}
function Ba(e, t, n) {
  n === void 0 && (n = {});
  var r = "";
  if (!t)
    return r;
  var a = n, o = a.indent, i = o === void 0 ? 0 : o, s = t.fallbacks;
  n.format === !1 && (i = -1 / 0);
  var u = ea(n), l = u.linebreak, c = u.space;
  if (e && i++, s)
    if (Array.isArray(s))
      for (var f = 0; f < s.length; f++) {
        var p = s[f];
        for (var m in p) {
          var v = p[m];
          v != null && (r && (r += l), r += ia(m + ":" + c + Qr(v) + ";", i));
        }
      }
    else
      for (var g in s) {
        var h = s[g];
        h != null && (r && (r += l), r += ia(g + ":" + c + Qr(h) + ";", i));
      }
  for (var w in t) {
    var S = t[w];
    S != null && w !== "fallbacks" && (r && (r += l), r += ia(w + ":" + c + Qr(S) + ";", i));
  }
  return !r && !n.allowEmpty || !e ? r : (i--, r && (r = "" + l + r + l), ia("" + e + c + "{" + r, i) + ia("}", i));
}
var Zg = /([[\].#*$><+~=|^:(),"'`\s])/g, Lc = typeof CSS < "u" && CSS.escape, Ru = function(e) {
  return Lc ? Lc(e) : e.replace(Zg, "\\$1");
}, ph = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "style", this.isProcessed = !1;
    var o = a.sheet, i = a.Renderer;
    this.key = n, this.options = a, this.style = r, o ? this.renderer = o.renderer : i && (this.renderer = new i());
  }
  var t = e.prototype;
  return t.prop = function(r, a, o) {
    if (a === void 0)
      return this.style[r];
    var i = o ? o.force : !1;
    if (!i && this.style[r] === a)
      return this;
    var s = a;
    (!o || o.process !== !1) && (s = this.options.jss.plugins.onChangeValue(a, r, this));
    var u = s == null || s === !1, l = r in this.style;
    if (u && !l && !i)
      return this;
    var c = u && l;
    if (c ? delete this.style[r] : this.style[r] = s, this.renderable && this.renderer)
      return c ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, s), this;
    var f = this.options.sheet;
    return f && f.attached && process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), Ns = /* @__PURE__ */ function(e) {
  fh(t, e);
  function t(r, a, o) {
    var i;
    i = e.call(this, r, a, o) || this;
    var s = o.selector, u = o.scoped, l = o.sheet, c = o.generateId;
    return s ? i.selectorText = s : u !== !1 && (i.id = c(de(de(i)), l), i.selectorText = "." + Ru(i.id)), i;
  }
  var n = t.prototype;
  return n.applyTo = function(a) {
    var o = this.renderer;
    if (o) {
      var i = this.toJSON();
      for (var s in i)
        o.setProperty(a, s, i[s]);
    }
    return this;
  }, n.toJSON = function() {
    var a = {};
    for (var o in this.style) {
      var i = this.style[o];
      typeof i != "object" ? a[o] = i : Array.isArray(i) && (a[o] = Qr(i));
    }
    return a;
  }, n.toString = function(a) {
    var o = this.options.sheet, i = o ? o.options.link : !1, s = i ? ye({}, a, {
      allowEmpty: !0
    }) : a;
    return Ba(this.selectorText, this.style, s);
  }, Se(t, [{
    key: "selector",
    set: function(a) {
      if (a !== this.selectorText) {
        this.selectorText = a;
        var o = this.renderer, i = this.renderable;
        if (!(!i || !o)) {
          var s = o.setSelector(i, a);
          s || o.replaceRule(i, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(ph), Jg = {
  onCreateRule: function(t, n, r) {
    return t[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new Ns(t, n, r);
  }
}, Ii = {
  indent: 1,
  children: !0
}, e1 = /@([\w-]+)/, t1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var o = n.match(e1);
    this.at = o ? o[1] : "unknown", this.query = a.name || "@" + this.at, this.options = a, this.rules = new ii(ye({}, a, {
      parent: this
    }));
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.addRule = function(r, a, o) {
    var i = this.rules.add(r, a, o);
    return i ? (this.options.jss.plugins.onProcessRule(i), i) : null;
  }, t.replaceRule = function(r, a, o) {
    var i = this.rules.replace(r, a, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, t.toString = function(r) {
    r === void 0 && (r = Ii);
    var a = ea(r), o = a.linebreak;
    if (r.indent == null && (r.indent = Ii.indent), r.children == null && (r.children = Ii.children), r.children === !1)
      return this.query + " {}";
    var i = this.rules.toString(r);
    return i ? this.query + " {" + o + i + o + "}" : "";
  }, e;
}(), r1 = /@container|@media|@supports\s+/, n1 = {
  onCreateRule: function(t, n, r) {
    return r1.test(t) ? new t1(t, n, r) : null;
  }
}, Li = {
  indent: 1,
  children: !0
}, a1 = /@keyframes\s+([\w-]+)/, Is = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var o = n.match(a1);
    o && o[1] ? this.name = o[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = a;
    var i = a.scoped, s = a.sheet, u = a.generateId;
    this.id = i === !1 ? this.name : Ru(u(this, s)), this.rules = new ii(ye({}, a, {
      parent: this
    }));
    for (var l in r)
      this.rules.add(l, r[l], ye({}, a, {
        parent: this
      }));
    this.rules.process();
  }
  var t = e.prototype;
  return t.toString = function(r) {
    r === void 0 && (r = Li);
    var a = ea(r), o = a.linebreak;
    if (r.indent == null && (r.indent = Li.indent), r.children == null && (r.children = Li.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var i = this.rules.toString(r);
    return i && (i = "" + o + i + o), this.at + " " + this.id + " {" + i + "}";
  }, e;
}(), o1 = /@keyframes\s+/, i1 = /\$([\w-]+)/g, Ls = function(t, n) {
  return typeof t == "string" ? t.replace(i1, function(r, a) {
    return a in n ? n[a] : (process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] Referenced keyframes rule "' + a + '" is not defined.'), r);
  }) : t;
}, jc = function(t, n, r) {
  var a = t[n], o = Ls(a, r);
  o !== a && (t[n] = o);
}, s1 = {
  onCreateRule: function(t, n, r) {
    return typeof t == "string" && o1.test(t) ? new Is(t, n, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, n, r) {
    return n.type !== "style" || !r || ("animation-name" in t && jc(t, "animation-name", r.keyframes), "animation" in t && jc(t, "animation", r.keyframes)), t;
  },
  onChangeValue: function(t, n, r) {
    var a = r.options.sheet;
    if (!a)
      return t;
    switch (n) {
      case "animation":
        return Ls(t, a.keyframes);
      case "animation-name":
        return Ls(t, a.keyframes);
      default:
        return t;
    }
  }
}, u1 = /* @__PURE__ */ function(e) {
  fh(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.toString = function(a) {
    var o = this.options.sheet, i = o ? o.options.link : !1, s = i ? ye({}, a, {
      allowEmpty: !0
    }) : a;
    return Ba(this.key, this.style, s);
  }, t;
}(ph), l1 = {
  onCreateRule: function(t, n, r) {
    return r.parent && r.parent.type === "keyframes" ? new u1(t, n, r) : null;
  }
}, c1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = r, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    var a = ea(r), o = a.linebreak;
    if (Array.isArray(this.style)) {
      for (var i = "", s = 0; s < this.style.length; s++)
        i += Ba(this.at, this.style[s]), this.style[s + 1] && (i += o);
      return i;
    }
    return Ba(this.at, this.style, r);
  }, e;
}(), d1 = /@font-face/, f1 = {
  onCreateRule: function(t, n, r) {
    return d1.test(t) ? new c1(t, n, r) : null;
  }
}, p1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = r, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    return Ba(this.key, this.style, r);
  }, e;
}(), h1 = {
  onCreateRule: function(t, n, r) {
    return t === "@viewport" || t === "@-ms-viewport" ? new p1(t, n, r) : null;
  }
}, v1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = r, this.options = a;
  }
  var t = e.prototype;
  return t.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var a = "", o = 0; o < this.value.length; o++)
        a += this.key + " " + this.value[o] + ";", this.value[o + 1] && (a += `
`);
      return a;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), m1 = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, g1 = {
  onCreateRule: function(t, n, r) {
    return t in m1 ? new v1(t, n, r) : null;
  }
}, Wc = [Jg, n1, s1, l1, f1, h1, g1], y1 = {
  process: !0
}, Yc = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, ii = /* @__PURE__ */ function() {
  function e(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var t = e.prototype;
  return t.add = function(r, a, o) {
    var i = this.options, s = i.parent, u = i.sheet, l = i.jss, c = i.Renderer, f = i.generateId, p = i.scoped, m = ye({
      classes: this.classes,
      parent: s,
      sheet: u,
      jss: l,
      Renderer: c,
      generateId: f,
      scoped: p,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, o), v = r;
    r in this.raw && (v = r + "-d" + this.counter++), this.raw[v] = a, v in this.classes && (m.selector = "." + Ru(this.classes[v]));
    var g = Fu(v, a, m);
    if (!g)
      return null;
    this.register(g);
    var h = m.index === void 0 ? this.index.length : m.index;
    return this.index.splice(h, 0, g), g;
  }, t.replace = function(r, a, o) {
    var i = this.get(r), s = this.index.indexOf(i);
    i && this.remove(i);
    var u = o;
    return s !== -1 && (u = ye({}, o, {
      index: s
    })), this.add(r, a, u);
  }, t.get = function(r) {
    return this.map[r];
  }, t.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, t.indexOf = function(r) {
    return this.index.indexOf(r);
  }, t.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, t.register = function(r) {
    this.map[r.key] = r, r instanceof Ns ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof Is && this.keyframes && (this.keyframes[r.name] = r.id);
  }, t.unregister = function(r) {
    delete this.map[r.key], r instanceof Ns ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof Is && delete this.keyframes[r.name];
  }, t.update = function() {
    var r, a, o;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], a = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2]) : (a = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), a, o);
    else
      for (var i = 0; i < this.index.length; i++)
        this.updateOne(this.index[i], a, o);
  }, t.updateOne = function(r, a, o) {
    o === void 0 && (o = y1);
    var i = this.options, s = i.jss.plugins, u = i.sheet;
    if (r.rules instanceof e) {
      r.rules.update(a, o);
      return;
    }
    var l = r.style;
    if (s.onUpdate(a, r, u, o), o.process && l && l !== r.style) {
      s.onProcessStyle(r.style, r, u);
      for (var c in r.style) {
        var f = r.style[c], p = l[c];
        f !== p && r.prop(c, f, Yc);
      }
      for (var m in l) {
        var v = r.style[m], g = l[m];
        v == null && v !== g && r.prop(m, null, Yc);
      }
    }
  }, t.toString = function(r) {
    for (var a = "", o = this.options.sheet, i = o ? o.options.link : !1, s = ea(r), u = s.linebreak, l = 0; l < this.index.length; l++) {
      var c = this.index[l], f = c.toString(r);
      !f && !i || (a && (a += u), a += f);
    }
    return a;
  }, e;
}(), hh = /* @__PURE__ */ function() {
  function e(n, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = ye({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new ii(this.options);
    for (var a in n)
      this.rules.add(a, n[a]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(r, a, o) {
    var i = this.queue;
    this.attached && !i && (this.queue = []);
    var s = this.rules.add(r, a, o);
    return s ? (this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && (i ? i.push(s) : (this.insertRule(s), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), s) : (this.deployed = !1, s)) : null;
  }, t.replaceRule = function(r, a, o) {
    var i = this.rules.get(r);
    if (!i)
      return this.addRule(r, a, o);
    var s = this.rules.replace(r, a, o);
    return s && this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && this.renderer && (s ? i.renderable && this.renderer.replaceRule(i.renderable, s) : this.renderer.deleteRule(i)), s) : (this.deployed = !1, s);
  }, t.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, t.addRules = function(r, a) {
    var o = [];
    for (var i in r) {
      var s = this.addRule(i, r[i], a);
      s && o.push(s);
    }
    return o;
  }, t.getRule = function(r) {
    return this.rules.get(r);
  }, t.deleteRule = function(r) {
    var a = typeof r == "object" ? r : this.rules.get(r);
    return !a || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !a.renderable ? !1 : (this.rules.remove(a), this.attached && a.renderable && this.renderer ? this.renderer.deleteRule(a.renderable) : !0);
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, t.updateOne = function(r, a, o) {
    return this.rules.updateOne(r, a, o), this;
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, e;
}(), b1 = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = e.prototype;
  return t.onCreateRule = function(r, a, o) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var s = this.registry.onCreateRule[i](r, a, o);
      if (s)
        return s;
    }
    return null;
  }, t.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var a = r.options.sheet, o = 0; o < this.registry.onProcessRule.length; o++)
        this.registry.onProcessRule[o](r, a);
      r.style && this.onProcessStyle(r.style, r, a), r.isProcessed = !0;
    }
  }, t.onProcessStyle = function(r, a, o) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++)
      a.style = this.registry.onProcessStyle[i](a.style, a, o);
  }, t.onProcessSheet = function(r) {
    for (var a = 0; a < this.registry.onProcessSheet.length; a++)
      this.registry.onProcessSheet[a](r);
  }, t.onUpdate = function(r, a, o, i) {
    for (var s = 0; s < this.registry.onUpdate.length; s++)
      this.registry.onUpdate[s](r, a, o, i);
  }, t.onChangeValue = function(r, a, o) {
    for (var i = r, s = 0; s < this.registry.onChangeValue.length; s++)
      i = this.registry.onChangeValue[s](i, a, o);
    return i;
  }, t.use = function(r, a) {
    a === void 0 && (a = {
      queue: "external"
    });
    var o = this.plugins[a.queue];
    o.indexOf(r) === -1 && (o.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(i, s) {
      for (var u in s)
        u in i ? i[u].push(s[u]) : process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] Unknown hook "' + u + '".');
      return i;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), w1 = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var t = e.prototype;
  return t.add = function(r) {
    var a = this.registry, o = r.options.index;
    if (a.indexOf(r) === -1) {
      if (a.length === 0 || o >= this.index) {
        a.push(r);
        return;
      }
      for (var i = 0; i < a.length; i++)
        if (a[i].options.index > o) {
          a.splice(i, 0, r);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(r) {
    var a = this.registry.indexOf(r);
    this.registry.splice(a, 1);
  }, t.toString = function(r) {
    for (var a = r === void 0 ? {} : r, o = a.attached, i = lh(a, ["attached"]), s = ea(i), u = s.linebreak, l = "", c = 0; c < this.registry.length; c++) {
      var f = this.registry[c];
      o != null && f.attached !== o || (l && (l += u), l += f.toString(i));
    }
    return l;
  }, Se(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), ba = new w1(), js = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Ws = "2f1acc6c3a606b082e5eef5e54414ffb";
js[Ws] == null && (js[Ws] = 0);
var Hc = js[Ws]++, D1 = 1e10, Vc = function(t) {
  t === void 0 && (t = {});
  var n = 0, r = function(o, i) {
    n += 1, n > D1 && process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var s = "", u = "";
    return i && (i.options.classNamePrefix && (u = i.options.classNamePrefix), i.options.jss.id != null && (s = String(i.options.jss.id))), t.minify ? "" + (u || "c") + Hc + s + n : u + o.key + "-" + Hc + (s ? "-" + s : "") + "-" + n;
  };
  return r;
}, vh = function(t) {
  var n;
  return function() {
    return n || (n = t()), n;
  };
}, C1 = function(t, n) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(n) : t.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, E1 = function(t, n, r) {
  try {
    var a = r;
    if (Array.isArray(r) && (a = Qr(r)), t.attributeStyleMap)
      t.attributeStyleMap.set(n, a);
    else {
      var o = a ? a.indexOf("!important") : -1, i = o > -1 ? a.substr(0, o - 1) : a;
      t.style.setProperty(n, i, o > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, x1 = function(t, n) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(n) : t.style.removeProperty(n);
  } catch (r) {
    process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] DOMException "' + r.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, S1 = function(t, n) {
  return t.selectorText = n, t.selectorText === n;
}, mh = vh(function() {
  return document.querySelector("head");
});
function $1(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (r.attached && r.options.index > t.index && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function k1(e, t) {
  for (var n = e.length - 1; n >= 0; n--) {
    var r = e[n];
    if (r.attached && r.options.insertionPoint === t.insertionPoint)
      return r;
  }
  return null;
}
function O1(e) {
  for (var t = mh(), n = 0; n < t.childNodes.length; n++) {
    var r = t.childNodes[n];
    if (r.nodeType === 8 && r.nodeValue.trim() === e)
      return r;
  }
  return null;
}
function B1(e) {
  var t = ba.registry;
  if (t.length > 0) {
    var n = $1(t, e);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = k1(t, e), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var r = e.insertionPoint;
  if (r && typeof r == "string") {
    var a = O1(r);
    if (a)
      return {
        parent: a.parentNode,
        node: a.nextSibling
      };
    process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function T1(e, t) {
  var n = t.insertionPoint, r = B1(t);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(e, r.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var a = n, o = a.parentNode;
    o ? o.insertBefore(e, a.nextSibling) : process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  mh().appendChild(e);
}
var A1 = vh(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), zc = function(t, n, r) {
  try {
    "insertRule" in t ? t.insertRule(n, r) : "appendRule" in t && t.appendRule(n);
  } catch (a) {
    return process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] " + a.message), !1;
  }
  return t.cssRules[r];
}, Kc = function(t, n) {
  var r = t.cssRules.length;
  return n === void 0 || n > r ? r : n;
}, P1 = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, M1 = /* @__PURE__ */ function() {
  function e(n) {
    this.getPropertyValue = C1, this.setProperty = E1, this.removeProperty = x1, this.setSelector = S1, this.hasInsertedRules = !1, this.cssRules = [], n && ba.add(n), this.sheet = n;
    var r = this.sheet ? this.sheet.options : {}, a = r.media, o = r.meta, i = r.element;
    this.element = i || P1(), this.element.setAttribute("data-jss", ""), a && this.element.setAttribute("media", a), o && this.element.setAttribute("data-meta", o);
    var s = A1();
    s && this.element.setAttribute("nonce", s);
  }
  var t = e.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      T1(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, t.insertRules = function(r, a) {
    for (var o = 0; o < r.index.length; o++)
      this.insertRule(r.index[o], o, a);
  }, t.insertRule = function(r, a, o) {
    if (o === void 0 && (o = this.element.sheet), r.rules) {
      var i = r, s = o;
      if (r.type === "conditional" || r.type === "keyframes") {
        var u = Kc(o, a);
        if (s = zc(o, i.toString({
          children: !1
        }), u), s === !1)
          return !1;
        this.refCssRule(r, u, s);
      }
      return this.insertRules(i.rules, s), s;
    }
    var l = r.toString();
    if (!l)
      return !1;
    var c = Kc(o, a), f = zc(o, l, c);
    return f === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, c, f), f);
  }, t.refCssRule = function(r, a, o) {
    r.renderable = o, r.options.parent instanceof hh && this.cssRules.splice(a, 0, o);
  }, t.deleteRule = function(r) {
    var a = this.element.sheet, o = this.indexOf(r);
    return o === -1 ? !1 : (a.deleteRule(o), this.cssRules.splice(o, 1), !0);
  }, t.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, t.replaceRule = function(r, a) {
    var o = this.indexOf(r);
    return o === -1 ? !1 : (this.element.sheet.deleteRule(o), this.cssRules.splice(o, 1), this.insertRule(a, o));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), F1 = 0, R1 = /* @__PURE__ */ function() {
  function e(n) {
    this.id = F1++, this.version = "10.10.0", this.plugins = new b1(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Vc,
      Renderer: Ya ? M1 : null,
      plugins: []
    }, this.generateId = Vc({
      minify: !1
    });
    for (var r = 0; r < Wc.length; r++)
      this.plugins.use(Wc[r], {
        queue: "internal"
      });
    this.setup(n);
  }
  var t = e.prototype;
  return t.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = ye({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, t.createStyleSheet = function(r, a) {
    a === void 0 && (a = {});
    var o = a, i = o.index;
    typeof i != "number" && (i = ba.index === 0 ? 0 : ba.index + 1);
    var s = new hh(r, ye({}, a, {
      jss: this,
      generateId: a.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: i
    }));
    return this.plugins.onProcessSheet(s), s;
  }, t.removeStyleSheet = function(r) {
    return r.detach(), ba.remove(r), this;
  }, t.createRule = function(r, a, o) {
    if (a === void 0 && (a = {}), o === void 0 && (o = {}), typeof r == "object")
      return this.createRule(void 0, r, a);
    var i = ye({}, o, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    i.generateId || (i.generateId = this.generateId), i.classes || (i.classes = {}), i.keyframes || (i.keyframes = {});
    var s = Fu(r, a, i);
    return s && this.plugins.onProcessRule(s), s;
  }, t.use = function() {
    for (var r = this, a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return o.forEach(function(s) {
      r.plugins.use(s);
    }), this;
  }, e;
}(), _u = function(t) {
  return new R1(t);
}, Nu = typeof CSS == "object" && CSS != null && "number" in CSS;
function gh(e) {
  var t = null;
  for (var n in e) {
    var r = e[n], a = typeof r;
    if (a === "function")
      t || (t = {}), t[n] = r;
    else if (a === "object" && r !== null && !Array.isArray(r)) {
      var o = gh(r);
      o && (t || (t = {}), t[n] = o);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
_u();
var yh = Date.now(), ji = "fnValues" + yh, Wi = "fnStyle" + ++yh, _1 = function() {
  return {
    onCreateRule: function(n, r, a) {
      if (typeof r != "function")
        return null;
      var o = Fu(n, {}, a);
      return o[Wi] = r, o;
    },
    onProcessStyle: function(n, r) {
      if (ji in r || Wi in r)
        return n;
      var a = {};
      for (var o in n) {
        var i = n[o];
        typeof i == "function" && (delete n[o], a[o] = i);
      }
      return r[ji] = a, n;
    },
    onUpdate: function(n, r, a, o) {
      var i = r, s = i[Wi];
      if (s && (i.style = s(n) || {}, process.env.NODE_ENV === "development")) {
        for (var u in i.style)
          if (typeof i.style[u] == "function") {
            process.env.NODE_ENV !== "production" && Nt(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var l = i[ji];
      if (l)
        for (var c in l)
          i.prop(c, l[c](n), o);
    }
  };
}, Ar = "@global", Ys = "@global ", N1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "global", this.at = Ar, this.isProcessed = !1, this.key = n, this.options = a, this.rules = new ii(ye({}, a, {
      parent: this
    }));
    for (var o in r)
      this.rules.add(o, r[o]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(r) {
    return this.rules.get(r);
  }, t.addRule = function(r, a, o) {
    var i = this.rules.add(r, a, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, t.replaceRule = function(r, a, o) {
    var i = this.rules.replace(r, a, o);
    return i && this.options.jss.plugins.onProcessRule(i), i;
  }, t.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, t.toString = function(r) {
    return this.rules.toString(r);
  }, e;
}(), I1 = /* @__PURE__ */ function() {
  function e(n, r, a) {
    this.type = "global", this.at = Ar, this.isProcessed = !1, this.key = n, this.options = a;
    var o = n.substr(Ys.length);
    this.rule = a.jss.createRule(o, r, ye({}, a, {
      parent: this
    }));
  }
  var t = e.prototype;
  return t.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, e;
}(), L1 = /\s*,\s*/g;
function bh(e, t) {
  for (var n = e.split(L1), r = "", a = 0; a < n.length; a++)
    r += t + " " + n[a].trim(), n[a + 1] && (r += ", ");
  return r;
}
function j1(e, t) {
  var n = e.options, r = e.style, a = r ? r[Ar] : null;
  if (a) {
    for (var o in a)
      t.addRule(o, a[o], ye({}, n, {
        selector: bh(o, e.selector)
      }));
    delete r[Ar];
  }
}
function W1(e, t) {
  var n = e.options, r = e.style;
  for (var a in r)
    if (!(a[0] !== "@" || a.substr(0, Ar.length) !== Ar)) {
      var o = bh(a.substr(Ar.length), e.selector);
      t.addRule(o, r[a], ye({}, n, {
        selector: o
      })), delete r[a];
    }
}
function Y1() {
  function e(n, r, a) {
    if (!n)
      return null;
    if (n === Ar)
      return new N1(n, r, a);
    if (n[0] === "@" && n.substr(0, Ys.length) === Ys)
      return new I1(n, r, a);
    var o = a.parent;
    return o && (o.type === "global" || o.options.parent && o.options.parent.type === "global") && (a.scoped = !1), !a.selector && a.scoped === !1 && (a.selector = n), null;
  }
  function t(n, r) {
    n.type !== "style" || !r || (j1(n, r), W1(n, r));
  }
  return {
    onCreateRule: e,
    onProcessRule: t
  };
}
var Uc = /\s*,\s*/g, H1 = /&/g, V1 = /\$([\w-]+)/g;
function z1() {
  function e(a, o) {
    return function(i, s) {
      var u = a.getRule(s) || o && o.getRule(s);
      return u ? u.selector : (process.env.NODE_ENV !== "production" && Nt(!1, '[JSS] Could not find the referenced rule "' + s + '" in "' + (a.options.meta || a.toString()) + '".'), s);
    };
  }
  function t(a, o) {
    for (var i = o.split(Uc), s = a.split(Uc), u = "", l = 0; l < i.length; l++)
      for (var c = i[l], f = 0; f < s.length; f++) {
        var p = s[f];
        u && (u += ", "), u += p.indexOf("&") !== -1 ? p.replace(H1, c) : c + " " + p;
      }
    return u;
  }
  function n(a, o, i) {
    if (i)
      return ye({}, i, {
        index: i.index + 1
      });
    var s = a.options.nestingLevel;
    s = s === void 0 ? 1 : s + 1;
    var u = ye({}, a.options, {
      nestingLevel: s,
      index: o.indexOf(a) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete u.name, u;
  }
  function r(a, o, i) {
    if (o.type !== "style")
      return a;
    var s = o, u = s.options.parent, l, c;
    for (var f in a) {
      var p = f.indexOf("&") !== -1, m = f[0] === "@";
      if (!(!p && !m)) {
        if (l = n(s, u, l), p) {
          var v = t(f, s.selector);
          c || (c = e(u, i)), v = v.replace(V1, c);
          var g = s.key + "-" + f;
          "replaceRule" in u ? u.replaceRule(g, a[f], ye({}, l, {
            selector: v
          })) : u.addRule(g, a[f], ye({}, l, {
            selector: v
          }));
        } else
          m && u.addRule(f, {}, l).addRule(s.key, a[f], {
            selector: s.selector
          });
        delete a[f];
      }
    }
    return a;
  }
  return {
    onProcessStyle: r
  };
}
var K1 = /[A-Z]/g, U1 = /^ms-/, Yi = {};
function q1(e) {
  return "-" + e.toLowerCase();
}
function wh(e) {
  if (Yi.hasOwnProperty(e))
    return Yi[e];
  var t = e.replace(K1, q1);
  return Yi[e] = U1.test(t) ? "-" + t : t;
}
function $o(e) {
  var t = {};
  for (var n in e) {
    var r = n.indexOf("--") === 0 ? n : wh(n);
    t[r] = e[n];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map($o) : t.fallbacks = $o(e.fallbacks)), t;
}
function X1() {
  function e(n) {
    if (Array.isArray(n)) {
      for (var r = 0; r < n.length; r++)
        n[r] = $o(n[r]);
      return n;
    }
    return $o(n);
  }
  function t(n, r, a) {
    if (r.indexOf("--") === 0)
      return n;
    var o = wh(r);
    return r === o ? n : (a.prop(o, n), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: t
  };
}
var Q = Nu && CSS ? CSS.px : "px", Ga = Nu && CSS ? CSS.ms : "ms", Dn = Nu && CSS ? CSS.percent : "%", G1 = {
  // Animation properties
  "animation-delay": Ga,
  "animation-duration": Ga,
  // Background properties
  "background-position": Q,
  "background-position-x": Q,
  "background-position-y": Q,
  "background-size": Q,
  // Border Properties
  border: Q,
  "border-bottom": Q,
  "border-bottom-left-radius": Q,
  "border-bottom-right-radius": Q,
  "border-bottom-width": Q,
  "border-left": Q,
  "border-left-width": Q,
  "border-radius": Q,
  "border-right": Q,
  "border-right-width": Q,
  "border-top": Q,
  "border-top-left-radius": Q,
  "border-top-right-radius": Q,
  "border-top-width": Q,
  "border-width": Q,
  "border-block": Q,
  "border-block-end": Q,
  "border-block-end-width": Q,
  "border-block-start": Q,
  "border-block-start-width": Q,
  "border-block-width": Q,
  "border-inline": Q,
  "border-inline-end": Q,
  "border-inline-end-width": Q,
  "border-inline-start": Q,
  "border-inline-start-width": Q,
  "border-inline-width": Q,
  "border-start-start-radius": Q,
  "border-start-end-radius": Q,
  "border-end-start-radius": Q,
  "border-end-end-radius": Q,
  // Margin properties
  margin: Q,
  "margin-bottom": Q,
  "margin-left": Q,
  "margin-right": Q,
  "margin-top": Q,
  "margin-block": Q,
  "margin-block-end": Q,
  "margin-block-start": Q,
  "margin-inline": Q,
  "margin-inline-end": Q,
  "margin-inline-start": Q,
  // Padding properties
  padding: Q,
  "padding-bottom": Q,
  "padding-left": Q,
  "padding-right": Q,
  "padding-top": Q,
  "padding-block": Q,
  "padding-block-end": Q,
  "padding-block-start": Q,
  "padding-inline": Q,
  "padding-inline-end": Q,
  "padding-inline-start": Q,
  // Mask properties
  "mask-position-x": Q,
  "mask-position-y": Q,
  "mask-size": Q,
  // Width and height properties
  height: Q,
  width: Q,
  "min-height": Q,
  "max-height": Q,
  "min-width": Q,
  "max-width": Q,
  // Position properties
  bottom: Q,
  left: Q,
  top: Q,
  right: Q,
  inset: Q,
  "inset-block": Q,
  "inset-block-end": Q,
  "inset-block-start": Q,
  "inset-inline": Q,
  "inset-inline-end": Q,
  "inset-inline-start": Q,
  // Shadow properties
  "box-shadow": Q,
  "text-shadow": Q,
  // Column properties
  "column-gap": Q,
  "column-rule": Q,
  "column-rule-width": Q,
  "column-width": Q,
  // Font and text properties
  "font-size": Q,
  "font-size-delta": Q,
  "letter-spacing": Q,
  "text-decoration-thickness": Q,
  "text-indent": Q,
  "text-stroke": Q,
  "text-stroke-width": Q,
  "word-spacing": Q,
  // Motion properties
  motion: Q,
  "motion-offset": Q,
  // Outline properties
  outline: Q,
  "outline-offset": Q,
  "outline-width": Q,
  // Perspective properties
  perspective: Q,
  "perspective-origin-x": Dn,
  "perspective-origin-y": Dn,
  // Transform properties
  "transform-origin": Dn,
  "transform-origin-x": Dn,
  "transform-origin-y": Dn,
  "transform-origin-z": Dn,
  // Transition properties
  "transition-delay": Ga,
  "transition-duration": Ga,
  // Alignment properties
  "vertical-align": Q,
  "flex-basis": Q,
  // Some random properties
  "shape-margin": Q,
  size: Q,
  gap: Q,
  // Grid properties
  grid: Q,
  "grid-gap": Q,
  "row-gap": Q,
  "grid-row-gap": Q,
  "grid-column-gap": Q,
  "grid-template-rows": Q,
  "grid-template-columns": Q,
  "grid-auto-rows": Q,
  "grid-auto-columns": Q,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": Q,
  "box-shadow-y": Q,
  "box-shadow-blur": Q,
  "box-shadow-spread": Q,
  "font-line-height": Q,
  "text-shadow-x": Q,
  "text-shadow-y": Q,
  "text-shadow-blur": Q
};
function Dh(e) {
  var t = /(-[a-z])/g, n = function(i) {
    return i[1].toUpperCase();
  }, r = {};
  for (var a in e)
    r[a] = e[a], r[a.replace(t, n)] = e[a];
  return r;
}
var Q1 = Dh(G1);
function wa(e, t, n) {
  if (t == null)
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      t[r] = wa(e, t[r], n);
  else if (typeof t == "object")
    if (e === "fallbacks")
      for (var a in t)
        t[a] = wa(a, t[a], n);
    else
      for (var o in t)
        t[o] = wa(e + "-" + o, t[o], n);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var i = n[e] || Q1[e];
    return i && !(t === 0 && i === Q) ? typeof i == "function" ? i(t).toString() : "" + t + i : t.toString();
  }
  return t;
}
function Z1(e) {
  e === void 0 && (e = {});
  var t = Dh(e);
  function n(a, o) {
    if (o.type !== "style")
      return a;
    for (var i in a)
      a[i] = wa(i, a[i], t);
    return a;
  }
  function r(a, o) {
    return wa(o, a, t);
  }
  return {
    onProcessStyle: n,
    onChangeValue: r
  };
}
function Hs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function J1(e) {
  if (Array.isArray(e))
    return Hs(e);
}
function ey(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ch(e, t) {
  if (e) {
    if (typeof e == "string")
      return Hs(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Hs(e, t);
  }
}
function ty() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ry(e) {
  return J1(e) || ey(e) || Ch(e) || ty();
}
var pa = "", Vs = "", Eh = "", xh = "", ny = Ya && "ontouchstart" in document.documentElement;
if (Ya) {
  var Hi = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, ay = document.createElement("p"), Vi = ay.style, oy = "Transform";
  for (var zi in Hi)
    if (zi + oy in Vi) {
      pa = zi, Vs = Hi[zi];
      break;
    }
  pa === "Webkit" && "msHyphens" in Vi && (pa = "ms", Vs = Hi.ms, xh = "edge"), pa === "Webkit" && "-apple-trailing-word" in Vi && (Eh = "apple");
}
var we = {
  js: pa,
  css: Vs,
  vendor: Eh,
  browser: xh,
  isTouch: ny
};
function iy(e) {
  return e[1] === "-" || we.js === "ms" ? e : "@" + we.css + "keyframes" + e.substr(10);
}
var sy = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : we.js === "ms" ? "-webkit-" + t : we.css + t;
  }
}, uy = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : we.js === "Webkit" ? we.css + "print-" + t : t;
  }
}, ly = /[-\s]+(.)?/g;
function cy(e, t) {
  return t ? t.toUpperCase() : "";
}
function Iu(e) {
  return e.replace(ly, cy);
}
function Rr(e) {
  return Iu("-" + e);
}
var dy = {
  noPrefill: ["mask"],
  supportedProperty: function(t, n) {
    if (!/^mask/.test(t))
      return !1;
    if (we.js === "Webkit") {
      var r = "mask-image";
      if (Iu(r) in n)
        return t;
      if (we.js + Rr(r) in n)
        return we.css + t;
    }
    return t;
  }
}, fy = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : we.vendor === "apple" && !we.isTouch ? we.css + t : t;
  }
}, py = {
  noPrefill: ["transform"],
  supportedProperty: function(t, n, r) {
    return t !== "transform" ? !1 : r.transform ? t : we.css + t;
  }
}, hy = {
  noPrefill: ["transition"],
  supportedProperty: function(t, n, r) {
    return t !== "transition" ? !1 : r.transition ? t : we.css + t;
  }
}, vy = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : we.js === "Webkit" || we.js === "ms" && we.browser !== "edge" ? we.css + t : t;
  }
}, my = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : we.js === "Moz" || we.js === "ms" || we.vendor === "apple" ? we.css + t : t;
  }
}, gy = {
  supportedProperty: function(t, n) {
    if (!/^break-/.test(t))
      return !1;
    if (we.js === "Webkit") {
      var r = "WebkitColumn" + Rr(t);
      return r in n ? we.css + "column-" + t : !1;
    }
    if (we.js === "Moz") {
      var a = "page" + Rr(t);
      return a in n ? "page-" + t : !1;
    }
    return !1;
  }
}, yy = {
  supportedProperty: function(t, n) {
    if (!/^(border|margin|padding)-inline/.test(t))
      return !1;
    if (we.js === "Moz")
      return t;
    var r = t.replace("-inline", "");
    return we.js + Rr(r) in n ? we.css + r : !1;
  }
}, by = {
  supportedProperty: function(t, n) {
    return Iu(t) in n ? t : !1;
  }
}, wy = {
  supportedProperty: function(t, n) {
    var r = Rr(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : we.js + r in n ? we.css + t : we.js !== "Webkit" && "Webkit" + r in n ? "-webkit-" + t : !1;
  }
}, Dy = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : we.js === "ms" ? "" + we.css + t : t;
  }
}, Cy = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : we.js === "ms" ? we.css + "scroll-chaining" : t;
  }
}, Ey = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, xy = {
  supportedProperty: function(t, n) {
    var r = Ey[t];
    return r && we.js + Rr(r) in n ? we.css + r : !1;
  }
}, Sh = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, Sy = Object.keys(Sh), $y = function(t) {
  return we.css + t;
}, ky = {
  supportedProperty: function(t, n, r) {
    var a = r.multiple;
    if (Sy.indexOf(t) > -1) {
      var o = Sh[t];
      if (!Array.isArray(o))
        return we.js + Rr(o) in n ? we.css + o : !1;
      if (!a)
        return !1;
      for (var i = 0; i < o.length; i++)
        if (!(we.js + Rr(o[0]) in n))
          return !1;
      return o.map($y);
    }
    return !1;
  }
}, $h = [sy, uy, dy, fy, py, hy, vy, my, gy, yy, by, wy, Dy, Cy, xy, ky], qc = $h.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), Oy = $h.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, t) {
  return e.push.apply(e, ry(t.noPrefill)), e;
}, []), ha, Ur = {};
if (Ya) {
  ha = document.createElement("p");
  var Ki = window.getComputedStyle(document.documentElement, "");
  for (var Ui in Ki)
    isNaN(Ui) || (Ur[Ki[Ui]] = Ki[Ui]);
  Oy.forEach(function(e) {
    return delete Ur[e];
  });
}
function zs(e, t) {
  if (t === void 0 && (t = {}), !ha)
    return e;
  if (process.env.NODE_ENV !== "benchmark" && Ur[e] != null)
    return Ur[e];
  (e === "transition" || e === "transform") && (t[e] = e in ha.style);
  for (var n = 0; n < qc.length && (Ur[e] = qc[n](e, ha.style, t), !Ur[e]); n++)
    ;
  try {
    ha.style[e] = "";
  } catch {
    return !1;
  }
  return Ur[e];
}
var Cn = {}, By = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, Ty = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, xr;
function Ay(e, t, n) {
  if (t === "var")
    return "var";
  if (t === "all")
    return "all";
  if (n === "all")
    return ", all";
  var r = t ? zs(t) : ", " + zs(n);
  return r || t || n;
}
Ya && (xr = document.createElement("p"));
function Xc(e, t) {
  var n = t;
  if (!xr || e === "content")
    return t;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var r = e + n;
  if (process.env.NODE_ENV !== "benchmark" && Cn[r] != null)
    return Cn[r];
  try {
    xr.style[e] = n;
  } catch {
    return Cn[r] = !1, !1;
  }
  if (By[e])
    n = n.replace(Ty, Ay);
  else if (xr.style[e] === "" && (n = we.css + n, n === "-ms-flex" && (xr.style[e] = "-ms-flexbox"), xr.style[e] = n, xr.style[e] === ""))
    return Cn[r] = !1, !1;
  return xr.style[e] = "", Cn[r] = n, Cn[r];
}
function Py() {
  function e(a) {
    if (a.type === "keyframes") {
      var o = a;
      o.at = iy(o.at);
    }
  }
  function t(a) {
    for (var o in a) {
      var i = a[o];
      if (o === "fallbacks" && Array.isArray(i)) {
        a[o] = i.map(t);
        continue;
      }
      var s = !1, u = zs(o);
      u && u !== o && (s = !0);
      var l = !1, c = Xc(u, Qr(i));
      c && c !== i && (l = !0), (s || l) && (s && delete a[o], a[u || o] = c || i);
    }
    return a;
  }
  function n(a, o) {
    return o.type !== "style" ? a : t(a);
  }
  function r(a, o) {
    return Xc(o, Qr(a)) || a;
  }
  return {
    onProcessRule: e,
    onProcessStyle: n,
    onChangeValue: r
  };
}
function My() {
  var e = function(n, r) {
    return n.length === r.length ? n > r ? 1 : -1 : n.length - r.length;
  };
  return {
    onProcessStyle: function(n, r) {
      if (r.type !== "style")
        return n;
      for (var a = {}, o = Object.keys(n).sort(e), i = 0; i < o.length; i++)
        a[o[i]] = n[o[i]];
      return a;
    }
  };
}
function kh() {
  return {
    plugins: [
      _1(),
      Y1(),
      z1(),
      X1(),
      Z1(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : Py(),
      My()
    ]
  };
}
function Oh() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.baseClasses, n = e.newClasses, r = e.Component;
  if (!n)
    return t;
  var a = ye({}, t);
  return process.env.NODE_ENV !== "production" && typeof n == "string" ? (console.error(["Material-UI: The value `".concat(n, "` ") + "provided to the classes prop of ".concat(ya(r), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(n).forEach(function(o) {
    process.env.NODE_ENV !== "production" && (!t[o] && n[o] && console.error(["Material-UI: The key `".concat(o, "` ") + "provided to the classes prop is not implemented in ".concat(ya(r), "."), "You can only override one of the following: ".concat(Object.keys(t).join(","), ".")].join(`
`)), n[o] && typeof n[o] != "string" && console.error(["Material-UI: The key `".concat(o, "` ") + "provided to the classes prop is not valid for ".concat(ya(r), "."), "You need to provide a non empty string instead of: ".concat(n[o], ".")].join(`
`))), n[o] && (a[o] = "".concat(t[o], " ").concat(n[o]));
  }), a);
}
var Fy = {
  set: function(t, n, r, a) {
    var o = t.get(n);
    o || (o = /* @__PURE__ */ new Map(), t.set(n, o)), o.set(r, a);
  },
  get: function(t, n, r) {
    var a = t.get(n);
    return a ? a.get(r) : void 0;
  },
  delete: function(t, n, r) {
    var a = t.get(n);
    a.delete(r);
  }
};
const Bn = Fy;
var Bh = d.createContext(null);
process.env.NODE_ENV !== "production" && (Bh.displayName = "ThemeContext");
const Ry = Bh;
function Th() {
  var e = d.useContext(Ry);
  return process.env.NODE_ENV !== "production" && d.useDebugValue(e), e;
}
var _y = _u(kh()), Ny = qg(), Iy = /* @__PURE__ */ new Map(), Ly = {
  disableGeneration: !1,
  generateClassName: Ny,
  jss: _y,
  sheetsCache: null,
  sheetsManager: Iy,
  sheetsRegistry: null
}, ko = d.createContext(Ly);
process.env.NODE_ENV !== "production" && (ko.displayName = "StylesContext");
var Qa;
function Ks(e) {
  var t = e.children, n = e.injectFirst, r = n === void 0 ? !1 : n, a = e.disableGeneration, o = a === void 0 ? !1 : a, i = nr(e, ["children", "injectFirst", "disableGeneration"]), s = d.useContext(ko), u = ye({}, s, {
    disableGeneration: o
  }, i);
  if (process.env.NODE_ENV !== "production" && typeof window > "u" && !u.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && u.jss.options.insertionPoint && r && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && r && i.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !u.jss.options.insertionPoint && r && typeof window < "u") {
    if (!Qa) {
      var l = document.head;
      Qa = document.createComment("mui-inject-first"), l.insertBefore(Qa, l.firstChild);
    }
    u.jss = _u({
      plugins: kh().plugins,
      insertionPoint: Qa
    });
  }
  return /* @__PURE__ */ d.createElement(ko.Provider, {
    value: u
  }, t);
}
process.env.NODE_ENV !== "production" && (Ks.propTypes = {
  /**
   * Your component tree.
   */
  children: rt.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: rt.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: rt.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: rt.bool,
  /**
   * JSS's instance.
   */
  jss: rt.object,
  /**
   * @ignore
   */
  serverGenerateClassName: rt.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: rt.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: rt.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: rt.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ks.propTypes = Pg(Ks.propTypes));
var qi = -1e9;
function jy() {
  return qi += 1, process.env.NODE_ENV !== "production" && qi >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), qi;
}
var Wy = {};
const Ah = Wy;
function Yy(e) {
  var t = typeof e == "function";
  return process.env.NODE_ENV !== "production" && ht(e) !== "object" && !t && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(r, a) {
      var o;
      try {
        o = t ? e(r) : e;
      } catch (u) {
        throw process.env.NODE_ENV !== "production" && t === !0 && r === Ah && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), u;
      }
      if (!a || !r.overrides || !r.overrides[a])
        return o;
      var i = r.overrides[a], s = ye({}, o);
      return Object.keys(i).forEach(function(u) {
        process.env.NODE_ENV !== "production" && (s[u] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(u, "` key of `theme.overrides.").concat(a, "`.")].join(`
`))), s[u] = In(s[u], i[u]);
      }), s;
    },
    options: {}
  };
}
function Hy(e, t, n) {
  var r = e.state, a = e.stylesOptions;
  if (a.disableGeneration)
    return t || {};
  r.cacheClasses || (r.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var o = !1;
  return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, o = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, o = !0), o && (r.cacheClasses.value = Oh({
    baseClasses: r.cacheClasses.lastJSS,
    newClasses: t,
    Component: n
  })), r.cacheClasses.value;
}
function Vy(e, t) {
  var n = e.state, r = e.theme, a = e.stylesOptions, o = e.stylesCreator, i = e.name;
  if (!a.disableGeneration) {
    var s = Bn.get(a.sheetsManager, o, r);
    s || (s = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, Bn.set(a.sheetsManager, o, r, s));
    var u = ye({}, o.options, a, {
      theme: r,
      flip: typeof a.flip == "boolean" ? a.flip : r.direction === "rtl"
    });
    u.generateId = u.serverGenerateClassName || u.generateClassName;
    var l = a.sheetsRegistry;
    if (s.refs === 0) {
      var c;
      a.sheetsCache && (c = Bn.get(a.sheetsCache, o, r));
      var f = o.create(r, i);
      c || (c = a.jss.createStyleSheet(f, ye({
        link: !1
      }, u)), c.attach(), a.sheetsCache && Bn.set(a.sheetsCache, o, r, c)), l && l.add(c), s.staticSheet = c, s.dynamicStyles = gh(f);
    }
    if (s.dynamicStyles) {
      var p = a.jss.createStyleSheet(s.dynamicStyles, ye({
        link: !0
      }, u));
      p.update(t), p.attach(), n.dynamicSheet = p, n.classes = Oh({
        baseClasses: s.staticSheet.classes,
        newClasses: p.classes
      }), l && l.add(p);
    } else
      n.classes = s.staticSheet.classes;
    s.refs += 1;
  }
}
function zy(e, t) {
  var n = e.state;
  n.dynamicSheet && n.dynamicSheet.update(t);
}
function Ky(e) {
  var t = e.state, n = e.theme, r = e.stylesOptions, a = e.stylesCreator;
  if (!r.disableGeneration) {
    var o = Bn.get(r.sheetsManager, a, n);
    o.refs -= 1;
    var i = r.sheetsRegistry;
    o.refs === 0 && (Bn.delete(r.sheetsManager, a, n), r.jss.removeStyleSheet(o.staticSheet), i && i.remove(o.staticSheet)), t.dynamicSheet && (r.jss.removeStyleSheet(t.dynamicSheet), i && i.remove(t.dynamicSheet));
  }
}
function Uy(e, t) {
  var n = d.useRef([]), r, a = d.useMemo(function() {
    return {};
  }, t);
  n.current !== a && (n.current = a, r = e()), d.useEffect(
    function() {
      return function() {
        r && r();
      };
    },
    [a]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function qy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.name, r = t.classNamePrefix, a = t.Component, o = t.defaultTheme, i = o === void 0 ? Ah : o, s = nr(t, ["name", "classNamePrefix", "Component", "defaultTheme"]), u = Yy(e), l = n || r || "makeStyles";
  u.options = {
    index: jy(),
    name: n,
    meta: l,
    classNamePrefix: l
  };
  var c = function() {
    var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, m = Th() || i, v = ye({}, d.useContext(ko), s), g = d.useRef(), h = d.useRef();
    Uy(function() {
      var S = {
        name: n,
        state: {},
        stylesCreator: u,
        stylesOptions: v,
        theme: m
      };
      return Vy(S, p), h.current = !1, g.current = S, function() {
        Ky(S);
      };
    }, [m, u]), d.useEffect(function() {
      h.current && zy(g.current, p), h.current = !0;
    });
    var w = Hy(g.current, p.classes, a);
    return process.env.NODE_ENV !== "production" && d.useDebugValue(w), w;
  };
  return c;
}
function $e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Lu = Wa(), Xy = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Gy = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Qy = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Ph = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ju = {};
ju[Lu.ForwardRef] = Qy;
ju[Lu.Memo] = Ph;
function Gc(e) {
  return Lu.isMemo(e) ? Ph : ju[e.$$typeof] || Xy;
}
var Zy = Object.defineProperty, Jy = Object.getOwnPropertyNames, Qc = Object.getOwnPropertySymbols, eb = Object.getOwnPropertyDescriptor, tb = Object.getPrototypeOf, Zc = Object.prototype;
function Mh(e, t, n) {
  if (typeof t != "string") {
    if (Zc) {
      var r = tb(t);
      r && r !== Zc && Mh(e, r, n);
    }
    var a = Jy(t);
    Qc && (a = a.concat(Qc(t)));
    for (var o = Gc(e), i = Gc(t), s = 0; s < a.length; ++s) {
      var u = a[s];
      if (!Gy[u] && !(n && n[u]) && !(i && i[u]) && !(o && o[u])) {
        var l = eb(t, u);
        try {
          Zy(e, u, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var rb = Mh;
const nb = /* @__PURE__ */ gr(rb);
var ab = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(r) {
    var a = n.defaultTheme, o = n.withTheme, i = o === void 0 ? !1 : o, s = n.name, u = nr(n, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && r === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var l = s;
    if (process.env.NODE_ENV !== "production" && !s) {
      var c = ya(r);
      c !== void 0 && (l = c);
    }
    var f = qy(t, ye({
      defaultTheme: a,
      Component: r,
      name: s || r.displayName,
      classNamePrefix: l
    }, u)), p = /* @__PURE__ */ d.forwardRef(function(v, g) {
      v.classes;
      var h = v.innerRef, w = nr(v, ["classes", "innerRef"]), S = f(ye({}, r.defaultProps, v)), x, O = w;
      return (typeof s == "string" || i) && (x = Th() || a, s && (O = Xg({
        theme: x,
        name: s,
        props: w
      })), i && !O.theme && (O.theme = x)), /* @__PURE__ */ d.createElement(r, ye({
        ref: h || g,
        classes: S
      }, O));
    });
    return process.env.NODE_ENV !== "production" && (p.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: rt.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: oh(rt.oneOfType([rt.func, rt.object]), function(m) {
        return m.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (p.displayName = "WithStyles(".concat(ya(r), ")")), nb(p, r), process.env.NODE_ENV !== "production" && (p.Naked = r, p.options = n, p.useStyles = f), p;
  };
}, Dr = ["xs", "sm", "md", "lg", "xl"];
function ob(e) {
  var t = e.values, n = t === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : t, r = e.unit, a = r === void 0 ? "px" : r, o = e.step, i = o === void 0 ? 5 : o, s = nr(e, ["values", "unit", "step"]);
  function u(v) {
    var g = typeof n[v] == "number" ? n[v] : v;
    return "@media (min-width:".concat(g).concat(a, ")");
  }
  function l(v) {
    var g = Dr.indexOf(v) + 1, h = n[Dr[g]];
    if (g === Dr.length)
      return u("xs");
    var w = typeof h == "number" && g > 0 ? h : v;
    return "@media (max-width:".concat(w - i / 100).concat(a, ")");
  }
  function c(v, g) {
    var h = Dr.indexOf(g);
    return h === Dr.length - 1 ? u(v) : "@media (min-width:".concat(typeof n[v] == "number" ? n[v] : v).concat(a, ") and ") + "(max-width:".concat((h !== -1 && typeof n[Dr[h + 1]] == "number" ? n[Dr[h + 1]] : g) - i / 100).concat(a, ")");
  }
  function f(v) {
    return c(v, v);
  }
  var p = !1;
  function m(v) {
    return process.env.NODE_ENV !== "production" && (p || (p = !0, console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join(`
`)))), n[v];
  }
  return ye({
    keys: Dr,
    values: n,
    up: u,
    down: l,
    between: c,
    only: f,
    width: m
  }, s);
}
function ib(e, t, n) {
  var r;
  return ye({
    gutters: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), ye({
        paddingLeft: t(2),
        paddingRight: t(2)
      }, o, le({}, e.up("sm"), ye({
        paddingLeft: t(3),
        paddingRight: t(3)
      }, o[e.up("sm")])));
    },
    toolbar: (r = {
      minHeight: 56
    }, le(r, "".concat(e.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), le(r, e.up("sm"), {
      minHeight: 64
    }), r)
  }, n);
}
var sb = {
  black: "#000",
  white: "#fff"
};
const Oo = sb;
var ub = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const Wu = ub;
var Xi = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, Gi = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, Qi = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Zi = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Ji = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, es = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function Fh(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error("Material-UI: The value provided ".concat(e, " is out of range [").concat(t, ", ").concat(n, "].")), Math.min(Math.max(t, e), n);
}
function lb(e) {
  e = e.substr(1);
  var t = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"), n = e.match(t);
  return n && n[0].length === 1 && (n = n.map(function(r) {
    return r + r;
  })), n ? "rgb".concat(n.length === 4 ? "a" : "", "(").concat(n.map(function(r, a) {
    return a < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function cb(e) {
  e = Ln(e);
  var t = e, n = t.values, r = n[0], a = n[1] / 100, o = n[2] / 100, i = a * Math.min(o, 1 - o), s = function(f) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (f + r / 30) % 12;
    return o - i * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  }, u = "rgb", l = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (u += "a", l.push(n[3])), Yu({
    type: u,
    values: l
  });
}
function Ln(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ln(lb(e));
  var t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(e, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : xo(3, e));
  var r = e.substring(t + 1, e.length - 1).split(",");
  return r = r.map(function(a) {
    return parseFloat(a);
  }), {
    type: n,
    values: r
  };
}
function Yu(e) {
  var t = e.type, n = e.values;
  return t.indexOf("rgb") !== -1 ? n = n.map(function(r, a) {
    return a < 3 ? parseInt(r, 10) : r;
  }) : t.indexOf("hsl") !== -1 && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(t, "(").concat(n.join(", "), ")");
}
function Jc(e, t) {
  var n = ed(e), r = ed(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function ed(e) {
  e = Ln(e);
  var t = e.type === "hsl" ? Ln(cb(e)).values : e.values;
  return t = t.map(function(n) {
    return n /= 255, n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function db(e, t) {
  if (e = Ln(e), t = Fh(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Yu(e);
}
function fb(e, t) {
  if (e = Ln(e), t = Fh(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  return Yu(e);
}
var td = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Oo.white,
    default: Wu[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, ts = {
  text: {
    primary: Oo.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: Wu[800],
    default: "#303030"
  },
  action: {
    active: Oo.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function rd(e, t, n, r) {
  var a = r.light || r, o = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = fb(e.main, a) : t === "dark" && (e.dark = db(e.main, o)));
}
function pb(e) {
  var t = e.primary, n = t === void 0 ? {
    light: Xi[300],
    main: Xi[500],
    dark: Xi[700]
  } : t, r = e.secondary, a = r === void 0 ? {
    light: Gi.A200,
    main: Gi.A400,
    dark: Gi.A700
  } : r, o = e.error, i = o === void 0 ? {
    light: Qi[300],
    main: Qi[500],
    dark: Qi[700]
  } : o, s = e.warning, u = s === void 0 ? {
    light: Zi[300],
    main: Zi[500],
    dark: Zi[700]
  } : s, l = e.info, c = l === void 0 ? {
    light: Ji[300],
    main: Ji[500],
    dark: Ji[700]
  } : l, f = e.success, p = f === void 0 ? {
    light: es[300],
    main: es[500],
    dark: es[700]
  } : f, m = e.type, v = m === void 0 ? "light" : m, g = e.contrastThreshold, h = g === void 0 ? 3 : g, w = e.tonalOffset, S = w === void 0 ? 0.2 : w, x = nr(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function O(j) {
    var I = Jc(j, ts.text.primary) >= h ? ts.text.primary : td.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var N = Jc(j, I);
      N < 3 && console.error(["Material-UI: The contrast ratio of ".concat(N, ":1 for ").concat(I, " on ").concat(j), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return I;
  }
  var B = function(I) {
    var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (I = ye({}, I), !I.main && I[N] && (I.main = I[N]), !I.main)
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(N, "` property.") : xo(4, N));
    if (typeof I.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(I.main), `\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@material-ui/core/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`) : xo(5, JSON.stringify(I.main)));
    return rd(I, "light", q, S), rd(I, "dark", J, S), I.contrastText || (I.contrastText = O(I.main)), I;
  }, F = {
    dark: ts,
    light: td
  };
  process.env.NODE_ENV !== "production" && (F[v] || console.error("Material-UI: The palette type `".concat(v, "` is not supported.")));
  var L = In(ye({
    // A collection of common colors.
    common: Oo,
    // The palette type, can be light or dark.
    type: v,
    // The colors used to represent primary interface elements for a user.
    primary: B(n),
    // The colors used to represent secondary interface elements for a user.
    secondary: B(a, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: B(i),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: B(u),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: B(c),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: B(p),
    // The grey colors.
    grey: Wu,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: h,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: O,
    // Generate a rich color object.
    augmentColor: B,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: S
  }, F[v]), x);
  return L;
}
function Rh(e) {
  return Math.round(e * 1e5) / 1e5;
}
var nd = !1;
function hb(e) {
  return process.env.NODE_ENV !== "production" && (nd || (console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://mui.com/r/migration-v4/#theme for a migration path."].join(`
`)), nd = !0)), Rh(e);
}
var ad = {
  textTransform: "uppercase"
}, od = '"Roboto", "Helvetica", "Arial", sans-serif';
function vb(e, t) {
  var n = typeof t == "function" ? t(e) : t, r = n.fontFamily, a = r === void 0 ? od : r, o = n.fontSize, i = o === void 0 ? 14 : o, s = n.fontWeightLight, u = s === void 0 ? 300 : s, l = n.fontWeightRegular, c = l === void 0 ? 400 : l, f = n.fontWeightMedium, p = f === void 0 ? 500 : f, m = n.fontWeightBold, v = m === void 0 ? 700 : m, g = n.htmlFontSize, h = g === void 0 ? 16 : g, w = n.allVariants, S = n.pxToRem, x = nr(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof h != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var O = i / 14, B = S || function(j) {
    return "".concat(j / h * O, "rem");
  }, F = function(I, N, q, J, R) {
    return ye({
      fontFamily: a,
      fontWeight: I,
      fontSize: B(N),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: q
    }, a === od ? {
      letterSpacing: "".concat(Rh(J / N), "em")
    } : {}, R, w);
  }, L = {
    h1: F(u, 96, 1.167, -1.5),
    h2: F(u, 60, 1.2, -0.5),
    h3: F(c, 48, 1.167, 0),
    h4: F(c, 34, 1.235, 0.25),
    h5: F(c, 24, 1.334, 0),
    h6: F(p, 20, 1.6, 0.15),
    subtitle1: F(c, 16, 1.75, 0.15),
    subtitle2: F(p, 14, 1.57, 0.1),
    body1: F(c, 16, 1.5, 0.15),
    body2: F(c, 14, 1.43, 0.15),
    button: F(p, 14, 1.75, 0.4, ad),
    caption: F(c, 12, 1.66, 0.4),
    overline: F(c, 12, 2.66, 1, ad)
  };
  return In(ye({
    htmlFontSize: h,
    pxToRem: B,
    round: hb,
    // TODO v5: remove
    fontFamily: a,
    fontSize: i,
    fontWeightLight: u,
    fontWeightRegular: c,
    fontWeightMedium: p,
    fontWeightBold: v
  }, L), x, {
    clone: !1
    // No need to clone deep
  });
}
var mb = 0.2, gb = 0.14, yb = 0.12;
function ze() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(mb, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(gb, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(yb, ")")].join(",");
}
var bb = ["none", ze(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), ze(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), ze(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), ze(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), ze(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), ze(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), ze(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), ze(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), ze(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), ze(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), ze(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), ze(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), ze(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), ze(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), ze(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), ze(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), ze(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), ze(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), ze(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), ze(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), ze(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), ze(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), ze(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), ze(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const wb = bb;
var Db = {
  borderRadius: 4
};
const Cb = Db;
var Eb = process.env.NODE_ENV !== "production" ? rt.oneOfType([rt.number, rt.string, rt.object, rt.array]) : {};
const xb = Eb;
var Sb = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function $b(e) {
  var t = e.spacing || 8;
  return typeof t == "number" ? function(n) {
    return process.env.NODE_ENV !== "production" && typeof n != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(n, ".")), t * n;
  } : Array.isArray(t) ? function(n) {
    return process.env.NODE_ENV !== "production" && n > t.length - 1 && console.error(["Material-UI: The value provided (".concat(n, ") overflows."), "The supported values are: ".concat(JSON.stringify(t), "."), "".concat(n, " > ").concat(t.length - 1, ", you need to add the missing values.")].join(`
`)), t[n];
  } : typeof t == "function" ? t : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(t, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
process.env.NODE_ENV !== "production" && Sb.reduce(function(e, t) {
  return e[t] = xb, e;
}, {});
var id;
function kb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (e.mui)
    return e;
  var t = $b({
    spacing: e
  }), n = function() {
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(o.length))), o.length === 0 ? t(1) : o.length === 1 ? t(o[0]) : o.map(function(s) {
      if (typeof s == "string")
        return s;
      var u = t(s);
      return typeof u == "number" ? "".concat(u, "px") : u;
    }).join(" ");
  };
  return Object.defineProperty(n, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!id || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), id = !0), e;
    }
  }), n.mui = !0, n;
}
var sd = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, ud = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ld(e) {
  return "".concat(Math.round(e), "ms");
}
const Ob = {
  easing: sd,
  duration: ud,
  create: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.duration, a = r === void 0 ? ud.standard : r, o = n.easing, i = o === void 0 ? sd.easeInOut : o, s = n.delay, u = s === void 0 ? 0 : s, l = nr(n, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var c = function(m) {
        return typeof m == "string";
      }, f = function(m) {
        return !isNaN(parseFloat(m));
      };
      !c(t) && !Array.isArray(t) && console.error('Material-UI: Argument "props" must be a string or Array.'), !f(a) && !c(a) && console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(a, ".")), c(i) || console.error('Material-UI: Argument "easing" must be a string.'), !f(u) && !c(u) && console.error('Material-UI: Argument "delay" must be a number or a string.'), Object.keys(l).length !== 0 && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(l).join(","), "]."));
    }
    return (Array.isArray(t) ? t : [t]).map(function(p) {
      return "".concat(p, " ").concat(typeof a == "string" ? a : ld(a), " ").concat(i, " ").concat(typeof u == "string" ? u : ld(u));
    }).join(",");
  },
  getAutoHeightDuration: function(t) {
    if (!t)
      return 0;
    var n = t / 36;
    return Math.round((4 + 15 * Math.pow(n, 0.25) + n / 5) * 10);
  }
};
var Bb = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const Tb = Bb;
function Ab() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.breakpoints, n = t === void 0 ? {} : t, r = e.mixins, a = r === void 0 ? {} : r, o = e.palette, i = o === void 0 ? {} : o, s = e.spacing, u = e.typography, l = u === void 0 ? {} : u, c = nr(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), f = pb(i), p = ob(n), m = kb(s), v = In({
    breakpoints: p,
    direction: "ltr",
    mixins: ib(p, m, a),
    overrides: {},
    // Inject custom styles
    palette: f,
    props: {},
    // Provide default props
    shadows: wb,
    typography: vb(f, l),
    spacing: m,
    shape: Cb,
    transitions: Ob,
    zIndex: Tb
  }, c), g = arguments.length, h = new Array(g > 1 ? g - 1 : 0), w = 1; w < g; w++)
    h[w - 1] = arguments[w];
  if (v = h.reduce(function(O, B) {
    return In(O, B);
  }, v), process.env.NODE_ENV !== "production") {
    var S = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], x = function O(B, F) {
      var L = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, j;
      for (j in B) {
        var I = B[j];
        L === 1 ? j.indexOf("Mui") === 0 && I && O(I, j, L + 1) : S.indexOf(j) !== -1 && Object.keys(I).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `".concat(F, "` component increases ") + "the CSS specificity of the `".concat(j, "` internal state."), "You can not override it like this: ", JSON.stringify(B, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: le({}, "&$".concat(j), I)
        }, null, 2), "", "https://mui.com/r/pseudo-classes-guide"].join(`
`)), B[j] = {});
      }
    };
    x(v.overrides);
  }
  return v;
}
var Pb = Ab();
const Mb = Pb;
function Fb(e, t) {
  return ab(e, ye({
    defaultTheme: Mb
  }, t));
}
var Rb = function(t) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: t.typography.pxToRem(24),
      transition: t.transitions.create("fill", {
        duration: t.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: t.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: t.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: t.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: t.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: t.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: t.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: t.typography.pxToRem(35)
    }
  };
}, Hu = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r = t.children, a = t.classes, o = t.className, i = t.color, s = i === void 0 ? "inherit" : i, u = t.component, l = u === void 0 ? "svg" : u, c = t.fontSize, f = c === void 0 ? "medium" : c, p = t.htmlColor, m = t.titleAccess, v = t.viewBox, g = v === void 0 ? "0 0 24 24" : v, h = nr(t, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ U.createElement(l, ye({
    className: Vg(a.root, o, s !== "inherit" && a["color".concat(Fs(s))], f !== "default" && f !== "medium" && a["fontSize".concat(Fs(f))]),
    focusable: "false",
    viewBox: g,
    color: p,
    "aria-hidden": m ? void 0 : !0,
    role: m ? "img" : void 0,
    ref: n
  }, h), r, m ? /* @__PURE__ */ U.createElement("title", null, m) : null);
});
process.env.NODE_ENV !== "production" && (Hu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: Ut.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: Ut.object,
  /**
   * @ignore
   */
  className: Ut.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: Ut.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Ut.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: oh(Ut.oneOf(["default", "inherit", "large", "medium", "small"]), function(e) {
    var t = e.fontSize;
    if (t === "default")
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: Ut.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: Ut.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: Ut.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: Ut.string
});
Hu.muiName = "SvgIcon";
const cd = Fb(Rb, {
  name: "MuiSvgIcon"
})(Hu);
function _b(e, t) {
  var n = function(a, o) {
    return /* @__PURE__ */ d.createElement(cd, ye({
      ref: o
    }, a), e);
  };
  return process.env.NODE_ENV !== "production" && (n.displayName = "".concat(t, "Icon")), n.muiName = cd.muiName, /* @__PURE__ */ d.memo(/* @__PURE__ */ d.forwardRef(n));
}
function Nb(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, n;
  function r() {
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    var s = this, u = function() {
      e.apply(s, o);
    };
    clearTimeout(n), n = setTimeout(u, t);
  }
  return r.clear = function() {
    clearTimeout(n);
  }, r;
}
function Ib(e, t) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function(n, r, a, o, i) {
    var s = a || "<<anonymous>>", u = i || r;
    return typeof n[r] < "u" ? new Error("The ".concat(o, " `").concat(u, "` of ") + "`".concat(s, "` is deprecated. ").concat(t)) : null;
  };
}
function Lb(e, t) {
  return /* @__PURE__ */ U.isValidElement(e) && t.indexOf(e.type.muiName) !== -1;
}
function _h(e) {
  return e && e.ownerDocument || document;
}
function jb(e) {
  var t = _h(e);
  return t.defaultView || window;
}
function Wb(e) {
  if (process.env.NODE_ENV === "production")
    return function() {
      return null;
    };
  var t = function(r) {
    return function(a, o, i, s, u) {
      var l = u || o;
      return typeof a[o] < "u" && !a[r] ? new Error("The prop `".concat(l, "` of ") + "`".concat(e, "` must be used on `").concat(r, "`.")) : null;
    };
  };
  return t;
}
function Us(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Yb(e, t, n, r, a) {
  if (process.env.NODE_ENV === "production")
    return null;
  var o = a || t;
  return typeof e[t] < "u" ? new Error("The prop `".concat(o, "` is not supported. Please remove it.")) : null;
}
function Hb(e) {
  var t = e.controlled, n = e.default, r = e.name, a = e.state, o = a === void 0 ? "value" : a, i = U.useRef(t !== void 0), s = i.current, u = U.useState(n), l = u[0], c = u[1], f = s ? t : l;
  if (process.env.NODE_ENV !== "production") {
    U.useEffect(function() {
      s !== (t !== void 0) && console.error(["Material-UI: A component is changing the ".concat(s ? "" : "un", "controlled ").concat(o, " state of ").concat(r, " to be ").concat(s ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(r, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [t]);
    var p = U.useRef(n), m = p.current;
    U.useEffect(function() {
      !s && m !== n && console.error(["Material-UI: A component is changing the default ".concat(o, " state of an uncontrolled ").concat(r, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(r, ".")].join(`
`));
    }, [JSON.stringify(n)]);
  }
  var v = U.useCallback(function(g) {
    s || c(g);
  }, []);
  return [f, v];
}
var Vb = typeof window < "u" ? U.useLayoutEffect : U.useEffect;
function zb(e) {
  var t = U.useRef(e);
  return Vb(function() {
    t.current = e;
  }), U.useCallback(function() {
    return t.current.apply(void 0, arguments);
  }, []);
}
function Kb(e, t) {
  return U.useMemo(function() {
    return e == null && t == null ? null : function(n) {
      Us(e, n), Us(t, n);
    };
  }, [e, t]);
}
function Ub(e) {
  var t = U.useState(e), n = t[0], r = t[1], a = e || n;
  return U.useEffect(function() {
    n == null && r("mui-".concat(Math.round(Math.random() * 1e5)));
  }, [n]), a;
}
var si = !0, qs = !1, dd = null, qb = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Xb(e) {
  var t = e.type, n = e.tagName;
  return !!(n === "INPUT" && qb[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Gb(e) {
  e.metaKey || e.altKey || e.ctrlKey || (si = !0);
}
function rs() {
  si = !1;
}
function Qb() {
  this.visibilityState === "hidden" && qs && (si = !0);
}
function Zb(e) {
  e.addEventListener("keydown", Gb, !0), e.addEventListener("mousedown", rs, !0), e.addEventListener("pointerdown", rs, !0), e.addEventListener("touchstart", rs, !0), e.addEventListener("visibilitychange", Qb, !0);
}
function fd(e) {
  var t = e.target;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return si || Xb(t);
}
function Jb() {
  qs = !0, window.clearTimeout(dd), dd = window.setTimeout(function() {
    qs = !1;
  }, 100);
}
function ew() {
  var e = U.useCallback(function(t) {
    var n = zp.findDOMNode(t);
    n != null && Zb(n.ownerDocument);
  }, []);
  return process.env.NODE_ENV !== "production" && U.useDebugValue(fd), {
    isFocusVisible: fd,
    onBlurVisible: Jb,
    ref: e
  };
}
const tw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Fs,
  createChainedFunction: Ng,
  createSvgIcon: _b,
  debounce: Nb,
  deprecatedPropType: Ib,
  isMuiElement: Lb,
  ownerDocument: _h,
  ownerWindow: jb,
  requirePropFactory: Wb,
  setRef: Us,
  unstable_useId: Ub,
  unsupportedProp: Yb,
  useControlled: Hb,
  useEventCallback: zb,
  useForkRef: Kb,
  useIsFocusVisible: ew
}, Symbol.toStringTag, { value: "Module" })), rw = /* @__PURE__ */ wg(tw);
var pd;
function He() {
  return pd || (pd = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = rw;
  }($i)), $i;
}
var nw = We, aw = Ye;
Object.defineProperty(Au, "__esModule", {
  value: !0
});
var _r = Au.default = void 0, ow = aw(d), iw = nw(He()), sw = (0, iw.default)(/* @__PURE__ */ ow.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
_r = Au.default = sw;
const Ct = _`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.5;
  color: ${y.grey900};
  margin: 0;
  padding: 0;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`, Nh = _`
  ${Ct};
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.5rem;

  @media (${Fe.smallMax}) {
    font-size: 1.5rem;
    line-height: 1.875rem;
  }
`, uw = D.h1`
  ${Nh};
`, Ih = _`
  ${Ct};
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;

  @media (${Fe.smallMax}) {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
`, TP = D.h2`
  ${Ih};
`, Lh = _`
  ${Ct};
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.75rem;

  @media (${Fe.smallMax}) {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
`, Vu = D.h3`
  ${Lh};
`, jh = _`
  ${Ct};
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;

  @media (${Fe.smallMax}) {
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
`, zu = D.h4`
  ${jh};
`, Wh = _`
  ${Ct};
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  @media (${Fe.smallMax}) {
    font-size: 0.75rem;
    line-height: 1rem;
  }
`, Ku = D.h5`
  ${Wh}
`, ui = {
  Heading1: Nh,
  Heading2: Ih,
  Heading3: Lh,
  Heading4: jh,
  Heading5: Wh
}, Yh = D.h2`
  ${Ct};
  color: ${y.grey500};
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 600;
`, lw = D.p`
  ${Ct};
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.25rem;
`, Uu = D.span`
  ${Ct};
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 0;
  white-space: nowrap;
  text-align: left;
`, li = D.h6`
  ${Ct};
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.25rem;
`, hn = D.p`
  ${Ct};
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${y.grey700};
`, Hh = _`
  ${Ct};
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
  padding: 0;
  font-weight: 400;
`, Vh = D.p`
  ${Hh};
`, zh = _`
  ${Ct};
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0;
  padding: 0;
  font-weight: 400;
`, ci = D.p`
  ${zh};
`, vn = {
  Body1: Hh,
  Body2: zh
}, cw = D.div`
  background-color: ${y.white};
  border-radius: 0.5rem;
  position: relative;

  &:focus {
    outline: none;
  }
`, Kh = cw, dw = D.div`
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  outline: 0;
`, Uh = dw, fw = D.span`
  position: fixed;
  top: ${({ top: e, placementTop: t }) => `calc(${e}px ${t ? `- ${k.XS}` : `+ ${k.XS}`})`};
  ${({ left: e }) => e && _`
      left: ${e}px;
    `};
  ${({ right: e }) => e ? _`
          right: ${e}px;
        ` : _`
          margin-right: ${k.M};
        `}
  z-index: 1000000; /* higher than modals */
  background-color: ${y.grey800};
  color: ${y.white};
  padding: ${k.XS} ${k.M};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  white-space: pre-line;
  hyphens: auto;
`, pw = ({ parentRef: e, placementTop: t, className: n, ...r }) => {
  const [a, o] = Ne(void 0), [i, s] = Ne(), [u, l] = Ne(0), c = ve(null), { tooltipProps: f } = j0(r);
  return Oa(() => {
    if (e != null && e.current && (c != null && c.current)) {
      const { right: p } = e.current.getBoundingClientRect();
      window.innerWidth - p < 128 ? (s(window.innerWidth - p), o(void 0)) : (s(void 0), o(e.current.getBoundingClientRect().x)), l(
        t ? e.current.getBoundingClientRect().y - c.current.getBoundingClientRect().height : e.current.getBoundingClientRect().y + e.current.getBoundingClientRect().height
      );
    }
  }, [e, e == null ? void 0 : e.current]), /* @__PURE__ */ d.createElement(ku, null, /* @__PURE__ */ d.createElement(
    fw,
    {
      top: u,
      left: a,
      right: i,
      placementTop: t,
      className: n,
      ref: c,
      ...xe(r, f)
    },
    r.children
  ));
}, At = pw, hw = (e) => new DOMParser().parseFromString(e, "text/html").documentElement.textContent || "", vw = hw, mw = D(At)`
  display: flex;
  align-items: center;
`, gw = ({
  showTooltip: e,
  tooltipParentRef: t,
  tooltipProps: n,
  tooltipText: r,
  htmlContent: a,
  className: o
}) => e ? /* @__PURE__ */ d.createElement(mw, { parentRef: t, ...n, className: o }, a || /* @__PURE__ */ d.createElement("span", null, vw(r))) : null, yw = ({
  onlyShowIfOverflow: e
}) => {
  const t = ve(null), n = Tt({}), { triggerProps: r, tooltipProps: a } = Bt({}, n, t);
  delete r.onClick, delete r.onMouseDown, delete r.onPointerDown, delete r.onKeyDown;
  let o = n.isOpen;
  return e && (!n.isOpen || !t.current || !t.current ? o = !1 : o = t.current.offsetWidth < t.current.scrollWidth), { tooltipParentRef: t, showTooltip: o, tooltipProps: a, triggerProps: r };
}, ir = _`
  box-shadow: 0px 0px 0.3125rem rgba(0, 0, 0, 0.15);
`, bw = _`
  box-shadow: 0px 0px 0.5rem rgba(0, 0, 0, 0.25);
`, qu = _`
  box-shadow: inset 0rem -0.25rem 0rem rgba(0, 0, 0, 0.25);
`, Xu = _`
  box-shadow: inset 0rem -0.125rem 0rem rgba(0, 0, 0, 0.1);
`, ww = _`
  box-shadow: inset 0rem -0.25rem 0rem rgba(255, 255, 255, 0.3);
`, AP = _`
  box-shadow: inset 0rem -0.125rem 0rem rgba(255, 255, 255, 0.4);
`, Dw = _`
  background-color: ${y.grey100};
  color: ${y.black};

  ${qu};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.grey200};
    `
)};

  &:hover {
    background-color: ${y.grey200};
  }

  &:active {
    background-color: ${y.grey300};
  }
`, Cw = _`
  background-color: ${y.frenchBlue};
  color: ${y.white};

  ${qu};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.yaleBlue};
    `
)};

  &:hover {
    background-color: ${y.yaleBlue};
  }

  &:active {
    background-color: ${y.midnightBlue};
  }
`, Ew = _`
  background-color: transparent;
  color: ${y.black};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // &:focus with keyboard
  e && t && _`
      color: ${y.black} !important; /* To override theme color set in contex */
      background-color: ${y.grey200};
    `
)};

  &:hover {
    color: ${y.black} !important; /* To override theme color set in contex */
    background-color: ${y.grey200};
  }

  &:active {
    color: ${y.black} !important; /* To override theme color set in contex */
    background-color: ${y.grey300};
  }

  > svg {
    margin-bottom: 0;
  }

  ${({ isDisabled: e }) => e && _`
      background-color: transparent !important; /* To override default background color of disabled buttons */
    `}
`, xw = _`
  background-color: ${y.black};
  color: ${y.white};

  ${ww};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // &:focus with keyboard
  e && t && _`
      background-color: ${y.grey800};
    `
)};

  &:hover {
    background-color: ${y.grey800};
  }

  &:active {
    background-color: ${y.grey700};
  }
`, Sw = D.button`
  padding: 0;
  ${({ isSmall: e, isText: t }) => t ? _`
          height: ${e ? "2rem" : "2.5rem"};
          padding: ${e ? `0 ${k.S}` : `0 ${k.M}`};
          max-width: 100%;
        ` : _`
          height: ${e ? "2rem" : "2.5rem"};
          width: ${e ? "2rem" : "2.5rem"};
        `};

  border-radius: 1.25rem;
  margin: 0;
  cursor: pointer;
  border: none;

  flex-shrink: 0;

  white-space: nowrap;
  position: relative;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${({ isSmall: e, color: t, isActive: n }) => (n || !e && t === "blue") && _`
      outline-offset: ${k.XXS};
    `};

  ${tt};

  > svg {
    color: inherit;
    fill: currentColor;
    margin-bottom: 0.125rem;
    font-size: 1.5rem;
    height: 1.5rem;
    width: 1.5rem;
  }
  ${({ variant: e }) => {
  switch (e) {
    case "active":
      return xw;
    case "blue":
      return Cw;
    case "small":
      return Ew;
    case "grey":
    default:
      return Dw;
  }
}};

  ${pn};
`, $w = D(or)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: ${k.XS};
  margin-bottom: 0.125rem;

  ${({ isSmall: e }) => e && _`
      font-size: 0.75rem;
    `};
`, kw = ({
  icon: e,
  text: t,
  isActive: n,
  isSmall: r,
  buttonRef: a,
  color: o = "grey",
  tooltipPlacementTop: i = !1,
  ...s
}) => {
  const u = ve(null), l = a || u, c = Tt({}), { triggerProps: f, tooltipProps: p } = Bt({}, c, l);
  delete f.onKeyDown, delete f.onKeyUp, Fp();
  const m = n ? "active" : r ? "small" : o;
  return /* @__PURE__ */ d.createElement(Lr, { ...s, buttonRef: l }, (v) => /* @__PURE__ */ d.createElement(
    Sw,
    {
      ...xe(s, v, f),
      isText: !!t,
      variant: m,
      isSmall: r,
      isActive: n,
      color: o,
      onClick: (g) => {
        s.onClick && (g.preventDefault(), g.stopPropagation(), s.onClick(g));
      },
      onKeyDown: (g) => {
        g.key === "Enter" && s.onClick && g.stopPropagation();
      }
    },
    e,
    t && /* @__PURE__ */ d.createElement($w, { isSmall: r }, t),
    c.isOpen && /* @__PURE__ */ d.createElement(At, { parentRef: l, ...p, placementTop: i }, s["aria-label"])
  ));
}, pr = kw, Ow = ({ className: e }) => /* @__PURE__ */ d.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: e
  },
  /* @__PURE__ */ d.createElement("path", { d: "M3.585 5.8L1 8.31174L12 19L23 8.31174L20.415 5.8L12 13.9587L3.585 5.8Z" })
), mn = Ow, Bw = (e) => `${e}rem`, Bo = 8, Tw = D(Kh)`
  width: 77rem;
  max-width: calc(100% - ${k.XXXXXL});
  margin: ${k.XXXXL} 0;
  padding: ${k.XL} ${k.L} ${k.L};

  @media (${Fe.mediumMax}) {
    margin: ${k.XXL} 0;
    width: calc(100% - ${k.XXXXXL});
  }

  @media (${Fe.smallMax}) {
    width: 100vw;
    max-width: unset;
    padding: ${k.S} ${k.S};
    margin: ${k.M} 0;
  }
`, Aw = D(bg)`
  margin: 0 -${k.XXS} ${k.XS};

  && > svg {
    width: 14px;
    height: 14px;
    margin-right: ${k.S};
  }
`, Pw = D.header`
  width: 100%;
  ${({ isScrolled: e }) => e && _`
      position: sticky;
      /* Use headerScrollOffset to overflow the viewport and pad the header height
       * to get a the same height and a smooth transition with smaller text when sticky.
       * We need to overflow the viewport to not get a jittery transition to the sticky header.
      */
      top: -${Bo}px;
      padding-top: calc(${Bo}px + ${k.S});
    `};
  background-color: ${y.white};
  z-index: 10;
`, Mw = D.div`
  display: flex;
  justify-content: space-between;
  /* Constrain the height of this content slot to the height of the headings in the two different states*/
  height: ${({ height: e }) => e};
`, Fw = D(pr)`
  margin: 0 0 0 ${k.M};
  align-self: top;
`, Rw = D.div`
  flex: 2 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`, _w = D(Yh)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  display: inline-block;
  flex-shrink: 0;
`, Nw = D(Yh)`
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 0;
`, Iw = D(Vu)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`, Lw = D(zu)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  margin-bottom: ${k.XXS};
`, jw = D.div`
  flex: 1 1 auto;
  max-width: 50%;
  height: 100%;
`, Ww = D.div`
  width: 100%;
`, Yw = D.div``, Hw = D(mn)`
  transform: rotate(90deg);
`, Vw = ({
  heading: e,
  subheading: t,
  contentSlot1: n,
  contentSlot2: r,
  contentSlot3: a,
  scrollElementRef: o,
  navigationProps: i,
  className: s,
  hasModalOnTop: u,
  ...l
}) => {
  const c = ve(null), f = o || c, p = ve(!1), { overlayProps: m } = dn({ ...l, isOpen: !u }, f), v = ve(null), [g, h] = Ne(!1);
  Rp();
  const { modalProps: w } = Ou(), { dialogProps: S, titleProps: x } = Bu(l, f), O = () => {
    v != null && v.current && (v.current.getBoundingClientRect().y <= -Bo ? h(!0) : v.current.getBoundingClientRect().y > -Bo && h(!1));
  };
  je(() => {
    if (f != null && f.current) {
      const J = f.current;
      return J.addEventListener("scroll", O, !1), () => J.removeEventListener("scroll", O, !1);
    }
    return () => null;
  }, []);
  const I = Bw(
    3 + (t ? 1.25 : 0) + (i != null && i.hasNavigated ? 2 : 0) - (g ? 1.25 : 0)
  ), { onClose: N, isDismissable: q } = l;
  return /* @__PURE__ */ d.createElement(ku, null, /* @__PURE__ */ d.createElement(fn, { contain: !u, restoreFocus: !0 }, /* @__PURE__ */ d.createElement(
    Uh,
    {
      ref: f,
      ...xe(m, w, S),
      onClick: () => {
        !p.current && q && N();
      },
      onPointerDown: () => {
        p.current = !1;
      },
      className: s
    },
    /* @__PURE__ */ d.createElement(
      Tw,
      {
        onClick: (J) => J.stopPropagation(),
        onPointerDown: (J) => {
          p.current = !0, J.stopPropagation();
        }
      },
      /* @__PURE__ */ d.createElement(Pw, { ref: v, isScrolled: g }, /* @__PURE__ */ d.createElement(Mw, { height: I }, /* @__PURE__ */ d.createElement(Rw, null, (i == null ? void 0 : i.hasNavigated) && /* @__PURE__ */ d.createElement(
        Aw,
        {
          color: "black",
          icon: /* @__PURE__ */ d.createElement(Hw, null),
          onClick: i == null ? void 0 : i.navigateBackCallback,
          "aria-label": "Gå tillbaka"
        },
        i == null ? void 0 : i.backButtonText
      ), g ? /* @__PURE__ */ d.createElement(d.Fragment, null, t && /* @__PURE__ */ d.createElement(Nw, { as: "h3" }, t), /* @__PURE__ */ d.createElement(Lw, { ...x }, e)) : /* @__PURE__ */ d.createElement(d.Fragment, null, t && /* @__PURE__ */ d.createElement(_w, { as: "h3" }, t), /* @__PURE__ */ d.createElement(Iw, { ...x }, e))), /* @__PURE__ */ d.createElement(jw, null, n), /* @__PURE__ */ d.createElement(Fw, { "aria-label": "Stäng", isSmall: !0, icon: /* @__PURE__ */ d.createElement(_r, null), onClick: N })), /* @__PURE__ */ d.createElement(Ww, null, r)),
      /* @__PURE__ */ d.createElement(Yw, null, a)
    )
  )));
}, PP = Vw, zw = D(Kh)`
  width: calc(100% - ${k.L});
  max-width: 40rem;
  margin: ${k.XXXXL} ${k.S};

  @media (${Fe.smallMax}) {
    margin: ${k.XXXXL} ${k.XS};
  }
`, Kw = D.div`
  padding: ${k.XL} ${k.L} ${k.XL} ${k.L};

  @media (${Fe.smallMax}) {
    padding: ${k.M} ${k.M} ${k.XL} ${k.M};
  }
`, Uw = D.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${k.M};

  position: relative;
`, qw = D(Vu)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`, Xw = D.div`
  flex: 1 0 auto;
`, Gw = D.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;

  &::before {
    content: '';
    display: block;
    height: 0;
    width: 0;
    padding-bottom: 33%; /* fallback for older browsers */
    padding-bottom: clamp(7.5rem, 33%, 12.5rem);
  }
`, Qw = D.img`
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`, Zw = D(pr)`
  margin-left: ${k.M};
`, Jw = D(pr)`
  position: absolute;
  top: ${k.M};
  right: ${k.M};
`, eD = ({
  heading: e,
  scrollElementRef: t,
  imgSrc: n,
  className: r,
  ...a
}) => {
  const o = ve(null), i = t || o, s = ve(!1), { overlayProps: u } = dn({ ...a, isOpen: !0 }, i);
  Rp();
  const { modalProps: l } = Ou(), { dialogProps: c, titleProps: f } = Bu(a, i), { children: p, onClose: m, isDismissable: v } = a;
  return /* @__PURE__ */ d.createElement(ku, null, /* @__PURE__ */ d.createElement(fn, { contain: !0, restoreFocus: !0 }, /* @__PURE__ */ d.createElement(
    Uh,
    {
      ...xe(u, c, l),
      ref: i,
      onClick: () => {
        !s.current && v && m();
      },
      onPointerDown: () => {
        s.current = !1;
      },
      className: r
    },
    /* @__PURE__ */ d.createElement(
      zw,
      {
        onClick: (g) => g.stopPropagation(),
        onPointerDown: (g) => {
          s.current = !0, g.stopPropagation();
        }
      },
      n && /* @__PURE__ */ d.createElement(Gw, null, /* @__PURE__ */ d.createElement(Qw, { src: n }), /* @__PURE__ */ d.createElement(Jw, { "aria-label": "Stäng", icon: /* @__PURE__ */ d.createElement(_r, null), onClick: m })),
      /* @__PURE__ */ d.createElement(Kw, null, /* @__PURE__ */ d.createElement(Uw, null, /* @__PURE__ */ d.createElement(qw, { ...f }, e), !n && /* @__PURE__ */ d.createElement(Zw, { "aria-label": "Stäng", icon: /* @__PURE__ */ d.createElement(_r, null), onClick: m, isSmall: !0 })), /* @__PURE__ */ d.createElement(Xw, null, p))
    )
  )));
}, tD = eD, rD = ({ ref: e, alignRight: t, padding: n = 8, isOpen: r }) => {
  const a = ve(void 0), o = (u) => {
    u.style.right = "unset", u.style.left = "0";
  }, i = (u) => {
    u.style.right = "0", u.style.left = "unset";
  }, s = () => {
    var l;
    const u = e == null ? void 0 : e.current;
    if (u) {
      if (!t) {
        const { left: p, width: m } = u.getBoundingClientRect();
        window.innerWidth - p < m ? (a.current || (a.current = window.innerWidth), i(u)) : a.current && window.innerWidth >= a.current && o(u);
      }
      const { right: c, width: f } = u.getBoundingClientRect();
      if (c < f) {
        const p = ((l = u.parentElement) == null ? void 0 : l.getBoundingClientRect().left) || 0;
        a.current || (a.current = window.innerWidth), u.style.maxWidth = `${window.innerWidth - n * 2}px`, u.style.right = "unset", u.style.left = `-${p - n}px`;
      }
    }
  };
  Oa(() => {
    s();
  }, [r]), Oa(() => (window.addEventListener("resize", s), () => window.removeEventListener("resize", s)), [s]);
}, Gu = rD;
var Qu = {}, nD = We, aD = Ye;
Object.defineProperty(Qu, "__esModule", {
  value: !0
});
var To = Qu.default = void 0, oD = aD(d), iD = nD(He()), sD = (0, iD.default)(/* @__PURE__ */ oD.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
To = Qu.default = sD;
const uD = D.li`
  list-style: none;

  color: ${({ isSelected: e }) => e ? y.frenchBlue : y.black};

  padding: ${k.S} ${k.S};
  margin: 0;
  height: ${({ isTextOnly: e }) => e ? "2.5rem" : "3.75rem"};
  white-space: nowrap;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  user-select: none;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ alignCheckIconRight: e }) => e ? "space-between" : "flex-start"};

  ${tt};
  transition: color 0.1s ease-out;
  border-radius: 0.25rem;

  > * {
    ${({ isSelected: e }) => e ? _`
            font-weight: 600;
          ` : _`
            font-weight: 400;
          `};
  }

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.grey100};
      outline-offset: -2px;
    `
)};

  &:hover {
    background-color: ${y.grey100};
  }

  &:active {
    background-color: ${y.grey300};
  }

  > svg {
    color: ${y.frenchBlue};
    ${({ alignCheckIconRight: e }) => e ? `margin-left: ${k.S};` : `margin-right: ${k.S};`};
  }
`, lD = D(or)`
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  line-height: 2.5rem;
  pointer-events: none;
`, cD = ({ item: e, state: t, alignRight: n }) => {
  var h, w;
  const r = d.useRef(null), a = d.useRef(null), o = t.disabledKeys.has(e.key), i = t.selectionManager.isSelected(e.key), { optionProps: s } = _p(
    {
      key: e.key,
      isDisabled: o,
      isSelected: i,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !1
    },
    t,
    r
  );
  s.onClick = s.onPointerUp, delete s.onPointerUp;
  const u = Tt({}), { triggerProps: l, tooltipProps: c } = Bt({}, u, r), { isFocused: f, isFocusVisible: p, focusProps: m } = vt(), v = a.current ? ((h = a.current) == null ? void 0 : h.offsetWidth) < ((w = a.current) == null ? void 0 : w.scrollWidth) && u.isOpen : !1, g = typeof e.rendered == "string";
  return /* @__PURE__ */ d.createElement(
    uD,
    {
      ref: r,
      isFocused: f,
      isFocusVisible: p,
      isSelected: i,
      isTextOnly: g,
      alignCheckIconRight: n,
      ...xe(s, m, l)
    },
    i && !n && /* @__PURE__ */ d.createElement(To, { fontSize: "small" }),
    g ? /* @__PURE__ */ d.createElement(lD, { ref: a }, e.rendered) : e.rendered,
    i && n && /* @__PURE__ */ d.createElement(To, { fontSize: "small" }),
    v && /* @__PURE__ */ d.createElement(At, { parentRef: r, ...c }, e.rendered)
  );
}, qh = cD, dD = D(lw)`
  color: ${y.grey500};
  font-size: 0.75rem;
`, fD = D.ul`
  padding: 0;
  list-style: 'none';
`, pD = ({ state: e, section: t, alignRight: n }) => {
  const { itemProps: r, headingProps: a, groupProps: o } = W0({
    heading: t.rendered,
    "aria-label": t["aria-label"]
  });
  return /* @__PURE__ */ d.createElement("li", { ...r }, t.rendered && /* @__PURE__ */ d.createElement(dD, { ...a }, t.rendered), /* @__PURE__ */ d.createElement(fD, { ...o }, [...t.childNodes].map((i) => /* @__PURE__ */ d.createElement(qh, { key: i.key, item: i, state: e, alignRight: n }))));
}, hD = pD, vD = D.div`
  position: absolute;
  width: 12.375rem;
  top: calc(100% + ${k.XS});
  ${({ alignRight: e }) => e ? _`
          right: 0;
        ` : _`
          left: 0;
        `};
  display: flex;
  flex-direction: column;
  padding: 0 ${k.S} 0 ${k.S};
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: ${y.white};
  z-index: 1;
  ${ir}

  @media (${Fe.smallMax}) {
    min-width: 12.375rem;
    width: 100%;
  }
`, mD = D.ul`
  margin: ${k.L} -0.1875rem ${k.L} 0;
  padding: 0;
  background: ${y.white};
  flex: 1;
  height: 100%;
  max-height: 12.5rem;
  overflow-y: scroll;
  scrollbar-color: ${y.grey300} transparent;
  scrollbar-width: thin;
  outline: 0;
  &::-webkit-scrollbar {
    width: 0.1875rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: ${y.grey300};
  }
`, gD = ({
  state: e,
  alignRight: t = !1,
  overlayRef: n,
  ignoreTrigger: r,
  ...a
}) => {
  const o = d.useRef(null), { listBoxProps: i } = Np(
    {
      autoFocus: e.focusStrategy || !0,
      selectionMode: "single",
      disallowEmptySelection: !0,
      ...a
    },
    e,
    o
  ), { overlayProps: s } = dn(
    {
      onClose: () => e.close(),
      shouldCloseOnBlur: !0,
      isOpen: e.isOpen,
      isDismissable: !0,
      shouldCloseOnInteractOutside: (u) => u !== r
    },
    n
  );
  return Gu({ ref: n, alignRight: t, isOpen: e.isOpen }), /* @__PURE__ */ d.createElement(fn, { restoreFocus: !0 }, /* @__PURE__ */ d.createElement(vD, { ...xe(s, a), ref: n, alignRight: t }, /* @__PURE__ */ d.createElement(Eo, { onDismiss: () => e.close() }), /* @__PURE__ */ d.createElement(mD, { ...xe(i), ref: o }, /* @__PURE__ */ d.createElement(F0, null, [...e.collection].filter((u) => !u.hasChildNodes).map((u) => /* @__PURE__ */ d.createElement(qh, { key: u.key, item: u, state: e, alignRight: t })), [...e.collection].filter((u) => u.hasChildNodes).map((u) => /* @__PURE__ */ d.createElement(
    hD,
    {
      key: u.key,
      section: u,
      state: e,
      alignRight: t
    }
  )))), /* @__PURE__ */ d.createElement(Eo, { onDismiss: () => e.close() })));
}, yD = gD, bD = D.div`
  position: relative;
  overflow: visible;
  display: inline-flex;
  flex-direction: column;

  @media (${Fe.smallMax}) {
    width: 100%;
  }
`, wD = D(li)`
  margin-bottom: ${k.XXS};
  white-space: nowrap;
`, DD = ({
  triggerButton: e,
  defaultOption: t,
  name: n,
  className: r,
  alignRight: a,
  label: o,
  isDisabled: i,
  ...s
}) => {
  var O, B;
  const u = ng(s), { visuallyHiddenProps: l } = Ip(), c = o ? {} : l, f = ve(null), { labelProps: p, triggerProps: m, valueProps: v, menuProps: g } = Y0(
    s,
    u,
    f
  ), h = d.useRef(null), { isFocused: w, isFocusVisible: S, focusProps: x } = vt();
  return /* @__PURE__ */ d.createElement(bD, { className: r }, /* @__PURE__ */ d.createElement(wD, { ...xe(p, c), as: "span" }, o), /* @__PURE__ */ d.createElement(
    H0,
    {
      state: u,
      triggerRef: f,
      label: s["aria-label"],
      name: n
    }
  ), /* @__PURE__ */ d.createElement(
    e,
    {
      isOpen: u.isOpen,
      isFocused: w,
      isDisabled: i,
      isFocusVisible: S,
      isDefaultOptionSelected: ((O = u.selectedItem) == null ? void 0 : O.key) !== (t == null ? void 0 : t.value),
      valueProps: v,
      buttonRef: f,
      onClick: () => {
        f.current && (u.isOpen ? (u.setFocused(!1), u.close()) : (f.current.focus(), u.open()));
      },
      ...xe(m, x)
    },
    (B = u.selectedItem) == null ? void 0 : B.rendered
  ), u.isOpen && /* @__PURE__ */ d.createElement(
    yD,
    {
      ...xe(g),
      overlayRef: h,
      state: u,
      isFocusVisible: S,
      alignRight: a,
      ignoreTrigger: f.current
    }
  ));
}, CD = ({ onSelect: e, options: t, ...n }) => {
  const r = () => {
    const s = t.reduce((u, l) => (l.section && (u[l.section] = [...u[l.section] || [], l]), u), {});
    return Object.keys(s).map((u) => ({ label: u, items: s[u] }));
  }, a = (s) => s.kind === "reactnode" ? /* @__PURE__ */ d.createElement(nn, { textValue: s.textValue, key: s.value }, s.labelReactNode) : /* @__PURE__ */ d.createElement(nn, { key: s.value }, s.label), o = t.some((s) => s.section), i = o ? r().map((s) => /* @__PURE__ */ d.createElement(rg, { title: s.label, key: s.label }, s.items.map((u) => a(u)))) : [];
  return /* @__PURE__ */ d.createElement(
    DD,
    {
      ...n,
      onSelectionChange: (s) => {
        const u = t.find((l) => l.value === s.toString());
        u && e(u);
      }
    },
    o ? t.filter((s) => !s.section).map((s) => a(s)).concat(i) : t.map((s) => a(s))
  );
}, MP = CD, ED = D.button`
  height: 2.5rem;
  width: 12.375rem;
  border-radius: 3rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  font-family: ${eh.fontFamily};
  padding: 0 ${k.XL} 0 ${k.M};
  margin: 0;
  cursor: pointer;
  border: none;
  background-color: ${({ isDefaultOptionSelected: e }) => e ? y.black : y.grey100};
  color: ${({ isDefaultOptionSelected: e }) => e ? y.white : y.black};
  white-space: nowrap;
  position: relative;

  ${tt};

  ${({ isDefaultOptionSelected: e }) => _`
    &:hover {
      background-color: ${e ? y.grey800 : y.grey200};
    }
    &:active {
      background-color: ${e ? y.grey700 : y.grey300};
    }
  `};

  @media (${Fe.smallMax}) {
    width: 100%;
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`, xD = D(or)`
  margin: 0 ${k.M} 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  text-align: left;
  pointer-events: none;
`, SD = D(mn)`
  position: absolute;
  top: 50%;
  right: ${k.M};
  transform: translate(-50%, -50%) ${({ isOpen: e }) => e && "rotateX(180deg)"};
  height: 0.75rem;
  width: 0.75rem;
  justify-self: flex-end;
  align-self: center;
  color: inherit;
  fill: currentColor;
  flex-grow: 1;
  pointer-events: none;
`, $D = ({
  onClick: e,
  isOpen: t,
  valueProps: n,
  isFocused: r,
  isFocusVisible: a,
  isDefaultOptionSelected: o,
  isDisabled: i,
  buttonRef: s,
  className: u,
  ...l
}) => {
  var h, w;
  const c = ve(null), f = Tt({}), { triggerProps: p, tooltipProps: m } = Bt({}, f, s);
  delete p.onKeyDown, delete p.onKeyUp;
  const v = c.current ? ((h = c.current) == null ? void 0 : h.offsetWidth) < ((w = c.current) == null ? void 0 : w.scrollWidth) && f.isOpen : !1, { children: g } = l;
  return /* @__PURE__ */ d.createElement(
    ED,
    {
      isFocused: r,
      isFocusVisible: a,
      isDefaultOptionSelected: o,
      disabled: i,
      className: u,
      ref: s,
      ...xe(l, p),
      onClick: (S) => {
        S.preventDefault(), e(S);
      }
    },
    typeof g == "string" ? /* @__PURE__ */ d.createElement(xD, { ...n, ref: c }, g) : g,
    /* @__PURE__ */ d.createElement(SD, { "aria-hidden": "true", isOpen: t }),
    v && /* @__PURE__ */ d.createElement(At, { parentRef: s, ...m }, g)
  );
}, FP = $D;
var Zu = {}, kD = We, OD = Ye;
Object.defineProperty(Zu, "__esModule", {
  value: !0
});
var Xh = Zu.default = void 0, BD = OD(d), TD = kD(He()), AD = (0, TD.default)(/* @__PURE__ */ BD.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");
Xh = Zu.default = AD;
const PD = D.button`
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 1.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  padding: 0;
  margin: 0;
  cursor: pointer;
  border: none;
  background-color: ${y.grey100};
  color: ${y.black};
  white-space: nowrap;
  position: relative;
  flex-shrink: 0;

  ${tt};
  ${({ isFocused: e, isFocusVisible: t }) => e && t && _`
      background-color: ${y.grey200};
    `};

  &:hover {
    background-color: ${y.grey200};
  }

  &:active {
    background-color: ${y.grey300};
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`, MD = D(mn)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) ${({ isOpen: e }) => e && "rotateX(180deg)"};
  height: 0.75rem;
  width: 0.75rem;
  color: inherit;
  fill: currentColor;
`, FD = D(Xh)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 0.75rem;
  width: 0.75rem;
  color: inherit;
  fill: currentColor;
`, Gh = ({
  isFocused: e,
  isFocusVisible: t,
  isDisabled: n,
  buttonRef: r,
  className: a,
  children: o,
  ...i
}) => /* @__PURE__ */ d.createElement(
  PD,
  {
    isFocused: e,
    isFocusVisible: t,
    disabled: n,
    ref: r,
    ...i,
    className: a
  },
  o
), RP = (e) => {
  const { isOpen: t } = e;
  return /* @__PURE__ */ d.createElement(Gh, { ...e }, /* @__PURE__ */ d.createElement(MD, { "aria-hidden": "true", isOpen: t }));
}, _P = (e) => /* @__PURE__ */ d.createElement(Gh, { ...e }, /* @__PURE__ */ d.createElement(FD, { "aria-hidden": "true" })), RD = _`
  background-color: ${y.frenchBlue};
  &&,
  &&:link,
  &&:visited {
    color: ${y.white};
  }

  ${Xu};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.yaleBlue};
    `
)};

  &:hover {
    background-color: ${y.yaleBlue};
  }

  &:active {
    background-color: ${y.midnightBlue};
    border-radius: 0.5rem;
  }

  ${pn};
`, _D = _`
  background-color: ${y.white};
  border: 0.125rem solid ${y.frenchBlue};
  &&&&&,
  &&&&&:link,
  &&&&&:visited {
    color: ${y.frenchBlue};
  }

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      &&&&&,
      &&&&&:focus {
        background-color: ${y.yaleBlue};
        border: 0.125rem solid ${y.yaleBlue};
        color: ${y.white};
      }
    `
)};

  &&&&&:hover {
    background-color: ${y.yaleBlue};
    border: 0.125rem solid ${y.yaleBlue};
    color: ${y.white};
  }

  &&&&&:active {
    background-color: ${y.midnightBlue};
    border: 0.125rem solid ${y.midnightBlue};
    color: ${y.white};
    border-radius: 0.5rem;
  }

  ${({ isDisabled: e }) => e && _`
      &&&&& {
        pointer-events: none;
        cursor: default;
        &,
        &:link,
        &:visited {
          color: ${y.grey400};
        }
        background-color: ${y.white};
        border: 0.125rem solid ${y.grey400};
      }
    `};
`, ND = D.button`
  height: 2.5rem;
  width: fit-content;
  max-width: 100%;
  margin: 0;
  padding: ${k.XS} ${k.M};
  outline-offset: ${k.XXS};
  ${oi};
  ${ai};

  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;

  ${tt};

  ${({ color: e }) => {
  switch (e) {
    case "outlinedBlue":
      return _D;
    case "blue":
    default:
      return RD;
  }
}};

  > svg {
    font-size: 1rem;
    ${({ leftAlignIcon: e }) => e ? _`
            margin-right: ${k.S};
          ` : _`
            margin-left: ${k.S};
          `}
  }
`, ID = ({ children: e, icon: t, leftAlignIcon: n = !1, ...r }) => /* @__PURE__ */ d.createElement(Lr, { ...r }, (a) => /* @__PURE__ */ d.createElement(ND, { ...a, leftAlignIcon: n }, n && t, /* @__PURE__ */ d.createElement(or, null, e), !n && t)), hd = ID, LD = D.button`
  margin: 0;
  height: 1.75rem;
  max-width: 100%;
  padding: ${k.XXS} ${k.XXL};
  background-color: ${y.grey100};
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  user-select: none;
  flex-grow: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${oi};
  ${ai};
  ${tt};

  &:hover {
    background-color: ${y.grey200};
  }

  &:active {
    background-color: ${y.grey300};
    border-radius: 0.5rem;
  }

  ${pn};
`, jD = D(or)`
  color: ${y.black};
  overflow: hidden;
  text-overflow: ellipsis;
`, WD = ({ children: e, ...t }) => /* @__PURE__ */ d.createElement(Lr, { ...t }, (n) => /* @__PURE__ */ d.createElement(LD, { ...n }, /* @__PURE__ */ d.createElement(jD, null, e))), NP = WD, YD = D.button`
  height: 4.625rem;
  width: fit-content;
  max-width: 100%;
  margin: 0;
  padding: ${k.XS} ${k.XXXXL};
  background-color: ${y.frenchBlue};
  color: ${y.white};
  border: none;
  border-radius: 1.5rem;
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  ${tt};

  ${qu};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // &:focus
  e && t && _`
      background-color: ${y.yaleBlue};
    `
)};

  &:hover {
    background-color: ${y.yaleBlue};
  }

  &:active {
    background-color: ${y.midnightBlue};
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
    ${pn};
  }
`, HD = D.span`
  font-size: 1.5rem;
  line-height: 2.125rem;
  font-weight: 400;
`, VD = ({ children: e, ...t }) => /* @__PURE__ */ d.createElement(Lr, { ...t }, (n) => /* @__PURE__ */ d.createElement(YD, { ...n }, /* @__PURE__ */ d.createElement(HD, null, e))), IP = VD, zD = D.a`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-decoration: none;
  cursor: pointer;

  &:link,
  &:visited,
  & {
    color: ${y.frenchBlue};

    &:hover,
    &:focus {
      color: ${y.yaleBlue} !important;
      text-decoration: underline;
    }

    &:active {
      color: ${y.midnightBlue} !important;
      text-decoration: underline;
    }
  }

  ${({ isDisabled: e }) => e && _`
      &:link,
      &:visited {
        opacity: 0.3;
        pointer-events: none;
        user-select: none;
      }
    `};
`, KD = ({
  href: e,
  target: t,
  rel: n,
  className: r,
  isDisabled: a,
  onClick: o,
  children: i,
  dangerouslySetInnerHTML: s,
  ...u
}) => {
  const c = e || o ? 0 : -1;
  return /* @__PURE__ */ d.createElement(
    zD,
    {
      href: e,
      isDisabled: a,
      onClick: o && o,
      className: r,
      target: t,
      rel: n,
      tabIndex: c,
      "aria-disabled": a,
      dangerouslySetInnerHTML: s,
      ...u
    },
    i
  );
}, LP = KD, UD = D.div`
  position: relative;
  border: 2px solid transparent;
  border-radius: 2.9375rem;
  padding: 0.125rem;
  display: inline-block;
  margin: -0.25rem -0.25rem;
  height: max-content;
  transition: outline 0.25s ${mt};
  outline-offset: -0.125rem;

  outline: ${({ isFocusVisible: e }) => `0.125rem solid ${e ? y.frenchBlue : "transparent"}`};

  @media (prefers-reduced-motion) {
    /* styles to apply if the user's settings are set to reduced motion */
    transition: none;
  }
`, qD = D.label`
  height: 2.5rem;
  padding: 0 ${k.M};
  color: ${({ isSelected: e }) => e ? y.white : y.grey400};
  border: none;
  border-radius: 2.8125rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    background 0.1s ease-out,
    color 0.1s ease-out;

  width: 100%;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  letter-spacing: 0.05em;

  ${({ isSelected: e, isDisabled: t }) => _`
    &:hover,
    &:active {
      color: ${e ? y.white : t ? y.grey400 : y.grey700};
    }
  `}

  ${({ isDisabled: e }) => e && _`
      cursor: default;
    `}
`, XD = D.span`
  max-width: 8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  pointer-events: none;
`, GD = ({ state: e, ...t }) => {
  var S, x;
  const { value: n, isDisabled: r = !1, children: a, refs: o } = t, i = ve(null), s = ve(null), u = ve(null), { inputProps: l } = Lp(t, e, i), c = ni(), { isFocusVisible: f, focusProps: p } = vt(), m = n === e.selectedValue, v = Tt(t), { triggerProps: g, tooltipProps: h } = Bt(t, v, s), w = u.current ? (v.isOpen || f) && ((S = u.current) == null ? void 0 : S.offsetWidth) < ((x = u.current) == null ? void 0 : x.scrollWidth) : !1;
  return /* @__PURE__ */ d.createElement(
    UD,
    {
      ref: (O) => !o.current.includes(O) && o.current.push(O),
      isFocusVisible: f
    },
    /* @__PURE__ */ d.createElement(
      qD,
      {
        htmlFor: c,
        isSelected: m,
        isDisabled: r,
        ref: s,
        ...g
      },
      /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement(
        "input",
        {
          type: "radio",
          id: c,
          ref: i,
          disabled: r,
          ...xe(l, p)
        }
      )),
      /* @__PURE__ */ d.createElement(XD, { ref: u }, a),
      w && /* @__PURE__ */ d.createElement(At, { parentRef: s, ...h }, a)
    )
  );
}, QD = GD, ZD = D.div`
  display: flex;
  align-items: center;
  background-color: ${y.grey100};
  width: max-content;
  height: 2.25rem;
  border-radius: 1.25rem;
  position: relative;
  cursor: pointer;

  ${({ isDisabled: e }) => e && _`
      filter: grayscale(1);
      pointer-events: none;
    `};
`, JD = D.div`
  background-color: ${y.frenchBlue};
  height: 100%;
  transition: left 0.25s ${mt};
  border-radius: 2.25rem;
  width: ${({ highlighterProperties: e }) => e == null ? void 0 : e.width}px;
  position: absolute;

  ${({ isSelected: e, highlighterProperties: t }) => e ? _`
          left: calc(100% - ${t == null ? void 0 : t.left}px);
        ` : _`
          left: 0px;
        `};

  ${({ isDisabled: e }) => e && _`
      background-color: ${y.grey300};
    `}
`, e2 = ({ options: e, className: t, ...n }) => {
  const r = Kp(n), { radioGroupProps: a, labelProps: o } = jp(n, r), i = ve([]), [s, u] = Ne(), { tooltipParentRef: l, showTooltip: c, tooltipProps: f, triggerProps: p } = yw({}), [m, v] = Ne(window.innerWidth), { isDisabled: g = !1, disabledTooltipText: h } = n;
  return je(() => {
    const w = () => {
      v(window.innerWidth);
    };
    return window.addEventListener("resize", w), () => {
      window.removeEventListener("resize", w);
    };
  }, []), je(() => {
    var S;
    const w = e.findIndex((x) => x.value === r.selectedValue);
    if (w !== -1) {
      const x = i == null ? void 0 : i.current.slice(0, w);
      let O = ((S = l == null ? void 0 : l.current) == null ? void 0 : S.clientWidth) || 0;
      x.forEach((L) => {
        O -= ((L == null ? void 0 : L.getBoundingClientRect().width) || 0) - 8;
      });
      const B = i == null ? void 0 : i.current[w], F = B == null ? void 0 : B.getBoundingClientRect();
      u({ width: ((F == null ? void 0 : F.width) || 0) - 8, left: O });
    }
  }, [r.selectedValue, m]), /* @__PURE__ */ d.createElement(
    ZD,
    {
      ...xe(a, o, p),
      className: t,
      ref: l
    },
    (s == null ? void 0 : s.width) !== 0 && /* @__PURE__ */ d.createElement(
      JD,
      {
        isSelected: !0,
        highlighterProperties: s,
        isDisabled: n.isDisabled
      }
    ),
    e.map(({ label: w, value: S }) => /* @__PURE__ */ d.createElement(QD, { key: S, value: S, state: r, isDisabled: g, refs: i }, w)),
    /* @__PURE__ */ d.createElement(
      gw,
      {
        tooltipParentRef: l,
        tooltipText: h || "",
        showTooltip: !!h && g && c,
        tooltipProps: f
      }
    )
  );
}, t2 = ({ onSelect: e, options: t, ...n }) => /* @__PURE__ */ d.createElement(
  e2,
  {
    options: t,
    ...n,
    onChange: (r) => {
      const a = t.find((o) => o.value === r);
      a && e(a);
    }
  }
), jP = t2, r2 = D.div`
  max-width: 22rem;
  margin-top: ${k.XS};
  ${({ noPadding: e }) => !e && _`
      padding: ${k.M};
    `}
  background-color: ${y.white};
  border-radius: 0.25rem;
  outline: 0;
  ${ir};
  overflow: ${({ allowOverflow: e }) => e ? "visible" : "hidden"};
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  z-index: 10000;

  ${({ alignRight: e }) => e && _`
      right: 0;
    `}
`, n2 = D.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`, vd = D(zu)`
  margin-right: ${k.XXS};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, a2 = D.div`
  overflow: ${({ allowOverflow: e }) => e ? "visible" : "auto"};
`, o2 = ({
  headingText: e,
  children: t,
  isOpen: n,
  onClose: r,
  overlayRef: a,
  allowOverflow: o,
  hideHeader: i,
  noPadding: s,
  alignRight: u = !1,
  ...l
}) => {
  const { overlayProps: c } = dn(
    {
      onClose: r,
      isOpen: n,
      isDismissable: !0
    },
    a
  ), { modalProps: f } = Ou(), { dialogProps: p, titleProps: m } = Bu({}, a);
  return Gu({ ref: a, alignRight: u, isOpen: n, fullWidthOnSmallScreens: !0 }), /* @__PURE__ */ d.createElement(fn, { restoreFocus: !0, contain: !0 }, /* @__PURE__ */ d.createElement(
    r2,
    {
      ...xe(c, p, l, f),
      allowOverflow: o,
      ref: a,
      alignRight: u,
      noPadding: s
    },
    i ? /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement(vd, { ...m }, e), /* @__PURE__ */ d.createElement(pr, { isSmall: !0, icon: /* @__PURE__ */ d.createElement(_r, null), "aria-label": "Stäng", onClick: r })) : /* @__PURE__ */ d.createElement(n2, null, /* @__PURE__ */ d.createElement(vd, { ...m }, e), /* @__PURE__ */ d.createElement(pr, { isSmall: !0, icon: /* @__PURE__ */ d.createElement(_r, null), "aria-label": "Stäng", onClick: r })),
    /* @__PURE__ */ d.createElement(a2, { allowOverflow: o }, t({ close: r })),
    /* @__PURE__ */ d.createElement(Eo, { onDismiss: r })
  ));
}, i2 = o2, s2 = D.div`
  position: relative;
  overflow: visible;
  display: inline-block;
  height: max-content;
`, u2 = ({
  triggerButton: e,
  isActive: t = !1,
  headingText: n,
  buttonText: r,
  onClose: a,
  alignRight: o = !1,
  hideHeader: i = !1,
  noPadding: s = !1,
  allowOverflow: u = !1,
  children: l,
  className: c,
  ...f
}) => {
  const p = ag({}), m = ve(null), v = ve(null), { triggerProps: g, overlayProps: h } = V0({ type: "dialog" }, p, m);
  return /* @__PURE__ */ d.createElement(s2, { className: c }, /* @__PURE__ */ d.createElement(
    e,
    {
      buttonRef: m,
      isOpen: p.isOpen,
      onClick: () => p.toggle(),
      isActive: t,
      text: r,
      ...xe(g, f)
    }
  ), p.isOpen && /* @__PURE__ */ d.createElement(
    i2,
    {
      ...h,
      overlayRef: v,
      isOpen: !0,
      allowOverflow: u,
      onClose: () => {
        a && a(), p.close();
      },
      headingText: n,
      alignRight: o,
      hideHeader: i,
      noPadding: s
    },
    l
  ));
}, WP = u2;
var Ju = {}, l2 = We, c2 = Ye;
Object.defineProperty(Ju, "__esModule", {
  value: !0
});
var Qh = Ju.default = void 0, d2 = c2(d), f2 = l2(He()), p2 = (0, f2.default)(/* @__PURE__ */ d2.createElement("path", {
  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
}), "Tune");
Qh = Ju.default = p2;
D.button`
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 1.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  margin: 0;
  cursor: pointer;
  border: none;
  background-color: ${y.grey100};
  color: ${y.black};
  white-space: nowrap;
  position: relative;
  flex-shrink: 0;

  ${tt};
  ${({ isFocused: e, isFocusVisible: t }) => e && t && _`
      background-color: ${y.grey200};
    `};

  &:hover {
    background-color: ${y.grey200};
  }

  &:active {
    background-color: ${y.grey300};
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`;
const h2 = D(Qh)`
  height: 0.75rem;
  width: 0.75rem;
  color: inherit;
  fill: currentColor;
`, v2 = ({
  icon: e,
  color: t = "grey",
  ...n
}) => /* @__PURE__ */ d.createElement(pr, { icon: e, ...n, color: t }), YP = (e) => /* @__PURE__ */ d.createElement(v2, { ...e, isSmall: !0, icon: /* @__PURE__ */ d.createElement(h2, null), color: "grey" }), Vr = D.button`
  ${({ isFocusVisible: e, includeStyling: t }) => t && _`
      ${tt({ isFocusVisible: e })};
      ${Ct};
      border: none;
      height: 2rem;
      background: none;
      cursor: pointer;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1.25rem;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      padding: 0;
      white-space: nowrap;
      text-align: left;
      text-decoration: none;
      &:focus-visible {
        outline-offset: 0.25rem;
      }
    `};
`, m2 = D.li`
  ${({ includeStyling: e }) => e && _`
      display: flex;
      align-items: center;
      position: relative;
      padding: 0;
      height: 2rem;
      text-align: center;
      letter-spacing: 0.05rem;
      background-color: transparent;
      border: none;
      cursor: pointer;
      text-decoration: none;
      white-space: nowrap;
      transition: color 0.1s ${mt};

      > ${Vr} {
        color: ${y.grey600};
      }

      &:hover {
        > ${Vr} {
          color: ${y.grey800};
        }
      }

      &:active {
        > ${Vr} {
          color: ${y.grey700};
        }
      }

      @media (${Fe.smallMax}) {
        margin: 0;
      }
    `};

  ${({ isSelected: e }) => e && _`
      > ${Vr} {
        color: ${y.black};
      }
    `};

  ${({ isSelected: e, showActiveTab: t }) => e && t && _`
      &::after {
        content: '';
        height: 0.125rem;
        width: 2rem;
        background-color: ${y.frenchBlue};
        position: absolute;
        bottom: 0;
        left: calc(50% - 1rem);
      }
    `};

  @media (${Fe.smallMax}) {
    margin: 0;
  }

  ${({ disabled: e }) => e && _`
      > ${Vr} {
        color: ${y.grey400};
        cursor: pointer;
      }
      &:hover {
        > ${Vr} {
          color: ${y.grey400};
          cursor: pointer;
        }
      }
    `};
`, g2 = D.div`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background-color: ${y.clownRed};
  align-self: flex-start;
  ${ir};
`, y2 = ({
  item: e,
  state: t,
  showActiveTabs: n,
  includeStyling: r,
  className: a,
  ariaControls: o,
  ...i
}) => {
  var v, g, h, w, S, x;
  const s = ve(null), { tabProps: u } = z0({ key: e.key }, t, s), { isFocusVisible: l } = Fp(), c = e.key === ((v = t.selectedItem) == null ? void 0 : v.key), f = Tt({}), { triggerProps: p, tooltipProps: m } = Bt({}, f, s);
  return delete p.onClick, delete p.onMouseDown, delete p.onPointerDown, /* @__PURE__ */ d.createElement(
    m2,
    {
      ...xe(i, p),
      disabled: (g = e.value) == null ? void 0 : g.isDisabled,
      showActiveTab: n,
      includeStyling: r,
      className: a,
      isSelected: c
    },
    /* @__PURE__ */ d.createElement(
      Vr,
      {
        ...u,
        ref: s,
        isFocusVisible: l,
        "aria-controls": o,
        id: `tab-${(h = e.value) == null ? void 0 : h.value}`,
        includeStyling: r
      },
      (w = e.value) == null ? void 0 : w.label
    ),
    ((S = e.value) == null ? void 0 : S.hasNotification) && /* @__PURE__ */ d.createElement(g2, null),
    f.isOpen && ((x = e.value) == null ? void 0 : x.isDisabled) && e.value.disabledText && /* @__PURE__ */ d.createElement(At, { parentRef: s, ...m }, e.value.disabledText)
  );
}, b2 = y2, w2 = D.div`
  ${({ hidden: e }) => e && "display: none;"}
  outline: 0;
  width: 100%;
`, D2 = ({ hidden: e, item: t }) => {
  const n = ve(null);
  return /* @__PURE__ */ d.createElement(
    w2,
    {
      id: t.value,
      ref: n,
      hidden: e,
      "aria-labelledby": `tab-${t.value}`,
      role: "tabpanel"
    },
    t.children
  );
}, C2 = D2, E2 = D.div`
  ${({ includeStyling: e }) => e && _`
      display: flex;
      flex-direction: column;
      width: 100%;
    `};
`, x2 = D.ul`
  ${({ includeStyling: e }) => e && _`
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-self: flex-start;

      overflow-x: auto;
      padding: ${k.XS};
      margin: -${k.XS} -${k.XS} 0 -${k.XS};
      height: max-content;

      > * {
        margin: 0 ${k.M};
      }

      > *:first-child {
        margin-left: 0;
      }

      > *:last-child {
        margin-right: 0;
      }
    `};
`, S2 = ({
  className: e,
  showActiveTabs: t,
  includeStyling: n,
  tabClassName: r,
  tabListClassName: a,
  ...o
}) => {
  const i = og(o), s = ve(null);
  o.items && Array.from(o.items).forEach((l) => {
    l.isDisabled && i.disabledKeys.add(l.value);
  });
  const { tabListProps: u } = K0(o, i, s);
  return /* @__PURE__ */ d.createElement(E2, { className: e, includeStyling: n }, /* @__PURE__ */ d.createElement(
    x2,
    {
      ...u,
      ref: s,
      includeStyling: n,
      className: a
    },
    [...i.collection].map((l) => {
      var c;
      return /* @__PURE__ */ d.createElement(
        b2,
        {
          key: l.key,
          item: l,
          state: i,
          showActiveTabs: t,
          includeStyling: n,
          className: r,
          ariaControls: (c = l.value) == null ? void 0 : c.value
        }
      );
    })
  ), o.items && Array.from(o.items).map((l) => {
    var c;
    return /* @__PURE__ */ d.createElement(C2, { key: l.value, item: l, hidden: ((c = i.selectedItem) == null ? void 0 : c.key) !== l.value }, l.children);
  }));
}, $2 = S2, k2 = ({
  tabs: e,
  onSelect: t,
  showActiveTabs: n = !0,
  includeStyling: r = !0,
  tabClassName: a,
  tabListClassName: o,
  ...i
}) => /* @__PURE__ */ d.createElement(
  $2,
  {
    ...i,
    items: e,
    onSelectionChange: (s) => {
      const u = e.find((l) => l.value === s);
      u && t && t(u);
    },
    showActiveTabs: n,
    includeStyling: r,
    tabClassName: a,
    tabListClassName: o
  },
  (s) => /* @__PURE__ */ d.createElement(nn, { key: s.value, textValue: s.value }, s.children)
), O2 = k2, B2 = D.div`
  margin: ${k.M} auto 0;
  width: 75rem; /* 71rem + 4rem for margin (2rem on each side) */
  max-width: 100%;
  padding: 0 ${k.XL};

  @media (${Fe.smallMax}) {
    padding: 0 ${k.M};
  }
`, T2 = D(uw)`
  margin-bottom: ${k.XS};
  margin-left: -3px; /* Fine tune alignment with tabs since there is some empty space before the first letter in the typeface*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (${Fe.smallMax}) {
    margin-left: -2px; /* Fine tune alignment with tabs since there is some empty space before the first letter in the typeface*/
  }
`, A2 = ({ title: e, tabs: t, onSelect: n, className: r, ...a }) => /* @__PURE__ */ d.createElement(B2, { className: r }, /* @__PURE__ */ d.createElement(T2, null, e), /* @__PURE__ */ d.createElement(O2, { tabs: t, onSelect: n, className: r, ...a })), HP = A2, P2 = D.button`
  ${({ isSmall: e }) => e ? _`
          padding: 0 ${k.XS};
          height: 1.125rem;
        ` : _`
          padding: ${k.XXS} ${k.XS};
          height: 1.875rem;
        `};
  width: fit-content;
  max-width: 100%;
  margin: 0;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;

  background-color: ${y.grey100};
  color: ${y.black};
  ${Xu}

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.grey200};
    `
)};

  &:hover {
    background-color: ${y.grey200};
  }

  &:active {
    background-color: ${y.grey300};
    border-radius: 0.5rem;
    box-shadow: none;
  }

  ${tt};

  > svg {
    font-size: 1rem;
    margin-left: ${k.S};
  }

  ${pn};
`, M2 = D(li)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
`, F2 = ({
  tooltipPlacementTop: e,
  children: t,
  ...n
}) => {
  var l, c;
  const r = ve(null), a = ve(null), o = Tt({}), { triggerProps: i, tooltipProps: s } = Bt({}, o, r), u = a.current ? ((l = a.current) == null ? void 0 : l.offsetWidth) < ((c = a.current) == null ? void 0 : c.scrollWidth) && o.isOpen : !1;
  return /* @__PURE__ */ d.createElement(Lr, { ...n, buttonRef: r }, (f) => /* @__PURE__ */ d.createElement(P2, { ...xe(f, i) }, /* @__PURE__ */ d.createElement(M2, { ref: a }, t), u && /* @__PURE__ */ d.createElement(At, { parentRef: r, placementTop: e, ...s }, t)));
}, VP = F2, R2 = D.div`
  padding: ${k.XXS} 0;
  ${({ withDivider: e }) => e && _`
      border-bottom: 0.125rem solid ${y.grey300};
    `}
`, _2 = D(li)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, N2 = ({ withDivider: e, className: t, ...n }) => {
  const { children: r } = n;
  return /* @__PURE__ */ d.createElement(R2, { className: t, withDivider: e }, /* @__PURE__ */ d.createElement(_2, null, r));
}, zP = N2;
var el = {}, I2 = We, L2 = Ye;
Object.defineProperty(el, "__esModule", {
  value: !0
});
var tl = el.default = void 0, j2 = L2(d), W2 = I2(He()), Y2 = (0, W2.default)(/* @__PURE__ */ j2.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
tl = el.default = Y2;
var rl = {}, H2 = We, V2 = Ye;
Object.defineProperty(rl, "__esModule", {
  value: !0
});
var Zh = rl.default = void 0, z2 = V2(d), K2 = H2(He()), U2 = (0, K2.default)(/* @__PURE__ */ z2.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
Zh = rl.default = U2;
const q2 = "0.25s", X2 = D.div`
  height: 2.5rem;
  max-width: 14.5rem;
  width: 100%;
  position: relative;
  background-color: ${y.white};
  display: flex;
  margin: 0;
  border: solid 0.125rem ${y.grey200};
  border-radius: 1.25rem;
  align-items: center;
  transition: all ${q2} ${mt};
  color: ${y.grey600};
  padding: 0;
  overflow: hidden;
  flex: 0 1 auto;

  ${({ isFocused: e, isDisabled: t, collapsed: n }) => !e && !t && !n && _`
      &:hover {
        border-color: ${y.grey400};
      }
    `};

  ${({ collapsed: e, isFocused: t }) => e && !t && _`
      max-width: 2.5rem !important; /* Important is used to enforce the small width when collapsed even when another max-width has been set by extending the compnents styling */
      cursor: pointer;
      background-color: transparent;
      border-color: transparent;
      flex: 0 0 auto;

      &:hover {
        color: ${y.grey800};
        background-color: ${y.grey200};
      }
    `};

  ${({ isFocused: e }) => e && _`
      border-color: ${y.grey800};
      color: ${y.grey800};
    `};

  ${({ isDisabled: e }) => e && _`
      cursor: default;
      pointer-events: none;
      background-color: ${y.grey100};
    `};

  &:hover {
    color: ${y.grey800};
  }

  @media (${Fe.smallMax}) {
    max-width: 100%;
  }
`, G2 = D.input`
  width: 100%;
  min-width: 0;
  height: 2.5rem;
  flex: 1 1 auto;
  padding: ${k.S} ${k.XL} ${k.S} ${k.M};
  margin: 0;
  background-color: transparent;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ collapsed: e }) => e && _`
      padding-right: 1.25rem;
      width: 0;
    `};

  &::-webkit-input-placeholder {
    line-height: 1.5;
    vertical-align: middle;
  }

  &::placeholder {
    color: ${y.grey600};
  }
`, md = D.div`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 0 1.25rem 1.25rem 0;
  cursor: text;
  background: transparent;
  border: none;

  ${({ isFocused: e, collapsed: t }) => !e && t && _`
      border-radius: 1.25rem;
      cursor: pointer;
    `};

  ${({ isClearIcon: e }) => e && _`
      cursor: pointer;
      color: ${y.grey700};
    `};
`, Q2 = ({
  collapsed: e = !1,
  className: t,
  placeholder: n,
  onFocusedChange: r,
  ...a
}) => {
  const { isDisabled: o = !1 } = a, i = ve(null), s = ig(a), { inputProps: u } = U0(a, s, i), l = ni(), { isFocused: c, focusProps: f, isFocusVisible: p } = vt({ isTextInput: !0 });
  je(() => {
    r && r(c);
  }, [c, r]);
  const { keyboardProps: m } = Jn({
    onKeyDown: (g) => {
      var h;
      return (g.key === "Enter" || g.key === "Escape") && ((h = i.current) == null ? void 0 : h.blur());
    }
  }), v = n || "Sök";
  return /* @__PURE__ */ d.createElement(
    X2,
    {
      isFocused: c,
      isDisabled: o,
      collapsed: s.value ? !1 : e,
      isFocusVisible: p,
      className: t
    },
    /* @__PURE__ */ d.createElement(
      G2,
      {
        ...xe(u, f, m),
        type: "text",
        ref: i,
        id: l,
        placeholder: v,
        isFocused: c,
        disabled: o,
        collapsed: s.value ? !1 : e
      }
    ),
    s.value ? /* @__PURE__ */ d.createElement(
      md,
      {
        as: "button",
        collapsed: e,
        isFocused: c,
        isClearIcon: !0,
        onClick: () => {
          var g;
          s.setValue(""), (g = i.current) == null || g.focus();
        },
        "aria-label": "Rensa"
      },
      /* @__PURE__ */ d.createElement(tl, null)
    ) : /* @__PURE__ */ d.createElement(
      md,
      {
        collapsed: e,
        isFocused: c,
        onClick: () => {
          var g;
          return (g = i.current) == null ? void 0 : g.focus();
        }
      },
      /* @__PURE__ */ d.createElement(Zh, null)
    )
  );
}, KP = Q2, Z2 = D.div`
  display: flex;
  align-items: center;
  background-color: ${y.grey100};
  width: max-content;
  height: 2.5rem;
  border-radius: 1.25rem;
  position: relative;
  border: ${({ isFocusVisible: e }) => `0.125rem solid ${e ? y.frenchBlue : "transparent"}`};
  cursor: pointer;

  ${({ isDisabled: e }) => e && _`
      filter: grayscale(1);
      pointer-events: none;
    `};
`, gd = D(or)`
  color: ${({ isSelected: e }) => e ? y.white : y.grey400};
  user-select: none;
  padding: ${k.XS} ${k.M};
  z-index: 1;
  white-space: nowrap;

  ${({ isSelected: e }) => !e && _`
      &:hover {
        color: ${y.grey700};
        cursor: pointer;
      }
    `};

  &:active {
    /* color: ${y.grey800}; */
  }
`, J2 = D.div`
  ${({ color: e }) => e ? _`
          background-color: ${e};
        ` : _`
          /* default to frenchBlue if no other color is defined for option */
          background-color: ${y.frenchBlue};
        `};
  height: 100%;
  transition: left 0.25s ${mt};
  border-radius: 2.25rem;
  width: ${({ width: e }) => e}px;
  position: absolute;

  ${({ isSelected: e, width: t }) => e ? _`
          left: calc(100% - ${t}px);
        ` : _`
          left: 0;
        `};

  ${({ isDisabled: e }) => e && _`
      background-color: ${y.grey300};
    `}
`, eC = ({ option1: e, option2: t, className: n, onSelect: r, ...a }) => {
  const o = Up({
    ...a,
    onChange: (v) => {
      r(v ? t : e);
    }
  }), i = ve(null), { inputProps: s } = Wp(
    {
      "aria-label": o.isSelected ? t.ariaLabel : e.ariaLabel,
      isDisabled: a.isDisabled
    },
    o,
    i
  ), { isFocusVisible: u, focusProps: l } = vt(), c = ve(null), f = ve(null), [p, m] = Ne(0);
  return je(() => {
    var h, w;
    const v = ((h = c.current) == null ? void 0 : h.clientWidth) || 0, g = ((w = f.current) == null ? void 0 : w.clientWidth) || 0;
    m(o.isSelected ? g : v);
  }, [o]), /* @__PURE__ */ d.createElement(
    Z2,
    {
      className: n,
      onClick: () => {
        o.toggle();
      },
      isFocusVisible: u,
      isDisabled: a.isDisabled
    },
    /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement("input", { ...xe(s, l), ref: i })),
    p !== 0 && /* @__PURE__ */ d.createElement(
      J2,
      {
        color: (o.isSelected ? t.color : e.color) || y.frenchBlue,
        isSelected: o.isSelected,
        width: p,
        isDisabled: a.isDisabled
      }
    ),
    /* @__PURE__ */ d.createElement(gd, { isSelected: !o.isSelected, ref: c }, e.label),
    /* @__PURE__ */ d.createElement(gd, { isSelected: o.isSelected, ref: f }, t.label)
  );
}, UP = eC, ho = D(Ku)`
  margin-top: ${k.XXS};
`, tC = D.button`
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 11rem;
  width: 100%;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;

  ${oi};

  ${tt};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      img {
        transform: scale(1.35);

        @media (prefers-reduced-motion: reduce) {
          transform: none;
        }
      }

      ${ho} {
        color: ${y.frenchBlue};
      }
    `
)};

  &:hover {
    img {
      transform: scale(1.35);

      @media (prefers-reduced-motion: reduce) {
        transform: none;
      }
    }

    ${ho} {
      color: ${y.frenchBlue};
    }
  }

  &:active {
    ${ho} {
      color: ${y.yaleBlue};
    }
  }

  &:disabled {
    opacity: 0.3;
    cursor: auto;
    pointer-events: none;
  }
`, rC = D(Uu)`
  position: absolute;
  margin: ${k.XS};
  padding: 0.125rem ${k.XS};
  background-color: ${y.white};
  border-radius: 0.25rem;
  top: 0;
  left: 0;
`, nC = D.div`
  position: relative;
  display: inline-block;
  overflow: hidden;
  z-index: 0; /* To form a new stacking context to get around the following webkit bug: https://bugs.webkit.org/show_bug.cgi?id=98538 ! */
  width: 100%;
  padding-bottom: calc(100% / 1.7); /* To keep aspect ratio of 17:10*/
  height: 0;
  border-radius: 0.25rem;
  background-color: ${y.paradisoGreen};
`, aC = D.img`
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ${mt};
`, oC = ({
  imgSrc: e,
  title: t,
  badgeText: n,
  ...r
}) => /* @__PURE__ */ d.createElement(Lr, { ...r }, (a) => /* @__PURE__ */ d.createElement(tC, { ...a }, /* @__PURE__ */ d.createElement(nC, null, e && /* @__PURE__ */ d.createElement(aC, { src: e, alt: "" }), n && /* @__PURE__ */ d.createElement(rC, null, n)), /* @__PURE__ */ d.createElement(ho, null, t))), qP = oC, iC = D.div`
  width: auto;
  padding: 0.125rem ${k.XS};
  background-color: ${y.white};
  border-radius: 0.25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${ir};
`, sC = D(li)`
  color: currentColor;
`, uC = ({ children: e, className: t }) => /* @__PURE__ */ d.createElement(iC, { className: t }, /* @__PURE__ */ d.createElement(sC, null, e)), Jh = uC, lC = _`
  background-color: ${y.grey100};
`, cC = _`
  background-color: ${y.black};
  color: ${y.white};
`, dC = D.div`
  min-height: 6.5rem;
  border-radius: 0.25rem;
  padding: ${k.L};
  display: flex;

  ${({ infoBoxColor: e }) => {
  switch (e) {
    case "dark":
      return cC;
    case "light":
    default:
      return lC;
  }
}};
`, fC = D(Ku)`
  margin-bottom: ${k.XS};
  color: inherit;
`, pC = D.div`
  ${({ hasIcon: e }) => e && _`
      margin-left: ${k.M};
    `}
`, hC = ({ title: e, icon: t, color: n, className: r, children: a }) => /* @__PURE__ */ d.createElement(dC, { infoBoxColor: n, className: r }, t, /* @__PURE__ */ d.createElement(pC, { hasIcon: !!t }, /* @__PURE__ */ d.createElement(fC, null, e), a)), XP = hC, Ao = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, ev = /* @__PURE__ */ d.createContext(Ao), vC = /* @__PURE__ */ d.createContext(!1);
let mC = !!(typeof window < "u" && window.document && window.document.createElement), ns = /* @__PURE__ */ new WeakMap();
function gC(e = !1) {
  let t = mr(ev), n = ve(null);
  if (n.current === null && !e) {
    var r, a;
    let o = (a = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (r = a.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (o) {
      let i = ns.get(o);
      i == null ? ns.set(o, {
        id: t.current,
        state: o.memoizedState
      }) : o.memoizedState !== i.state && (t.current = i.id, ns.delete(o));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function yC(e) {
  let t = mr(ev);
  t === Ao && !mC && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = gC(!!e), r = t === Ao && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function bC(e) {
  let t = d.useId(), [n] = Ne(tv()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Ao.prefix}`;
  return e || `${r}-${t}`;
}
d.useId;
function wC() {
  return !1;
}
function DC() {
  return !0;
}
function CC(e) {
  return () => {
  };
}
function tv() {
  return typeof d.useSyncExternalStore == "function" ? d.useSyncExternalStore(CC, wC, DC) : mr(vC);
}
function rv(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (n = rv(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function EC() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++)
    (e = arguments[n]) && (t = rv(e)) && (r && (r += " "), r += t);
  return r;
}
const xC = typeof document < "u" ? d.useLayoutEffect : () => {
};
function SC(e) {
  const t = ve(null);
  return xC(() => {
    t.current = e;
  }, [
    e
  ]), Le((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
let yd = /* @__PURE__ */ new Map();
function $C(e, t) {
  if (e === t)
    return e;
  let n = yd.get(e);
  if (n)
    return n(t), t;
  let r = yd.get(t);
  return r ? (r(e), e) : t;
}
function kC(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const ta = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Po = (e) => e && "window" in e && e.window === e ? e : ta(e).defaultView || window;
function OC(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let o = t[a], i = r[a];
      typeof o == "function" && typeof i == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = kC(o, i) : (a === "className" || a === "UNSAFE_className") && typeof o == "string" && typeof i == "string" ? t[a] = EC(o, i) : a === "id" && o && i ? t.id = $C(o, i) : t[a] = i !== void 0 ? i : o;
    }
  }
  return t;
}
function Ta(e) {
  if (BC())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = TC(e);
    e.focus(), AC(t);
  }
}
let Za = null;
function BC() {
  if (Za == null) {
    Za = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Za = !0, !0;
        }
      });
    } catch {
    }
  }
  return Za;
}
function TC(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function AC(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function di(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function nl(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function jn() {
  return nl(/^Mac/i);
}
function PC() {
  return nl(/^iPhone/i);
}
function nv() {
  return nl(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  jn() && navigator.maxTouchPoints > 1;
}
function MC() {
  return PC() || nv();
}
function FC() {
  return jn() || MC();
}
function RC() {
  return di(/AppleWebKit/i) && !_C();
}
function _C() {
  return di(/Chrome/i);
}
function NC() {
  return di(/Android/i);
}
function IC() {
  return di(/Firefox/i);
}
const LC = /* @__PURE__ */ Ir({
  isNative: !0,
  open: YC
});
function jC() {
  return mr(LC);
}
function Mo(e, t, n = !0) {
  var r, a;
  let { metaKey: o, ctrlKey: i, altKey: s, shiftKey: u } = t;
  IC() && (!((a = window.event) === null || a === void 0 || (r = a.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (jn() ? o = !0 : i = !0);
  let l = RC() && jn() && !nv() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: o,
    ctrlKey: i,
    altKey: s,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: o,
    ctrlKey: i,
    altKey: s,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  Mo.isOpening = n, Ta(e), e.dispatchEvent(l), Mo.isOpening = !1;
}
Mo.isOpening = !1;
function WC(e, t) {
  if (e instanceof HTMLAnchorElement)
    t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function YC(e, t) {
  WC(e, (n) => Mo(n, t));
}
let On = /* @__PURE__ */ new Map(), Xs = /* @__PURE__ */ new Set();
function bd() {
  if (typeof window > "u")
    return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target)
      return;
    let a = On.get(r.target);
    a || (a = /* @__PURE__ */ new Set(), On.set(r.target, a), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target)
      return;
    let a = On.get(r.target);
    if (a && (a.delete(r.propertyName), a.size === 0 && (r.target.removeEventListener("transitioncancel", n), On.delete(r.target)), On.size === 0)) {
      for (let o of Xs)
        o();
      Xs.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? bd() : document.addEventListener("DOMContentLoaded", bd));
function HC(e) {
  requestAnimationFrame(() => {
    On.size === 0 ? e() : Xs.add(e);
  });
}
function wd(e, t) {
  let n = e;
  for (Dd(n, t) && (n = n.parentElement); n && !Dd(n, t); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function Dd(e, t) {
  let n = window.getComputedStyle(e), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
function VC(e, t, n, r) {
  let a = SC(n), o = n == null;
  je(() => {
    if (o || !e.current)
      return;
    let i = e.current;
    return i.addEventListener(t, a, r), () => {
      i.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    o,
    a
  ]);
}
function av(e, t) {
  let n = Cd(e, t, "left"), r = Cd(e, t, "top"), a = t.offsetWidth, o = t.offsetHeight, i = e.scrollLeft, s = e.scrollTop, { borderTopWidth: u, borderLeftWidth: l } = getComputedStyle(e), c = e.scrollLeft + parseInt(l, 10), f = e.scrollTop + parseInt(u, 10), p = c + e.clientWidth, m = f + e.clientHeight;
  n <= i ? i = n - parseInt(l, 10) : n + a > p && (i += n + a - p), r <= f ? s = r - parseInt(u, 10) : r + o > m && (s += r + o - m), e.scrollLeft = i, e.scrollTop = s;
}
function Cd(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let a = 0;
  for (; t.offsetParent && (a += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      a -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return a;
}
function Ed(e, t) {
  if (document.contains(e)) {
    let i = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(i).overflow === "hidden") {
      let u = wd(e);
      for (; e && u && e !== i && u !== i; )
        av(u, e), e = u, u = wd(e);
    } else {
      var n;
      let { left: u, top: l } = e.getBoundingClientRect();
      e == null || (n = e.scrollIntoView) === null || n === void 0 || n.call(e, {
        block: "nearest"
      });
      let { left: c, top: f } = e.getBoundingClientRect();
      if (Math.abs(u - c) > 1 || Math.abs(l - f) > 1) {
        var r, a, o;
        t == null || (a = t.containingElement) === null || a === void 0 || (r = a.scrollIntoView) === null || r === void 0 || r.call(a, {
          block: "center",
          inline: "center"
        }), (o = e.scrollIntoView) === null || o === void 0 || o.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function zC(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : NC() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
const KC = d.createContext({
  register: () => {
  }
});
KC.displayName = "PressResponderContext";
let Ha = null, UC = /* @__PURE__ */ new Set(), Da = /* @__PURE__ */ new Map(), an = !1, Gs = !1;
function al(e, t) {
  for (let n of UC)
    n(e, t);
}
function qC(e) {
  return !(e.metaKey || !jn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Fo(e) {
  an = !0, qC(e) && (Ha = "keyboard", al("keyboard", e));
}
function Pt(e) {
  Ha = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (an = !0, al("pointer", e));
}
function ov(e) {
  zC(e) && (an = !0, Ha = "virtual");
}
function iv(e) {
  e.target === window || e.target === document || (!an && !Gs && (Ha = "virtual", al("virtual", e)), an = !1, Gs = !1);
}
function sv() {
  an = !1, Gs = !0;
}
function xd(e) {
  if (typeof window > "u" || Da.get(Po(e)))
    return;
  const t = Po(e), n = ta(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    an = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Fo, !0), n.addEventListener("keyup", Fo, !0), n.addEventListener("click", ov, !0), t.addEventListener("focus", iv, !0), t.addEventListener("blur", sv, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Pt, !0), n.addEventListener("pointermove", Pt, !0), n.addEventListener("pointerup", Pt, !0)) : (n.addEventListener("mousedown", Pt, !0), n.addEventListener("mousemove", Pt, !0), n.addEventListener("mouseup", Pt, !0)), t.addEventListener("beforeunload", () => {
    uv(e);
  }, {
    once: !0
  }), Da.set(t, {
    focus: r
  });
}
const uv = (e, t) => {
  const n = Po(e), r = ta(e);
  t && r.removeEventListener("DOMContentLoaded", t), Da.has(n) && (n.HTMLElement.prototype.focus = Da.get(n).focus, r.removeEventListener("keydown", Fo, !0), r.removeEventListener("keyup", Fo, !0), r.removeEventListener("click", ov, !0), n.removeEventListener("focus", iv, !0), n.removeEventListener("blur", sv, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Pt, !0), r.removeEventListener("pointermove", Pt, !0), r.removeEventListener("pointerup", Pt, !0)) : (r.removeEventListener("mousedown", Pt, !0), r.removeEventListener("mousemove", Pt, !0), r.removeEventListener("mouseup", Pt, !0)), Da.delete(n));
};
function XC(e) {
  const t = ta(e);
  let n;
  return t.readyState !== "loading" ? xd(e) : (n = () => {
    xd(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => uv(e, n);
}
typeof document < "u" && XC();
function Qs() {
  return Ha;
}
function Sd(e) {
  const t = ta(e);
  if (Qs() === "virtual") {
    let n = t.activeElement;
    HC(() => {
      t.activeElement === n && e.isConnected && Ta(e);
    });
  } else
    Ta(e);
}
function GC(e) {
  const t = Po(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement))
    return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: o } = e.ownerDocument.defaultView;
    let { display: i, visibility: s } = o(e);
    a = i !== "none" && s !== "hidden" && s !== "collapse";
  }
  return a;
}
function QC(e, t) {
  return !e.hasAttribute("hidden") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function lv(e, t) {
  return e.nodeName !== "#comment" && GC(e) && QC(e, t) && (!e.parentElement || lv(e.parentElement, e));
}
const ol = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], ZC = ol.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
ol.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const JC = ol.join(':not([hidden]):not([tabindex="-1"]),');
function cv(e, t) {
  return !e || !t ? !1 : t.some((n) => n.contains(e));
}
function eE(e, t, n) {
  let r = t != null && t.tabbable ? JC : ZC, a = ta(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(o) {
      var i;
      return !(t == null || (i = t.from) === null || i === void 0) && i.contains(o) ? NodeFilter.FILTER_REJECT : o.matches(r) && lv(o) && (!n || cv(o, n)) && (!(t != null && t.accept) || t.accept(o)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (a.currentNode = t.from), a;
}
class il {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a)
      return;
    let o = new $d({
      scopeRef: t
    });
    a.addChild(o), o.parent = a, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null)
      return;
    let n = this.fastMap.get(t);
    if (!n)
      return;
    let r = n.parent;
    for (let o of this.traverse())
      o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && cv(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0)
      for (let n of t.children)
        yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new il();
    var r;
    for (let a of this.traverse())
      n.addTreeNode(a.scopeRef, (r = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, a.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new $d({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class $d {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
new il();
const tE = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), rE = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function nE(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r)
      return r.direction === "rtl";
    if (n.script)
      return tE.has(n.script);
  }
  let t = e.split("-")[0];
  return rE.has(t);
}
const aE = Symbol.for("react-aria.i18n.locale");
function dv() {
  let e = typeof window < "u" && window[aE] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: nE(e) ? "rtl" : "ltr"
  };
}
let Zs = dv(), va = /* @__PURE__ */ new Set();
function kd() {
  Zs = dv();
  for (let e of va)
    e(Zs);
}
function oE() {
  let e = tv(), [t, n] = Ne(Zs);
  return je(() => (va.size === 0 && window.addEventListener("languagechange", kd), va.add(n), () => {
    va.delete(n), va.size === 0 && window.removeEventListener("languagechange", kd);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const iE = /* @__PURE__ */ d.createContext(null);
function sE() {
  let e = oE();
  return mr(iE) || e;
}
function Od(e) {
  return FC() ? e.altKey : e.ctrlKey;
}
function sa(e) {
  return jn() ? e.metaKey : e.ctrlKey;
}
const uE = 1e3;
function lE(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, a = ve({
    search: "",
    timeout: null
  }).current, o = (i) => {
    let s = cE(i.key);
    if (!s || i.ctrlKey || i.metaKey || !i.currentTarget.contains(i.target))
      return;
    s === " " && a.search.trim().length > 0 && (i.preventDefault(), "continuePropagation" in i || i.stopPropagation()), a.search += s;
    let u = t.getKeyForSearch(a.search, n.focusedKey);
    u == null && (u = t.getKeyForSearch(a.search)), u != null && (n.setFocusedKey(u), r && r(u)), clearTimeout(a.timeout), a.timeout = setTimeout(() => {
      a.search = "";
    }, uE);
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? o : null
    }
  };
}
function cE(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function fv(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: a = !1, shouldFocusWrap: o = !1, disallowEmptySelection: i = !1, disallowSelectAll: s = !1, selectOnFocus: u = t.selectionBehavior === "replace", disallowTypeAhead: l = !1, shouldUseVirtualFocus: c, allowsTabNavigation: f = !1, isVirtualized: p, scrollRef: m = r, linkBehavior: v = "action" } = e, { direction: g } = sE(), h = jC(), w = (N) => {
    if (N.altKey && N.key === "Tab" && N.preventDefault(), !r.current.contains(N.target))
      return;
    const q = (T, C) => {
      if (T != null) {
        if (t.isLink(T) && v === "selection" && u && !Od(N)) {
          eg(() => {
            t.setFocusedKey(T, C);
          });
          let M = m.current.querySelector(`[data-key="${CSS.escape(T.toString())}"]`);
          h.open(M, N);
          return;
        }
        if (t.setFocusedKey(T, C), t.isLink(T) && v === "override")
          return;
        N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(T) : u && !Od(N) && t.replaceSelection(T);
      }
    };
    switch (N.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var J, R;
          N.preventDefault();
          let T = t.focusedKey != null ? n.getKeyBelow(t.focusedKey) : (J = n.getFirstKey) === null || J === void 0 ? void 0 : J.call(n);
          T == null && o && (T = (R = n.getFirstKey) === null || R === void 0 ? void 0 : R.call(n, t.focusedKey)), q(T);
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var ae, H;
          N.preventDefault();
          let T = t.focusedKey != null ? n.getKeyAbove(t.focusedKey) : (ae = n.getLastKey) === null || ae === void 0 ? void 0 : ae.call(n);
          T == null && o && (T = (H = n.getLastKey) === null || H === void 0 ? void 0 : H.call(n, t.focusedKey)), q(T);
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var oe, ue;
          N.preventDefault();
          let T = n.getKeyLeftOf(t.focusedKey);
          T == null && o && (T = g === "rtl" ? (oe = n.getFirstKey) === null || oe === void 0 ? void 0 : oe.call(n, t.focusedKey) : (ue = n.getLastKey) === null || ue === void 0 ? void 0 : ue.call(n, t.focusedKey)), q(T, g === "rtl" ? "first" : "last");
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var me, V;
          N.preventDefault();
          let T = n.getKeyRightOf(t.focusedKey);
          T == null && o && (T = g === "rtl" ? (me = n.getLastKey) === null || me === void 0 ? void 0 : me.call(n, t.focusedKey) : (V = n.getFirstKey) === null || V === void 0 ? void 0 : V.call(n, t.focusedKey)), q(T, g === "rtl" ? "last" : "first");
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          N.preventDefault();
          let T = n.getFirstKey(t.focusedKey, sa(N));
          t.setFocusedKey(T), sa(N) && N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(T) : u && t.replaceSelection(T);
        }
        break;
      case "End":
        if (n.getLastKey) {
          N.preventDefault();
          let T = n.getLastKey(t.focusedKey, sa(N));
          t.setFocusedKey(T), sa(N) && N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(T) : u && t.replaceSelection(T);
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow) {
          N.preventDefault();
          let T = n.getKeyPageBelow(t.focusedKey);
          q(T);
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove) {
          N.preventDefault();
          let T = n.getKeyPageAbove(t.focusedKey);
          q(T);
        }
        break;
      case "a":
        sa(N) && t.selectionMode === "multiple" && s !== !0 && (N.preventDefault(), t.selectAll());
        break;
      case "Escape":
        N.preventDefault(), i || t.clearSelection();
        break;
      case "Tab":
        if (!f) {
          if (N.shiftKey)
            r.current.focus();
          else {
            let T = eE(r.current, {
              tabbable: !0
            }), C, M;
            do
              M = T.lastChild(), M && (C = M);
            while (M);
            C && !C.contains(document.activeElement) && Ta(C);
          }
          break;
        }
    }
  }, S = ve({
    top: 0,
    left: 0
  });
  VC(m, "scroll", p ? null : () => {
    S.current = {
      top: m.current.scrollTop,
      left: m.current.scrollLeft
    };
  });
  let x = (N) => {
    if (t.isFocused) {
      N.currentTarget.contains(N.target) || t.setFocused(!1);
      return;
    }
    if (N.currentTarget.contains(N.target)) {
      if (t.setFocused(!0), t.focusedKey == null) {
        let R = (H) => {
          H != null && (t.setFocusedKey(H), u && t.replaceSelection(H));
        }, ae = N.relatedTarget;
        var q, J;
        ae && N.currentTarget.compareDocumentPosition(ae) & Node.DOCUMENT_POSITION_FOLLOWING ? R((q = t.lastSelectedKey) !== null && q !== void 0 ? q : n.getLastKey()) : R((J = t.firstSelectedKey) !== null && J !== void 0 ? J : n.getFirstKey());
      } else
        p || (m.current.scrollTop = S.current.top, m.current.scrollLeft = S.current.left);
      if (!p && t.focusedKey != null) {
        let R = m.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
        R && (R.contains(document.activeElement) || Ta(R), Qs() === "keyboard" && Ed(R, {
          containingElement: r.current
        }));
      }
    }
  }, O = (N) => {
    N.currentTarget.contains(N.relatedTarget) || t.setFocused(!1);
  };
  const B = ve(a);
  je(() => {
    if (B.current) {
      let N = null;
      a === "first" && (N = n.getFirstKey()), a === "last" && (N = n.getLastKey());
      let q = t.selectedKeys;
      if (q.size) {
        for (let J of q)
          if (t.canSelectItem(J)) {
            N = J;
            break;
          }
      }
      t.setFocused(!0), t.setFocusedKey(N), N == null && !c && Sd(r.current);
    }
  }, []);
  let F = ve(t.focusedKey);
  je(() => {
    let N = Qs();
    if (t.isFocused && t.focusedKey != null && (m != null && m.current)) {
      let q = m.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
      q && (N === "keyboard" || B.current) && (p || av(m.current, q), N !== "virtual" && Ed(q, {
        containingElement: r.current
      }));
    }
    t.isFocused && t.focusedKey == null && F.current != null && Sd(r.current), F.current = t.focusedKey, B.current = !1;
  }, [
    p,
    m,
    t.focusedKey,
    t.isFocused,
    r
  ]);
  let L = {
    onKeyDown: w,
    onFocus: x,
    onBlur: O,
    onMouseDown(N) {
      m.current === N.target && N.preventDefault();
    }
  }, { typeSelectProps: j } = lE({
    keyboardDelegate: n,
    selectionManager: t
  });
  l || (L = OC(j, L));
  let I;
  return c || (I = t.focusedKey == null ? 0 : -1), {
    collectionProps: {
      ...L,
      tabIndex: I
    }
  };
}
const dE = D.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc(100% + ${k.XS});
  width: 100vw;
  max-width: 12.375rem;
  padding: ${k.M} ${k.S} ${k.M} ${k.S};
  margin: 0;
  list-style: none;

  ${({ alignRight: e }) => e ? _`
          right: 0;
        ` : _`
          left: 0;
        `};
  border-radius: 0.5rem;
  background-color: ${y.white};
  z-index: 1000;
  ${ir};
  outline: 0;
`, fE = D.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`, pE = D.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding-bottom: ${k.XS};
  margin-bottom: ${k.XXS};
  border-bottom: 1px solid ${y.grey100};

  > * {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`, hE = D.li`
  position: relative;
  list-style: none;

  padding: ${k.S} 0 ${k.S} ${k.S};
  margin: 0;
  height: 2.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  white-space: nowrap;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  user-select: none;
  cursor: pointer;
  color: ${y.black};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${tt};
  transition: color 0.1s ease-out;
  border-radius: 0.25rem;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${({ isFocused: e, isFocusVisible: t }) => (
  // &:focus
  e && t && _`
      background-color: ${y.grey100};
    `
)};

  &:hover {
    background-color: ${y.grey100};
  }

  &:active {
    background-color: ${y.grey300};
  }

  ${({ isDisabled: e }) => e && _`
      pointer-events: auto;
      color: ${y.grey400};
      cursor: not-allowed;
    `}

  ${({ isSubMenuItem: e, isDisabled: t }) => e && t && _`
      cursor: pointer;
      &:hover {
        background-color: transparent;
      }
      &:active {
        background-color: transparent;
      }
    `}
`;
class vE {
  constructor(t, n) {
    oa(this, "collator");
    oa(this, "collection");
    oa(this, "disabledKeys");
    /* The KeyboardDelegate interface doesn't allow us to return null from its functions,
     * so we return this string instead to represent a "null key".
     */
    oa(this, "NULL_KEY", "NULL_KEY_STRING_P7vMeJukUVgwboG3VFUQ_ywNsqgFmCHddbpZL8eYB_ArnQikyWNKQmXLVUej0H");
    this.collator = new Intl.Collator("sv"), this.collection = t, this.disabledKeys = n;
  }
  isNullKey(t) {
    return t === this.NULL_KEY;
  }
  getKeyAbove(t) {
    const { collection: n, disabledKeys: r } = this;
    let a = n.getKeyBefore(t);
    for (; a !== null && !this.isNullKey(t); ) {
      const o = n.getItem(a);
      if ((o == null ? void 0 : o.type) === "item" && !r.has(o.key))
        return a;
      a = n.getKeyBefore(a);
    }
    return t;
  }
  getKeyRightOf(t) {
    const { collection: n, disabledKeys: r } = this, a = n.getItem(t), o = (a == null ? void 0 : a.childNodes) && [...a.childNodes][0];
    return (o == null ? void 0 : o.type) === "item" && !r.has(o.key) ? o.key : t;
  }
  getKeyLeftOf(t) {
    const { collection: n, disabledKeys: r } = this, a = n.getItem(t), o = (a == null ? void 0 : a.parentKey) != null && n.getItem(a == null ? void 0 : a.parentKey);
    return o && o.type === "item" && !r.has(o.key) ? o.key : t;
  }
  getKeyBelow(t) {
    const { collection: n, disabledKeys: r } = this;
    let a = n.getKeyAfter(t);
    for (; a != null && !this.isNullKey(a); ) {
      const o = n.getItem(a);
      if ((o == null ? void 0 : o.type) === "item" && !r.has(o.key))
        return a;
      a = n.getKeyAfter(a);
    }
    return t;
  }
  getFirstKey() {
    const { collection: t, disabledKeys: n } = this;
    let r = t.getFirstKey();
    for (; r !== null && !this.isNullKey(r); ) {
      const a = t.getItem(r);
      if ((a == null ? void 0 : a.type) === "item" && !n.has(a.key))
        return r;
      const o = t.getKeyAfter(r);
      o && (r = o);
    }
    return this.NULL_KEY;
  }
  getLastKey() {
    const { collection: t, disabledKeys: n } = this;
    let r = t.getLastKey();
    for (; r !== null && !this.isNullKey(r); ) {
      const a = t.getItem(r);
      if ((a == null ? void 0 : a.type) === "item" && !n.has(a.key))
        return r;
      const o = t.getKeyBefore(r);
      o && (r = o);
    }
    return this.NULL_KEY;
  }
  getKeyForSearch(t, n = this.getFirstKey()) {
    const { collator: r, collection: a } = this;
    let o = n;
    const i = a.getLastKey();
    for (; o !== null && !this.isNullKey(o); ) {
      const s = a.getItem(o);
      if (s != null && s.textValue && r.compare(
        t.toLowerCase(),
        s.textValue.toLocaleLowerCase().slice(0, t.length)
      ) === 0)
        return o;
      i && i === o ? o = null : o = this.getKeyBelow(o);
    }
    return n;
  }
}
const pv = vE, mE = 75, gE = 20, as = 4, yE = ({ submenuRef: e, isOpen: t }) => {
  const n = Le(() => {
    const r = e == null ? void 0 : e.current;
    if (r) {
      const { x: a, width: o, y: i, height: s } = r.getBoundingClientRect(), u = o - (window.innerWidth - a);
      if (u > 0)
        if (u < mE)
          r.style.width = `${window.innerWidth - a - as}px`;
        else {
          r.style.left = "unset", r.style.right = "100%";
          const { right: c } = r.getBoundingClientRect();
          c < o && (r.style.width = `${c - as}px`);
        }
      const l = s - (window.innerHeight - i);
      l > 0 && (l < gE ? r.style.height = `${window.innerHeight - i - as}px` : (r.style.top = "unset", r.style.bottom = "0"));
    }
  }, []);
  je(() => {
    n();
  }, [t]), Oa(() => (window.addEventListener("resize", n), () => window.removeEventListener("resize", n)), [n]);
};
var sl = {}, bE = We, wE = Ye;
Object.defineProperty(sl, "__esModule", {
  value: !0
});
var hv = sl.default = void 0, DE = wE(d), CE = bE(He()), EE = (0, CE.default)(/* @__PURE__ */ DE.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
hv = sl.default = EE;
const xE = D.ul`
  position: absolute;
  top: -${k.M};
  left: 100%;
  background-color: ${y.white};
  width: 12.375rem;
  padding: ${k.M} ${k.S} ${k.M} ${k.S};
  border-radius: 0.25rem;
  ${ir};
`, SE = ({ node: e, state: t, menuTriggerState: n }) => {
  const r = ve(null), a = !!e.parentKey, o = t.disabledKeys.has(e.key), { menuItemProps: i } = Hp(
    {
      key: e.key,
      isDisabled: t.disabledKeys.has(e.key),
      closeOnSelect: !0,
      onClose: () => {
      },
      onAction: () => {
      }
    },
    t,
    r
  );
  delete i.onPointerEnter;
  const { isFocusVisible: s, focusProps: u, isFocused: l } = vt(), c = e.hasChildNodes && t.expandedKeys.has(e.key), f = e.parentKey && t.expandedKeys.has(e.parentKey) || !1, p = t.selectionManager.isSelected(e.key), { focusProps: m } = q0({
    onFocus: () => {
      e.hasChildNodes && c && t.toggleKey(e.key);
    }
  }), { hoverProps: v } = X0({
    onHoverStart: () => {
      !c && !o && t.toggleKey(e.key);
    },
    onHoverEnd: () => {
      c && !o && (t.toggleKey(e.key), t.expandedKeys.clear());
    }
  }), g = (I) => {
    var q;
    if (I == null || I.stopPropagation(), I == null || I.preventDefault(), o)
      return;
    e.hasChildNodes ? t.toggleKey(e.key) : t.selectionManager.selectionMode === "none" && (n.close(), t.expandedKeys.clear()), (q = e.value) == null || q.onClick();
    const N = e.childNodes && [...e.childNodes][0];
    N && t.selectionManager.setFocusedKey(N.key);
  }, { keyboardProps: h } = Jn({
    onKeyDown: (I) => {
      e.childNodes && (!c && I.key === "ArrowRight" ? t.toggleKey(e.key) : f && (I.key === "Escape" || I.key === "ArrowLeft") && e.parentKey && t.toggleKey(e.parentKey)), (I.key === "Enter" || I.key === " ") && g(), I.continuePropagation();
    }
  }), w = ve(null);
  yE({ submenuRef: w, isOpen: c });
  const S = d.useRef(null), x = Tt({}), { triggerProps: O, tooltipProps: B } = Bt({}, x, r), F = () => {
    var N, q;
    return (S.current ? ((N = S.current) == null ? void 0 : N.offsetWidth) < ((q = S.current) == null ? void 0 : q.scrollWidth) && (x.isOpen || l && s) : !1) ? e.textValue : "";
  }, j = (() => {
    var N;
    const I = (N = e.value) == null ? void 0 : N.disabledTooltipText;
    return x.isOpen && o && I || "";
  })() || F();
  return /* @__PURE__ */ d.createElement(
    hE,
    {
      isSubMenuItem: a,
      isFocused: l,
      isFocusVisible: s,
      isDisabled: t.disabledKeys.has(e.key),
      "aria-expanded": c || void 0,
      "aria-selected": p,
      ref: r,
      ...xe(
        O,
        v,
        u,
        h,
        i,
        m
      ),
      onClick: g
    },
    /* @__PURE__ */ d.createElement("span", { ref: S }, e.rendered),
    e.hasChildNodes && /* @__PURE__ */ d.createElement(hv, null),
    j && /* @__PURE__ */ d.createElement(At, { parentRef: r, ...B, "aria-hidden": !0 }, j),
    c && /* @__PURE__ */ d.createElement(xE, { ref: w, role: "group", ...i }, /* @__PURE__ */ d.createElement(vv, { nodes: e.childNodes, state: t, menuTriggerState: n }))
  );
}, vv = ({ nodes: e, state: t, menuTriggerState: n }) => /* @__PURE__ */ d.createElement(fn, { contain: !0, restoreFocus: !0, autoFocus: !0 }, Array.from(e).map((r) => /* @__PURE__ */ d.createElement(
  SE,
  {
    node: r,
    key: r.key,
    state: t,
    menuTriggerState: n
  }
))), $E = ({
  menuTriggerState: e,
  alignRight: t = !1,
  heading: n,
  subheading: r,
  autofocus: a = !0,
  ...o
}) => {
  const i = qp({
    ...o,
    disabledKeys: Array.from(o.items).reduce((f, p) => (p.isDisabled && f.push(p.key), p.submenuItems && p.submenuItems.forEach((m) => {
      m.isDisabled && f.push(m.key);
    }), f), []),
    children: (f) => {
      const p = f.kind === "reactnode" ? f.textValue : f.label, m = f.kind === "reactnode" ? f.labelReactNode : f.label;
      return /* @__PURE__ */ d.createElement(
        nn,
        {
          key: f.key,
          textValue: p,
          childItems: f.submenuItems && f.submenuItems.length ? f.submenuItems : void 0
        },
        m
      );
    }
  }), s = ve(null), u = Nn(
    () => new pv(i.collection, i.disabledKeys),
    [i.collection, i.disabledKeys]
  ), { collectionProps: l } = fv({
    keyboardDelegate: u,
    ref: s,
    selectionManager: i.selectionManager,
    autoFocus: a ? "first" : void 0
  }), { overlayProps: c } = dn(
    {
      onClose: () => {
        e.close(), i.expandedKeys.clear();
      },
      isDismissable: !0,
      shouldCloseOnBlur: !0,
      isOpen: e.isOpen
    },
    s
  );
  return Gu({ ref: s, alignRight: t, isOpen: e.isOpen }), /* @__PURE__ */ d.createElement(
    dE,
    {
      alignRight: t,
      ...xe(l, c, o),
      ref: s,
      role: "group",
      className: "syntax-menu-listbox"
    },
    (n || r) && /* @__PURE__ */ d.createElement(pE, null, n && /* @__PURE__ */ d.createElement(Uu, null, n), r && /* @__PURE__ */ d.createElement(hn, null, r)),
    /* @__PURE__ */ d.createElement(fE, null, /* @__PURE__ */ d.createElement(vv, { nodes: i.collection, state: i, menuTriggerState: e }))
  );
}, kE = D.div`
  position: relative;
  overflow: visible;
  display: inline-flex;
  flex-direction: column;

  ${({ iconColor: e }) => e && _`
      && > button > svg {
        color: ${e};
      }
      && > button:hover > svg {
        color: ${y.black};
      }
    `}
`, OE = ({
  triggerButton: e,
  triggerOnClick: t,
  isDisabled: n,
  heading: r,
  subheading: a,
  className: o,
  iconColor: i,
  ...s
}) => {
  const u = ve(null), l = Xp({}), { menuProps: c, menuTriggerProps: f } = Yp(
    { type: "menu" },
    l,
    u
  ), p = ve(!1);
  return /* @__PURE__ */ d.createElement(kE, { className: o, role: "menu", iconColor: i }, /* @__PURE__ */ d.createElement(
    e,
    {
      isOpen: l.isOpen,
      isDisabled: n,
      triggerRef: u,
      "aria-controls": f["aria-controls"],
      "aria-expanded": f["aria-expanded"],
      "aria-haspopup": f["aria-haspopup"],
      id: f.id,
      onClick: () => {
        t && t(), p.current || l.toggle(), p.current = !1;
      },
      onPointerDown: () => {
        l.isOpen && (p.current = !0);
      }
    }
  ), l.isOpen && /* @__PURE__ */ d.createElement(
    $E,
    {
      ...xe(c, s),
      menuTriggerState: l,
      heading: r,
      subheading: a
    }
  ));
}, GP = OE;
var ul = {}, BE = We, TE = Ye;
Object.defineProperty(ul, "__esModule", {
  value: !0
});
var mv = ul.default = void 0, AE = TE(d), PE = BE(He()), ME = (0, PE.default)(/* @__PURE__ */ AE.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert");
mv = ul.default = ME;
const FE = ({
  triggerRef: e,
  // Default to "Meny" if aria-label is missing
  "aria-label": t = "Meny",
  ...n
}) => /* @__PURE__ */ d.createElement(
  pr,
  {
    ...n,
    isSmall: !0,
    color: "grey",
    icon: /* @__PURE__ */ d.createElement(mv, null),
    buttonRef: e,
    "aria-label": t
  }
), QP = FE, RE = D.label`
  height: ${k.XXL};
  display: flex;
  align-items: center;
  ${(e) => e.isDisabled && _`
      color: ${y.grey400};
    `}
`, _E = D.div`
  display: flex;
  align-items: center;
  margin-left: ${k.M};
  width: 100%;
`, NE = D.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: left;
`, IE = D.span`
  font-weight: ${(e) => e.isSelected ? "600" : "normal"};
  font-size: ${k.M};
  line-height: 1.25rem;
`, LE = D.span`
  color: ${y.grey500};
  font-size: 0.875rem;
  line-height: 1.25rem;
`, jE = D(Jh)`
  && {
    background-color: ${y.paradisoGreen};
    margin-left: ${k.M};

    > h6 {
      color: ${y.white};
    }
  }
`, WE = D.div`
  display: flex;
  align-items: center;
`, YE = D.svg`
  margin: -2px;
`, HE = ({ isSelected: e, isFocusVisible: t, isDisabled: n }) => {
  const r = n ? y.grey400 : y.frenchBlue;
  return /* @__PURE__ */ d.createElement(WE, null, /* @__PURE__ */ d.createElement(YE, { width: 28, height: 28, "aria-hidden": "true" }, e && /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 5, fill: r }), /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 9, fill: "none", stroke: r, strokeWidth: 2 }), t && /* @__PURE__ */ d.createElement("circle", { cx: 14, cy: 14, r: 12, fill: "none", stroke: r, strokeWidth: 2 })));
}, VE = (e) => {
  const t = d.useRef(null), { state: n, value: r, label: a, sublabel: o, badgeText: i, rightSection: s, isDisabled: u = !1 } = e, { inputProps: l } = Lp(e, n, t), { isFocusVisible: c, focusProps: f } = vt(), p = n.selectedValue === r;
  return /* @__PURE__ */ d.createElement(RE, { isDisabled: u }, /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement("input", { ...l, ...f, ref: t })), /* @__PURE__ */ d.createElement(
    HE,
    {
      isFocusVisible: c,
      isSelected: p,
      isDisabled: u
    }
  ), /* @__PURE__ */ d.createElement(_E, null, /* @__PURE__ */ d.createElement(NE, null, /* @__PURE__ */ d.createElement(IE, { isSelected: p }, a), o && /* @__PURE__ */ d.createElement(LE, null, o)), i && /* @__PURE__ */ d.createElement(jE, null, i), s));
}, zE = VE, KE = D.div`
  display: grid;
  gap: ${k.M};
`, UE = ({ options: e, className: t, ...n }) => {
  const r = Kp(n), { radioGroupProps: a, labelProps: o } = jp(n, r);
  return /* @__PURE__ */ d.createElement(KE, { ...xe(a, o), className: t }, e.map(({ label: i, sublabel: s, badgeText: u, value: l, isDisabled: c, rightSection: f }) => /* @__PURE__ */ d.createElement(
    zE,
    {
      key: l,
      value: l,
      state: r,
      isDisabled: c || !1,
      label: i,
      "aria-label": i,
      sublabel: s,
      badgeText: u,
      rightSection: f
    }
  )));
}, qE = ({ onSelect: e, options: t, ...n }) => /* @__PURE__ */ d.createElement(
  UE,
  {
    options: t,
    ...n,
    onChange: (r) => {
      const a = t.find((o) => o.value === r);
      a && e(a);
    }
  }
), ZP = qE, XE = D.div`
  width: fit-content;
  margin: 0;
  padding: 0;
  display: inline-flex;
  background-color: ${y.grey50};
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  user-select: none;
  ${ai};
  ${tt};

  ${Xu};

  ${({ isFocused: e, isFocusVisible: t }) => (
  // focus with keyboard
  e && t && _`
      background-color: ${y.grey100};
    `
)};

  &:hover {
    background-color: ${y.grey100};
  }

  &:active {
    background-color: ${y.grey200};
    border-radius: 0.5rem;
  }

  ${pn};
`, GE = ({ children: e, ...t }) => {
  const { keyboardProps: n } = Jn({
    onKeyUp: (r) => {
      (r.key === "Enter" || r.key === " ") && t.onClick && t.onClick(r);
    }
  });
  return /* @__PURE__ */ d.createElement(Lr, { ...t }, (r) => /* @__PURE__ */ d.createElement(
    XE,
    {
      ...xe(r, n),
      role: "button",
      tabIndex: r.isDisabled ? -1 : 0
    },
    e
  ));
}, JP = GE, QE = ({ width: e, height: t, viewBox: n, white: r }) => /* @__PURE__ */ d.createElement(
  "svg",
  {
    fill: r ? "#fff" : void 0,
    viewBox: n || "0 0 90 26",
    width: e || 80,
    height: t || 48
  },
  /* @__PURE__ */ d.createElement("path", { d: "M10.287 12.903c0 2.784-.945 4.937-3.992 4.937-2.364 0-3.939-2-3.939-5.2s1.576-5.2 3.939-5.2c3.309.053 3.992 2.73 3.992 5.463zM.78 20.992c.368 3.362 2.311 4.517 5.568 4.517 5.148 0 5.568-3.362 5.568-5.988V6.285H10.34v2.1h-.053a4.293 4.293 0 0 0-4.2-2.416c-2.889 0-5.305 2.364-5.305 6.828 0 4.727 3.152 6.513 5.41 6.513a4.5 4.5 0 0 0 4.15-2.311l.053.053v2.626c0 3.834-1.786 4.412-3.992 4.412-2.154 0-3.677-.945-3.939-3.414l-1.684.316zM15.224.192H16.8v18.8h-1.576z" }),
  /* @__PURE__ */ d.createElement(
    "path",
    {
      fill: r ? "#fff" : "#ed1b2e",
      d: "M21.16 11.275a3.974 3.974 0 0 1 3.939-3.782c2.626 0 3.572 1.943 3.939 3.782H21.16zm9.665 1.313c-.158-3.729-2-6.618-5.725-6.618-3.152 0-5.725 2.311-5.725 6.671 0 4.307 2.574 6.671 5.725 6.671a5.814 5.814 0 0 0 5.725-3.782l-1.471-.42a4.108 4.108 0 0 1-4.1 2.679c-2.836 0-4.044-2.049-4.044-4.885v-.368h9.612l.003.052zm3.519-1.313a3.974 3.974 0 0 1 3.939-3.782c2.626 0 3.572 1.943 3.939 3.782h-7.878zm9.665 1.313c-.158-3.729-2-6.618-5.725-6.618-3.152 0-5.725 2.311-5.725 6.671 0 4.307 2.574 6.671 5.725 6.671a5.814 5.814 0 0 0 5.725-3.782l-1.471-.42a4.108 4.108 0 0 1-4.1 2.679c-2.836 0-4.044-2.049-4.044-4.885v-.368h9.612l.003.052z"
    }
  ),
  /* @__PURE__ */ d.createElement("path", { d: "M46.792 6.285h1.576V8.07h.053a3.844 3.844 0 0 1 3.414-2.1 8.51 8.51 0 0 1 1.156.053v1.366a3.753 3.753 0 0 0-1.051-.105c-2.469 0-3.572 1.786-3.572 4.36v7.3h-1.576V6.285zm15.864 10.873h-.053a4.015 4.015 0 0 1-3.782 2.154c-3.1 0-4.465-1.786-4.465-4.412V6.285h1.576v8.089c0 2.574 1.1 3.414 3.1 3.414 1.891 0 3.624-1.261 3.624-4.1V6.285h1.576v12.659h-1.576v-1.786zm14.023-4.517c0 3.2-1.576 5.2-3.834 5.2-3.1 0-3.729-2.679-3.729-5.2 0-2.416.63-5.2 3.782-5.2 2.205.052 3.781 1.996 3.781 5.2zm-9.087 12.921h1.576V17.21h.053c.63 1.418 2 2.1 3.834 2.1 2.521 0 5.2-1.628 5.2-6.881 0-4.255-2.521-6.461-5.305-6.461a4.016 4.016 0 0 0-3.729 2.206h-.053V6.285h-1.576v19.277zm13.709-10.085a3.356 3.356 0 0 0 3.677 2.521c1.313 0 3.1-.525 3.1-2.574 0-3.782-7.511-.893-7.511-5.935 0-1.838 1.523-3.467 4.307-3.467 2.469 0 4.15.735 4.78 2.889l-1.523.368a2.745 2.745 0 0 0-3.046-1.943c-2.364 0-2.994.945-2.994 2.206 0 3.257 7.511.84 7.511 5.935 0 2.1-1.733 3.834-4.937 3.834-1.891 0-3.729-.525-4.99-3.362l1.626-.472z" })
), eM = QE, ZE = ({ width: e, height: t, viewBox: n, white: r }) => /* @__PURE__ */ d.createElement("svg", { viewBox: n || "0 0 25 15", width: e || 25, height: t || 15 }, /* @__PURE__ */ d.createElement("g", { fill: r ? "#fff" : "#ed1b2e", fillRule: "nonzero" }, /* @__PURE__ */ d.createElement("path", { d: "M2.16 6.275a3.974 3.974 0 0 1 3.939-3.782c2.626 0 3.572 1.943 3.939 3.782H2.16zm9.665 1.313C11.667 3.859 9.825.97 6.1.97 2.948.97.375 3.281.375 7.641c0 4.307 2.574 6.671 5.725 6.671a5.814 5.814 0 0 0 5.725-3.782l-1.471-.42a4.108 4.108 0 0 1-4.1 2.679c-2.836 0-4.044-2.049-4.044-4.885v-.368h9.612l.003.052zM15.344 6.275a3.974 3.974 0 0 1 3.939-3.782c2.626 0 3.572 1.943 3.939 3.782h-7.878zm9.665 1.313c-.158-3.729-2-6.618-5.725-6.618-3.152 0-5.725 2.311-5.725 6.671 0 4.307 2.574 6.671 5.725 6.671a5.814 5.814 0 0 0 5.725-3.782l-1.471-.42a4.108 4.108 0 0 1-4.1 2.679c-2.836 0-4.044-2.049-4.044-4.885v-.368h9.612l.003.052z" }))), JE = ZE, e5 = D.div`
  ${({ isLarge: e }) => e ? _`
          width: 2.5rem;
          height: 2.5rem;
        ` : _`
          width: 2rem;
          height: 2rem;
        `};
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  background-color: ${({ backgroundColor: e }) => e};
  color: ${({ textColor: e }) => e};

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  > span {
    font-size: ${({ isLarge: e }) => e ? "1.25rem" : "1rem"};
    font-weight: 600;
    line-height: 1;
  }
`, t5 = ({
  fullName: e,
  imgSrc: t,
  color: n,
  invertColors: r,
  isLarge: a = !1,
  displayFullNameOnHover: o = !1,
  isGleerups: i = !1,
  className: s
}) => {
  const u = ve(null), l = Tt({}), { triggerProps: c, tooltipProps: f } = Bt({}, l, u), p = o ? c : {}, [m, v] = Ne(!1), g = e.split(" ").slice(0, 2).map((x) => x.charAt(0)), h = t && !m, w = r ? y.white : n, S = r ? n : y.white;
  return /* @__PURE__ */ d.createElement(
    e5,
    {
      className: s,
      backgroundColor: h ? "transperent" : w,
      textColor: S,
      isLarge: a,
      ref: u,
      ...p
    },
    h && /* @__PURE__ */ d.createElement("img", { src: t, alt: "Avatar", onError: () => v(!0) }),
    !h && i && /* @__PURE__ */ d.createElement(JE, null),
    !h && !i && /* @__PURE__ */ d.createElement("span", null, g),
    l.isOpen && o && /* @__PURE__ */ d.createElement(At, { parentRef: u, ...f }, e)
  );
}, r5 = t5, n5 = D.button`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  width: 2rem;
  height: 2rem;

  ${tt};

  > div {
    height: 1.5rem;
    width: 1.5rem;
    > span {
      font-size: 0.625rem;
    }
  }

  &:hover {
    background-color: ${y.grey200};
    cursor: pointer;
  }

  &:active {
    background-color: ${y.grey300};
  }
`, a5 = ({
  fullName: e,
  color: t,
  imgSrc: n,
  onClick: r,
  triggerRef: a,
  ...o
}) => {
  const { isFocusVisible: i, focusProps: s } = vt();
  return /* @__PURE__ */ d.createElement(
    n5,
    {
      ref: a,
      onClick: r,
      isFocusVisible: i,
      ...s,
      ...o
    },
    /* @__PURE__ */ d.createElement(r5, { fullName: e, color: t, imgSrc: n })
  );
}, tM = a5, o5 = (e) => /* @__PURE__ */ U.createElement("svg", { id: "lock", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 400 400", ...e }, /* @__PURE__ */ U.createElement("defs", null, /* @__PURE__ */ U.createElement("style", null, ".cls-1,.cls-3{fill:#ababad;}.cls-2{fill:#d0d0d2;}.cls-3{opacity:0.5;}.cls-4{fill:#8a8a8c;}.cls-5{fill:#e2e2e4;}.cls-6{fill:none;stroke:#d0d0d2;stroke-miterlimit:10;stroke-width:4px;}.cls-7{fill:#505052;}")), /* @__PURE__ */ U.createElement("path", { className: "cls-1", d: "M288.51,141.14v90.32H256V141.14a58.68,58.68,0,0,0-117.35,0v90.32H106.22V141.14a91.15,91.15,0,0,1,182.29,0Z" }), /* @__PURE__ */ U.createElement("rect", { className: "cls-2", x: 77.14, y: 174.04, width: 245.72, height: 175.96, rx: 8.21 }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M200,174H315a7.61,7.61,0,0,1,7.61,7.61V342.39A7.61,7.61,0,0,1,315,350H200a0,0,0,0,1,0,0V174A0,0,0,0,1,200,174Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-4", d: "M308,174h7.27a7.61,7.61,0,0,1,7.61,7.61V342.39a7.61,7.61,0,0,1-7.61,7.61H308a0,0,0,0,1,0,0V174A0,0,0,0,1,308,174Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-5", d: "M77.14,174h7.31a7.61,7.61,0,0,1,7.61,7.61V342.39A7.61,7.61,0,0,1,84.45,350H77.14a0,0,0,0,1,0,0V174A0,0,0,0,1,77.14,174Z", transform: "translate(169.2 524.04) rotate(-180)" }), /* @__PURE__ */ U.createElement("path", { className: "cls-6", d: "M121.42,111.21c.43-1.14.87-2.27,1.34-3.39a82.33,82.33,0,0,1,75.83-50.26" }), /* @__PURE__ */ U.createElement("path", { className: "cls-7", d: "M223.86,275.35a23.86,23.86,0,1,0-33,22v22.55a2.21,2.21,0,0,0,2.21,2.21h13.86a2.21,2.21,0,0,0,2.21-2.21V297.39A23.85,23.85,0,0,0,223.86,275.35Z" })), i5 = o5, s5 = (e) => /* @__PURE__ */ U.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 400 400", ...e }, /* @__PURE__ */ U.createElement("defs", null, /* @__PURE__ */ U.createElement("style", null, ".cls-1{fill:#ababad;}.cls-2{fill:#8a8a8c;}.cls-3{fill:#d0d0d2;}.cls-4{fill:#eeeef0;}.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}.cls-6{fill:#505052;}")), /* @__PURE__ */ U.createElement("g", { id: "notfound" }, /* @__PURE__ */ U.createElement("path", { className: "cls-1", d: "M243.39,240.14l-8.87,5a5.57,5.57,0,0,1-7.53-2l-15.25-25.95a5.35,5.35,0,0,1,2-7.39l8.87-5a5.55,5.55,0,0,1,7.52,2l15.25,25.95A5.36,5.36,0,0,1,243.39,240.14Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-2", d: "M236.57,217.71l-6-10.19a6.43,6.43,0,0,0-8.69-2.29l-7.4,4.2a6.17,6.17,0,0,0-2.44,8.28Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M248.93,237l-20.14,11.42a2,2,0,0,1-2.74-.72l-2.12-3.61a1.94,1.94,0,0,1,.73-2.69L244.8,230a2,2,0,0,1,2.74.72l2.12,3.61A2,2,0,0,1,248.93,237Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M236.79,180.72l-44.06,25.47,8,18.25a91.81,91.81,0,0,0,39.86-20.55l-4.06-8.47" }), /* @__PURE__ */ U.createElement("ellipse", { className: "cls-1", cx: 179.55, cy: 137.03, rx: 88.6, ry: 87.03 }), /* @__PURE__ */ U.createElement("ellipse", { className: "cls-2", cx: 179.55, cy: 137.03, rx: 76.64, ry: 75.28 }), /* @__PURE__ */ U.createElement("ellipse", { className: "cls-4", cx: 179.55, cy: 137.03, rx: 68.58, ry: 67.37 }), /* @__PURE__ */ U.createElement("path", { className: "cls-5", d: "M126.58,137.85c-.11-.65-.21-1.3-.29-1.95a44.45,44.45,0,0,1,22.4-44.21" }), /* @__PURE__ */ U.createElement("path", { className: "cls-2", d: "M301.12,347l-1.23.69a19.38,19.38,0,0,1-26.22-6.9L220.6,250.54a3.08,3.08,0,0,1,1.16-4.24l29-16.45a3.18,3.18,0,0,1,4.31,1.13l53.06,90.29A18.68,18.68,0,0,1,301.12,347Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M202.23,191.41a80.24,80.24,0,0,1-43.58,9.76,69.45,69.45,0,0,0,51.07-3.65c33.75-16.24,47.84-56.1,31.77-89.36A77.65,77.65,0,0,1,202.23,191.41Z" }), /* @__PURE__ */ U.createElement("polygon", { className: "cls-6", points: "261.57 242.17 227.21 261.65 225.52 258.77 259.88 239.28 261.57 242.17" }), /* @__PURE__ */ U.createElement("polygon", { className: "cls-6", points: "264.63 247.59 230.28 267.08 228.58 264.2 262.94 244.71 264.63 247.59" }))), u5 = s5, l5 = (e) => /* @__PURE__ */ U.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 400 400", ...e }, /* @__PURE__ */ U.createElement("defs", null, /* @__PURE__ */ U.createElement("style", null, ".cls-1{fill:#ababad;}.cls-2{fill:#eeeef0;}.cls-3{fill:#505052;}.cls-4{fill:#636365;}.cls-11,.cls-5{fill:#fff;}.cls-10,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-10,.cls-11,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#d0d0d2;stroke-linecap:round;stroke-linejoin:round;}.cls-6{stroke-dasharray:8.03 8.03;}.cls-7{stroke-dasharray:8.48 8.48;}.cls-8{stroke-dasharray:7.84 7.84;}.cls-9{stroke-dasharray:8.09 8.09;}.cls-10{stroke-dasharray:8.12 8.12;}.cls-11{stroke-dasharray:8 8;}")), /* @__PURE__ */ U.createElement("g", { id: "missing" }, /* @__PURE__ */ U.createElement("rect", { className: "cls-1", x: 41, y: 138.38, width: 300, height: 210.57, rx: 6.98 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-2", x: 41, y: 137.59, width: 300, height: 208.07, rx: 6.98 }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M48,137.59H334a7,7,0,0,1,7,7v17.93a0,0,0,0,1,0,0H41a0,0,0,0,1,0,0V144.56A7,7,0,0,1,48,137.59Z" }), /* @__PURE__ */ U.createElement("circle", { className: "cls-4", cx: 328.68, cy: 150.04, r: 5.4 }), /* @__PURE__ */ U.createElement("circle", { className: "cls-4", cx: 314.9, cy: 150.04, r: 5.4 }), /* @__PURE__ */ U.createElement("circle", { className: "cls-4", cx: 302.01, cy: 150.04, r: 5.4 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-1", x: 328.68, y: 99.07, width: 5.18, height: 23.21, rx: 2.59 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-1", x: 348.61, y: 104.36, width: 5.18, height: 28.54, rx: 2.59, transform: "translate(186.75 -213.59) rotate(45)" }), /* @__PURE__ */ U.createElement("path", { className: "cls-1", d: "M347.54,138.24h0a2.59,2.59,0,0,1,2.59-2.59l20.44.22a2.59,2.59,0,0,1,2.59,2.6h0a2.59,2.59,0,0,1-2.59,2.59l-20.44-.23A2.59,2.59,0,0,1,347.54,138.24Z" }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 109.23, y: 187.48, width: 204.75, height: 29.9, rx: 2.03 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-6", x: 109.23, y: 187.48, width: 204.75, height: 29.9, rx: 2.03 }), /* @__PURE__ */ U.createElement("circle", { className: "cls-5", cx: 84.22, cy: 202.43, r: 16.19 }), /* @__PURE__ */ U.createElement("circle", { className: "cls-7", cx: 84.22, cy: 202.43, r: 16.19 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 187.77, y: 229.29, width: 126.2, height: 16.19, rx: 1.56 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-8", x: 187.77, y: 229.29, width: 126.2, height: 16.19, rx: 1.56 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 187.77, y: 251.73, width: 126.2, height: 45.25, rx: 1.72 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-9", x: 187.77, y: 251.73, width: 126.2, height: 45.25, rx: 1.72 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 68.03, y: 229.29, width: 111.47, height: 93.04, rx: 1.77 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-10", x: 68.03, y: 229.29, width: 111.47, height: 93.04, rx: 1.77 }), /* @__PURE__ */ U.createElement("rect", { className: "cls-11", x: 187.77, y: 302.78, width: 63.1, height: 19.56, rx: 7.89 }))), c5 = l5, d5 = (e) => /* @__PURE__ */ U.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 400 400", ...e }, /* @__PURE__ */ U.createElement("defs", null, /* @__PURE__ */ U.createElement("style", null, ".cls-1{fill:#606060;}.cls-2{fill:#eeeef0;}.cls-3{fill:#e2e2e4;}.cls-4{fill:#ababad;}.cls-5{fill:#8a8a8c;}")), /* @__PURE__ */ U.createElement("g", { id: "unknown" }, /* @__PURE__ */ U.createElement("path", { className: "cls-1", d: "M86.86,141.27H313.14a8.63,8.63,0,0,1,8.63,8.63V306.75a0,0,0,0,1,0,0H78.23a0,0,0,0,1,0,0V149.9A8.63,8.63,0,0,1,86.86,141.27Z" }), /* @__PURE__ */ U.createElement("rect", { className: "cls-2", x: 87.52, y: 150.37, width: 224.95, height: 147.28 }), /* @__PURE__ */ U.createElement("polygon", { className: "cls-3", points: "87.53 297.65 312.48 297.65 312.48 150.37 87.53 297.65" }), /* @__PURE__ */ U.createElement("path", { className: "cls-4", d: "M50,328.06H350a0,0,0,0,1,0,0v9.44a3.22,3.22,0,0,1-3.22,3.22H53.22A3.22,3.22,0,0,1,50,337.51v-9.44A0,0,0,0,1,50,328.06Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-3", d: "M348.34,330.07H51.66a1.65,1.65,0,0,1-1-3l27.55-20.34H321.77l27.55,20.34A1.65,1.65,0,0,1,348.34,330.07Z" }), /* @__PURE__ */ U.createElement("path", { className: "cls-5", d: "M322.28,346.06H77.72a24,24,0,0,1-11.31-2.84l-4.68-2.49H338.27l-4.68,2.49A24,24,0,0,1,322.28,346.06Z" }), /* @__PURE__ */ U.createElement("polygon", { className: "cls-4", points: "303.69 310.27 98.61 310.27 80.96 325.17 319.04 325.17 303.69 310.27" }), /* @__PURE__ */ U.createElement("path", { className: "cls-5", d: "M166.88,330.07h66.24a0,0,0,0,1,0,0v.85a5,5,0,0,1-5,5H171.86a5,5,0,0,1-5-5v-.85A0,0,0,0,1,166.88,330.07Z" }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 195.89, y: 189.29, width: 8.21, height: 69.44, rx: 4.11, transform: "translate(-99.82 207.03) rotate(-45)" }), /* @__PURE__ */ U.createElement("rect", { className: "cls-5", x: 195.89, y: 189.29, width: 8.21, height: 69.44, rx: 4.11, transform: "translate(216.98 -75.81) rotate(45)" }))), f5 = d5, p5 = (e) => /* @__PURE__ */ U.createElement("svg", { viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ U.createElement("path", { d: "M79.3082 66.1953L39.2867 170.045C38.7338 171.482 38.9917 172.977 39.9591 173.95C40.9266 174.922 42.416 175.18 43.8456 174.625L147.211 134.409", fill: "#206FB8" }), /* @__PURE__ */ U.createElement("path", { d: "M53.31 148.705C51.9794 146.906 50.7335 145.118 49.57 143.365L43.8022 158.328C47.4576 163.11 51.1605 167.266 54.5271 170.468L68.2348 165.135C63.8058 161.456 58.4651 155.675 53.31 148.705Z", fill: "#66B9AB" }), /* @__PURE__ */ U.createElement("path", { d: "M73.2723 129.063C68.6968 122.877 64.8228 116.817 61.8812 111.418L55.1934 128.77C57.0912 131.712 59.185 134.749 61.4562 137.817C68.4885 147.325 75.7291 155.175 81.5423 159.957L97.0241 153.934C90.7942 149.85 81.8744 140.693 73.2723 129.063Z", fill: "#66B9AB" }), /* @__PURE__ */ U.createElement("path", { d: "M97.0591 110.856C86.3549 96.3848 78.5779 82.6731 76.0736 74.5898L68.7195 93.6759C72.5585 101.107 78.2788 110.196 85.243 119.611C94.7301 132.436 104.312 142.88 111.241 148.403L126.845 142.332C119.938 138.18 108.43 126.226 97.0591 110.856Z", fill: "#66B9AB" }), /* @__PURE__ */ U.createElement("path", { d: "M146.549 134.113C141.316 134.113 124.988 121.675 108.568 105.18C88.6838 85.2062 77.5939 68.509 80.0755 66.0149C80.2818 65.8084 80.6181 65.7031 81.076 65.7031C86.3095 65.7031 102.637 78.1408 119.057 94.6357C138.939 114.61 150.031 131.309 147.55 133.801C147.343 134.009 147.007 134.113 146.549 134.113Z", fill: "#144379" }), /* @__PURE__ */ U.createElement("path", { d: "M81.076 65.1748C80.4778 65.1748 80.0157 65.3276 79.7022 65.6414C76.5976 68.7591 89.3543 86.629 108.192 105.554C125.131 122.567 141.217 134.641 146.547 134.641C147.147 134.641 147.61 134.491 147.923 134.175C151.028 131.057 138.271 113.189 119.431 94.2643C102.495 77.2491 86.4085 65.1748 81.076 65.1748ZM81.0781 66.2319C85.4225 66.234 100.077 76.32 118.684 95.0096C127.754 104.123 135.696 113.27 141.045 120.763C148.783 131.598 147.193 133.411 147.176 133.429C147.075 133.529 146.852 133.584 146.547 133.584C142.205 133.584 127.548 123.498 108.941 104.807C99.8687 95.6931 91.9267 86.5485 86.5777 79.0557C78.842 68.2182 80.4324 66.4054 80.4489 66.3888C80.55 66.2877 80.7728 66.2319 81.0781 66.2319Z", fill: "#106FC0" }), /* @__PURE__ */ U.createElement("path", { d: "M114.678 93.459C117.17 89.3069 124.413 93.6613 126.905 89.5092C129.397 85.3551 122.154 81.0027 124.646 76.8485C127.136 72.6964 134.38 77.0488 136.872 72.8967C139.364 68.7425 132.122 64.3881 134.613 60.236", stroke: "#F08E84", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ U.createElement("path", { d: "M158.062 91.0638C158.062 91.5408 157.678 91.9248 157.204 91.9248C156.729 91.9248 156.346 91.5408 156.346 91.0638C156.346 90.5889 156.729 90.2029 157.204 90.2029C157.678 90.2029 158.062 90.5889 158.062 91.0638Z", stroke: "#6360D2", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ U.createElement("path", { d: "M157.895 134.429C157.895 135.709 156.864 136.745 155.589 136.745C154.316 136.745 153.282 135.709 153.282 134.429C153.282 133.151 154.316 132.112 155.589 132.112C156.864 132.112 157.895 133.151 157.895 134.429Z", fill: "#66B9AB" }), /* @__PURE__ */ U.createElement("path", { d: "M147.366 145.217C147.366 146.497 146.333 147.534 145.06 147.534C143.785 147.534 142.751 146.497 142.751 145.217C142.751 143.939 143.785 142.9 145.06 142.9C146.333 142.9 147.366 143.939 147.366 145.217Z", fill: "#106FC0" }), /* @__PURE__ */ U.createElement("path", { d: "M167.498 133.634C167.498 134.448 166.842 135.106 166.033 135.106C165.224 135.106 164.568 134.448 164.568 133.634C164.568 132.823 165.224 132.164 166.033 132.164C166.842 132.164 167.498 132.823 167.498 133.634Z", fill: "#EBAA1D" }), /* @__PURE__ */ U.createElement("path", { d: "M160.573 149.635C160.573 150.777 159.65 151.704 158.514 151.704C157.377 151.704 156.455 150.777 156.455 149.635C156.455 148.491 157.377 147.566 158.514 147.566C159.65 147.566 160.573 148.491 160.573 149.635Z", stroke: "#F08E84", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ U.createElement("path", { d: "M79.2258 60.2957C79.2258 61.1918 78.5017 61.9186 77.6106 61.9186C76.7194 61.9186 75.9954 61.1918 75.9954 60.2957C75.9954 59.3996 76.7194 58.6729 77.6106 58.6729C78.5017 58.6729 79.2258 59.3996 79.2258 60.2957Z", fill: "#6360D2" }), /* @__PURE__ */ U.createElement("path", { d: "M133.972 120.241C135.177 118.981 147.676 106.37 166.184 109.06C183.73 111.614 192.161 125.809 193.155 127.554", stroke: "#FBB722", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ U.createElement("path", { d: "M101.855 91.0645C102.942 90.0528 115.701 77.7802 112.819 60.6453C111.051 50.1339 104.388 43.6776 102.031 41.5882", stroke: "#46A1ED", strokeWidth: 3, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ U.createElement("path", { d: "M91.7699 62.7845C90.4022 62.7845 89.2944 61.6696 89.2944 60.2966C89.2944 58.9235 90.4022 57.8086 91.7699 57.8086C93.1375 57.8086 94.2474 58.9235 94.2474 60.2966C94.2474 61.6696 93.1375 62.7845 91.7699 62.7845Z", fill: "#79C86E" }), /* @__PURE__ */ U.createElement("path", { d: "M84.7645 52.5801C83.3968 52.5801 82.2891 51.4672 82.2891 50.0942C82.2891 48.7191 83.3968 47.6042 84.7645 47.6042C86.1322 47.6042 87.242 48.7191 87.242 50.0942C87.242 51.4672 86.1322 52.5801 84.7645 52.5801Z", stroke: "#FBB722", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ U.createElement("path", { d: "M138.234 89.4432C138.234 90.3392 137.512 91.0639 136.621 91.0639C135.727 91.0639 135.005 90.3392 135.005 89.4432C135.005 88.5471 135.727 87.8203 136.621 87.8203C137.512 87.8203 138.234 88.5471 138.234 89.4432Z", fill: "#206FB8" }), /* @__PURE__ */ U.createElement("path", { d: "M138.234 56.1072C138.234 57.0012 137.512 57.728 136.621 57.728C135.727 57.728 135.005 57.0012 135.005 56.1072C135.005 55.2111 135.727 54.4844 136.621 54.4844C137.512 54.4844 138.234 55.2111 138.234 56.1072Z", fill: "#F08E84" }), /* @__PURE__ */ U.createElement("path", { d: "M197.001 131.548C197.001 132.471 196.258 133.219 195.338 133.219C194.42 133.219 193.675 132.471 193.675 131.548C193.675 130.625 194.42 129.876 195.338 129.876C196.258 129.876 197.001 130.625 197.001 131.548Z", fill: "#FBB722" })), h5 = p5, v5 = ({ illustrationName: e }) => {
  switch (e) {
    case "locked":
      return /* @__PURE__ */ d.createElement(i5, null);
    case "not_found":
      return /* @__PURE__ */ d.createElement(u5, null);
    case "empty":
      return /* @__PURE__ */ d.createElement(c5, null);
    case "error":
      return /* @__PURE__ */ d.createElement(f5, null);
    case "success":
      return /* @__PURE__ */ d.createElement(h5, null);
    default:
      return null;
  }
}, m5 = v5, g5 = D.div`
  max-width: 48rem;
  padding: ${k.M};
  background-color: ${y.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-self: center;
`, y5 = D.div`
  width: 12.5rem;
  margin-bottom: ${k.L};

  @media (${Fe.smallMax}) {
    width: 9.375rem;
  }
`, b5 = D(Vu)`
  text-align: center;
  margin-bottom: ${k.L};
`, w5 = D(Vh)`
  text-align: center;
  margin-bottom: ${k.XXL};
`, D5 = ({
  illustrationName: e,
  heading: t,
  body: n,
  callToActionButton: r,
  className: a
}) => /* @__PURE__ */ d.createElement(g5, { className: a }, /* @__PURE__ */ d.createElement(y5, null, /* @__PURE__ */ d.createElement(m5, { illustrationName: e })), /* @__PURE__ */ d.createElement(b5, null, t), /* @__PURE__ */ d.createElement(w5, null, n), r), rM = D5, C5 = D.div`
  width: 3.25rem;
  height: 3.25rem;
  border: 0.5rem solid ${y.grey50};
  border-top-color: ${y.frenchBlue};

  ${({ isSmall: e }) => e && _`
      width: 1.375rem;
      height: 1.375rem;
      border-width: 0.25rem;
    `};

  border-radius: 50%;
  opacity: 0;
  animation:
    spin 2s linear infinite,
    fadeIn 0.6s ${mt} forwards;
  animation-delay: ${({ delay: e }) => e}s;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`, E5 = D.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-self: center;
  flex: 1 0 auto;
  ${({ isSmall: e }) => e ? _`
          margin: ${k.S} 0;
        ` : _`
          height: 100%;
        `};
`, x5 = ({ delay: e = 0.6, isSmall: t = !1, className: n }) => {
  const { progressBarProps: r } = G0({
    isIndeterminate: !0,
    "aria-label": "Laddar..."
  });
  return /* @__PURE__ */ d.createElement(E5, { isSmall: t, className: n }, /* @__PURE__ */ d.createElement(C5, { ...r, isSmall: t, delay: e }));
}, nM = x5, gv = D.div`
  width: 1.125rem;
  height: 1.125rem;
  background-color: ${y.frenchBlue};
  border: 0.125rem solid ${y.frenchBlue};
  border-radius: 0.125rem;
  display: inline-block;
  position: relative;
  margin: ${k.XS} ${k.M} ${k.XS} ${k.XS};
  flex: 0 0 auto;

  ${({ isFocused: e, isFocusVisible: t }) => e && t && _`
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: -0.375rem;
        left: -0.375rem;
        width: calc(100% + 0.5rem);
        height: calc(100% + 0.5rem);
        border-radius: 0.125rem;
        border: 0.125rem solid ${y.frenchBlue};
      }
    `}

  ${({ isDisabled: e }) => e && _`
      border-color: ${y.grey400};
      background-color: ${y.grey400};
    `};

  ${({ isSelected: e }) => !e && _`
      background-color: transparent;
    `};

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`, fi = _`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, Ro = D(Vh)`
  ${fi};
  color: ${y.grey700};
`, S5 = D.div`
  ${Ct};
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
  padding: 0;
  font-weight: 400;
  ${fi};
  color: ${y.grey700};
`, $5 = D.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`, Js = D(zu)`
  ${fi};
  /* We disable the default font size change on Heading4 on small screens so that the text won't jump when ticking the checkbox */
  font-size: 1rem;
  line-height: 1.5rem;
`, yv = D(ci)`
  ${fi};
  color: ${y.grey500};
`, k5 = D.label`
  display: flex;
  align-items: center;
  height: 2.75rem;
  width: max-content;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;

  &:hover {
    > ${gv} {
      border-color: ${y.midnightBlue};
      ${({ isSelected: e }) => e && _`
          background-color: ${y.midnightBlue};
        `}
    }

    > ${Ro} {
      color: ${y.black};
    }
  }

  ${tt};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      ${Js}, ${yv}, ${Ro} {
        color: ${y.grey400} !important;
      }
    `}

  > * {
    user-select: none;
  }
`, O5 = ({
  label: e,
  sublabel: t,
  isSelected: n,
  onChange: r,
  isDisabled: a,
  className: o,
  id: i,
  htmlContent: s
}) => {
  const { focusProps: u, isFocused: l, isFocusVisible: c } = vt(), f = (p) => {
    p.stopPropagation(), p.preventDefault(), r(!n, i);
  };
  return /* @__PURE__ */ d.createElement(
    k5,
    {
      onClick: f,
      isFocused: l,
      isFocusVisible: c,
      isDisabled: a,
      isSelected: n,
      className: o,
      id: i
    },
    /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement(
      "input",
      {
        type: "checkbox",
        checked: n,
        ...u,
        onChange: f,
        disabled: a
      }
    )),
    /* @__PURE__ */ d.createElement(
      gv,
      {
        isFocused: l,
        isFocusVisible: c,
        isSelected: n,
        isDisabled: a
      },
      /* @__PURE__ */ d.createElement(
        "svg",
        {
          width: "13",
          height: "10",
          viewBox: "0 0 13 10",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        },
        n && /* @__PURE__ */ d.createElement(
          "path",
          {
            d: "M12.9902 2.00008L11.5802 0.580078L4.99023 7.17008L2.41023 4.60008L0.990234 6.01008L4.99023 10.0001L12.9902 2.00008Z",
            fill: "#FFFFFF"
          }
        )
      )
    ),
    t ? /* @__PURE__ */ d.createElement($5, null, n ? /* @__PURE__ */ d.createElement(Js, null, e) : /* @__PURE__ */ d.createElement(Ro, null, e), /* @__PURE__ */ d.createElement(yv, null, t)) : n ? /* @__PURE__ */ d.createElement(Js, null, s || e) : s ? /* @__PURE__ */ d.createElement(S5, null, s) : e ? /* @__PURE__ */ d.createElement(Ro, null, e) : null
  );
}, aM = O5;
var ll = {}, B5 = We, T5 = Ye;
Object.defineProperty(ll, "__esModule", {
  value: !0
});
var gn = ll.default = void 0, A5 = T5(d), P5 = B5(He()), M5 = (0, P5.default)(/* @__PURE__ */ A5.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");
gn = ll.default = M5;
var cl = {}, F5 = We, R5 = Ye;
Object.defineProperty(cl, "__esModule", {
  value: !0
});
var bv = cl.default = void 0, _5 = R5(d), N5 = F5(He()), I5 = (0, N5.default)(/* @__PURE__ */ _5.createElement("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
}), "VisibilityOutlined");
bv = cl.default = I5;
var dl = {}, L5 = We, j5 = Ye;
Object.defineProperty(dl, "__esModule", {
  value: !0
});
var wv = dl.default = void 0, W5 = j5(d), Y5 = L5(He()), H5 = (0, Y5.default)(/* @__PURE__ */ W5.createElement("path", {
  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
}), "VisibilityOffOutlined");
wv = dl.default = H5;
var fl = {}, V5 = We, z5 = Ye;
Object.defineProperty(fl, "__esModule", {
  value: !0
});
var pi = fl.default = void 0, K5 = z5(d), U5 = V5(He()), q5 = (0, U5.default)(/* @__PURE__ */ K5.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
}), "CheckCircleOutlineOutlined");
pi = fl.default = q5;
const X5 = D.div`
  display: flex;
  flex-direction: column;
`, G5 = D.div`
  display: flex;
  justify-content: space-between;
`, Q5 = D.label`
  ${ui.Heading5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, Z5 = D.button`
  ${vn.Body2};
  margin: 0;
  padding: 0;
  border: 0;
  color: ${y.frenchBlue};
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  text-align: right;

  &:hover {
    color: ${y.yaleBlue};
  }

  &:focus {
    color: ${y.midnightBlue};
  }
`, J5 = D(ci)`
  color: ${y.grey600};
  margin-top: ${k.XXS};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, ex = D.div`
  display: flex;
  align-items: center;
  height: 2.5rem;
  border: 2px solid ${y.grey200};
  border-radius: 0.25rem;
  padding: 0;
  background-color: ${y.white};
  transition: border-color 0.1s ${mt};
  margin-top: ${k.XXS};

  ${tt};

  ${({ isFocused: e }) => e ? _`
          border-color: ${y.black};
        ` : _`
          &:hover {
            border-color: ${y.grey400};
          }
        `};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      background-color: ${y.grey50};
    `};

  ${({ hasErrorMessage: e, hasPositiveMessage: t }) => e ? _`
          && {
            border-color: ${y.clownRed};
          }
        ` : t ? _`
            && {
              border-color: ${y.fokusGrassGreen};
            }
          ` : null};
`, tx = D.input`
  ${vn.Body1};
  width: 100%;
  padding: ${k.XS} 0 ${k.XS} ${k.S};
  border: 0;
  outline: 0;
  margin-right: ${k.XXS};
  background-color: transparent;

  &:disabled {
    ::placeholder {
      color: ${y.grey400};
    }
    color: ${y.grey400};
  }
  &:autofill {
    padding: 0.375rem 0.75rem;
    margin: 0;
  }
`, rx = D.button`
  border: none;
  background-color: transparent;
  padding: 0;
  margin-right: ${k.S};
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  cursor: pointer;

  > svg {
    font-size: 1rem;
  }
`, Dv = _`
  && {
    font-size: inherit;
    margin-top: -2px; /* Visual alignment */
    margin-right: ${k.XXS};
  }
`, nx = D(gn)`
  ${Dv};
`, pl = D(hn)`
  display: inline-flex;
  align-items: center;
`, ax = D(pl)`
  color: ${y.clownRed};
`, ox = D(pl)`
  color: ${y.fokusGrassGreen};
`, ix = D(pl)`
  color: ${y.grey600};
`, sx = D(pi)`
  ${Dv};
`, ux = ({
  description: e,
  errorMessage: t,
  positiveMessage: n,
  neutralMessage: r,
  helpButtonLabel: a,
  helpButtonOnClick: o,
  alertRoleOnError: i,
  className: s,
  allowShowHide: u = !0,
  ...l
}) => {
  var I;
  const [c, f] = Ne(!1), p = ve(null), m = ni(), { isFocused: v, focusProps: g, isFocusVisible: h } = vt({
    isTextInput: !0
  }), { labelProps: w, inputProps: S, descriptionProps: x, errorMessageProps: O } = Vp(
    l,
    p
  ), B = t ? xe(S, { "aria-describedby": m, "aria-invalid": !0 }) : S, F = l.type === "password" && c && u ? "text" : l.type, L = !((I = l.value) != null && I.length), { isDisabled: j } = l;
  return /* @__PURE__ */ d.createElement(X5, { className: s }, /* @__PURE__ */ d.createElement(G5, null, /* @__PURE__ */ d.createElement(Q5, { ...w, isDisabled: j }, l.label, l.isRequired && "*"), a && o && /* @__PURE__ */ d.createElement(Z5, { type: "button", onClick: o }, a)), e && /* @__PURE__ */ d.createElement(J5, { as: "span", ...x, isDisabled: j }, e), /* @__PURE__ */ d.createElement(
    ex,
    {
      isFocused: v,
      isFocusVisible: h,
      hasErrorMessage: !!t,
      hasPositiveMessage: !!n,
      isDisabled: j
    },
    /* @__PURE__ */ d.createElement(
      tx,
      {
        ...xe(g, B, { disabled: j }),
        ref: p,
        type: F
      }
    ),
    l.type === "password" && !L && u && /* @__PURE__ */ d.createElement(
      rx,
      {
        type: "button",
        onClick: () => f((N) => !N),
        isFocused: v
      },
      c ? /* @__PURE__ */ d.createElement(wv, null) : /* @__PURE__ */ d.createElement(bv, null)
    )
  ), t ? /* @__PURE__ */ d.createElement(
    ax,
    {
      ...xe(O, {
        id: B["aria-describedby"],
        role: i ? "alert" : void 0
      })
    },
    /* @__PURE__ */ d.createElement(nx, null),
    " ",
    t
  ) : n ? /* @__PURE__ */ d.createElement(ox, null, /* @__PURE__ */ d.createElement(sx, null), n) : r ? /* @__PURE__ */ d.createElement(ix, null, r) : null);
}, lx = ux, Cv = _`
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  background-color: ${y.white};
  position: relative;
  outline: 0;

  @media (${Fe.smallMax}) {
    flex-direction: row;
    height: 5rem;
  }
  &:focus-visible {
    outline: 2px solid ${y.frenchBlue};
    outline-offset: 4px;
    border-radius: 0.25rem;
  }

  &:hover {
    ${(e) => e.disabled ? "" : bw};
  }

  cursor: ${(e) => e.disabled ? "default" : "pointer"};
`, cx = D.div`
  ${Cv}
  ${ir}
`, dx = D.a`
  ${Cv}
  ${ir}
  &&& {
    text-decoration: none;
  }
`, fx = (e, t) => {
  if (e)
    return -1;
  if (t === "button")
    return 0;
}, px = ({ children: e, onClick: t, href: n, disabled: r, className: a, role: o, ...i }) => {
  const l = {
    onClick: (c) => {
      if (r) {
        c.preventDefault();
        return;
      }
      t == null || t();
    },
    onKeyDown: (c) => {
      !o || r || !t || (c.key === "Enter" || c.key === " ") && (c.preventDefault(), t());
    },
    className: a,
    role: o === "button" ? "button" : void 0,
    tabIndex: fx(r, o),
    ...i
  };
  return o === "link" && !r ? /* @__PURE__ */ d.createElement(dx, { ...l, disabled: r, href: n }, e) : /* @__PURE__ */ d.createElement(cx, { ...l, disabled: r || !o }, e);
}, oM = px, hx = D.div`
  padding: ${k.M};
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`, vx = ({ children: e, className: t }) => /* @__PURE__ */ d.createElement(hx, { className: t }, e), iM = vx, sM = "52.25%", uM = "75%", mx = D.img`
  object-fit: cover;
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
  transition: transform 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);

  width: calc(100% + 2px);
  position: absolute;
  top: 0;
  left: -1px;
  height: 100%;

  ${({ leftAlignImage: e }) => e && _`
      position: initial;
      width: 9rem;
    `}

  @media (${Fe.smallMax}) {
    position: initial;
    width: 9rem;
  }
`, gx = D.div`
  overflow: hidden;
  position: relative;
  background-size: cover;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;

  &:before {
    display: block;
    content: '';
    padding-top: ${(e) => e.aspectRatio};
    background-color: ${(e) => e.backgroundColor};
    width: 100%;
  }

  &[data-disabled='true'] {
    &::before {
      filter: grayscale(100%);
      opacity: 0.6;
    }
    & > img {
      opacity: 0.6;
      filter: grayscale(100%);
    }
  }

  ${({ leftAlignImage: e }) => e && _`
      overflow: initial;

      &:before {
        display: flex;
        padding-top: 0;
      }
    `}

  @media (${Fe.smallMax}) {
    overflow: initial;

    &:before {
      display: flex;
      padding-top: 0;
    }
  }
`, yx = D.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;

  ${({ leftAlignImage: e }) => e && _`
      justify-content: flex-start;
      align-items: flex-end;
    `}

  @media (${Fe.smallMax}) {
    justify-content: flex-start;
    align-items: flex-end;
  }
`, bx = ({
  disabled: e,
  thumbnailSrc: t,
  title: n,
  children: r,
  aspectRatio: a,
  backgroundColor: o,
  leftAlignImage: i,
  className: s,
  ...u
}) => /* @__PURE__ */ d.createElement(
  gx,
  {
    ...u,
    aspectRatio: a,
    backgroundColor: o,
    "data-disabled": e,
    leftAlignImage: i,
    className: s
  },
  t && /* @__PURE__ */ d.createElement(
    mx,
    {
      leftAlignImage: i,
      alt: n && `omslagsbild för ${n}`,
      src: t
    }
  ),
  /* @__PURE__ */ d.createElement(yx, { leftAlignImage: i }, !!r && r)
), lM = bx, wx = D(Ku)`
  color: ${(e) => e.disabled ? y.grey500 : y.black};
`, Dx = D.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`, Cx = ({ title: e, className: t, disabled: n, ...r }) => {
  const a = ve(null), o = Tt({}), { triggerProps: i, tooltipProps: s } = Bt({}, o, a), u = a.current ? a.current.clientHeight + 1 < a.current.scrollHeight && o.isOpen : !1;
  return delete i.onClick, delete i.onMouseDown, delete i.onPointerDown, /* @__PURE__ */ d.createElement(Dx, { ref: a, className: t, ...i }, /* @__PURE__ */ d.createElement(wx, { ...r, disabled: n }, e), u && /* @__PURE__ */ d.createElement(At, { parentRef: a, ...s }, e));
}, cM = Cx, eu = D.div`
  margin-left: ${k.XXS};

  ${({ active: e }) => e ? _`
          color: ${y.black};
          font-weight: 600;
        ` : _`
          color: ${y.grey600};
        `}
`, vo = D.div`
  color: ${y.grey600};
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
`, Ex = D.a`
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:link {
    text-decoration: none;
  }

  &:focus-visible {
    outline-offset: ${k.XXS};
  }

  &:hover {
    text-decoration: none;
    > ${eu} {
      color: ${y.grey900};
    }
  }

  @media (${Fe.largeMin}) {
    :not(:first-child) {
      margin-left: ${k.M};
    }
  }

  ${({ active: e }) => e ? _`
          > ${vo} {
            background-color: ${y.frenchBlue};
            color: ${y.white};
          }
        ` : _`
          &:hover {
            > ${vo} {
              background-color: ${y.grey200};
              color: ${y.grey900};
            }
          }
          > ${vo} {
            &:hover {
              color: ${y.grey900};
            }
          }
        `};

  ${({ disabled: e }) => e && _`
      pointer-events: none;
      opacity: 0.5;

      > ${eu} {
        color: ${y.grey500};
      }
    `};
`, xx = ({
  active: e,
  icon: t,
  title: n,
  href: r,
  disabled: a,
  openInNewTab: o,
  tabIndex: i
}) => /* @__PURE__ */ d.createElement(
  Ex,
  {
    href: r,
    disabled: a,
    active: e,
    tabIndex: i !== void 0 ? i : a ? -1 : 0,
    target: o ? "_blank" : void 0,
    rel: o ? "noopener noreferrer" : void 0
  },
  /* @__PURE__ */ d.createElement(vo, null, t),
  /* @__PURE__ */ d.createElement(eu, { active: e }, n)
), Ev = xx, Sx = D.nav`
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 3rem;
  align-items: center;
  flex: 1 1 auto;

  a {
    height: unset;
    font-weight: 400;
  }
`, $x = ({ items: e, className: t }) => /* @__PURE__ */ d.createElement(Sx, { className: t }, Array.from(e).map((n) => /* @__PURE__ */ d.createElement(
  Ev,
  {
    active: n.active,
    icon: n.icon,
    title: n.title,
    disabled: n.disabled,
    href: n.href,
    key: n.title,
    openInNewTab: n.openInNewTab
  }
))), dM = $x;
var hl = {}, kx = We, Ox = Ye;
Object.defineProperty(hl, "__esModule", {
  value: !0
});
var xv = hl.default = void 0, Bx = Ox(d), Tx = kx(He()), Ax = (0, Tx.default)(/* @__PURE__ */ Bx.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
xv = hl.default = Ax;
var vl = {}, Px = We, Mx = Ye;
Object.defineProperty(vl, "__esModule", {
  value: !0
});
var Sv = vl.default = void 0, Fx = Mx(d), Rx = Px(He()), _x = (0, Rx.default)(/* @__PURE__ */ Fx.createElement("path", {
  d: "M7 14l5-5 5 5z"
}), "ArrowDropUp");
Sv = vl.default = _x;
const $v = D.div`
  color: ${y.grey600};
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${k.XXS};
`, Nx = D.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    > ${$v} {
      background-color: ${y.grey200};
      color: ${y.grey900};
    }
  }

  &:focus-visible {
    outline-offset: ${k.XXS};
  }
`, Ix = ({
  isOpen: e,
  triggerRef: t,
  onClick: n,
  title: r,
  icon: a,
  ...o
}) => /* @__PURE__ */ d.createElement(
  Nx,
  {
    type: "button",
    ref: t,
    onClick: (i) => {
      i.preventDefault(), n && n(i);
    },
    ...o
  },
  /* @__PURE__ */ d.createElement(Ev, { icon: a, title: r, active: !0, tabIndex: -1 }),
  /* @__PURE__ */ d.createElement($v, null, e ? /* @__PURE__ */ d.createElement(Sv, null) : /* @__PURE__ */ d.createElement(xv, null))
), Lx = Ix, jx = D.nav`
  margin-left: ${k.S};
  position: relative;
  margin-right: auto;
`, Wx = D.li`
  position: relative;
  list-style: none;

  padding: ${k.S} 0 ${k.S} ${k.S};
  margin: 0;
  height: 2.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  white-space: nowrap;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  user-select: none;
  cursor: pointer;
  color: ${y.black};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${tt};
  transition: color 0.1s ease-out;
  border-radius: 0.25rem;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${({ isFocused: e, isFocusVisible: t }) => (
  // &:focus
  e && t && _`
      background-color: ${y.grey100};
    `
)};

  &:hover {
    background-color: ${y.grey100};
  }

  &:active {
    background-color: ${y.grey300};
  }

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      color: ${y.grey400};
    `}
`, Yx = ({ item: e, treeState: t, onAction: n }) => {
  var c;
  const r = d.useRef(null), { menuItemProps: a } = Hp(
    {
      key: e.key,
      isDisabled: (c = e.value) == null ? void 0 : c.isDisabled,
      onAction: n,
      onClose: () => {
      }
    },
    t,
    r
  ), { isFocusVisible: o, focusProps: i, isFocused: s } = vt(), u = new pv(t.collection, t.disabledKeys), { collectionProps: l } = fv({
    keyboardDelegate: u,
    ref: r,
    selectionManager: t.selectionManager,
    autoFocus: "first"
  });
  return /* @__PURE__ */ d.createElement(
    Wx,
    {
      isFocused: s,
      isFocusVisible: o,
      ...xe(a, i, l),
      ref: r
    },
    e.rendered
  );
}, Hx = D.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  justify-content: flex-start;
  top: 2.5rem;
  width: 100vw;
  max-width: 12.375rem;
  padding: ${k.M} ${k.S} ${k.M} ${k.S};
  margin: 0;
  list-style: none;
  border-radius: 0.5rem;
  background-color: ${y.white};
  z-index: 1000;
  ${ir};
  outline: 0;
`, Vx = (e) => {
  const t = qp({
    ...e,
    items: e.items,
    // eslint-disable-next-line react/no-unstable-nested-components
    children: (o) => {
      const i = o.kind === "reactnode" ? o.textValue : o.label, s = o.kind === "reactnode" ? o.labelReactNode : o.label;
      return /* @__PURE__ */ d.createElement(nn, { key: o.key, textValue: i }, s);
    }
  }), n = ve(null), { overlayProps: r } = dn(
    {
      onClose: e.close,
      shouldCloseOnBlur: !0,
      isOpen: e.isOpen,
      isDismissable: !0
    },
    n
  );
  Array.from(e.items).filter((o) => o.isDisabled).forEach(({ key: o }) => {
    t.disabledKeys.add(o);
  });
  const a = () => {
  };
  return /* @__PURE__ */ d.createElement(Hx, { ref: n, ...r }, /* @__PURE__ */ d.createElement(fn, { contain: !0, restoreFocus: !0, autoFocus: !0 }, [...t.collection].map((o) => {
    var i;
    return /* @__PURE__ */ d.createElement(
      Yx,
      {
        key: o.key,
        item: o,
        treeState: t,
        onAction: ((i = o.value) == null ? void 0 : i.onClick) || a
      }
    );
  })));
}, zx = ({ items: e, title: t, icon: n, className: r }) => {
  const a = ve(null), o = Xp({}), { menuTriggerProps: i } = Yp({}, o, a), s = { ...o, items: e };
  return /* @__PURE__ */ d.createElement(jx, { className: r }, /* @__PURE__ */ d.createElement(
    Lx,
    {
      icon: n,
      title: t,
      onClick: () => {
        o.toggle();
      },
      isOpen: o.isOpen,
      triggerRef: a,
      "aria-controls": i["aria-controls"],
      "aria-expanded": i["aria-expanded"],
      "aria-haspopup": i["aria-haspopup"],
      id: i.id
    }
  ), o.isOpen && /* @__PURE__ */ d.createElement(Vx, { ...s }));
}, fM = zx, kv = D.span`
  margin-left: ${k.XXS};
  color: ${y.black};
`, Kx = D.div`
  display: flex;
  align-items: center;
  color: ${y.black};

  ${({ disabled: e }) => e && _`
      color: ${y.grey400};

      > ${kv} {
        color: ${y.grey400};
      }
    `};
`, Ux = ({ icon: e, title: t, disabled: n }) => /* @__PURE__ */ d.createElement(Kx, { disabled: n }, e, /* @__PURE__ */ d.createElement(kv, null, t)), pM = Ux, Aa = 24, tu = 40, Fn = Aa / 2, qx = Fn - 1, Xx = tu - Fn, Gx = Fn, Qx = D.svg`
  outline: 0;
  cursor: pointer;

  /* Using regular css &:hover selector here because useHover hook doesn't work with SVGs */
  &:hover {
    circle {
      fill: ${y.grey300};
    }
  }
`, Zx = D.rect`
  fill: ${({ isSelected: e }) => e ? y.frenchBlue : y.grey600};
  ${({ isDisabled: e }) => e && _`
      fill: ${y.grey400};
    `}
  transition: fill 0.2s ${mt};
`, Jx = D.circle`
  fill: ${y.grey200};
  transition: transform 0.2s ${mt};
  ${({ isSelected: e }) => e ? _`
          transform: translateX(${Xx}px);
        ` : _`
          transform: translateX(${Gx}px);
        `}
`, e3 = ({ isSelected: e, onClick: t, isDisabled: n }) => /* @__PURE__ */ d.createElement(Qx, { width: tu, height: Aa, "aria-hidden": "true", onClick: t }, /* @__PURE__ */ d.createElement(
  Zx,
  {
    isSelected: e,
    rx: Fn,
    ry: Fn,
    width: tu,
    height: Aa,
    isDisabled: n
  }
), /* @__PURE__ */ d.createElement(Jx, { cy: Fn, r: qx, isSelected: e })), t3 = e3, r3 = D.label`
  display: flex;
  align-items: center;
  user-select: none;
  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
      pointer-events: none;
    `}
`, n3 = D(or)`
  margin-right: ${k.S};
  line-height: 1rem;
`, a3 = D.div`
  /* values in px as opposed to rem as the svg element it contains doesn't scale with font size change */
  position: relative;
  border: ${({ isFocusVisible: e }) => e ? `2px solid ${y.frenchBlue}` : "2px solid transparent"};
  border-radius: ${Aa}px;
  padding: 2px;
  display: flex;
  margin: -4px -4px;
  height: ${Aa + 8}px;
  justify-content: center;
`, o3 = ({ children: e, className: t, ...n }) => {
  const r = Up(n), a = d.useRef(null), { inputProps: o } = Wp(n, r, a), { isFocusVisible: i, focusProps: s } = vt(), { isDisabled: u } = n;
  return /* @__PURE__ */ d.createElement(r3, { className: t, isDisabled: u }, /* @__PURE__ */ d.createElement(Zn, null, /* @__PURE__ */ d.createElement(
    "input",
    {
      ...xe(o, s, { "aria-checked": r.isSelected }),
      ref: a
    }
  )), /* @__PURE__ */ d.createElement(n3, null, e), /* @__PURE__ */ d.createElement(a3, { isFocusVisible: i }, /* @__PURE__ */ d.createElement(t3, { isSelected: r.isSelected, isDisabled: u })));
}, hM = o3, i3 = D.div`
  display: flex;
  flex-direction: column;
`, s3 = D.div`
  display: flex;
  justify-content: space-between;
`, u3 = D.label`
  ${ui.Heading5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, Ov = _`
  && {
    font-size: inherit;
    margin-top: -2px; /* Visual alignment */
    margin-right: ${k.XXS};
  }
`, l3 = D(gn)`
  ${Ov};
`, ml = D(hn)`
  display: inline-flex;
  align-items: center;
`, c3 = D(ml)`
  color: ${y.clownRed};
`, d3 = D(ml)`
  color: ${y.fokusGrassGreen};
`, f3 = D(ml)`
  color: ${y.grey600};
`, p3 = D(pi)`
  ${Ov};
`, h3 = D(ci)`
  color: ${y.grey600};
  margin-top: ${k.XXS};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, v3 = D.div`
  display: flex;
  align-items: center;
  height: 12rem;
  border: 2px solid ${y.grey200};
  border-radius: 0.25rem;
  padding: 0;
  background-color: ${y.white};
  transition: border-color 0.1s ${mt};
  margin-top: ${k.XXS};

  ${tt};

  ${({ isFocused: e }) => e ? _`
          border-color: ${y.black};
        ` : _`
          &:hover {
            border-color: ${y.grey400};
          }
        `};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      background-color: ${y.grey50};
    `};

  ${({ hasErrorMessage: e, hasPositiveMessage: t }) => e ? _`
          && {
            border-color: ${y.clownRed};
          }
        ` : t ? _`
            && {
              border-color: ${y.fokusGrassGreen};
            }
          ` : null};
`, m3 = D.textarea`
  ${vn.Body1};
  width: 100%;
  height: 100%;
  padding: ${k.XS} 0 ${k.XS} ${k.S};
  border: 0;
  outline: 0;
  margin-right: ${k.XXS};
  background-color: transparent;
  resize: none;
`, g3 = ({
  description: e,
  errorMessage: t,
  positiveMessage: n,
  neutralMessage: r,
  className: a,
  ...o
}) => {
  const i = ve(null), { isFocused: s, focusProps: u, isFocusVisible: l } = vt({
    isTextInput: !0
  }), { labelProps: c, inputProps: f, descriptionProps: p, errorMessageProps: m } = Vp(
    o,
    i
  ), { isDisabled: v } = o;
  return /* @__PURE__ */ d.createElement(i3, { className: a }, /* @__PURE__ */ d.createElement(s3, null, /* @__PURE__ */ d.createElement(u3, { ...c, isDisabled: v }, o.label, o.isRequired && "*")), e && /* @__PURE__ */ d.createElement(h3, { as: "span", ...p, isDisabled: v }, e), /* @__PURE__ */ d.createElement(
    v3,
    {
      isFocused: s,
      isFocusVisible: l,
      hasErrorMessage: !!t,
      hasPositiveMessage: !!n,
      isDisabled: v
    },
    /* @__PURE__ */ d.createElement(m3, { ...xe(f, u), ref: i })
  ), t ? /* @__PURE__ */ d.createElement(c3, { ...m }, /* @__PURE__ */ d.createElement(l3, null), " ", t) : n ? /* @__PURE__ */ d.createElement(d3, null, /* @__PURE__ */ d.createElement(p3, null), n) : r ? /* @__PURE__ */ d.createElement(f3, null, r) : null);
}, vM = g3, Bv = D.button`
  ${({ includeStyling: e, expanded: t, isDisabled: n }) => e && _`
      width: 100%;
      padding: ${k.XS};
      border: none;
      background-color: ${t ? y.grey50 : y.white};
      text-align: start;

      &:hover {
        cursor: pointer;
      }
      ${n && "pointer-events: none;"}
      ${n && `color: ${y.grey400};`}
    `};
`, y3 = D.li`
  ${({ includeStyling: e, expanded: t, isDisabled: n }) => e && _`
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: ${k.XS};
      border-radius: 4px 4px 0 0;
      background-color: ${t ? y.grey50 : y.white};

      &:hover {
        background-color: ${y.grey50};
        ${n && "cursor: disabled;"}
        > ${Bv} {
          background-color: ${y.grey50};
        }
      }
    `};
`, b3 = D.div`
  ${({ includeStyling: e }) => e && _`
      display: flex;
      justify-content: space-between;
      width: 100%;
    `};
`, gl = ({ isOpen: e }) => _`
  justify-self: flex-end;
  align-self: center;
  height: 0.75rem;
  width: 0.75rem;
  color: inherit;
  fill: currentColor;
  transform: ${e ? "rotateX(180deg)" : "none"};
`, w3 = D(mn)`
  ${gl};
  margin-left: ${k.L};
  margin-right: ${k.XS};
`, D3 = D(mn)`
  ${gl};
`, C3 = D(mn)`
  ${gl};
  transform: rotate(-90deg);
`, E3 = D(Jh)`
  margin-left: auto;
  margin-right: ${k.M};
  background-color: ${({ badgeColor: e }) => e ?? y.lavaRed};
  color: ${y.white};
  white-space: nowrap;
`, Bd = D(or)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${({ trailingIcon: e }) => e && `margin-right: ${k.M};`}
`, x3 = D.span`
  display: block;
  margin-top: ${k.XS};
  color: ${y.grey900};
  font-size: ${k.S};
  font-weight: 400;
  font-style: italic;
`, S3 = D.div`
  display: ${({ visible: e }) => e ? "block" : "none"};
`, Td = D.span`
  font-weight: 400;
  margin-left: ${k.XXS};
`, $3 = ({
  badgeColor: e,
  includeStyling: t = !0,
  item: n,
  showIcon: r = !0,
  trailingIcon: a = !0,
  currentExpanded: o,
  setCurrentExpanded: i,
  singleExpandedAllowed: s
}) => {
  const [u, l] = Ne(n.isOpen ?? !1), c = ve(null), f = Tt({}), { triggerProps: p, tooltipProps: m } = Bt({}, f, c), v = c.current ? c.current.offsetWidth < c.current.scrollWidth && f.isOpen : !1;
  delete p.onClick, delete p.onMouseDown, delete p.onPointerDown, delete p.onKeyDown;
  const g = Nn(() => {
    if (s) {
      const w = o === n.id;
      return l(w), w;
    }
    return n.isOpen ?? u;
  }, [o, u, n.isOpen]), h = () => {
    s ? i(g ? "" : n.id) : l(!u), n.onClick && n.onClick();
  };
  return /* @__PURE__ */ d.createElement(
    y3,
    {
      key: n.id,
      expanded: g,
      isDisabled: n.isDisabled,
      includeStyling: t,
      ...p
    },
    /* @__PURE__ */ d.createElement(
      Bv,
      {
        id: `accordion-control-${n.id}`,
        "aria-expanded": g,
        "aria-controls": `content-${n.id}`,
        onClick: h,
        type: "button",
        expanded: g,
        isDisabled: n.isDisabled,
        "aria-label": n.label,
        includeStyling: t
      },
      /* @__PURE__ */ d.createElement(b3, { includeStyling: t }, !a && r && /* @__PURE__ */ d.createElement(w3, { isOpen: g, "aria-hidden": "true" }), t ? /* @__PURE__ */ d.createElement(Bd, { trailingIcon: a, ref: c }, n.htmlLabel ?? n.label, n.itemNumbers && /* @__PURE__ */ d.createElement(Td, null, `(${n.itemNumbers})`)) : /* @__PURE__ */ d.createElement(Bd, { ref: c }, /* @__PURE__ */ d.createElement("span", null, n.label), n.itemNumbers && /* @__PURE__ */ d.createElement(Td, null, `(${n.itemNumbers})`)), n.badge && /* @__PURE__ */ d.createElement(E3, { badgeColor: e }, n.badge), a && r && (n.rightPointingChevron ? /* @__PURE__ */ d.createElement(C3, { isOpen: g, "aria-hidden": "true" }) : /* @__PURE__ */ d.createElement(D3, { isOpen: g, "aria-hidden": "true" }))),
      n.description ? /* @__PURE__ */ d.createElement(x3, null, n.description) : null
    ),
    /* @__PURE__ */ d.createElement(
      S3,
      {
        visible: g,
        id: `content-${n.id}`,
        "aria-hidden": !g
      },
      n.subItems
    ),
    v && /* @__PURE__ */ d.createElement(At, { parentRef: c, ...m }, n.label)
  );
}, k3 = $3, O3 = D.ul`
  margin: 0;
  padding: 0;
  width: 100%;
`, B3 = ({
  badgeColor: e,
  className: t,
  includeStyling: n,
  items: r,
  showIcon: a,
  trailingIcon: o,
  singleExpandedAllowed: i,
  ...s
}) => {
  const u = r.find((f) => f.isOpen), [l, c] = Ne("");
  return je(() => {
    c((u == null ? void 0 : u.id) || "");
  }, [u == null ? void 0 : u.id]), /* @__PURE__ */ d.createElement(O3, { className: t, ...s }, r.map((f) => /* @__PURE__ */ d.createElement(
    k3,
    {
      item: f,
      key: f.id,
      trailingIcon: o,
      showIcon: a,
      includeStyling: n,
      badgeColor: e,
      currentExpanded: i ? l : null,
      setCurrentExpanded: c,
      singleExpandedAllowed: i
    }
  )));
}, mM = B3, T3 = D.li`
  list-style: none;

  color: ${({ isSelected: e }) => e ? y.frenchBlue : y.black};

  padding: ${k.S} ${k.S};
  margin: 0;
  height: ${({ isTextOnly: e }) => e ? "2.5rem" : "3.75rem"};
  white-space: nowrap;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  user-select: none;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  transition: color 0.1s ease-out;
  border-radius: 0.25rem;

  > * {
    ${({ isSelected: e }) => e ? _`
            font-weight: 600;
          ` : _`
            font-weight: 400;
          `};
  }

  ${({ isFocused: e }) => (
  // focus with keyboard
  e && _`
      background-color: ${y.grey100};
      outline: -webkit-focus-ring-color auto 1px;
      outline-offset: -2px;
    `
)};

  &:hover {
    background-color: ${y.grey100};
  }

  &:active {
    background-color: ${y.grey300};
  }
`, A3 = D(or)`
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  line-height: 2.5rem;
  pointer-events: none;
`, P3 = D(To)`
  color: ${y.frenchBlue};
  margin-right: ${k.S};
`, M3 = ({ item: e, state: t }) => {
  var m, v;
  const n = d.useRef(null), r = d.useRef(null), a = t.disabledKeys.has(e.key), o = t.selectionManager.isSelected(e.key), { optionProps: i, isFocused: s } = _p(
    {
      key: e.key,
      isDisabled: a,
      isSelected: o,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !1
    },
    t,
    n
  );
  i.onClick = i.onPointerUp, delete i.onPointerUp;
  const u = Tt({}), { triggerProps: l, tooltipProps: c } = Bt({}, u, n), f = r.current ? ((m = r.current) == null ? void 0 : m.offsetWidth) < ((v = r.current) == null ? void 0 : v.scrollWidth) && (u.isOpen || s) : !1, p = typeof e.rendered == "string";
  return /* @__PURE__ */ d.createElement(
    T3,
    {
      ref: n,
      isFocused: s,
      isSelected: o,
      isTextOnly: p,
      ...xe(i, l)
    },
    o && /* @__PURE__ */ d.createElement(P3, { fontSize: "small" }),
    p ? /* @__PURE__ */ d.createElement(A3, { ref: r }, e.rendered) : e.rendered,
    f && /* @__PURE__ */ d.createElement(At, { parentRef: n, ...c }, e.rendered)
  );
}, F3 = M3, R3 = D.ul`
  margin: ${k.L} -0.1875rem ${k.L} 0;
  padding: 0;
  background: ${y.white};
  flex: 1;
  height: 100%;
  max-height: 12.5rem;
  overflow-y: scroll;
  scrollbar-color: ${y.grey300} transparent;
  scrollbar-width: thin;
  outline: 0;
  &::-webkit-scrollbar {
    width: 0.1875rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: ${y.grey300};
  }
`, _3 = ({ state: e, listBoxRef: t, ...n }) => {
  const { listBoxProps: r } = Np(
    {
      autoFocus: e.focusStrategy || !0,
      selectionMode: "single",
      disallowEmptySelection: !0,
      ...n
    },
    e,
    t
  );
  return /* @__PURE__ */ d.createElement(R3, { ...xe(r), ref: t }, [...e.collection].filter((a) => !a.hasChildNodes).map((a) => /* @__PURE__ */ d.createElement(F3, { key: a.key, item: a, state: e })));
}, N3 = _3, I3 = D.div`
  position: absolute;
  width: 100%;
  top: calc(100% + ${k.XS});
  display: flex;
  flex-direction: column;
  padding: 0 ${k.S} 0 ${k.S};
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: ${y.white};
  z-index: 1;
  ${ir}

  @media (${Fe.smallMax}) {
    min-width: 12.375rem;
    width: 100%;
  }
`, L3 = (e) => {
  const t = ve(null), { popoverRef: n = t, isOpen: r, onClose: a, children: o } = e, { overlayProps: i } = dn(
    {
      isOpen: r,
      onClose: a,
      shouldCloseOnBlur: !0,
      isDismissable: !1
    },
    n
  );
  return /* @__PURE__ */ d.createElement(fn, { restoreFocus: !0 }, /* @__PURE__ */ d.createElement(I3, { ...i, ref: n }, o, /* @__PURE__ */ d.createElement(Eo, { onDismiss: a })));
}, j3 = D.div`
  position: relative;
  overflow: visible;
  display: inline-flex;
  flex-direction: column;

  @media (${Fe.smallMax}) {
    width: 100%;
  }
`, W3 = D.div`
  position: relative;
  overflow: visible;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 2.5rem;
  margin-top: ${k.XXS};
  padding: 0;
  border: 2px solid ${y.grey200};
  border-radius: 0.25rem;
  background-color: ${y.white};
  transition: border-color 0.1s ${mt};

  @media (${Fe.smallMax}) {
    width: 100%;
  }

  ${({ isFocused: e }) => e ? _`
          border-color: ${y.black};
        ` : _`
          &:hover {
            border-color: ${y.grey400};
          }
        `};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      background-color: ${y.grey50};
    `};

  ${({ hasErrorMessage: e }) => e && _`
      && {
        border-color: ${y.clownRed};
      }
    `};
`, Y3 = D.input`
  ${vn.Body1};
  width: 100%;
  padding: ${k.XS} 0 ${k.XS} ${k.S};
  border: 0;
  outline: 0;
  margin-right: ${k.XXS};
  background-color: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:disabled {
    color: ${y.grey400};
  }
`, H3 = D.label`
  ${ui.Heading5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, V3 = D(gn)`
  && {
    font-size: inherit;
    margin-top: -2px; /* Visual alignment */
    margin-right: ${k.XXS};
  }
`, z3 = D(hn)`
  display: inline-flex;
  align-items: center;
  color: ${y.clownRed};
`, K3 = D.div`
  position: relative;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 2.25rem;
  width: ${k.XXL};
  border-radius: 0 1.25rem 1.25rem 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${y.grey700};

  &:disabled {
    color: ${y.grey300};
  }
`, U3 = ({
  triggerButton: e,
  defaultOption: t,
  errorMessage: n,
  name: r,
  className: a,
  label: o,
  isDisabled: i,
  placeholder: s,
  onClear: u,
  ...l
}) => {
  var F;
  const { contains: c } = Q0({ sensitivity: "base" }), f = sg({
    ...l,
    defaultFilter: c
  }), { visuallyHiddenProps: p } = Ip(), m = o ? {} : p, v = ve(null), g = ve(null), h = ve(null), w = ve(null), { buttonProps: S, inputProps: x, listBoxProps: O, labelProps: B } = Z0(
    {
      ...l,
      inputRef: g,
      buttonRef: v,
      listBoxRef: h,
      popoverRef: w
    },
    f
  );
  return je(() => {
    f.isFocused && f.open();
  }, [f.isFocused]), /* @__PURE__ */ d.createElement(j3, { className: a }, /* @__PURE__ */ d.createElement(H3, { ...xe(B, m), isDisabled: i }, o), /* @__PURE__ */ d.createElement(
    W3,
    {
      isFocused: f.isFocused,
      isDisabled: i,
      isActive: f.isOpen || f.inputValue.length > 0,
      hasErrorMessage: !!n
    },
    /* @__PURE__ */ d.createElement(
      Y3,
      {
        ...x,
        ref: g,
        onClick: () => f.setOpen(!0),
        placeholder: s,
        name: r,
        disabled: i
      }
    ),
    f.inputValue.length > 0 ? /* @__PURE__ */ d.createElement(
      K3,
      {
        as: "button",
        onClick: () => {
          u && u(), f.setInputValue("");
        },
        disabled: i,
        "aria-label": "Rensa fält"
      },
      /* @__PURE__ */ d.createElement(tl, null)
    ) : /* @__PURE__ */ d.createElement(
      e,
      {
        isOpen: f.isOpen,
        isFocused: f.isFocused,
        isDisabled: i,
        isDefaultOptionSelected: ((F = f.selectedItem) == null ? void 0 : F.key) !== (t == null ? void 0 : t.value),
        buttonRef: v,
        "aria-label": S["aria-label"],
        "aria-haspopup": S["aria-haspopup"],
        "aria-expanded": S["aria-expanded"],
        "aria-controls": S["aria-controls"],
        id: S.id,
        onClick: () => {
          g.current && (f.isOpen ? (f.setFocused(!1), f.close()) : (g.current.focus(), f.open()));
        }
      }
    )
  ), n && /* @__PURE__ */ d.createElement(z3, null, /* @__PURE__ */ d.createElement(V3, null), " ", n), f.isOpen && /* @__PURE__ */ d.createElement(L3, { popoverRef: w, isOpen: f.isOpen, onClose: f.close }, /* @__PURE__ */ d.createElement(N3, { ...O, listBoxRef: h, state: f })));
}, q3 = ({ onSelect: e, options: t, ...n }) => {
  const r = (a) => a.kind === "reactnode" ? /* @__PURE__ */ d.createElement(nn, { textValue: a.textValue, key: a.value }, a.labelReactNode) : /* @__PURE__ */ d.createElement(nn, { key: a.value }, a.label);
  return /* @__PURE__ */ d.createElement(
    U3,
    {
      ...n,
      onSelectionChange: (a) => {
        const o = t.find((i) => i.value === (a == null ? void 0 : a.toString()));
        o && e(o);
      }
    },
    t.map((a) => r(a))
  );
}, gM = q3, X3 = D.button`
  min-width: 2.5rem;
  height: 100%;
  margin: 0;
  background: none;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  position: relative;

  ${tt}

  &:focus,
  &:active {
    outline: none;
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`, G3 = D(mn)`
  position: absolute;
  right: ${k.XS};
  transform: translate(-50%, -50%) ${({ isOpen: e }) => e && "rotateX(180deg)"};
  height: 0.75rem;
  width: 0.75rem;
  justify-self: flex-end;
  align-self: center;
  color: inherit;
  fill: currentColor;
  flex-grow: 1;
`, Q3 = ({
  onClick: e,
  isOpen: t,
  isFocused: n,
  isDefaultOptionSelected: r,
  isDisabled: a,
  buttonRef: o,
  className: i,
  ...s
}) => {
  var v, g;
  const u = ve(null), l = Tt({}), { triggerProps: c, tooltipProps: f } = Bt({}, l, o);
  delete c.onKeyDown, delete c.onKeyUp;
  const p = u.current ? ((v = u.current) == null ? void 0 : v.offsetWidth) < ((g = u.current) == null ? void 0 : g.scrollWidth) && l.isOpen : !1, { children: m } = s;
  return /* @__PURE__ */ d.createElement(
    X3,
    {
      isFocused: n,
      isDefaultOptionSelected: r,
      disabled: a,
      className: i,
      ref: o,
      ...xe(s, c),
      onClick: (h) => {
        h.preventDefault(), e(h);
      },
      tabIndex: -1
    },
    /* @__PURE__ */ d.createElement(G3, { "aria-hidden": "true", isOpen: t }),
    p && /* @__PURE__ */ d.createElement(At, { parentRef: o, ...f }, m)
  );
}, yM = Q3;
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Ad(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ut(e) {
  var t, n;
  return Ad(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(Ad(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
function lt(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var a = oS[e], o = a ? typeof a == "function" ? a.apply(null, n) : a : "unknown error nr: " + e;
    throw Error("[Immer] " + o);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(i) {
    return "'" + i + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function on(e) {
  return !!e && !!e[$t];
}
function sn(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var a = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return a === Object || typeof a == "function" && Function.toString.call(a) === iS;
  }(e) || Array.isArray(e) || !!e[Ld] || !!(!((t = e.constructor) === null || t === void 0) && t[Ld]) || yl(e) || bl(e));
}
function Pa(e, t, n) {
  n === void 0 && (n = !1), ra(e) === 0 ? (n ? Object.keys : xl)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, a) {
    return t(a, r, e);
  });
}
function ra(e) {
  var t = e[$t];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : yl(e) ? 2 : bl(e) ? 3 : 0;
}
function ru(e, t) {
  return ra(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Z3(e, t) {
  return ra(e) === 2 ? e.get(t) : e[t];
}
function Tv(e, t, n) {
  var r = ra(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function J3(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function yl(e) {
  return nS && e instanceof Map;
}
function bl(e) {
  return aS && e instanceof Set;
}
function zr(e) {
  return e.o || e.t;
}
function wl(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = sS(e);
  delete t[$t];
  for (var n = xl(t), r = 0; r < n.length; r++) {
    var a = n[r], o = t[a];
    o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[a] = { configurable: !0, writable: !0, enumerable: o.enumerable, value: e[a] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function Dl(e, t) {
  return t === void 0 && (t = !1), Cl(e) || on(e) || !sn(e) || (ra(e) > 1 && (e.set = e.add = e.clear = e.delete = eS), Object.freeze(e), t && Pa(e, function(n, r) {
    return Dl(r, !0);
  }, !0)), e;
}
function eS() {
  lt(2);
}
function Cl(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function er(e) {
  var t = uS[e];
  return t || lt(18, e), t;
}
function Pd() {
  return process.env.NODE_ENV === "production" || Wn || lt(0), Wn;
}
function os(e, t) {
  t && (er("Patches"), e.u = [], e.s = [], e.v = t);
}
function _o(e) {
  nu(e), e.p.forEach(tS), e.p = null;
}
function nu(e) {
  e === Wn && (Wn = e.l);
}
function Md(e) {
  return Wn = { p: [], l: Wn, h: e, m: !0, _: 0 };
}
function tS(e) {
  var t = e[$t];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function is(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || er("ES5").S(t, e, r), r ? (n[$t].P && (_o(t), lt(4)), sn(e) && (e = No(t, e), t.l || Io(t, e)), t.u && er("Patches").M(n[$t].t, e, t.u, t.s)) : e = No(t, n, []), _o(t), t.u && t.v(t.u, t.s), e !== Av ? e : void 0;
}
function No(e, t, n) {
  if (Cl(t))
    return t;
  var r = t[$t];
  if (!r)
    return Pa(t, function(s, u) {
      return Fd(e, r, t, s, u, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return Io(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var a = r.i === 4 || r.i === 5 ? r.o = wl(r.k) : r.o, o = a, i = !1;
    r.i === 3 && (o = new Set(a), a.clear(), i = !0), Pa(o, function(s, u) {
      return Fd(e, r, a, s, u, n, i);
    }), Io(e, a, !1), n && e.u && er("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function Fd(e, t, n, r, a, o, i) {
  if (process.env.NODE_ENV !== "production" && a === n && lt(5), on(a)) {
    var s = No(e, a, o && t && t.i !== 3 && !ru(t.R, r) ? o.concat(r) : void 0);
    if (Tv(n, r, s), !on(s))
      return;
    e.m = !1;
  } else
    i && n.add(a);
  if (sn(a) && !Cl(a)) {
    if (!e.h.D && e._ < 1)
      return;
    No(e, a), t && t.A.l || Io(e, a);
  }
}
function Io(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && Dl(t, n);
}
function ss(e, t) {
  var n = e[$t];
  return (n ? zr(n) : e)[t];
}
function Rd(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function au(e) {
  e.P || (e.P = !0, e.l && au(e.l));
}
function us(e) {
  e.o || (e.o = wl(e.t));
}
function ou(e, t, n) {
  var r = yl(t) ? er("MapSet").F(t, n) : bl(t) ? er("MapSet").T(t, n) : e.O ? function(a, o) {
    var i = Array.isArray(a), s = { i: i ? 1 : 0, A: o ? o.A : Pd(), P: !1, I: !1, R: {}, l: o, t: a, k: null, o: null, j: null, C: !1 }, u = s, l = iu;
    i && (u = [s], l = ma);
    var c = Proxy.revocable(u, l), f = c.revoke, p = c.proxy;
    return s.k = p, s.j = f, p;
  }(t, n) : er("ES5").J(t, n);
  return (n ? n.A : Pd()).p.push(r), r;
}
function rS(e) {
  return on(e) || lt(22, e), function t(n) {
    if (!sn(n))
      return n;
    var r, a = n[$t], o = ra(n);
    if (a) {
      if (!a.P && (a.i < 4 || !er("ES5").K(a)))
        return a.t;
      a.I = !0, r = _d(n, o), a.I = !1;
    } else
      r = _d(n, o);
    return Pa(r, function(i, s) {
      a && Z3(a.t, i) === s || Tv(r, i, t(s));
    }), o === 3 ? new Set(r) : r;
  }(e);
}
function _d(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return wl(e);
}
var Nd, Wn, El = typeof Symbol < "u" && typeof Symbol("x") == "symbol", nS = typeof Map < "u", aS = typeof Set < "u", Id = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", Av = El ? Symbol.for("immer-nothing") : ((Nd = {})["immer-nothing"] = !0, Nd), Ld = El ? Symbol.for("immer-draftable") : "__$immer_draftable", $t = El ? Symbol.for("immer-state") : "__$immer_state", oS = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, iS = "" + Object.prototype.constructor, xl = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, sS = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return xl(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, uS = {}, iu = { get: function(e, t) {
  if (t === $t)
    return e;
  var n = zr(e);
  if (!ru(n, t))
    return function(a, o, i) {
      var s, u = Rd(o, i);
      return u ? "value" in u ? u.value : (s = u.get) === null || s === void 0 ? void 0 : s.call(a.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !sn(r) ? r : r === ss(e.t, t) ? (us(e), e.o[t] = ou(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in zr(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(zr(e));
}, set: function(e, t, n) {
  var r = Rd(zr(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var a = ss(zr(e), t), o = a == null ? void 0 : a[$t];
    if (o && o.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (J3(n, a) && (n !== void 0 || ru(e.t, t)))
      return !0;
    us(e), au(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return ss(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, us(e), au(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = zr(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  lt(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  lt(12);
} }, ma = {};
Pa(iu, function(e, t) {
  ma[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), ma.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && lt(13), ma.set.call(this, e, t, void 0);
}, ma.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && lt(14), iu.set.call(this, e[0], t, n, e[0]);
};
var lS = function() {
  function e(n) {
    var r = this;
    this.O = Id, this.D = !0, this.produce = function(a, o, i) {
      if (typeof a == "function" && typeof o != "function") {
        var s = o;
        o = a;
        var u = r;
        return function(g) {
          var h = this;
          g === void 0 && (g = s);
          for (var w = arguments.length, S = Array(w > 1 ? w - 1 : 0), x = 1; x < w; x++)
            S[x - 1] = arguments[x];
          return u.produce(g, function(O) {
            var B;
            return (B = o).call.apply(B, [h, O].concat(S));
          });
        };
      }
      var l;
      if (typeof o != "function" && lt(6), i !== void 0 && typeof i != "function" && lt(7), sn(a)) {
        var c = Md(r), f = ou(r, a, void 0), p = !0;
        try {
          l = o(f), p = !1;
        } finally {
          p ? _o(c) : nu(c);
        }
        return typeof Promise < "u" && l instanceof Promise ? l.then(function(g) {
          return os(c, i), is(g, c);
        }, function(g) {
          throw _o(c), g;
        }) : (os(c, i), is(l, c));
      }
      if (!a || typeof a != "object") {
        if ((l = o(a)) === void 0 && (l = a), l === Av && (l = void 0), r.D && Dl(l, !0), i) {
          var m = [], v = [];
          er("Patches").M(a, l, m, v), i(m, v);
        }
        return l;
      }
      lt(21, a);
    }, this.produceWithPatches = function(a, o) {
      if (typeof a == "function")
        return function(l) {
          for (var c = arguments.length, f = Array(c > 1 ? c - 1 : 0), p = 1; p < c; p++)
            f[p - 1] = arguments[p];
          return r.produceWithPatches(l, function(m) {
            return a.apply(void 0, [m].concat(f));
          });
        };
      var i, s, u = r.produce(a, o, function(l, c) {
        i = l, s = c;
      });
      return typeof Promise < "u" && u instanceof Promise ? u.then(function(l) {
        return [l, i, s];
      }) : [u, i, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    sn(n) || lt(8), on(n) && (n = rS(n));
    var r = Md(this), a = ou(this, n, void 0);
    return a[$t].C = !0, nu(r), a;
  }, t.finishDraft = function(n, r) {
    var a = n && n[$t];
    process.env.NODE_ENV !== "production" && (a && a.C || lt(9), a.I && lt(10));
    var o = a.A;
    return os(o, r), is(void 0, o);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !Id && lt(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var a;
    for (a = r.length - 1; a >= 0; a--) {
      var o = r[a];
      if (o.path.length === 0 && o.op === "replace") {
        n = o.value;
        break;
      }
    }
    a > -1 && (r = r.slice(a + 1));
    var i = er("Patches").$;
    return on(n) ? i(n, r) : this.produce(n, function(s) {
      return i(s, r);
    });
  }, e;
}(), kt = new lS(), Sl = kt.produce;
kt.produceWithPatches.bind(kt);
kt.setAutoFreeze.bind(kt);
kt.setUseProxies.bind(kt);
kt.applyPatches.bind(kt);
var jd = kt.createDraft.bind(kt), Wd = kt.finishDraft.bind(kt);
function sr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Lo = /* @__PURE__ */ new WeakMap(), jo = /* @__PURE__ */ new WeakMap(), ua = /* @__PURE__ */ new WeakMap(), Yd = /* @__PURE__ */ new WeakMap(), Hd = /* @__PURE__ */ new WeakMap(), Vd = /* @__PURE__ */ new WeakMap(), zd = /* @__PURE__ */ new WeakMap();
function Kd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ja(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kd(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var cS = () => {
  var e = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isInline: () => !1,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    apply: (t) => {
      for (var n of b.pathRefs(e))
        jS.transform(n, t);
      for (var r of b.pointRefs(e))
        WS.transform(r, t);
      for (var a of b.rangeRefs(e))
        VS.transform(a, t);
      var o = Lo.get(e) || [], i = jo.get(e) || /* @__PURE__ */ new Set(), s, u, l = (v) => {
        if (v) {
          var g = v.join(",");
          u.has(g) || (u.add(g), s.push(v));
        }
      };
      if (A.operationCanTransformPath(t)) {
        s = [], u = /* @__PURE__ */ new Set();
        for (var c of o) {
          var f = A.transform(c, t);
          l(f);
        }
      } else
        s = o, u = i;
      var p = e.getDirtyPaths(t);
      for (var m of p)
        l(m);
      Lo.set(e, s), jo.set(e, u), re.transform(e, t), e.operations.push(t), b.normalize(e), t.type === "set_selection" && (e.marks = null), ua.get(e) || (ua.set(e, !0), Promise.resolve().then(() => {
        ua.set(e, !1), e.onChange(), e.operations = [];
      }));
    },
    addMark: (t, n) => {
      var {
        selection: r,
        markableVoid: a
      } = e;
      if (r) {
        var o = (p, m) => {
          if (!he.isText(p))
            return !1;
          var [v, g] = b.parent(e, m);
          return !e.isVoid(v) || e.markableVoid(v);
        }, i = Y.isExpanded(r), s = !1;
        if (!i) {
          var [u, l] = b.node(e, r);
          if (u && o(u, l)) {
            var [c] = b.parent(e, l);
            s = c && e.markableVoid(c);
          }
        }
        if (i || s)
          re.setNodes(e, {
            [t]: n
          }, {
            match: o,
            split: !0,
            voids: !0
          });
        else {
          var f = Ja(Ja({}, b.marks(e) || {}), {}, {
            [t]: n
          });
          e.marks = f, ua.get(e) || e.onChange();
        }
      }
    },
    deleteBackward: (t) => {
      var {
        selection: n
      } = e;
      n && Y.isCollapsed(n) && re.delete(e, {
        unit: t,
        reverse: !0
      });
    },
    deleteForward: (t) => {
      var {
        selection: n
      } = e;
      n && Y.isCollapsed(n) && re.delete(e, {
        unit: t
      });
    },
    deleteFragment: (t) => {
      var {
        selection: n
      } = e;
      n && Y.isExpanded(n) && re.delete(e, {
        reverse: t === "backward"
      });
    },
    getFragment: () => {
      var {
        selection: t
      } = e;
      return t ? ie.fragment(e, t) : [];
    },
    insertBreak: () => {
      re.splitNodes(e, {
        always: !0
      });
    },
    insertSoftBreak: () => {
      re.splitNodes(e, {
        always: !0
      });
    },
    insertFragment: (t) => {
      re.insertFragment(e, t);
    },
    insertNode: (t) => {
      re.insertNodes(e, t);
    },
    insertText: (t) => {
      var {
        selection: n,
        marks: r
      } = e;
      if (n) {
        if (r) {
          var a = Ja({
            text: t
          }, r);
          re.insertNodes(e, a);
        } else
          re.insertText(e, t);
        e.marks = null;
      }
    },
    normalizeNode: (t) => {
      var [n, r] = t;
      if (!he.isText(n)) {
        if (fe.isElement(n) && n.children.length === 0) {
          var a = {
            text: ""
          };
          re.insertNodes(e, a, {
            at: r.concat(0),
            voids: !0
          });
          return;
        }
        for (var o = b.isEditor(n) ? !1 : fe.isElement(n) && (e.isInline(n) || n.children.length === 0 || he.isText(n.children[0]) || e.isInline(n.children[0])), i = 0, s = 0; s < n.children.length; s++, i++) {
          var u = ie.get(e, r);
          if (!he.isText(u)) {
            var l = n.children[s], c = u.children[i - 1], f = s === n.children.length - 1, p = he.isText(l) || fe.isElement(l) && e.isInline(l);
            if (p !== o)
              re.removeNodes(e, {
                at: r.concat(i),
                voids: !0
              }), i--;
            else if (fe.isElement(l)) {
              if (e.isInline(l)) {
                if (c == null || !he.isText(c)) {
                  var m = {
                    text: ""
                  };
                  re.insertNodes(e, m, {
                    at: r.concat(i),
                    voids: !0
                  }), i++;
                } else if (f) {
                  var v = {
                    text: ""
                  };
                  re.insertNodes(e, v, {
                    at: r.concat(i + 1),
                    voids: !0
                  }), i++;
                }
              }
            } else
              c != null && he.isText(c) && (he.equals(l, c, {
                loose: !0
              }) ? (re.mergeNodes(e, {
                at: r.concat(i),
                voids: !0
              }), i--) : c.text === "" ? (re.removeNodes(e, {
                at: r.concat(i - 1),
                voids: !0
              }), i--) : l.text === "" && (re.removeNodes(e, {
                at: r.concat(i),
                voids: !0
              }), i--));
          }
        }
      }
    },
    removeMark: (t) => {
      var {
        selection: n
      } = e;
      if (n) {
        var r = (c, f) => {
          if (!he.isText(c))
            return !1;
          var [p, m] = b.parent(e, f);
          return !e.isVoid(p) || e.markableVoid(p);
        }, a = Y.isExpanded(n), o = !1;
        if (!a) {
          var [i, s] = b.node(e, n);
          if (i && r(i, s)) {
            var [u] = b.parent(e, s);
            o = u && e.markableVoid(u);
          }
        }
        if (a || o)
          re.unsetNodes(e, t, {
            match: r,
            split: !0,
            voids: !0
          });
        else {
          var l = Ja({}, b.marks(e) || {});
          delete l[t], e.marks = l, ua.get(e) || e.onChange();
        }
      }
    },
    /**
     * Get the "dirty" paths generated from an operation.
     */
    getDirtyPaths: (t) => {
      switch (t.type) {
        case "insert_text":
        case "remove_text":
        case "set_node": {
          var {
            path: n
          } = t;
          return A.levels(n);
        }
        case "insert_node": {
          var {
            node: r,
            path: a
          } = t, o = A.levels(a), i = he.isText(r) ? [] : Array.from(ie.nodes(r), (N) => {
            var [, q] = N;
            return a.concat(q);
          });
          return [...o, ...i];
        }
        case "merge_node": {
          var {
            path: s
          } = t, u = A.ancestors(s), l = A.previous(s);
          return [...u, l];
        }
        case "move_node": {
          var {
            path: c,
            newPath: f
          } = t;
          if (A.equals(c, f))
            return [];
          var p = [], m = [];
          for (var v of A.ancestors(c)) {
            var g = A.transform(v, t);
            p.push(g);
          }
          for (var h of A.ancestors(f)) {
            var w = A.transform(h, t);
            m.push(w);
          }
          var S = m[m.length - 1], x = f[f.length - 1], O = S.concat(x);
          return [...p, ...m, O];
        }
        case "remove_node": {
          var {
            path: B
          } = t, F = A.ancestors(B);
          return [...F];
        }
        case "split_node": {
          var {
            path: L
          } = t, j = A.levels(L), I = A.next(L);
          return [...j, I];
        }
        default:
          return [];
      }
    }
  };
  return e;
};
function dS(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function hr(e, t) {
  if (e == null)
    return {};
  var n = dS(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var $l = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = !n, a = n ? gS(t) : t, o = ge.None, i = ge.None, s = 0, u = null, l = null;
  for (var c of a) {
    var f = c.codePointAt(0);
    if (!f)
      break;
    var p = BS(c, f);
    if ([o, i] = r ? [i, p] : [p, o], Tn(o, ge.ZWJ) && Tn(i, ge.ExtPict) && (r ? u = Ud(t.substring(0, s)) : u = Ud(t.substring(0, t.length - s)), !u) || Tn(o, ge.RI) && Tn(i, ge.RI) && (l !== null ? l = !l : r ? l = !0 : l = FS(t.substring(0, t.length - s)), !l) || o !== ge.None && i !== ge.None && AS(o, i))
      break;
    s += c.length;
  }
  return s || 1;
}, fS = /\s/, pS = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, hS = /['\u2018\u2019]/, vS = function(t) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = 0, a = !1; t.length > 0; ) {
    var o = $l(t, n), [i, s] = kl(t, o, n);
    if (mS(i, s, n))
      a = !0, r += o;
    else if (!a)
      r += o;
    else
      break;
    t = s;
  }
  return r;
}, kl = (e, t, n) => {
  if (n) {
    var r = e.length - t;
    return [e.slice(r, e.length), e.slice(0, r)];
  }
  return [e.slice(0, t), e.slice(t)];
}, mS = function e(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (fS.test(t))
    return !1;
  if (hS.test(t)) {
    var a = $l(n, r), [o, i] = kl(n, a, r);
    if (e(o, i, r))
      return !0;
  }
  return !pS.test(t);
}, gS = function* (t) {
  for (var n = t.length - 1, r = 0; r < t.length; r++) {
    var a = t.charAt(n - r);
    if (bS(a.charCodeAt(0))) {
      var o = t.charAt(n - r - 1);
      if (yS(o.charCodeAt(0))) {
        yield o + a, r++;
        continue;
      }
    }
    yield a;
  }
}, yS = (e) => e >= 55296 && e <= 56319, bS = (e) => e >= 56320 && e <= 57343, ge;
(function(e) {
  e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(ge || (ge = {}));
var wS = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, DS = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, CS = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, ES = /^[\u1100-\u115F\uA960-\uA97C]$/, xS = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, SS = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, $S = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, kS = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, OS = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, BS = (e, t) => {
  var n = ge.Any;
  return e.search(wS) !== -1 && (n |= ge.Extend), t === 8205 && (n |= ge.ZWJ), t >= 127462 && t <= 127487 && (n |= ge.RI), e.search(DS) !== -1 && (n |= ge.Prepend), e.search(CS) !== -1 && (n |= ge.SpacingMark), e.search(ES) !== -1 && (n |= ge.L), e.search(xS) !== -1 && (n |= ge.V), e.search(SS) !== -1 && (n |= ge.T), e.search($S) !== -1 && (n |= ge.LV), e.search(kS) !== -1 && (n |= ge.LVT), e.search(OS) !== -1 && (n |= ge.ExtPict), n;
};
function Tn(e, t) {
  return (e & t) !== 0;
}
var TS = [
  // GB6
  [ge.L, ge.L | ge.V | ge.LV | ge.LVT],
  // GB7
  [ge.LV | ge.V, ge.V | ge.T],
  // GB8
  [ge.LVT | ge.T, ge.T],
  // GB9
  [ge.Any, ge.Extend | ge.ZWJ],
  // GB9a
  [ge.Any, ge.SpacingMark],
  // GB9b
  [ge.Prepend, ge.Any],
  // GB11
  [ge.ZWJ, ge.ExtPict],
  // GB12 and GB13
  [ge.RI, ge.RI]
];
function AS(e, t) {
  return TS.findIndex((n) => Tn(e, n[0]) && Tn(t, n[1])) === -1;
}
var PS = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, Ud = (e) => e.search(PS) !== -1, MS = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, FS = (e) => {
  var t = e.match(MS);
  if (t === null)
    return !1;
  var n = t[0].length / 2;
  return n % 2 === 1;
}, qd = (e) => ut(e) && ie.isNodeList(e.children) && !b.isEditor(e), fe = {
  /**
   * Check if a value implements the 'Ancestor' interface.
   */
  isAncestor(e) {
    return ut(e) && ie.isNodeList(e.children);
  },
  /**
   * Check if a value implements the `Element` interface.
   */
  isElement: qd,
  /**
   * Check if a value is an array of `Element` objects.
   */
  isElementList(e) {
    return Array.isArray(e) && e.every((t) => fe.isElement(t));
  },
  /**
   * Check if a set of props is a partial of Element.
   */
  isElementProps(e) {
    return e.children !== void 0;
  },
  /**
   * Check if a value implements the `Element` interface and has elementKey with selected value.
   * Default it check to `type` key value
   */
  isElementType: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return qd(t) && t[r] === n;
  },
  /**
   * Check if an element matches set of properties.
   *
   * Note: this checks custom properties, and it does not ensure that any
   * children are equivalent.
   */
  matches(e, t) {
    for (var n in t)
      if (n !== "children" && e[n] !== t[n])
        return !1;
    return !0;
  }
}, RS = ["text"], _S = ["text"];
function Xd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function En(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xd(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Gd = /* @__PURE__ */ new WeakMap(), b = {
  /**
   * Get the ancestor above a location in the document.
   */
  above(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      voids: n = !1,
      mode: r = "lowest",
      at: a = e.selection,
      match: o
    } = t;
    if (a) {
      var i = b.path(e, a), s = r === "lowest";
      for (var [u, l] of b.levels(e, {
        at: i,
        voids: n,
        match: o,
        reverse: s
      }))
        if (!he.isText(u)) {
          if (Y.isRange(a)) {
            if (A.isAncestor(l, a.anchor.path) && A.isAncestor(l, a.focus.path))
              return [u, l];
          } else if (!A.equals(i, l))
            return [u, l];
        }
    }
  },
  /**
   * Add a custom property to the leaf text nodes in the current selection.
   *
   * If the selection is currently collapsed, the marks will be added to the
   * `editor.marks` property instead, and applied when text is inserted next.
   */
  addMark(e, t, n) {
    e.addMark(t, n);
  },
  /**
   * Get the point after a location.
   */
  after(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = b.point(e, t, {
      edge: "end"
    }), a = b.end(e, []), o = {
      anchor: r,
      focus: a
    }, {
      distance: i = 1
    } = n, s = 0, u;
    for (var l of b.positions(e, En(En({}, n), {}, {
      at: o
    }))) {
      if (s > i)
        break;
      s !== 0 && (u = l), s++;
    }
    return u;
  },
  /**
   * Get the point before a location.
   */
  before(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = b.start(e, []), a = b.point(e, t, {
      edge: "start"
    }), o = {
      anchor: r,
      focus: a
    }, {
      distance: i = 1
    } = n, s = 0, u;
    for (var l of b.positions(e, En(En({}, n), {}, {
      at: o,
      reverse: !0
    }))) {
      if (s > i)
        break;
      s !== 0 && (u = l), s++;
    }
    return u;
  },
  /**
   * Delete content in the editor backward from the current selection.
   */
  deleteBackward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteBackward(n);
  },
  /**
   * Delete content in the editor forward from the current selection.
   */
  deleteForward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteForward(n);
  },
  /**
   * Delete the content in the current selection.
   */
  deleteFragment(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      direction: n = "forward"
    } = t;
    e.deleteFragment(n);
  },
  /**
   * Get the start and end points of a location.
   */
  edges(e, t) {
    return [b.start(e, t), b.end(e, t)];
  },
  /**
   * Get the end point of a location.
   */
  end(e, t) {
    return b.point(e, t, {
      edge: "end"
    });
  },
  /**
   * Get the first node at a location.
   */
  first(e, t) {
    var n = b.path(e, t, {
      edge: "start"
    });
    return b.node(e, n);
  },
  /**
   * Get the fragment at a location.
   */
  fragment(e, t) {
    var n = b.range(e, t), r = ie.fragment(e, n);
    return r;
  },
  /**
   * Check if a node has block children.
   */
  hasBlocks(e, t) {
    return t.children.some((n) => fe.isElement(n) && b.isBlock(e, n));
  },
  /**
   * Check if a node has inline and text children.
   */
  hasInlines(e, t) {
    return t.children.some((n) => he.isText(n) || b.isInline(e, n));
  },
  /**
   * Check if a node has text children.
   */
  hasTexts(e, t) {
    return t.children.every((n) => he.isText(n));
  },
  /**
   * Insert a block break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertBreak(e) {
    e.insertBreak();
  },
  /**
   * Insert a soft break at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertSoftBreak(e) {
    e.insertSoftBreak();
  },
  /**
   * Insert a fragment at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertFragment(e, t) {
    e.insertFragment(t);
  },
  /**
   * Insert a node at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertNode(e, t) {
    e.insertNode(t);
  },
  /**
   * Insert text at the current selection.
   *
   * If the selection is currently expanded, it will be deleted first.
   */
  insertText(e, t) {
    e.insertText(t);
  },
  /**
   * Check if a value is a block `Element` object.
   */
  isBlock(e, t) {
    return !e.isInline(t);
  },
  /**
   * Check if a value is an `Editor` object.
   */
  isEditor(e) {
    var t = Gd.get(e);
    if (t !== void 0)
      return t;
    if (!ut(e))
      return !1;
    var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteBackward == "function" && typeof e.deleteForward == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isInline == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || ut(e.marks)) && (e.selection === null || Y.isRange(e.selection)) && ie.isNodeList(e.children) && Or.isOperationList(e.operations);
    return Gd.set(e, n), n;
  },
  /**
   * Check if a point is the end point of a location.
   */
  isEnd(e, t, n) {
    var r = b.end(e, n);
    return De.equals(t, r);
  },
  /**
   * Check if a point is an edge of a location.
   */
  isEdge(e, t, n) {
    return b.isStart(e, t, n) || b.isEnd(e, t, n);
  },
  /**
   * Check if an element is empty, accounting for void nodes.
   */
  isEmpty(e, t) {
    var {
      children: n
    } = t, [r] = n;
    return n.length === 0 || n.length === 1 && he.isText(r) && r.text === "" && !e.isVoid(t);
  },
  /**
   * Check if a value is an inline `Element` object.
   */
  isInline(e, t) {
    return e.isInline(t);
  },
  /**
   * Check if the editor is currently normalizing after each operation.
   */
  isNormalizing(e) {
    var t = Yd.get(e);
    return t === void 0 ? !0 : t;
  },
  /**
   * Check if a point is the start point of a location.
   */
  isStart(e, t, n) {
    if (t.offset !== 0)
      return !1;
    var r = b.start(e, n);
    return De.equals(t, r);
  },
  /**
   * Check if a value is a void `Element` object.
   */
  isVoid(e, t) {
    return e.isVoid(t);
  },
  /**
   * Get the last node at a location.
   */
  last(e, t) {
    var n = b.path(e, t, {
      edge: "end"
    });
    return b.node(e, n);
  },
  /**
   * Get the leaf text node at a location.
   */
  leaf(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = b.path(e, t, n), a = ie.leaf(e, r);
    return [a, r];
  },
  /**
   * Iterate through all of the levels at a location.
   */
  *levels(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      reverse: r = !1,
      voids: a = !1
    } = t, {
      match: o
    } = t;
    if (o == null && (o = () => !0), !!n) {
      var i = [], s = b.path(e, n);
      for (var [u, l] of ie.levels(e, s))
        if (o(u, l) && (i.push([u, l]), !a && fe.isElement(u) && b.isVoid(e, u)))
          break;
      r && i.reverse(), yield* i;
    }
  },
  /**
   * Get the marks that would be added to text at the current selection.
   */
  marks(e) {
    var {
      marks: t,
      selection: n
    } = e;
    if (!n)
      return null;
    if (t)
      return t;
    if (Y.isExpanded(n)) {
      var [r] = b.nodes(e, {
        match: he.isText
      });
      if (r) {
        var [a] = r, o = hr(a, RS);
        return o;
      } else
        return {};
    }
    var {
      anchor: i
    } = n, {
      path: s
    } = i, [u] = b.leaf(e, s);
    if (i.offset === 0) {
      var l = b.previous(e, {
        at: s,
        match: he.isText
      }), c = b.above(e, {
        match: (h) => fe.isElement(h) && b.isVoid(e, h) && e.markableVoid(h)
      });
      if (!c) {
        var f = b.above(e, {
          match: (h) => fe.isElement(h) && b.isBlock(e, h)
        });
        if (l && f) {
          var [p, m] = l, [, v] = f;
          A.isAncestor(v, m) && (u = p);
        }
      }
    }
    var g = hr(u, _S);
    return g;
  },
  /**
   * Get the matching node in the branch of the document after a location.
   */
  next(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      mode: n = "lowest",
      voids: r = !1
    } = t, {
      match: a,
      at: o = e.selection
    } = t;
    if (o) {
      var i = b.after(e, o, {
        voids: r
      });
      if (i) {
        var [, s] = b.last(e, []), u = [i.path, s];
        if (A.isPath(o) && o.length === 0)
          throw new Error("Cannot get the next node from the root node!");
        if (a == null)
          if (A.isPath(o)) {
            var [l] = b.parent(e, o);
            a = (f) => l.children.includes(f);
          } else
            a = () => !0;
        var [c] = b.nodes(e, {
          at: u,
          match: a,
          mode: n,
          voids: r
        });
        return c;
      }
    }
  },
  /**
   * Get the node at a location.
   */
  node(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = b.path(e, t, n), a = ie.get(e, r);
    return [a, r];
  },
  /**
   * Iterate through all of the nodes in the Editor.
   */
  *nodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      mode: r = "all",
      universal: a = !1,
      reverse: o = !1,
      voids: i = !1
    } = t, {
      match: s
    } = t;
    if (s || (s = () => !0), !!n) {
      var u, l;
      if (NS.isSpan(n))
        u = n[0], l = n[1];
      else {
        var c = b.path(e, n, {
          edge: "start"
        }), f = b.path(e, n, {
          edge: "end"
        });
        u = o ? f : c, l = o ? c : f;
      }
      var p = ie.nodes(e, {
        reverse: o,
        from: u,
        to: l,
        pass: (x) => {
          var [O] = x;
          return i ? !1 : fe.isElement(O) && b.isVoid(e, O);
        }
      }), m = [], v;
      for (var [g, h] of p) {
        var w = v && A.compare(h, v[1]) === 0;
        if (!(r === "highest" && w)) {
          if (!s(g, h)) {
            if (a && !w && he.isText(g))
              return;
            continue;
          }
          if (r === "lowest" && w) {
            v = [g, h];
            continue;
          }
          var S = r === "lowest" ? v : [g, h];
          S && (a ? m.push(S) : yield S), v = [g, h];
        }
      }
      r === "lowest" && v && (a ? m.push(v) : yield v), a && (yield* m);
    }
  },
  /**
   * Normalize any dirty objects in the editor.
   */
  normalize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      force: n = !1
    } = t, r = (u) => Lo.get(u) || [], a = (u) => jo.get(u) || /* @__PURE__ */ new Set(), o = (u) => {
      var l = r(u).pop(), c = l.join(",");
      return a(u).delete(c), l;
    };
    if (b.isNormalizing(e)) {
      if (n) {
        var i = Array.from(ie.nodes(e), (u) => {
          var [, l] = u;
          return l;
        }), s = new Set(i.map((u) => u.join(",")));
        Lo.set(e, i), jo.set(e, s);
      }
      r(e).length !== 0 && b.withoutNormalizing(e, () => {
        for (var u of r(e))
          if (ie.has(e, u)) {
            var l = b.node(e, u), [c, f] = l;
            fe.isElement(c) && c.children.length === 0 && e.normalizeNode(l);
          }
        for (var p = r(e).length * 42, m = 0; r(e).length !== 0; ) {
          if (m > p)
            throw new Error(`
            Could not completely normalize the editor after `.concat(p, ` iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.
          `));
          var v = o(e);
          if (ie.has(e, v)) {
            var g = b.node(e, v);
            e.normalizeNode(g);
          }
          m++;
        }
      });
    }
  },
  /**
   * Get the parent node of a location.
   */
  parent(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = b.path(e, t, n), a = A.parent(r), o = b.node(e, a);
    return o;
  },
  /**
   * Get the path of a location.
   */
  path(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      depth: r,
      edge: a
    } = n;
    if (A.isPath(t)) {
      if (a === "start") {
        var [, o] = ie.first(e, t);
        t = o;
      } else if (a === "end") {
        var [, i] = ie.last(e, t);
        t = i;
      }
    }
    return Y.isRange(t) && (a === "start" ? t = Y.start(t) : a === "end" ? t = Y.end(t) : t = A.common(t.anchor.path, t.focus.path)), De.isPoint(t) && (t = t.path), r != null && (t = t.slice(0, r)), t;
  },
  hasPath(e, t) {
    return ie.has(e, t);
  },
  /**
   * Create a mutable ref for a `Path` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pathRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: i
        } = a, s = b.pathRefs(e);
        return s.delete(a), a.current = null, i;
      }
    }, o = b.pathRefs(e);
    return o.add(a), a;
  },
  /**
   * Get the set of currently tracked path refs of the editor.
   */
  pathRefs(e) {
    var t = Hd.get(e);
    return t || (t = /* @__PURE__ */ new Set(), Hd.set(e, t)), t;
  },
  /**
   * Get the start or end point of a location.
   */
  point(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      edge: r = "start"
    } = n;
    if (A.isPath(t)) {
      var a;
      if (r === "end") {
        var [, o] = ie.last(e, t);
        a = o;
      } else {
        var [, i] = ie.first(e, t);
        a = i;
      }
      var s = ie.get(e, a);
      if (!he.isText(s))
        throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
      return {
        path: a,
        offset: r === "end" ? s.text.length : 0
      };
    }
    if (Y.isRange(t)) {
      var [u, l] = Y.edges(t);
      return r === "start" ? u : l;
    }
    return t;
  },
  /**
   * Create a mutable ref for a `Point` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  pointRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: i
        } = a, s = b.pointRefs(e);
        return s.delete(a), a.current = null, i;
      }
    }, o = b.pointRefs(e);
    return o.add(a), a;
  },
  /**
   * Get the set of currently tracked point refs of the editor.
   */
  pointRefs(e) {
    var t = Vd.get(e);
    return t || (t = /* @__PURE__ */ new Set(), Vd.set(e, t)), t;
  },
  /**
   * Return all the positions in `at` range where a `Point` can be placed.
   *
   * By default, moves forward by individual offsets at a time, but
   * the `unit` option can be used to to move by character, word, line, or block.
   *
   * The `reverse` option can be used to change iteration direction.
   *
   * Note: By default void nodes are treated as a single point and iteration
   * will not happen inside their content unless you pass in true for the
   * `voids` option, then iteration will occur.
   */
  *positions(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      at: n = e.selection,
      unit: r = "offset",
      reverse: a = !1,
      voids: o = !1
    } = t;
    if (!n)
      return;
    var i = b.range(e, n), [s, u] = Y.edges(i), l = a ? u : s, c = !1, f = "", p = 0, m = 0, v = 0;
    for (var [g, h] of b.nodes(e, {
      at: n,
      reverse: a,
      voids: o
    })) {
      if (fe.isElement(g)) {
        if (!o && e.isVoid(g)) {
          yield b.start(e, h);
          continue;
        }
        if (e.isInline(g))
          continue;
        if (b.hasInlines(e, g)) {
          var w = A.isAncestor(h, u.path) ? u : b.end(e, h), S = A.isAncestor(h, s.path) ? s : b.start(e, h);
          f = b.string(e, {
            anchor: S,
            focus: w
          }, {
            voids: o
          }), c = !0;
        }
      }
      if (he.isText(g)) {
        var x = A.equals(h, l.path);
        for (x ? (m = a ? l.offset : g.text.length - l.offset, v = l.offset) : (m = g.text.length, v = a ? m : 0), (x || c || r === "offset") && (yield {
          path: h,
          offset: v
        }, c = !1); ; ) {
          if (p === 0) {
            if (f === "")
              break;
            p = O(f, r, a), f = kl(f, p, a)[1];
          }
          if (v = a ? v - p : v + p, m = m - p, m < 0) {
            p = -m;
            break;
          }
          p = 0, yield {
            path: h,
            offset: v
          };
        }
      }
    }
    function O(B, F, L) {
      return F === "character" ? $l(B, L) : F === "word" ? vS(B, L) : F === "line" || F === "block" ? B.length : 1;
    }
  },
  /**
   * Get the matching node in the branch of the document before a location.
   */
  previous(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      mode: n = "lowest",
      voids: r = !1
    } = t, {
      match: a,
      at: o = e.selection
    } = t;
    if (o) {
      var i = b.before(e, o, {
        voids: r
      });
      if (i) {
        var [, s] = b.first(e, []), u = [i.path, s];
        if (A.isPath(o) && o.length === 0)
          throw new Error("Cannot get the previous node from the root node!");
        if (a == null)
          if (A.isPath(o)) {
            var [l] = b.parent(e, o);
            a = (f) => l.children.includes(f);
          } else
            a = () => !0;
        var [c] = b.nodes(e, {
          reverse: !0,
          at: u,
          match: a,
          mode: n,
          voids: r
        });
        return c;
      }
    }
  },
  /**
   * Get a range of a location.
   */
  range(e, t, n) {
    if (Y.isRange(t) && !n)
      return t;
    var r = b.start(e, t), a = b.end(e, n || t);
    return {
      anchor: r,
      focus: a
    };
  },
  /**
   * Create a mutable ref for a `Range` object, which will stay in sync as new
   * operations are applied to the editor.
   */
  rangeRef(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      affinity: r = "forward"
    } = n, a = {
      current: t,
      affinity: r,
      unref() {
        var {
          current: i
        } = a, s = b.rangeRefs(e);
        return s.delete(a), a.current = null, i;
      }
    }, o = b.rangeRefs(e);
    return o.add(a), a;
  },
  /**
   * Get the set of currently tracked range refs of the editor.
   */
  rangeRefs(e) {
    var t = zd.get(e);
    return t || (t = /* @__PURE__ */ new Set(), zd.set(e, t)), t;
  },
  /**
   * Remove a custom property from all of the leaf text nodes in the current
   * selection.
   *
   * If the selection is currently collapsed, the removal will be stored on
   * `editor.marks` and applied to the text inserted next.
   */
  removeMark(e, t) {
    e.removeMark(t);
  },
  /**
   * Manually set if the editor should currently be normalizing.
   *
   * Note: Using this incorrectly can leave the editor in an invalid state.
   *
   */
  setNormalizing(e, t) {
    Yd.set(e, t);
  },
  /**
   * Get the start point of a location.
   */
  start(e, t) {
    return b.point(e, t, {
      edge: "start"
    });
  },
  /**
   * Get the text string content of a location.
   *
   * Note: by default the text of void nodes is considered to be an empty
   * string, regardless of content, unless you pass in true for the voids option
   */
  string(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      voids: r = !1
    } = n, a = b.range(e, t), [o, i] = Y.edges(a), s = "";
    for (var [u, l] of b.nodes(e, {
      at: a,
      match: he.isText,
      voids: r
    })) {
      var c = u.text;
      A.equals(l, i.path) && (c = c.slice(0, i.offset)), A.equals(l, o.path) && (c = c.slice(o.offset)), s += c;
    }
    return s;
  },
  /**
   * Convert a range into a non-hanging one.
   */
  unhangRange(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      voids: r = !1
    } = n, [a, o] = Y.edges(t);
    if (a.offset !== 0 || o.offset !== 0 || Y.isCollapsed(t) || A.hasPrevious(o.path))
      return t;
    var i = b.above(e, {
      at: o,
      match: (m) => fe.isElement(m) && b.isBlock(e, m),
      voids: r
    }), s = i ? i[1] : [], u = b.start(e, a), l = {
      anchor: u,
      focus: o
    }, c = !0;
    for (var [f, p] of b.nodes(e, {
      at: l,
      match: he.isText,
      reverse: !0,
      voids: r
    })) {
      if (c) {
        c = !1;
        continue;
      }
      if (f.text !== "" || A.isBefore(p, s)) {
        o = {
          path: p,
          offset: f.text.length
        };
        break;
      }
    }
    return {
      anchor: a,
      focus: o
    };
  },
  /**
   * Match a void node in the current branch of the editor.
   */
  void(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return b.above(e, En(En({}, t), {}, {
      match: (n) => fe.isElement(n) && b.isVoid(e, n)
    }));
  },
  /**
   * Call a function, deferring normalization until after it completes.
   */
  withoutNormalizing(e, t) {
    var n = b.isNormalizing(e);
    b.setNormalizing(e, !1);
    try {
      t();
    } finally {
      b.setNormalizing(e, n);
    }
    b.normalize(e);
  }
}, NS = {
  /**
   * Check if a value implements the `Span` interface.
   */
  isSpan(e) {
    return Array.isArray(e) && e.length === 2 && e.every(A.isPath);
  }
}, IS = ["children"], LS = ["text"], Qd = /* @__PURE__ */ new WeakMap(), ie = {
  /**
   * Get the node at a specific path, asserting that it's an ancestor node.
   */
  ancestor(e, t) {
    var n = ie.get(e, t);
    if (he.isText(n))
      throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(nt.stringify(n)));
    return n;
  },
  /**
   * Return a generator of all the ancestor nodes above a specific path.
   *
   * By default the order is top-down, from highest to lowest ancestor in
   * the tree, but you can pass the `reverse: true` option to go bottom-up.
   */
  *ancestors(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of A.ancestors(t, n)) {
      var a = ie.ancestor(e, r), o = [a, r];
      yield o;
    }
  },
  /**
   * Get the child of a node at a specific index.
   */
  child(e, t) {
    if (he.isText(e))
      throw new Error("Cannot get the child of a text node: ".concat(nt.stringify(e)));
    var n = e.children[t];
    if (n == null)
      throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(nt.stringify(e)));
    return n;
  },
  /**
   * Iterate over the children of a node at a specific path.
   */
  *children(e, t) {
    for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      reverse: r = !1
    } = n, a = ie.ancestor(e, t), {
      children: o
    } = a, i = r ? o.length - 1 : 0; r ? i >= 0 : i < o.length; ) {
      var s = ie.child(a, i), u = t.concat(i);
      yield [s, u], i = r ? i - 1 : i + 1;
    }
  },
  /**
   * Get an entry for the common ancesetor node of two paths.
   */
  common(e, t, n) {
    var r = A.common(t, n), a = ie.get(e, r);
    return [a, r];
  },
  /**
   * Get the node at a specific path, asserting that it's a descendant node.
   */
  descendant(e, t) {
    var n = ie.get(e, t);
    if (b.isEditor(n))
      throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(nt.stringify(n)));
    return n;
  },
  /**
   * Return a generator of all the descendant node entries inside a root node.
   */
  *descendants(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of ie.nodes(e, t))
      r.length !== 0 && (yield [n, r]);
  },
  /**
   * Return a generator of all the element nodes inside a root node. Each iteration
   * will return an `ElementEntry` tuple consisting of `[Element, Path]`. If the
   * root node is an element it will be included in the iteration as well.
   */
  *elements(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of ie.nodes(e, t))
      fe.isElement(n) && (yield [n, r]);
  },
  /**
   * Extract props from a Node.
   */
  extractProps(e) {
    if (fe.isAncestor(e)) {
      var t = hr(e, IS);
      return t;
    } else {
      var t = hr(e, LS);
      return t;
    }
  },
  /**
   * Get the first node entry in a root node from a path.
   */
  first(e, t) {
    for (var n = t.slice(), r = ie.get(e, n); r && !(he.isText(r) || r.children.length === 0); )
      r = r.children[0], n.push(0);
    return [r, n];
  },
  /**
   * Get the sliced fragment represented by a range inside a root node.
   */
  fragment(e, t) {
    if (he.isText(e))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(nt.stringify(e)));
    var n = Sl({
      children: e.children
    }, (r) => {
      var [a, o] = Y.edges(t), i = ie.nodes(r, {
        reverse: !0,
        pass: (p) => {
          var [, m] = p;
          return !Y.includes(t, m);
        }
      });
      for (var [, s] of i) {
        if (!Y.includes(t, s)) {
          var u = ie.parent(r, s), l = s[s.length - 1];
          u.children.splice(l, 1);
        }
        if (A.equals(s, o.path)) {
          var c = ie.leaf(r, s);
          c.text = c.text.slice(0, o.offset);
        }
        if (A.equals(s, a.path)) {
          var f = ie.leaf(r, s);
          f.text = f.text.slice(a.offset);
        }
      }
      b.isEditor(r) && (r.selection = null);
    });
    return n.children;
  },
  /**
   * Get the descendant node referred to by a specific path. If the path is an
   * empty array, it refers to the root node itself.
   */
  get(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (he.isText(n) || !n.children[a])
        throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(nt.stringify(e)));
      n = n.children[a];
    }
    return n;
  },
  /**
   * Check if a descendant node exists at a specific path.
   */
  has(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (he.isText(n) || !n.children[a])
        return !1;
      n = n.children[a];
    }
    return !0;
  },
  /**
   * Check if a value implements the `Node` interface.
   */
  isNode(e) {
    return he.isText(e) || fe.isElement(e) || b.isEditor(e);
  },
  /**
   * Check if a value is a list of `Node` objects.
   */
  isNodeList(e) {
    if (!Array.isArray(e))
      return !1;
    var t = Qd.get(e);
    if (t !== void 0)
      return t;
    var n = e.every((r) => ie.isNode(r));
    return Qd.set(e, n), n;
  },
  /**
   * Get the last node entry in a root node from a path.
   */
  last(e, t) {
    for (var n = t.slice(), r = ie.get(e, n); r && !(he.isText(r) || r.children.length === 0); ) {
      var a = r.children.length - 1;
      r = r.children[a], n.push(a);
    }
    return [r, n];
  },
  /**
   * Get the node at a specific path, ensuring it's a leaf text node.
   */
  leaf(e, t) {
    var n = ie.get(e, t);
    if (!he.isText(n))
      throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(nt.stringify(n)));
    return n;
  },
  /**
   * Return a generator of the in a branch of the tree, from a specific path.
   *
   * By default the order is top-down, from highest to lowest node in the tree,
   * but you can pass the `reverse: true` option to go bottom-up.
   */
  *levels(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of A.levels(t, n)) {
      var a = ie.get(e, r);
      yield [a, r];
    }
  },
  /**
   * Check if a node matches a set of props.
   */
  matches(e, t) {
    return fe.isElement(e) && fe.isElementProps(t) && fe.matches(e, t) || he.isText(e) && he.isTextProps(t) && he.matches(e, t);
  },
  /**
   * Return a generator of all the node entries of a root node. Each entry is
   * returned as a `[Node, Path]` tuple, with the path referring to the node's
   * position inside the root node.
   */
  *nodes(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      pass: n,
      reverse: r = !1
    } = t, {
      from: a = [],
      to: o
    } = t, i = /* @__PURE__ */ new Set(), s = [], u = e; !(o && (r ? A.isBefore(s, o) : A.isAfter(s, o))); ) {
      if (i.has(u) || (yield [u, s]), !i.has(u) && !he.isText(u) && u.children.length !== 0 && (n == null || n([u, s]) === !1)) {
        i.add(u);
        var l = r ? u.children.length - 1 : 0;
        A.isAncestor(s, a) && (l = a[s.length]), s = s.concat(l), u = ie.get(e, s);
        continue;
      }
      if (s.length === 0)
        break;
      if (!r) {
        var c = A.next(s);
        if (ie.has(e, c)) {
          s = c, u = ie.get(e, s);
          continue;
        }
      }
      if (r && s[s.length - 1] !== 0) {
        var f = A.previous(s);
        s = f, u = ie.get(e, s);
        continue;
      }
      s = A.parent(s), u = ie.get(e, s), i.add(u);
    }
  },
  /**
   * Get the parent of a node at a specific path.
   */
  parent(e, t) {
    var n = A.parent(t), r = ie.get(e, n);
    if (he.isText(r))
      throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
    return r;
  },
  /**
   * Get the concatenated text string of a node's content.
   *
   * Note that this will not include spaces or line breaks between block nodes.
   * It is not a user-facing string, but a string for performing offset-related
   * computations for a node.
   */
  string(e) {
    return he.isText(e) ? e.text : e.children.map(ie.string).join("");
  },
  /**
   * Return a generator of all leaf text nodes in a root node.
   */
  *texts(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of ie.nodes(e, t))
      he.isText(n) && (yield [n, r]);
  }
};
function Zd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zd(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Or = {
  /**
   * Check if a value is a `NodeOperation` object.
   */
  isNodeOperation(e) {
    return Or.isOperation(e) && e.type.endsWith("_node");
  },
  /**
   * Check if a value is an `Operation` object.
   */
  isOperation(e) {
    if (!ut(e))
      return !1;
    switch (e.type) {
      case "insert_node":
        return A.isPath(e.path) && ie.isNode(e.node);
      case "insert_text":
        return typeof e.offset == "number" && typeof e.text == "string" && A.isPath(e.path);
      case "merge_node":
        return typeof e.position == "number" && A.isPath(e.path) && ut(e.properties);
      case "move_node":
        return A.isPath(e.path) && A.isPath(e.newPath);
      case "remove_node":
        return A.isPath(e.path) && ie.isNode(e.node);
      case "remove_text":
        return typeof e.offset == "number" && typeof e.text == "string" && A.isPath(e.path);
      case "set_node":
        return A.isPath(e.path) && ut(e.properties) && ut(e.newProperties);
      case "set_selection":
        return e.properties === null && Y.isRange(e.newProperties) || e.newProperties === null && Y.isRange(e.properties) || ut(e.properties) && ut(e.newProperties);
      case "split_node":
        return A.isPath(e.path) && typeof e.position == "number" && ut(e.properties);
      default:
        return !1;
    }
  },
  /**
   * Check if a value is a list of `Operation` objects.
   */
  isOperationList(e) {
    return Array.isArray(e) && e.every((t) => Or.isOperation(t));
  },
  /**
   * Check if a value is a `SelectionOperation` object.
   */
  isSelectionOperation(e) {
    return Or.isOperation(e) && e.type.endsWith("_selection");
  },
  /**
   * Check if a value is a `TextOperation` object.
   */
  isTextOperation(e) {
    return Or.isOperation(e) && e.type.endsWith("_text");
  },
  /**
   * Invert an operation, returning a new operation that will exactly undo the
   * original when applied.
   */
  inverse(e) {
    switch (e.type) {
      case "insert_node":
        return Ke(Ke({}, e), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return Ke(Ke({}, e), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return Ke(Ke({}, e), {}, {
          type: "split_node",
          path: A.previous(e.path)
        });
      case "move_node": {
        var {
          newPath: t,
          path: n
        } = e;
        if (A.equals(t, n))
          return e;
        if (A.isSibling(n, t))
          return Ke(Ke({}, e), {}, {
            path: t,
            newPath: n
          });
        var r = A.transform(n, e), a = A.transform(A.next(n), e);
        return Ke(Ke({}, e), {}, {
          path: r,
          newPath: a
        });
      }
      case "remove_node":
        return Ke(Ke({}, e), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return Ke(Ke({}, e), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: o,
          newProperties: i
        } = e;
        return Ke(Ke({}, e), {}, {
          properties: i,
          newProperties: o
        });
      }
      case "set_selection": {
        var {
          properties: s,
          newProperties: u
        } = e;
        return s == null ? Ke(Ke({}, e), {}, {
          properties: u,
          newProperties: null
        }) : u == null ? Ke(Ke({}, e), {}, {
          properties: null,
          newProperties: s
        }) : Ke(Ke({}, e), {}, {
          properties: u,
          newProperties: s
        });
      }
      case "split_node":
        return Ke(Ke({}, e), {}, {
          type: "merge_node",
          path: A.next(e.path)
        });
    }
  }
}, A = {
  /**
   * Get a list of ancestor paths for a given path.
   *
   * The paths are sorted from shallowest to deepest ancestor. However, if the
   * `reverse: true` option is passed, they are reversed.
   */
  ancestors(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = A.levels(e, t);
    return n ? r = r.slice(1) : r = r.slice(0, -1), r;
  },
  /**
   * Get the common ancestor path of two paths.
   */
  common(e, t) {
    for (var n = [], r = 0; r < e.length && r < t.length; r++) {
      var a = e[r], o = t[r];
      if (a !== o)
        break;
      n.push(a);
    }
    return n;
  },
  /**
   * Compare a path to another, returning an integer indicating whether the path
   * was before, at, or after the other.
   *
   * Note: Two paths of unequal length can still receive a `0` result if one is
   * directly above or below the other. If you want exact matching, use
   * [[Path.equals]] instead.
   */
  compare(e, t) {
    for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
      if (e[r] < t[r])
        return -1;
      if (e[r] > t[r])
        return 1;
    }
    return 0;
  },
  /**
   * Check if a path ends after one of the indexes in another.
   */
  endsAfter(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), o = e[n], i = t[n];
    return A.equals(r, a) && o > i;
  },
  /**
   * Check if a path ends at one of the indexes in another.
   */
  endsAt(e, t) {
    var n = e.length, r = e.slice(0, n), a = t.slice(0, n);
    return A.equals(r, a);
  },
  /**
   * Check if a path ends before one of the indexes in another.
   */
  endsBefore(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), o = e[n], i = t[n];
    return A.equals(r, a) && o < i;
  },
  /**
   * Check if a path is exactly equal to another.
   */
  equals(e, t) {
    return e.length === t.length && e.every((n, r) => n === t[r]);
  },
  /**
   * Check if the path of previous sibling node exists
   */
  hasPrevious(e) {
    return e[e.length - 1] > 0;
  },
  /**
   * Check if a path is after another.
   */
  isAfter(e, t) {
    return A.compare(e, t) === 1;
  },
  /**
   * Check if a path is an ancestor of another.
   */
  isAncestor(e, t) {
    return e.length < t.length && A.compare(e, t) === 0;
  },
  /**
   * Check if a path is before another.
   */
  isBefore(e, t) {
    return A.compare(e, t) === -1;
  },
  /**
   * Check if a path is a child of another.
   */
  isChild(e, t) {
    return e.length === t.length + 1 && A.compare(e, t) === 0;
  },
  /**
   * Check if a path is equal to or an ancestor of another.
   */
  isCommon(e, t) {
    return e.length <= t.length && A.compare(e, t) === 0;
  },
  /**
   * Check if a path is a descendant of another.
   */
  isDescendant(e, t) {
    return e.length > t.length && A.compare(e, t) === 0;
  },
  /**
   * Check if a path is the parent of another.
   */
  isParent(e, t) {
    return e.length + 1 === t.length && A.compare(e, t) === 0;
  },
  /**
   * Check is a value implements the `Path` interface.
   */
  isPath(e) {
    return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
  },
  /**
   * Check if a path is a sibling of another.
   */
  isSibling(e, t) {
    if (e.length !== t.length)
      return !1;
    var n = e.slice(0, -1), r = t.slice(0, -1), a = e[e.length - 1], o = t[t.length - 1];
    return a !== o && A.equals(n, r);
  },
  /**
   * Get a list of paths at every level down to a path. Note: this is the same
   * as `Path.ancestors`, but including the path itself.
   *
   * The paths are sorted from shallowest to deepest. However, if the `reverse:
   * true` option is passed, they are reversed.
   */
  levels(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = [], a = 0; a <= e.length; a++)
      r.push(e.slice(0, a));
    return n && r.reverse(), r;
  },
  /**
   * Given a path, get the path to the next sibling node.
   */
  next(e) {
    if (e.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
    var t = e[e.length - 1];
    return e.slice(0, -1).concat(t + 1);
  },
  /**
   * Returns whether this operation can affect paths or not. Used as an
   * optimization when updating dirty paths during normalization
   *
   * NOTE: This *must* be kept in sync with the implementation of 'transform'
   * below
   */
  operationCanTransformPath(e) {
    switch (e.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  /**
   * Given a path, return a new path referring to the parent node above it.
   */
  parent(e) {
    if (e.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
    return e.slice(0, -1);
  },
  /**
   * Given a path, get the path to the previous sibling node.
   */
  previous(e) {
    if (e.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
    var t = e[e.length - 1];
    if (t <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
    return e.slice(0, -1).concat(t - 1);
  },
  /**
   * Get a path relative to an ancestor.
   */
  relative(e, t) {
    if (!A.isAncestor(t, e) && !A.equals(e, t))
      throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
    return e.slice(t.length);
  },
  /**
   * Transform a path by an operation.
   */
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!e)
      return null;
    var r = [...e], {
      affinity: a = "forward"
    } = n;
    if (e.length === 0)
      return r;
    switch (t.type) {
      case "insert_node": {
        var {
          path: o
        } = t;
        (A.equals(o, r) || A.endsBefore(o, r) || A.isAncestor(o, r)) && (r[o.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: i
        } = t;
        if (A.equals(i, r) || A.isAncestor(i, r))
          return null;
        A.endsBefore(i, r) && (r[i.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: s,
          position: u
        } = t;
        A.equals(s, r) || A.endsBefore(s, r) ? r[s.length - 1] -= 1 : A.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += u);
        break;
      }
      case "split_node": {
        var {
          path: l,
          position: c
        } = t;
        if (A.equals(l, r)) {
          if (a === "forward")
            r[r.length - 1] += 1;
          else if (a !== "backward")
            return null;
        } else
          A.endsBefore(l, r) ? r[l.length - 1] += 1 : A.isAncestor(l, r) && e[l.length] >= c && (r[l.length - 1] += 1, r[l.length] -= c);
        break;
      }
      case "move_node": {
        var {
          path: f,
          newPath: p
        } = t;
        if (A.equals(f, p))
          return r;
        if (A.isAncestor(f, r) || A.equals(f, r)) {
          var m = p.slice();
          return A.endsBefore(f, p) && f.length < p.length && (m[f.length - 1] -= 1), m.concat(r.slice(f.length));
        } else
          A.isSibling(f, p) && (A.isAncestor(p, r) || A.equals(p, r)) ? A.endsBefore(f, r) ? r[f.length - 1] -= 1 : r[f.length - 1] += 1 : A.endsBefore(p, r) || A.equals(p, r) || A.isAncestor(p, r) ? (A.endsBefore(f, r) && (r[f.length - 1] -= 1), r[p.length - 1] += 1) : A.endsBefore(f, r) && (A.equals(p, r) && (r[p.length - 1] += 1), r[f.length - 1] -= 1);
        break;
      }
    }
    return r;
  }
}, jS = {
  /**
   * Transform the path ref's current value by an operation.
   */
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = A.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
};
function Jd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ef(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jd(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var De = {
  /**
   * Compare a point to another, returning an integer indicating whether the
   * point was before, at, or after the other.
   */
  compare(e, t) {
    var n = A.compare(e.path, t.path);
    return n === 0 ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
  },
  /**
   * Check if a point is after another.
   */
  isAfter(e, t) {
    return De.compare(e, t) === 1;
  },
  /**
   * Check if a point is before another.
   */
  isBefore(e, t) {
    return De.compare(e, t) === -1;
  },
  /**
   * Check if a point is exactly equal to another.
   */
  equals(e, t) {
    return e.offset === t.offset && A.equals(e.path, t.path);
  },
  /**
   * Check if a value implements the `Point` interface.
   */
  isPoint(e) {
    return ut(e) && typeof e.offset == "number" && A.isPath(e.path);
  },
  /**
   * Transform a point by an operation.
   */
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Sl(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "forward"
      } = n, {
        path: o,
        offset: i
      } = r;
      switch (t.type) {
        case "insert_node":
        case "move_node": {
          r.path = A.transform(o, t, n);
          break;
        }
        case "insert_text": {
          A.equals(t.path, o) && (t.offset < i || t.offset === i && a === "forward") && (r.offset += t.text.length);
          break;
        }
        case "merge_node": {
          A.equals(t.path, o) && (r.offset += t.position), r.path = A.transform(o, t, n);
          break;
        }
        case "remove_text": {
          A.equals(t.path, o) && t.offset <= i && (r.offset -= Math.min(i - t.offset, t.text.length));
          break;
        }
        case "remove_node": {
          if (A.equals(t.path, o) || A.isAncestor(t.path, o))
            return null;
          r.path = A.transform(o, t, n);
          break;
        }
        case "split_node": {
          if (A.equals(t.path, o)) {
            if (t.position === i && a == null)
              return null;
            (t.position < i || t.position === i && a === "forward") && (r.offset -= t.position, r.path = A.transform(o, t, ef(ef({}, n), {}, {
              affinity: "forward"
            })));
          } else
            r.path = A.transform(o, t, n);
          break;
        }
      }
    });
  }
}, WS = {
  /**
   * Transform the point ref's current value by an operation.
   */
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = De.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
}, YS = ["anchor", "focus"];
function tf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function HS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tf(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Y = {
  /**
   * Get the start and end points of a range, in the order in which they appear
   * in the document.
   */
  edges(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, {
      anchor: r,
      focus: a
    } = e;
    return Y.isBackward(e) === n ? [r, a] : [a, r];
  },
  /**
   * Get the end point of a range.
   */
  end(e) {
    var [, t] = Y.edges(e);
    return t;
  },
  /**
   * Check if a range is exactly equal to another.
   */
  equals(e, t) {
    return De.equals(e.anchor, t.anchor) && De.equals(e.focus, t.focus);
  },
  /**
   * Check if a range includes a path, a point or part of another range.
   */
  includes(e, t) {
    if (Y.isRange(t)) {
      if (Y.includes(e, t.anchor) || Y.includes(e, t.focus))
        return !0;
      var [n, r] = Y.edges(e), [a, o] = Y.edges(t);
      return De.isBefore(n, a) && De.isAfter(r, o);
    }
    var [i, s] = Y.edges(e), u = !1, l = !1;
    return De.isPoint(t) ? (u = De.compare(t, i) >= 0, l = De.compare(t, s) <= 0) : (u = A.compare(t, i.path) >= 0, l = A.compare(t, s.path) <= 0), u && l;
  },
  /**
   * Get the intersection of a range with another.
   */
  intersection(e, t) {
    var n = hr(e, YS), [r, a] = Y.edges(e), [o, i] = Y.edges(t), s = De.isBefore(r, o) ? o : r, u = De.isBefore(a, i) ? a : i;
    return De.isBefore(u, s) ? null : HS({
      anchor: s,
      focus: u
    }, n);
  },
  /**
   * Check if a range is backward, meaning that its anchor point appears in the
   * document _after_ its focus point.
   */
  isBackward(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return De.isAfter(t, n);
  },
  /**
   * Check if a range is collapsed, meaning that both its anchor and focus
   * points refer to the exact same position in the document.
   */
  isCollapsed(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return De.equals(t, n);
  },
  /**
   * Check if a range is expanded.
   *
   * This is the opposite of [[Range.isCollapsed]] and is provided for legibility.
   */
  isExpanded(e) {
    return !Y.isCollapsed(e);
  },
  /**
   * Check if a range is forward.
   *
   * This is the opposite of [[Range.isBackward]] and is provided for legibility.
   */
  isForward(e) {
    return !Y.isBackward(e);
  },
  /**
   * Check if a value implements the [[Range]] interface.
   */
  isRange(e) {
    return ut(e) && De.isPoint(e.anchor) && De.isPoint(e.focus);
  },
  /**
   * Iterate through all of the point entries in a range.
   */
  *points(e) {
    yield [e.anchor, "anchor"], yield [e.focus, "focus"];
  },
  /**
   * Get the start point of a range.
   */
  start(e) {
    var [t] = Y.edges(e);
    return t;
  },
  /**
   * Transform a range by an operation.
   */
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Sl(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "inward"
      } = n, o, i;
      if (a === "inward") {
        var s = Y.isCollapsed(r);
        Y.isForward(r) ? (o = "forward", i = s ? o : "backward") : (o = "backward", i = s ? o : "forward");
      } else
        a === "outward" ? Y.isForward(r) ? (o = "backward", i = "forward") : (o = "forward", i = "backward") : (o = a, i = a);
      var u = De.transform(r.anchor, t, {
        affinity: o
      }), l = De.transform(r.focus, t, {
        affinity: i
      });
      if (!u || !l)
        return null;
      r.anchor = u, r.focus = l;
    });
  }
}, VS = {
  /**
   * Transform the range ref's current value by an operation.
   */
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = Y.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
}, rf = void 0, nt = {
  setScrubber(e) {
    rf = e;
  },
  stringify(e) {
    return JSON.stringify(e, rf);
  }
}, Pv = (e, t) => {
  for (var n in e) {
    var r = e[n], a = t[n];
    if (ut(r) && ut(a)) {
      if (!Pv(r, a))
        return !1;
    } else if (Array.isArray(r) && Array.isArray(a)) {
      if (r.length !== a.length)
        return !1;
      for (var o = 0; o < r.length; o++)
        if (r[o] !== a[o])
          return !1;
    } else if (r !== a)
      return !1;
  }
  for (var i in t)
    if (e[i] === void 0 && t[i] !== void 0)
      return !1;
  return !0;
}, zS = ["text"], KS = ["anchor", "focus"];
function nf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nf(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var he = {
  /**
   * Check if two text nodes are equal.
   *
   * When loose is set, the text is not compared. This is
   * used to check whether sibling text nodes can be merged.
   */
  equals(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: r = !1
    } = n;
    function a(o) {
      var i = hr(o, zS);
      return i;
    }
    return Pv(r ? a(e) : e, r ? a(t) : t);
  },
  /**
   * Check if a value implements the `Text` interface.
   */
  isText(e) {
    return ut(e) && typeof e.text == "string";
  },
  /**
   * Check if a value is a list of `Text` objects.
   */
  isTextList(e) {
    return Array.isArray(e) && e.every((t) => he.isText(t));
  },
  /**
   * Check if some props are a partial of Text.
   */
  isTextProps(e) {
    return e.text !== void 0;
  },
  /**
   * Check if an text matches set of properties.
   *
   * Note: this is for matching custom properties, and it does not ensure that
   * the `text` property are two nodes equal.
   */
  matches(e, t) {
    for (var n in t)
      if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n]))
        return !1;
    return !0;
  },
  /**
   * Get the leaves for a text node given decorations.
   */
  decorations(e, t) {
    var n = [cr({}, e)];
    for (var r of t) {
      var a = hr(r, KS), [o, i] = Y.edges(r), s = [], u = 0, l = o.offset, c = i.offset;
      for (var f of n) {
        var {
          length: p
        } = f.text, m = u;
        if (u += p, l <= m && u <= c) {
          Object.assign(f, a), s.push(f);
          continue;
        }
        if (l !== c && (l === u || c === m) || l > u || c < m || c === m && m !== 0) {
          s.push(f);
          continue;
        }
        var v = f, g = void 0, h = void 0;
        if (c < u) {
          var w = c - m;
          h = cr(cr({}, v), {}, {
            text: v.text.slice(w)
          }), v = cr(cr({}, v), {}, {
            text: v.text.slice(0, w)
          });
        }
        if (l > m) {
          var S = l - m;
          g = cr(cr({}, v), {}, {
            text: v.text.slice(0, S)
          }), v = cr(cr({}, v), {}, {
            text: v.text.slice(S)
          });
        }
        Object.assign(v, a), g && s.push(g), s.push(v), h && s.push(h);
      }
      n = s;
    }
    return n;
  }
};
function af(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function la(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? af(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : af(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var US = (e, t, n) => {
  switch (n.type) {
    case "insert_node": {
      var {
        path: r,
        node: a
      } = n, o = ie.parent(e, r), i = r[r.length - 1];
      if (i > o.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
      if (o.children.splice(i, 0, a), t)
        for (var [s, u] of Y.points(t))
          t[u] = De.transform(s, n);
      break;
    }
    case "insert_text": {
      var {
        path: l,
        offset: c,
        text: f
      } = n;
      if (f.length === 0)
        break;
      var p = ie.leaf(e, l), m = p.text.slice(0, c), v = p.text.slice(c);
      if (p.text = m + f + v, t)
        for (var [g, h] of Y.points(t))
          t[h] = De.transform(g, n);
      break;
    }
    case "merge_node": {
      var {
        path: w
      } = n, S = ie.get(e, w), x = A.previous(w), O = ie.get(e, x), B = ie.parent(e, w), F = w[w.length - 1];
      if (he.isText(S) && he.isText(O))
        O.text += S.text;
      else if (!he.isText(S) && !he.isText(O))
        O.children.push(...S.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(w, "] to nodes of different interfaces: ").concat(nt.stringify(S), " ").concat(nt.stringify(O)));
      if (B.children.splice(F, 1), t)
        for (var [L, j] of Y.points(t))
          t[j] = De.transform(L, n);
      break;
    }
    case "move_node": {
      var {
        path: I,
        newPath: N
      } = n;
      if (A.isAncestor(I, N))
        throw new Error("Cannot move a path [".concat(I, "] to new path [").concat(N, "] because the destination is inside itself."));
      var q = ie.get(e, I), J = ie.parent(e, I), R = I[I.length - 1];
      J.children.splice(R, 1);
      var ae = A.transform(I, n), H = ie.get(e, A.parent(ae)), oe = ae[ae.length - 1];
      if (H.children.splice(oe, 0, q), t)
        for (var [ue, me] of Y.points(t))
          t[me] = De.transform(ue, n);
      break;
    }
    case "remove_node": {
      var {
        path: V
      } = n, T = V[V.length - 1], C = ie.parent(e, V);
      if (C.children.splice(T, 1), t)
        for (var [M, P] of Y.points(t)) {
          var W = De.transform(M, n);
          if (t != null && W != null)
            t[P] = W;
          else {
            var z = void 0, K = void 0;
            for (var [X, G] of ie.texts(e))
              if (A.compare(G, V) === -1)
                z = [X, G];
              else {
                K = [X, G];
                break;
              }
            var te = !1;
            z && K && (A.equals(K[1], V) ? te = !A.hasPrevious(K[1]) : te = A.common(z[1], V).length < A.common(K[1], V).length), z && !te ? (M.path = z[1], M.offset = z[0].text.length) : K ? (M.path = K[1], M.offset = 0) : t = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: se,
        offset: Z,
        text: ne
      } = n;
      if (ne.length === 0)
        break;
      var be = ie.leaf(e, se), Pe = be.text.slice(0, Z), Ve = be.text.slice(Z + ne.length);
      if (be.text = Pe + Ve, t)
        for (var [Et, Ze] of Y.points(t))
          t[Ze] = De.transform(Et, n);
      break;
    }
    case "set_node": {
      var {
        path: Yr,
        properties: bn,
        newProperties: gt
      } = n;
      if (Yr.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var zt = ie.get(e, Yr);
      for (var xt in gt) {
        if (xt === "children" || xt === "text")
          throw new Error('Cannot set the "'.concat(xt, '" property of nodes!'));
        var wr = gt[xt];
        wr == null ? delete zt[xt] : zt[xt] = wr;
      }
      for (var wn in bn)
        gt.hasOwnProperty(wn) || delete zt[wn];
      break;
    }
    case "set_selection": {
      var {
        newProperties: Kt
      } = n;
      if (Kt == null)
        t = Kt;
      else {
        if (t == null) {
          if (!Y.isRange(Kt))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(nt.stringify(Kt), " when there is no current selection."));
          t = la({}, Kt);
        }
        for (var ur in Kt) {
          var aa = Kt[ur];
          if (aa == null) {
            if (ur === "anchor" || ur === "focus")
              throw new Error('Cannot remove the "'.concat(ur, '" selection property'));
            delete t[ur];
          } else
            t[ur] = aa;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: lr,
        position: Ua,
        properties: gc
      } = n;
      if (lr.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(lr, "] because the root node cannot be split."));
      var Hr = ie.get(e, lr), x0 = ie.parent(e, lr), S0 = lr[lr.length - 1], Si;
      if (he.isText(Hr)) {
        var $0 = Hr.text.slice(0, Ua), k0 = Hr.text.slice(Ua);
        Hr.text = $0, Si = la(la({}, gc), {}, {
          text: k0
        });
      } else {
        var O0 = Hr.children.slice(0, Ua), B0 = Hr.children.slice(Ua);
        Hr.children = O0, Si = la(la({}, gc), {}, {
          children: B0
        });
      }
      if (x0.children.splice(S0 + 1, 0, Si), t)
        for (var [T0, A0] of Y.points(t))
          t[A0] = De.transform(T0, n);
      break;
    }
  }
  return t;
}, qS = {
  /**
   * Transform the editor by an operation.
   */
  transform(e, t) {
    e.children = jd(e.children);
    var n = e.selection && jd(e.selection);
    try {
      n = US(e, n, t);
    } finally {
      e.children = Wd(e.children), n ? e.selection = on(n) ? Wd(n) : n : e.selection = null;
    }
  }
}, XS = ["text"], GS = ["children"];
function of(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? of(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : of(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var QS = {
  /**
   * Insert nodes at a specific location in the Editor.
   */
  insertNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    b.withoutNormalizing(e, () => {
      var {
        hanging: r = !1,
        voids: a = !1,
        mode: o = "lowest"
      } = n, {
        at: i,
        match: s,
        select: u
      } = n;
      if (ie.isNode(t) && (t = [t]), t.length !== 0) {
        var [l] = t;
        if (i || (e.selection ? i = e.selection : e.children.length > 0 ? i = b.end(e, []) : i = [0], u = !0), u == null && (u = !1), Y.isRange(i))
          if (r || (i = b.unhangRange(e, i, {
            voids: a
          })), Y.isCollapsed(i))
            i = i.anchor;
          else {
            var [, c] = Y.edges(i), f = b.pointRef(e, c);
            re.delete(e, {
              at: i
            }), i = f.unref();
          }
        if (De.isPoint(i)) {
          s == null && (he.isText(l) ? s = (F) => he.isText(F) : e.isInline(l) ? s = (F) => he.isText(F) || b.isInline(e, F) : s = (F) => fe.isElement(F) && b.isBlock(e, F));
          var [p] = b.nodes(e, {
            at: i.path,
            match: s,
            mode: o,
            voids: a
          });
          if (p) {
            var [, m] = p, v = b.pathRef(e, m), g = b.isEnd(e, i, m);
            re.splitNodes(e, {
              at: i,
              match: s,
              mode: o,
              voids: a
            });
            var h = v.unref();
            i = g ? A.next(h) : h;
          } else
            return;
        }
        var w = A.parent(i), S = i[i.length - 1];
        if (!(!a && b.void(e, {
          at: w
        }))) {
          for (var x of t) {
            var O = w.concat(S);
            S++, e.apply({
              type: "insert_node",
              path: O,
              node: x
            }), i = A.next(i);
          }
          if (i = A.previous(i), u) {
            var B = b.end(e, i);
            B && re.select(e, B);
          }
        }
      }
    });
  },
  /**
   * Lift nodes at a specific location upwards in the document tree, splitting
   * their parent in two if necessary.
   */
  liftNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        at: n = e.selection,
        mode: r = "lowest",
        voids: a = !1
      } = t, {
        match: o
      } = t;
      if (o == null && (o = A.isPath(n) ? xn(e, n) : (x) => fe.isElement(x) && b.isBlock(e, x)), !!n) {
        var i = b.nodes(e, {
          at: n,
          match: o,
          mode: r,
          voids: a
        }), s = Array.from(i, (x) => {
          var [, O] = x;
          return b.pathRef(e, O);
        });
        for (var u of s) {
          var l = u.unref();
          if (l.length < 2)
            throw new Error("Cannot lift node at a path [".concat(l, "] because it has a depth of less than `2`."));
          var c = b.node(e, A.parent(l)), [f, p] = c, m = l[l.length - 1], {
            length: v
          } = f.children;
          if (v === 1) {
            var g = A.next(p);
            re.moveNodes(e, {
              at: l,
              to: g,
              voids: a
            }), re.removeNodes(e, {
              at: p,
              voids: a
            });
          } else if (m === 0)
            re.moveNodes(e, {
              at: l,
              to: p,
              voids: a
            });
          else if (m === v - 1) {
            var h = A.next(p);
            re.moveNodes(e, {
              at: l,
              to: h,
              voids: a
            });
          } else {
            var w = A.next(l), S = A.next(p);
            re.splitNodes(e, {
              at: w,
              voids: a
            }), re.moveNodes(e, {
              at: l,
              to: S,
              voids: a
            });
          }
        }
      }
    });
  },
  /**
   * Merge a node at a location with the previous node of the same depth,
   * removing any empty containing nodes after the merge if necessary.
   */
  mergeNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        match: n,
        at: r = e.selection
      } = t, {
        hanging: a = !1,
        voids: o = !1,
        mode: i = "lowest"
      } = t;
      if (r) {
        if (n == null)
          if (A.isPath(r)) {
            var [s] = b.parent(e, r);
            n = (I) => s.children.includes(I);
          } else
            n = (I) => fe.isElement(I) && b.isBlock(e, I);
        if (!a && Y.isRange(r) && (r = b.unhangRange(e, r, {
          voids: o
        })), Y.isRange(r))
          if (Y.isCollapsed(r))
            r = r.anchor;
          else {
            var [, u] = Y.edges(r), l = b.pointRef(e, u);
            re.delete(e, {
              at: r
            }), r = l.unref(), t.at == null && re.select(e, r);
          }
        var [c] = b.nodes(e, {
          at: r,
          match: n,
          voids: o,
          mode: i
        }), f = b.previous(e, {
          at: r,
          match: n,
          voids: o,
          mode: i
        });
        if (!(!c || !f)) {
          var [p, m] = c, [v, g] = f;
          if (!(m.length === 0 || g.length === 0)) {
            var h = A.next(g), w = A.common(m, g), S = A.isSibling(m, g), x = Array.from(b.levels(e, {
              at: m
            }), (I) => {
              var [N] = I;
              return N;
            }).slice(w.length).slice(0, -1), O = b.above(e, {
              at: m,
              mode: "highest",
              match: (I) => x.includes(I) && Mv(e, I)
            }), B = O && b.pathRef(e, O[1]), F, L;
            if (he.isText(p) && he.isText(v)) {
              var j = hr(p, XS);
              L = v.text.length, F = j;
            } else if (fe.isElement(p) && fe.isElement(v)) {
              var j = hr(p, GS);
              L = v.children.length, F = j;
            } else
              throw new Error("Cannot merge the node at path [".concat(m, "] with the previous sibling because it is not the same kind: ").concat(nt.stringify(p), " ").concat(nt.stringify(v)));
            S || re.moveNodes(e, {
              at: m,
              to: h,
              voids: o
            }), B && re.removeNodes(e, {
              at: B.current,
              voids: o
            }), fe.isElement(v) && b.isEmpty(e, v) || he.isText(v) && v.text === "" && g[g.length - 1] !== 0 ? re.removeNodes(e, {
              at: g,
              voids: o
            }) : e.apply({
              type: "merge_node",
              path: h,
              position: L,
              properties: F
            }), B && B.unref();
          }
        }
      }
    });
  },
  /**
   * Move the nodes at a location to a new location.
   */
  moveNodes(e, t) {
    b.withoutNormalizing(e, () => {
      var {
        to: n,
        at: r = e.selection,
        mode: a = "lowest",
        voids: o = !1
      } = t, {
        match: i
      } = t;
      if (r) {
        i == null && (i = A.isPath(r) ? xn(e, r) : (m) => fe.isElement(m) && b.isBlock(e, m));
        var s = b.pathRef(e, n), u = b.nodes(e, {
          at: r,
          match: i,
          mode: a,
          voids: o
        }), l = Array.from(u, (m) => {
          var [, v] = m;
          return b.pathRef(e, v);
        });
        for (var c of l) {
          var f = c.unref(), p = s.current;
          f.length !== 0 && e.apply({
            type: "move_node",
            path: f,
            newPath: p
          }), s.current && A.isSibling(p, f) && A.isAfter(p, f) && (s.current = A.next(s.current));
        }
        s.unref();
      }
    });
  },
  /**
   * Remove the nodes at a specific location in the document.
   */
  removeNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        hanging: n = !1,
        voids: r = !1,
        mode: a = "lowest"
      } = t, {
        at: o = e.selection,
        match: i
      } = t;
      if (o) {
        i == null && (i = A.isPath(o) ? xn(e, o) : (p) => fe.isElement(p) && b.isBlock(e, p)), !n && Y.isRange(o) && (o = b.unhangRange(e, o, {
          voids: r
        }));
        var s = b.nodes(e, {
          at: o,
          match: i,
          mode: a,
          voids: r
        }), u = Array.from(s, (p) => {
          var [, m] = p;
          return b.pathRef(e, m);
        });
        for (var l of u) {
          var c = l.unref();
          if (c) {
            var [f] = b.node(e, c);
            e.apply({
              type: "remove_node",
              path: c,
              node: f
            });
          }
        }
      }
    });
  },
  /**
   * Set new properties on the nodes at a location.
   */
  setNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    b.withoutNormalizing(e, () => {
      var {
        match: r,
        at: a = e.selection,
        compare: o,
        merge: i
      } = n, {
        hanging: s = !1,
        mode: u = "lowest",
        split: l = !1,
        voids: c = !1
      } = n;
      if (a) {
        if (r == null && (r = A.isPath(a) ? xn(e, a) : (L) => fe.isElement(L) && b.isBlock(e, L)), !s && Y.isRange(a) && (a = b.unhangRange(e, a, {
          voids: c
        })), l && Y.isRange(a)) {
          if (Y.isCollapsed(a) && b.leaf(e, a.anchor)[0].text.length > 0)
            return;
          var f = b.rangeRef(e, a, {
            affinity: "inward"
          }), [p, m] = Y.edges(a), v = u === "lowest" ? "lowest" : "highest", g = b.isEnd(e, m, m.path);
          re.splitNodes(e, {
            at: m,
            match: r,
            mode: v,
            voids: c,
            always: !g
          });
          var h = b.isStart(e, p, p.path);
          re.splitNodes(e, {
            at: p,
            match: r,
            mode: v,
            voids: c,
            always: !h
          }), a = f.unref(), n.at == null && re.select(e, a);
        }
        o || (o = (L, j) => L !== j);
        for (var [w, S] of b.nodes(e, {
          at: a,
          match: r,
          mode: u,
          voids: c
        })) {
          var x = {}, O = {};
          if (S.length !== 0) {
            var B = !1;
            for (var F in t)
              F === "children" || F === "text" || o(t[F], w[F]) && (B = !0, w.hasOwnProperty(F) && (x[F] = w[F]), i ? t[F] != null && (O[F] = i(w[F], t[F])) : t[F] != null && (O[F] = t[F]));
            B && e.apply({
              type: "set_node",
              path: S,
              properties: x,
              newProperties: O
            });
          }
        }
      }
    });
  },
  /**
   * Split the nodes at a specific location.
   */
  splitNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        mode: n = "lowest",
        voids: r = !1
      } = t, {
        match: a,
        at: o = e.selection,
        height: i = 0,
        always: s = !1
      } = t;
      if (a == null && (a = (me) => fe.isElement(me) && b.isBlock(e, me)), Y.isRange(o) && (o = ZS(e, o)), A.isPath(o)) {
        var u = o, l = b.point(e, u), [c] = b.parent(e, u);
        a = (me) => me === c, i = l.path.length - u.length + 1, o = l, s = !0;
      }
      if (o) {
        var f = b.pointRef(e, o, {
          affinity: "backward"
        }), p;
        try {
          var [m] = b.nodes(e, {
            at: o,
            match: a,
            mode: n,
            voids: r
          });
          if (!m)
            return;
          var v = b.void(e, {
            at: o,
            mode: "highest"
          }), g = 0;
          if (!r && v) {
            var [h, w] = v;
            if (fe.isElement(h) && e.isInline(h)) {
              var S = b.after(e, w);
              if (!S) {
                var x = {
                  text: ""
                }, O = A.next(w);
                re.insertNodes(e, x, {
                  at: O,
                  voids: r
                }), S = b.point(e, O);
              }
              o = S, s = !0;
            }
            var B = o.path.length - w.length;
            i = B + 1, s = !0;
          }
          p = b.pointRef(e, o);
          var F = o.path.length - i, [, L] = m, j = o.path.slice(0, F), I = i === 0 ? o.offset : o.path[F] + g;
          for (var [N, q] of b.levels(e, {
            at: j,
            reverse: !0,
            voids: r
          })) {
            var J = !1;
            if (q.length < L.length || q.length === 0 || !r && fe.isElement(N) && b.isVoid(e, N))
              break;
            var R = f.current, ae = b.isEnd(e, R, q);
            if (s || !f || !b.isEdge(e, R, q)) {
              J = !0;
              var H = ie.extractProps(N);
              e.apply({
                type: "split_node",
                path: q,
                position: I,
                properties: H
              });
            }
            I = q[q.length - 1] + (J || ae ? 1 : 0);
          }
          if (t.at == null) {
            var oe = p.current || b.end(e, []);
            re.select(e, oe);
          }
        } finally {
          var ue;
          f.unref(), (ue = p) === null || ue === void 0 || ue.unref();
        }
      }
    });
  },
  /**
   * Unset properties on the nodes at a location.
   */
  unsetNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Array.isArray(t) || (t = [t]);
    var r = {};
    for (var a of t)
      r[a] = null;
    re.setNodes(e, r, n);
  },
  /**
   * Unwrap the nodes at a location from a parent node, splitting the parent if
   * necessary to ensure that only the content in the range is unwrapped.
   */
  unwrapNodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        mode: n = "lowest",
        split: r = !1,
        voids: a = !1
      } = t, {
        at: o = e.selection,
        match: i
      } = t;
      if (o) {
        i == null && (i = A.isPath(o) ? xn(e, o) : (p) => fe.isElement(p) && b.isBlock(e, p)), A.isPath(o) && (o = b.range(e, o));
        var s = Y.isRange(o) ? b.rangeRef(e, o) : null, u = b.nodes(e, {
          at: o,
          match: i,
          mode: n,
          voids: a
        }), l = Array.from(
          u,
          (p) => {
            var [, m] = p;
            return b.pathRef(e, m);
          }
          // unwrapNode will call liftNode which does not support splitting the node when nested.
          // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
          // that wrap target node. So we reverse the order.
        ).reverse(), c = function(m) {
          var v = m.unref(), [g] = b.node(e, v), h = b.range(e, v);
          r && s && (h = Y.intersection(s.current, h)), re.liftNodes(e, {
            at: h,
            match: (w) => fe.isAncestor(g) && g.children.includes(w),
            voids: a
          });
        };
        for (var f of l)
          c(f);
        s && s.unref();
      }
    });
  },
  /**
   * Wrap the nodes at a location in a new container node, splitting the edges
   * of the range first to ensure that only the content in the range is wrapped.
   */
  wrapNodes(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    b.withoutNormalizing(e, () => {
      var {
        mode: r = "lowest",
        split: a = !1,
        voids: o = !1
      } = n, {
        match: i,
        at: s = e.selection
      } = n;
      if (s) {
        if (i == null && (A.isPath(s) ? i = xn(e, s) : e.isInline(t) ? i = (h) => fe.isElement(h) && b.isInline(e, h) || he.isText(h) : i = (h) => fe.isElement(h) && b.isBlock(e, h)), a && Y.isRange(s)) {
          var [u, l] = Y.edges(s), c = b.rangeRef(e, s, {
            affinity: "inward"
          });
          re.splitNodes(e, {
            at: l,
            match: i,
            voids: o
          }), re.splitNodes(e, {
            at: u,
            match: i,
            voids: o
          }), s = c.unref(), n.at == null && re.select(e, s);
        }
        var f = Array.from(b.nodes(e, {
          at: s,
          match: e.isInline(t) ? (h) => fe.isElement(h) && b.isBlock(e, h) : (h) => b.isEditor(h),
          mode: "lowest",
          voids: o
        }));
        for (var [, p] of f) {
          var m = Y.isRange(s) ? Y.intersection(s, b.range(e, p)) : s;
          if (m) {
            var v = Array.from(b.nodes(e, {
              at: m,
              match: i,
              mode: r,
              voids: o
            }));
            if (v.length > 0) {
              var g = function() {
                var [h] = v, w = v[v.length - 1], [, S] = h, [, x] = w;
                if (S.length === 0 && x.length === 0)
                  return "continue";
                var O = A.equals(S, x) ? A.parent(S) : A.common(S, x), B = b.range(e, S, x), F = b.node(e, O), [L] = F, j = O.length + 1, I = A.next(x.slice(0, j)), N = sf(sf({}, t), {}, {
                  children: []
                });
                re.insertNodes(e, N, {
                  at: I,
                  voids: o
                }), re.moveNodes(e, {
                  at: B,
                  match: (q) => fe.isAncestor(L) && L.children.includes(q),
                  to: I.concat(0),
                  voids: o
                });
              }();
              if (g === "continue")
                continue;
            }
          }
        }
      }
    });
  }
}, Mv = (e, t) => {
  if (fe.isElement(t)) {
    var n = t;
    return b.isVoid(e, t) ? !0 : n.children.length === 1 ? Mv(e, n.children[0]) : !1;
  } else
    return !b.isEditor(t);
}, ZS = (e, t) => {
  if (Y.isCollapsed(t))
    return t.anchor;
  var [, n] = Y.edges(t), r = b.pointRef(e, n);
  return re.delete(e, {
    at: t
  }), r.unref();
}, xn = (e, t) => {
  var [n] = b.node(e, t);
  return (r) => r === n;
};
function uf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uf(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : uf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var JS = {
  /**
   * Collapse the selection.
   */
  collapse(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      edge: n = "anchor"
    } = t, {
      selection: r
    } = e;
    if (r) {
      if (n === "anchor")
        re.select(e, r.anchor);
      else if (n === "focus")
        re.select(e, r.focus);
      else if (n === "start") {
        var [a] = Y.edges(r);
        re.select(e, a);
      } else if (n === "end") {
        var [, o] = Y.edges(r);
        re.select(e, o);
      }
    } else
      return;
  },
  /**
   * Unset the selection.
   */
  deselect(e) {
    var {
      selection: t
    } = e;
    t && e.apply({
      type: "set_selection",
      properties: t,
      newProperties: null
    });
  },
  /**
   * Move the selection's point forward or backward.
   */
  move(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      selection: n
    } = e, {
      distance: r = 1,
      unit: a = "character",
      reverse: o = !1
    } = t, {
      edge: i = null
    } = t;
    if (n) {
      i === "start" && (i = Y.isBackward(n) ? "focus" : "anchor"), i === "end" && (i = Y.isBackward(n) ? "anchor" : "focus");
      var {
        anchor: s,
        focus: u
      } = n, l = {
        distance: r,
        unit: a
      }, c = {};
      if (i == null || i === "anchor") {
        var f = o ? b.before(e, s, l) : b.after(e, s, l);
        f && (c.anchor = f);
      }
      if (i == null || i === "focus") {
        var p = o ? b.before(e, u, l) : b.after(e, u, l);
        p && (c.focus = p);
      }
      re.setSelection(e, c);
    }
  },
  /**
   * Set the selection to a new value.
   */
  select(e, t) {
    var {
      selection: n
    } = e;
    if (t = b.range(e, t), n) {
      re.setSelection(e, t);
      return;
    }
    if (!Y.isRange(t))
      throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(nt.stringify(t)));
    e.apply({
      type: "set_selection",
      properties: n,
      newProperties: t
    });
  },
  /**
   * Set new properties on one of the selection's points.
   */
  setPoint(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      selection: r
    } = e, {
      edge: a = "both"
    } = n;
    if (r) {
      a === "start" && (a = Y.isBackward(r) ? "focus" : "anchor"), a === "end" && (a = Y.isBackward(r) ? "anchor" : "focus");
      var {
        anchor: o,
        focus: i
      } = r, s = a === "anchor" ? o : i;
      re.setSelection(e, {
        [a === "anchor" ? "anchor" : "focus"]: lf(lf({}, s), t)
      });
    }
  },
  /**
   * Set new properties on the selection.
   */
  setSelection(e, t) {
    var {
      selection: n
    } = e, r = {}, a = {};
    if (n) {
      for (var o in t)
        (o === "anchor" && t.anchor != null && !De.equals(t.anchor, n.anchor) || o === "focus" && t.focus != null && !De.equals(t.focus, n.focus) || o !== "anchor" && o !== "focus" && t[o] !== n[o]) && (r[o] = n[o], a[o] = t[o]);
      Object.keys(r).length > 0 && e.apply({
        type: "set_selection",
        properties: r,
        newProperties: a
      });
    }
  }
}, e$ = {
  /**
   * Delete content in the editor.
   */
  delete(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    b.withoutNormalizing(e, () => {
      var {
        reverse: n = !1,
        unit: r = "character",
        distance: a = 1,
        voids: o = !1
      } = t, {
        at: i = e.selection,
        hanging: s = !1
      } = t;
      if (i) {
        var u = !1;
        if (Y.isRange(i) && Y.isCollapsed(i) && (u = !0, i = i.anchor), De.isPoint(i)) {
          var l = b.void(e, {
            at: i,
            mode: "highest"
          });
          if (!o && l) {
            var [, c] = l;
            i = c;
          } else {
            var f = {
              unit: r,
              distance: a
            }, p = n ? b.before(e, i, f) || b.start(e, []) : b.after(e, i, f) || b.end(e, []);
            i = {
              anchor: i,
              focus: p
            }, s = !0;
          }
        }
        if (A.isPath(i)) {
          re.removeNodes(e, {
            at: i,
            voids: o
          });
          return;
        }
        if (!Y.isCollapsed(i)) {
          if (!s) {
            var [, m] = Y.edges(i), v = b.end(e, []);
            De.equals(m, v) || (i = b.unhangRange(e, i, {
              voids: o
            }));
          }
          var [g, h] = Y.edges(i), w = b.above(e, {
            match: (Z) => fe.isElement(Z) && b.isBlock(e, Z),
            at: g,
            voids: o
          }), S = b.above(e, {
            match: (Z) => fe.isElement(Z) && b.isBlock(e, Z),
            at: h,
            voids: o
          }), x = w && S && !A.equals(w[1], S[1]), O = A.equals(g.path, h.path), B = o ? null : b.void(e, {
            at: g,
            mode: "highest"
          }), F = o ? null : b.void(e, {
            at: h,
            mode: "highest"
          });
          if (B) {
            var L = b.before(e, g);
            L && w && A.isAncestor(w[1], L.path) && (g = L);
          }
          if (F) {
            var j = b.after(e, h);
            j && S && A.isAncestor(S[1], j.path) && (h = j);
          }
          var I = [], N;
          for (var q of b.nodes(e, {
            at: i,
            voids: o
          })) {
            var [J, R] = q;
            N && A.compare(R, N) === 0 || (!o && fe.isElement(J) && b.isVoid(e, J) || !A.isCommon(R, g.path) && !A.isCommon(R, h.path)) && (I.push(q), N = R);
          }
          var ae = Array.from(I, (Z) => {
            var [, ne] = Z;
            return b.pathRef(e, ne);
          }), H = b.pointRef(e, g), oe = b.pointRef(e, h), ue = "";
          if (!O && !B) {
            var me = H.current, [V] = b.leaf(e, me), {
              path: T
            } = me, {
              offset: C
            } = g, M = V.text.slice(C);
            M.length > 0 && (e.apply({
              type: "remove_text",
              path: T,
              offset: C,
              text: M
            }), ue = M);
          }
          if (ae.reverse().map((Z) => Z.unref()).filter((Z) => Z !== null).forEach((Z) => re.removeNodes(e, {
            at: Z,
            voids: o
          })), !F) {
            var P = oe.current, [W] = b.leaf(e, P), {
              path: z
            } = P, K = O ? g.offset : 0, X = W.text.slice(K, h.offset);
            X.length > 0 && (e.apply({
              type: "remove_text",
              path: z,
              offset: K,
              text: X
            }), ue = X);
          }
          !O && x && oe.current && H.current && re.mergeNodes(e, {
            at: oe.current,
            hanging: !0,
            voids: o
          }), u && n && r === "character" && ue.length > 1 && ue.match(/[\u0E00-\u0E7F]+/) && re.insertText(e, ue.slice(0, ue.length - a));
          var G = H.unref(), te = oe.unref(), se = n ? G || te : te || G;
          t.at == null && se && re.select(e, se);
        }
      }
    });
  },
  /**
   * Insert a fragment at a specific location in the editor.
   */
  insertFragment(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    b.withoutNormalizing(e, () => {
      var {
        hanging: r = !1,
        voids: a = !1
      } = n, {
        at: o = e.selection
      } = n;
      if (t.length) {
        if (o)
          if (Y.isRange(o))
            if (r || (o = b.unhangRange(e, o, {
              voids: a
            })), Y.isCollapsed(o))
              o = o.anchor;
            else {
              var [, i] = Y.edges(o);
              if (!a && b.void(e, {
                at: i
              }))
                return;
              var s = b.pointRef(e, i);
              re.delete(e, {
                at: o
              }), o = s.unref();
            }
          else
            A.isPath(o) && (o = b.start(e, o));
        else
          return;
        if (!(!a && b.void(e, {
          at: o
        }))) {
          var u = b.above(e, {
            at: o,
            match: (P) => fe.isElement(P) && b.isInline(e, P),
            mode: "highest",
            voids: a
          });
          if (u) {
            var [, l] = u;
            if (b.isEnd(e, o, l)) {
              var c = b.after(e, l);
              o = c;
            } else if (b.isStart(e, o, l)) {
              var f = b.before(e, l);
              o = f;
            }
          }
          var p = b.above(e, {
            match: (P) => fe.isElement(P) && b.isBlock(e, P),
            at: o,
            voids: a
          }), [, m] = p, v = b.isStart(e, o, m), g = b.isEnd(e, o, m), h = v && g, w = !v || v && g, S = !g, [, x] = ie.first({
            children: t
          }, []), [, O] = ie.last({
            children: t
          }, []), B = [], F = (P) => {
            var [W, z] = P, K = z.length === 0;
            return K ? !1 : h ? !0 : !(w && A.isAncestor(z, x) && fe.isElement(W) && !e.isVoid(W) && !e.isInline(W) || S && A.isAncestor(z, O) && fe.isElement(W) && !e.isVoid(W) && !e.isInline(W));
          };
          for (var L of ie.nodes({
            children: t
          }, {
            pass: F
          }))
            F(L) && B.push(L);
          var j = [], I = [], N = [], q = !0, J = !1;
          for (var [R] of B)
            fe.isElement(R) && !e.isInline(R) ? (q = !1, J = !0, I.push(R)) : q ? j.push(R) : N.push(R);
          var [ae] = b.nodes(e, {
            at: o,
            match: (P) => he.isText(P) || b.isInline(e, P),
            mode: "highest",
            voids: a
          }), [, H] = ae, oe = b.isStart(e, o, H), ue = b.isEnd(e, o, H), me = b.pathRef(e, g && !N.length ? A.next(m) : m), V = b.pathRef(e, ue ? A.next(H) : H);
          re.splitNodes(e, {
            at: o,
            match: (P) => J ? fe.isElement(P) && b.isBlock(e, P) : he.isText(P) || b.isInline(e, P),
            mode: J ? "lowest" : "highest",
            always: J && (!v || j.length > 0) && (!g || N.length > 0),
            voids: a
          });
          var T = b.pathRef(e, !oe || oe && ue ? A.next(H) : H);
          if (re.insertNodes(e, j, {
            at: T.current,
            match: (P) => he.isText(P) || b.isInline(e, P),
            mode: "highest",
            voids: a
          }), h && !j.length && I.length && !N.length && re.delete(e, {
            at: m,
            voids: a
          }), re.insertNodes(e, I, {
            at: me.current,
            match: (P) => fe.isElement(P) && b.isBlock(e, P),
            mode: "lowest",
            voids: a
          }), re.insertNodes(e, N, {
            at: V.current,
            match: (P) => he.isText(P) || b.isInline(e, P),
            mode: "highest",
            voids: a
          }), !n.at) {
            var C;
            if (N.length > 0 && V.current ? C = A.previous(V.current) : I.length > 0 && me.current ? C = A.previous(me.current) : T.current && (C = A.previous(T.current)), C) {
              var M = b.end(e, C);
              re.select(e, M);
            }
          }
          T.unref(), me.unref(), V.unref();
        }
      }
    });
  },
  /**
   * Insert a string of text in the Editor.
   */
  insertText(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    b.withoutNormalizing(e, () => {
      var {
        voids: r = !1
      } = n, {
        at: a = e.selection
      } = n;
      if (a) {
        if (A.isPath(a) && (a = b.range(e, a)), Y.isRange(a))
          if (Y.isCollapsed(a))
            a = a.anchor;
          else {
            var o = Y.end(a);
            if (!r && b.void(e, {
              at: o
            }))
              return;
            var i = Y.start(a), s = b.pointRef(e, i), u = b.pointRef(e, o);
            re.delete(e, {
              at: a,
              voids: r
            });
            var l = s.unref(), c = u.unref();
            a = l || c, re.setSelection(e, {
              anchor: a,
              focus: a
            });
          }
        if (!(!r && b.void(e, {
          at: a
        }))) {
          var {
            path: f,
            offset: p
          } = a;
          t.length > 0 && e.apply({
            type: "insert_text",
            path: f,
            offset: p,
            text: t
          });
        }
      }
    });
  }
};
function cf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function eo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cf(Object(n), !0).forEach(function(r) {
      sr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var re = eo(eo(eo(eo({}, qS), QS), JS), e$), t$ = a$, Fv = "֑-߿יִ-﷽ﹰ-ﻼ", Rv = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", r$ = new RegExp("^[^" + Rv + "]*[" + Fv + "]"), n$ = new RegExp("^[^" + Fv + "]*[" + Rv + "]");
function a$(e) {
  return e = String(e || ""), r$.test(e) ? "rtl" : n$.test(e) ? "ltr" : "neutral";
}
const _v = /* @__PURE__ */ gr(t$);
function o$(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ol = o$, i$ = typeof qa == "object" && qa && qa.Object === Object && qa, s$ = i$, u$ = s$, l$ = typeof self == "object" && self && self.Object === Object && self, c$ = u$ || l$ || Function("return this")(), Nv = c$, d$ = Nv, f$ = function() {
  return d$.Date.now();
}, p$ = f$, h$ = /\s/;
function v$(e) {
  for (var t = e.length; t-- && h$.test(e.charAt(t)); )
    ;
  return t;
}
var m$ = v$, g$ = m$, y$ = /^\s+/;
function b$(e) {
  return e && e.slice(0, g$(e) + 1).replace(y$, "");
}
var w$ = b$, D$ = Nv, C$ = D$.Symbol, Iv = C$, df = Iv, Lv = Object.prototype, E$ = Lv.hasOwnProperty, x$ = Lv.toString, ca = df ? df.toStringTag : void 0;
function S$(e) {
  var t = E$.call(e, ca), n = e[ca];
  try {
    e[ca] = void 0;
    var r = !0;
  } catch {
  }
  var a = x$.call(e);
  return r && (t ? e[ca] = n : delete e[ca]), a;
}
var $$ = S$, k$ = Object.prototype, O$ = k$.toString;
function B$(e) {
  return O$.call(e);
}
var T$ = B$, ff = Iv, A$ = $$, P$ = T$, M$ = "[object Null]", F$ = "[object Undefined]", pf = ff ? ff.toStringTag : void 0;
function R$(e) {
  return e == null ? e === void 0 ? F$ : M$ : pf && pf in Object(e) ? A$(e) : P$(e);
}
var _$ = R$;
function N$(e) {
  return e != null && typeof e == "object";
}
var I$ = N$, L$ = _$, j$ = I$, W$ = "[object Symbol]";
function Y$(e) {
  return typeof e == "symbol" || j$(e) && L$(e) == W$;
}
var H$ = Y$, V$ = w$, hf = Ol, z$ = H$, vf = NaN, K$ = /^[-+]0x[0-9a-f]+$/i, U$ = /^0b[01]+$/i, q$ = /^0o[0-7]+$/i, X$ = parseInt;
function G$(e) {
  if (typeof e == "number")
    return e;
  if (z$(e))
    return vf;
  if (hf(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = hf(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = V$(e);
  var n = U$.test(e);
  return n || q$.test(e) ? X$(e.slice(2), n ? 2 : 8) : K$.test(e) ? vf : +e;
}
var Q$ = G$, Z$ = Ol, ls = p$, mf = Q$, J$ = "Expected a function", ek = Math.max, tk = Math.min;
function rk(e, t, n) {
  var r, a, o, i, s, u, l = 0, c = !1, f = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(J$);
  t = mf(t) || 0, Z$(n) && (c = !!n.leading, f = "maxWait" in n, o = f ? ek(mf(n.maxWait) || 0, t) : o, p = "trailing" in n ? !!n.trailing : p);
  function m(F) {
    var L = r, j = a;
    return r = a = void 0, l = F, i = e.apply(j, L), i;
  }
  function v(F) {
    return l = F, s = setTimeout(w, t), c ? m(F) : i;
  }
  function g(F) {
    var L = F - u, j = F - l, I = t - L;
    return f ? tk(I, o - j) : I;
  }
  function h(F) {
    var L = F - u, j = F - l;
    return u === void 0 || L >= t || L < 0 || f && j >= o;
  }
  function w() {
    var F = ls();
    if (h(F))
      return S(F);
    s = setTimeout(w, g(F));
  }
  function S(F) {
    return s = void 0, p && r ? m(F) : (r = a = void 0, i);
  }
  function x() {
    s !== void 0 && clearTimeout(s), l = 0, r = u = a = s = void 0;
  }
  function O() {
    return s === void 0 ? i : S(ls());
  }
  function B() {
    var F = ls(), L = h(F);
    if (r = arguments, a = this, u = F, L) {
      if (s === void 0)
        return v(u);
      if (f)
        return clearTimeout(s), s = setTimeout(w, t), m(u);
    }
    return s === void 0 && (s = setTimeout(w, t)), i;
  }
  return B.cancel = x, B.flush = O, B;
}
var jv = rk;
const nk = /* @__PURE__ */ gr(jv);
var ak = jv, ok = Ol, ik = "Expected a function";
function sk(e, t, n) {
  var r = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(ik);
  return ok(n) && (r = "leading" in n ? !!n.leading : r, a = "trailing" in n ? !!n.trailing : a), ak(e, t, {
    leading: r,
    maxWait: t,
    trailing: a
  });
}
var uk = sk;
const lk = /* @__PURE__ */ gr(uk);
function gf(e) {
  return typeof e == "object" && e != null && e.nodeType === 1;
}
function yf(e, t) {
  return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function cs(e, t) {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    var n = getComputedStyle(e, null);
    return yf(n.overflowY, t) || yf(n.overflowX, t) || function(r) {
      var a = function(o) {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!a && (a.clientHeight < r.scrollHeight || a.clientWidth < r.scrollWidth);
    }(e);
  }
  return !1;
}
function to(e, t, n, r, a, o, i, s) {
  return o < e && i > t || o > e && i < t ? 0 : o <= e && s <= n || i >= t && s >= n ? o - e - r : i > t && s < n || o < e && s > n ? i - t + a : 0;
}
var bf = function(e, t) {
  var n = window, r = t.scrollMode, a = t.block, o = t.inline, i = t.boundary, s = t.skipOverflowHiddenElements, u = typeof i == "function" ? i : function(Pe) {
    return Pe !== i;
  };
  if (!gf(e))
    throw new TypeError("Invalid target");
  for (var l, c, f = document.scrollingElement || document.documentElement, p = [], m = e; gf(m) && u(m); ) {
    if ((m = (c = (l = m).parentElement) == null ? l.getRootNode().host || null : c) === f) {
      p.push(m);
      break;
    }
    m != null && m === document.body && cs(m) && !cs(document.documentElement) || m != null && cs(m, s) && p.push(m);
  }
  for (var v = n.visualViewport ? n.visualViewport.width : innerWidth, g = n.visualViewport ? n.visualViewport.height : innerHeight, h = window.scrollX || pageXOffset, w = window.scrollY || pageYOffset, S = e.getBoundingClientRect(), x = S.height, O = S.width, B = S.top, F = S.right, L = S.bottom, j = S.left, I = a === "start" || a === "nearest" ? B : a === "end" ? L : B + x / 2, N = o === "center" ? j + O / 2 : o === "end" ? F : j, q = [], J = 0; J < p.length; J++) {
    var R = p[J], ae = R.getBoundingClientRect(), H = ae.height, oe = ae.width, ue = ae.top, me = ae.right, V = ae.bottom, T = ae.left;
    if (r === "if-needed" && B >= 0 && j >= 0 && L <= g && F <= v && B >= ue && L <= V && j >= T && F <= me)
      return q;
    var C = getComputedStyle(R), M = parseInt(C.borderLeftWidth, 10), P = parseInt(C.borderTopWidth, 10), W = parseInt(C.borderRightWidth, 10), z = parseInt(C.borderBottomWidth, 10), K = 0, X = 0, G = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - M - W : 0, te = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - P - z : 0, se = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : oe / R.offsetWidth : 0, Z = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : H / R.offsetHeight : 0;
    if (f === R)
      K = a === "start" ? I : a === "end" ? I - g : a === "nearest" ? to(w, w + g, g, P, z, w + I, w + I + x, x) : I - g / 2, X = o === "start" ? N : o === "center" ? N - v / 2 : o === "end" ? N - v : to(h, h + v, v, M, W, h + N, h + N + O, O), K = Math.max(0, K + w), X = Math.max(0, X + h);
    else {
      K = a === "start" ? I - ue - P : a === "end" ? I - V + z + te : a === "nearest" ? to(ue, V, H, P, z + te, I, I + x, x) : I - (ue + H / 2) + te / 2, X = o === "start" ? N - T - M : o === "center" ? N - (T + oe / 2) + G / 2 : o === "end" ? N - me + W + G : to(T, me, oe, M, W + G, N, N + O, O);
      var ne = R.scrollLeft, be = R.scrollTop;
      I += be - (K = Math.max(0, Math.min(be + K / Z, R.scrollHeight - H / Z + te))), N += ne - (X = Math.max(0, Math.min(ne + X / se, R.scrollWidth - oe / se + G)));
    }
    q.push({ el: R, top: K, left: X });
  }
  return q;
};
function Wv(e) {
  return e === Object(e) && Object.keys(e).length !== 0;
}
function ck(e, t) {
  t === void 0 && (t = "auto");
  var n = "scrollBehavior" in document.body.style;
  e.forEach(function(r) {
    var a = r.el, o = r.top, i = r.left;
    a.scroll && n ? a.scroll({
      top: o,
      left: i,
      behavior: t
    }) : (a.scrollTop = o, a.scrollLeft = i);
  });
}
function dk(e) {
  return e === !1 ? {
    block: "end",
    inline: "nearest"
  } : Wv(e) ? e : {
    block: "start",
    inline: "nearest"
  };
}
function fk(e, t) {
  var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
  if (Wv(t) && typeof t.behavior == "function")
    return t.behavior(n ? bf(e, t) : []);
  if (n) {
    var r = dk(t);
    return ck(bf(e, r), r.behavior);
  }
}
var Zr = [], pk = function() {
  return Zr.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, hk = function() {
  return Zr.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, wf = "ResizeObserver loop completed with undelivered notifications.", vk = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: wf
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = wf), window.dispatchEvent(e);
}, Ma;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Ma || (Ma = {}));
var Jr = function(e) {
  return Object.freeze(e);
}, mk = /* @__PURE__ */ function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, Jr(this);
  }
  return e;
}(), Yv = function() {
  function e(t, n, r, a) {
    return this.x = t, this.y = n, this.width = r, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Jr(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, a = t.top, o = t.right, i = t.bottom, s = t.left, u = t.width, l = t.height;
    return { x: n, y: r, top: a, right: o, bottom: i, left: s, width: u, height: l };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), Bl = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, Hv = function(e) {
  if (Bl(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var a = e, o = a.offsetWidth, i = a.offsetHeight;
  return !(o || i || e.getClientRects().length);
}, Df = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, gk = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Ca = typeof window < "u" ? window : {}, ro = /* @__PURE__ */ new WeakMap(), Cf = /auto|scroll/, yk = /^tb|vertical/, bk = /msie|trident/i.test(Ca.navigator && Ca.navigator.userAgent), qt = function(e) {
  return parseFloat(e || "0");
}, Rn = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new mk((n ? t : e) || 0, (n ? e : t) || 0);
}, Ef = Jr({
  devicePixelContentBoxSize: Rn(),
  borderBoxSize: Rn(),
  contentBoxSize: Rn(),
  contentRect: new Yv(0, 0, 0, 0)
}), Vv = function(e, t) {
  if (t === void 0 && (t = !1), ro.has(e) && !t)
    return ro.get(e);
  if (Hv(e))
    return ro.set(e, Ef), Ef;
  var n = getComputedStyle(e), r = Bl(e) && e.ownerSVGElement && e.getBBox(), a = !bk && n.boxSizing === "border-box", o = yk.test(n.writingMode || ""), i = !r && Cf.test(n.overflowY || ""), s = !r && Cf.test(n.overflowX || ""), u = r ? 0 : qt(n.paddingTop), l = r ? 0 : qt(n.paddingRight), c = r ? 0 : qt(n.paddingBottom), f = r ? 0 : qt(n.paddingLeft), p = r ? 0 : qt(n.borderTopWidth), m = r ? 0 : qt(n.borderRightWidth), v = r ? 0 : qt(n.borderBottomWidth), g = r ? 0 : qt(n.borderLeftWidth), h = f + l, w = u + c, S = g + m, x = p + v, O = s ? e.offsetHeight - x - e.clientHeight : 0, B = i ? e.offsetWidth - S - e.clientWidth : 0, F = a ? h + S : 0, L = a ? w + x : 0, j = r ? r.width : qt(n.width) - F - B, I = r ? r.height : qt(n.height) - L - O, N = j + h + B + S, q = I + w + O + x, J = Jr({
    devicePixelContentBoxSize: Rn(Math.round(j * devicePixelRatio), Math.round(I * devicePixelRatio), o),
    borderBoxSize: Rn(N, q, o),
    contentBoxSize: Rn(j, I, o),
    contentRect: new Yv(f, u, j, I)
  });
  return ro.set(e, J), J;
}, zv = function(e, t, n) {
  var r = Vv(e, n), a = r.borderBoxSize, o = r.contentBoxSize, i = r.devicePixelContentBoxSize;
  switch (t) {
    case Ma.DEVICE_PIXEL_CONTENT_BOX:
      return i;
    case Ma.BORDER_BOX:
      return a;
    default:
      return o;
  }
}, wk = /* @__PURE__ */ function() {
  function e(t) {
    var n = Vv(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = Jr([n.borderBoxSize]), this.contentBoxSize = Jr([n.contentBoxSize]), this.devicePixelContentBoxSize = Jr([n.devicePixelContentBoxSize]);
  }
  return e;
}(), Kv = function(e) {
  if (Hv(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, Dk = function() {
  var e = 1 / 0, t = [];
  Zr.forEach(function(i) {
    if (i.activeTargets.length !== 0) {
      var s = [];
      i.activeTargets.forEach(function(l) {
        var c = new wk(l.target), f = Kv(l.target);
        s.push(c), l.lastReportedSize = zv(l.target, l.observedBox), f < e && (e = f);
      }), t.push(function() {
        i.callback.call(i.observer, s, i.observer);
      }), i.activeTargets.splice(0, i.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var a = r[n];
    a();
  }
  return e;
}, xf = function(e) {
  Zr.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(a) {
      a.isActive() && (Kv(a.target) > e ? n.activeTargets.push(a) : n.skippedTargets.push(a));
    });
  });
}, Ck = function() {
  var e = 0;
  for (xf(e); pk(); )
    e = Dk(), xf(e);
  return hk() && vk(), e > 0;
}, ds, Uv = [], Ek = function() {
  return Uv.splice(0).forEach(function(e) {
    return e();
  });
}, xk = function(e) {
  if (!ds) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return Ek();
    }).observe(n, r), ds = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  Uv.push(e), ds();
}, Sk = function(e) {
  xk(function() {
    requestAnimationFrame(e);
  });
}, mo = 0, $k = function() {
  return !!mo;
}, kk = 250, Ok = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Sf = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], $f = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, fs = !1, Bk = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = kk), !fs) {
      fs = !0;
      var r = $f(t);
      Sk(function() {
        var a = !1;
        try {
          a = Ck();
        } finally {
          if (fs = !1, t = r - $f(), !$k())
            return;
          a ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, Ok);
    };
    document.body ? n() : Ca.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Sf.forEach(function(n) {
      return Ca.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), Sf.forEach(function(n) {
      return Ca.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), su = new Bk(), kf = function(e) {
  !mo && e > 0 && su.start(), mo += e, !mo && su.stop();
}, Tk = function(e) {
  return !Bl(e) && !gk(e) && getComputedStyle(e).display === "inline";
}, Ak = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || Ma.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = zv(this.target, this.observedBox, !0);
    return Tk(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), Pk = /* @__PURE__ */ function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), no = /* @__PURE__ */ new WeakMap(), Of = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, ao = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new Pk(t, n);
    no.set(t, r);
  }, e.observe = function(t, n, r) {
    var a = no.get(t), o = a.observationTargets.length === 0;
    Of(a.observationTargets, n) < 0 && (o && Zr.push(a), a.observationTargets.push(new Ak(n, r && r.box)), kf(1), su.schedule());
  }, e.unobserve = function(t, n) {
    var r = no.get(t), a = Of(r.observationTargets, n), o = r.observationTargets.length === 1;
    a >= 0 && (o && Zr.splice(Zr.indexOf(r), 1), r.observationTargets.splice(a, 1), kf(-1));
  }, e.disconnect = function(t) {
    var n = this, r = no.get(t);
    r.observationTargets.slice().forEach(function(a) {
      return n.unobserve(t, a.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), Mk = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    ao.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Df(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ao.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Df(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ao.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    ao.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}(), yr = {};
Object.defineProperty(yr, "__esModule", {
  value: !0
});
var Fk = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), ps = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, Rk = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: Fk ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, qv = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var oo = 1; oo < 20; oo++)
  qv["f" + oo] = 111 + oo;
function hi(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(i) {
    return Xv(i, t);
  }), a = function(s) {
    return r.some(function(u) {
      return Gv(u, s);
    });
  }, o = n == null ? a : a(n);
  return o;
}
function _k(e, t) {
  return hi(e, t);
}
function Nk(e, t) {
  return hi(e, { byKey: !0 }, t);
}
function Xv(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var a = e.split("+"), o = a.length;
  for (var i in ps)
    r[ps[i]] = !1;
  var s = !0, u = !1, l = void 0;
  try {
    for (var c = a[Symbol.iterator](), f; !(s = (f = c.next()).done); s = !0) {
      var p = f.value, m = p.endsWith("?") && p.length > 1;
      m && (p = p.slice(0, -1));
      var v = Tl(p), g = ps[v];
      (o === 1 || !g) && (n ? r.key = v : r.which = Qv(p)), g && (r[g] = m ? null : !0);
    }
  } catch (h) {
    u = !0, l = h;
  } finally {
    try {
      !s && c.return && c.return();
    } finally {
      if (u)
        throw l;
    }
  }
  return r;
}
function Gv(e, t) {
  for (var n in e) {
    var r = e[n], a = void 0;
    if (r != null && (n === "key" && t.key != null ? a = t.key.toLowerCase() : n === "which" ? a = r === 91 && t.which === 93 ? 91 : t.which : a = t[n], !(a == null && r === !1) && a !== r))
      return !1;
  }
  return !0;
}
function Qv(e) {
  e = Tl(e);
  var t = qv[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function Tl(e) {
  return e = e.toLowerCase(), e = Rk[e] || e, e;
}
yr.default = hi;
yr.isHotkey = hi;
yr.isCodeHotkey = _k;
var hs = yr.isKeyHotkey = Nk;
yr.parseHotkey = Xv;
yr.compareHotkey = Gv;
yr.toKeyCode = Qv;
yr.toKeyName = Tl;
function vi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ik(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Yn(e, t) {
  if (e == null)
    return {};
  var n = Ik(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      r = o[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var Lk = 0;
class jk {
  constructor() {
    this.id = "".concat(Lk++);
  }
}
var Al = /* @__PURE__ */ new WeakMap(), Pl = /* @__PURE__ */ new WeakMap(), Zv = /* @__PURE__ */ new WeakMap(), uu = /* @__PURE__ */ new WeakMap(), Ea = /* @__PURE__ */ new WeakMap(), mi = /* @__PURE__ */ new WeakMap(), Hn = /* @__PURE__ */ new WeakMap(), lu = /* @__PURE__ */ new WeakMap(), gi = /* @__PURE__ */ new WeakMap(), cu = /* @__PURE__ */ new WeakMap(), qr = /* @__PURE__ */ new WeakMap(), Xr = /* @__PURE__ */ new WeakMap(), xa = /* @__PURE__ */ new WeakMap(), du = /* @__PURE__ */ new WeakMap(), Ml = /* @__PURE__ */ new WeakMap(), Lt = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), bt = /* @__PURE__ */ new WeakMap(), Sr = /* @__PURE__ */ new WeakMap(), $r = /* @__PURE__ */ new WeakMap(), Wo = /* @__PURE__ */ new WeakMap(), Vn = Symbol("placeholder"), Jv = Symbol("mark-placeholder"), Wk = globalThis.Text, Fl = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, Yk = (e) => un(e) && e.nodeType === 8, Mt = (e) => un(e) && e.nodeType === 1, un = (e) => {
  var t = Fl(e);
  return !!t && e instanceof t.Node;
}, fu = (e) => {
  var t = e && e.anchorNode && Fl(e.anchorNode);
  return !!t && e instanceof t.Selection;
}, em = (e) => un(e) && e.nodeType === 3, Hk = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, Vk = (e) => {
  var [t, n] = e;
  if (Mt(t) && t.childNodes.length) {
    var r = n === t.childNodes.length, a = r ? n - 1 : n;
    for ([t, a] = tm(t, a, r ? "backward" : "forward"), r = a < n; Mt(t) && t.childNodes.length; ) {
      var o = r ? t.childNodes.length - 1 : 0;
      t = Kk(t, o, r ? "backward" : "forward");
    }
    n = r && t.textContent != null ? t.textContent.length : 0;
  }
  return [t, n];
}, zk = (e) => {
  for (var t = e && e.parentNode; t; ) {
    if (t.toString() === "[object ShadowRoot]")
      return !0;
    t = t.parentNode;
  }
  return !1;
}, tm = (e, t, n) => {
  for (var {
    childNodes: r
  } = e, a = r[t], o = t, i = !1, s = !1; (Yk(a) || Mt(a) && a.childNodes.length === 0 || Mt(a) && a.getAttribute("contenteditable") === "false") && !(i && s); ) {
    if (o >= r.length) {
      i = !0, o = t - 1, n = "backward";
      continue;
    }
    if (o < 0) {
      s = !0, o = t + 1, n = "forward";
      continue;
    }
    a = r[o], t = o, o += n === "forward" ? 1 : -1;
  }
  return [a, t];
}, Kk = (e, t, n) => {
  var [r] = tm(e, t, n);
  return r;
}, rm = (e) => {
  var t = "";
  if (em(e) && e.nodeValue)
    return e.nodeValue;
  if (Mt(e)) {
    for (var n of Array.from(e.childNodes))
      t += rm(n);
    var r = getComputedStyle(e).getPropertyValue("display");
    (r === "block" || r === "list" || e.tagName === "BR") && (t += `
`);
  }
  return t;
}, Uk = /data-slate-fragment="(.+?)"/m, qk = (e) => {
  var t = e.getData("text/html"), [, n] = t.match(Uk) || [];
  return n;
}, Rl = (e, t, n) => {
  var {
    target: r
  } = t;
  if (Mt(r) && r.matches('[contentEditable="false"]'))
    return !1;
  var {
    document: a
  } = ee.getWindow(e);
  if (a.contains(r))
    return ee.hasDOMNode(e, r, {
      editable: !0
    });
  var o = n.find((i) => {
    var {
      addedNodes: s,
      removedNodes: u
    } = i;
    for (var l of s)
      if (l === r || l.contains(r))
        return !0;
    for (var c of u)
      if (c === r || c.contains(r))
        return !0;
  });
  return !o || o === t ? !1 : Rl(e, o, n);
}, Xk = parseInt(d.version.split(".")[0], 10) >= 17, Gk = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Bf = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), jt = typeof navigator < "u" && /Android/.test(navigator.userAgent), Yo = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), vs = typeof navigator < "u" && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent), Qk = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), nm = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), Zk = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), Jk = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), e4 = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), t4 = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent), go = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Cr = !Zk && !Qk && // globalThis is undefined in older browsers
typeof globalThis < "u" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges == "function", ee = {
  /**
   * Check if the user is currently composing inside the editor.
   */
  isComposing(e) {
    return !!Xr.get(e);
  },
  /**
   * Return the host window of the current editor.
   */
  getWindow(e) {
    var t = Zv.get(e);
    if (!t)
      throw new Error("Unable to find a host window element for this editor");
    return t;
  },
  /**
   * Find a key for a Slate node.
   */
  findKey(e, t) {
    var n = lu.get(t);
    return n || (n = new jk(), lu.set(t, n)), n;
  },
  /**
   * Find the path of Slate node.
   */
  findPath(e, t) {
    for (var n = [], r = t; ; ) {
      var a = Pl.get(r);
      if (a == null) {
        if (b.isEditor(r))
          return n;
        break;
      }
      var o = Al.get(r);
      if (o == null)
        break;
      n.unshift(o), r = a;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(nt.stringify(t)));
  },
  /**
   * Find the DOM node that implements DocumentOrShadowRoot for the editor.
   */
  findDocumentOrShadowRoot(e) {
    var t = ee.toDOMNode(e, e), n = t.getRootNode();
    return (n instanceof Document || n instanceof ShadowRoot) && n.getSelection != null ? n : t.ownerDocument;
  },
  /**
   * Check if the editor is focused.
   */
  isFocused(e) {
    return !!qr.get(e);
  },
  /**
   * Check if the editor is in read-only mode.
   */
  isReadOnly(e) {
    return !!cu.get(e);
  },
  /**
   * Blur the editor.
   */
  blur(e) {
    var t = ee.toDOMNode(e, e), n = ee.findDocumentOrShadowRoot(e);
    qr.set(e, !1), n.activeElement === t && t.blur();
  },
  /**
   * Focus the editor.
   */
  focus(e) {
    var t = ee.toDOMNode(e, e), n = ee.findDocumentOrShadowRoot(e);
    qr.set(e, !0), n.activeElement !== t && t.focus({
      preventScroll: !0
    });
  },
  /**
   * Deselect the editor.
   */
  deselect(e) {
    var {
      selection: t
    } = e, n = ee.findDocumentOrShadowRoot(e), r = n.getSelection();
    r && r.rangeCount > 0 && r.removeAllRanges(), t && re.deselect(e);
  },
  /**
   * Check if a DOM node is within the editor.
   */
  hasDOMNode(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: r = !1
    } = n, a = ee.toDOMNode(e, e), o;
    try {
      o = Mt(t) ? t : t.parentElement;
    } catch (i) {
      if (!i.message.includes('Permission denied to access property "nodeType"'))
        throw i;
    }
    return o ? o.closest("[data-slate-editor]") === a && (!r || o.isContentEditable ? !0 : typeof o.isContentEditable == "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    o.closest('[contenteditable="false"]') === a || !!o.getAttribute("data-slate-zero-width")) : !1;
  },
  /**
   * Insert data from a `DataTransfer` into the editor.
   */
  insertData(e, t) {
    e.insertData(t);
  },
  /**
   * Insert fragment data from a `DataTransfer` into the editor.
   */
  insertFragmentData(e, t) {
    return e.insertFragmentData(t);
  },
  /**
   * Insert text data from a `DataTransfer` into the editor.
   */
  insertTextData(e, t) {
    return e.insertTextData(t);
  },
  /**
   * Sets data from the currently selected fragment on a `DataTransfer`.
   */
  setFragmentData(e, t, n) {
    e.setFragmentData(t, n);
  },
  /**
   * Find the native DOM element from a Slate node.
   */
  toDOMNode(e, t) {
    var n = gi.get(e), r = b.isEditor(t) ? uu.get(e) : n == null ? void 0 : n.get(ee.findKey(e, t));
    if (!r)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(nt.stringify(t)));
    return r;
  },
  /**
   * Find a native DOM selection point from a Slate point.
   */
  toDOMPoint(e, t) {
    var [n] = b.node(e, t.path), r = ee.toDOMNode(e, n), a;
    b.void(e, {
      at: t
    }) && (t = {
      path: t.path,
      offset: 0
    });
    for (var o = "[data-slate-string], [data-slate-zero-width]", i = Array.from(r.querySelectorAll(o)), s = 0, u = 0; u < i.length; u++) {
      var l = i[u], c = l.childNodes[0];
      if (!(c == null || c.textContent == null)) {
        var {
          length: f
        } = c.textContent, p = l.getAttribute("data-slate-length"), m = p == null ? f : parseInt(p, 10), v = s + m, g = i[u + 1];
        if (t.offset === v && g !== null && g !== void 0 && g.hasAttribute("data-slate-mark-placeholder")) {
          var h, w = g.childNodes[0];
          a = [
            // COMPAT: If we don't explicity set the dom point to be on the actual
            // dom text element, chrome will put the selection behind the actual dom
            // text element, causing domRange.getBoundingClientRect() calls on a collapsed
            // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
            // which will cause issues when scrolling to it.
            w instanceof Wk ? w : g,
            (h = g.textContent) !== null && h !== void 0 && h.startsWith("\uFEFF") ? 1 : 0
          ];
          break;
        }
        if (t.offset <= v) {
          var S = Math.min(f, Math.max(0, t.offset - s));
          a = [c, S];
          break;
        }
        s = v;
      }
    }
    if (!a)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(nt.stringify(t)));
    return a;
  },
  /**
   * Find a native DOM range from a Slate `range`.
   *
   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
   *
   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
   */
  toDOMRange(e, t) {
    var {
      anchor: n,
      focus: r
    } = t, a = Y.isBackward(t), o = ee.toDOMPoint(e, n), i = Y.isCollapsed(t) ? o : ee.toDOMPoint(e, r), s = ee.getWindow(e), u = s.document.createRange(), [l, c] = a ? i : o, [f, p] = a ? o : i, m = Mt(l) ? l : l.parentElement, v = !!m.getAttribute("data-slate-zero-width"), g = Mt(f) ? f : f.parentElement, h = !!g.getAttribute("data-slate-zero-width");
    return u.setStart(l, v ? 1 : c), u.setEnd(f, h ? 1 : p), u;
  },
  /**
   * Find a Slate node from a native DOM `element`.
   */
  toSlateNode(e, t) {
    var n = Mt(t) ? t : t.parentElement;
    n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
    var r = n ? mi.get(n) : null;
    if (!r)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
    return r;
  },
  /**
   * Get the target range from a DOM `event`.
   */
  findEventRange(e, t) {
    "nativeEvent" in t && (t = t.nativeEvent);
    var {
      clientX: n,
      clientY: r,
      target: a
    } = t;
    if (n == null || r == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var o = ee.toSlateNode(e, t.target), i = ee.findPath(e, o);
    if (fe.isElement(o) && b.isVoid(e, o)) {
      var s = a.getBoundingClientRect(), u = e.isInline(o) ? n - s.left < s.left + s.width - n : r - s.top < s.top + s.height - r, l = b.point(e, i, {
        edge: u ? "start" : "end"
      }), c = u ? b.before(e, l) : b.after(e, l);
      if (c) {
        var f = b.range(e, c);
        return f;
      }
    }
    var p, {
      document: m
    } = ee.getWindow(e);
    if (m.caretRangeFromPoint)
      p = m.caretRangeFromPoint(n, r);
    else {
      var v = m.caretPositionFromPoint(n, r);
      v && (p = m.createRange(), p.setStart(v.offsetNode, v.offset), p.setEnd(v.offsetNode, v.offset));
    }
    if (!p)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var g = ee.toSlateRange(e, p, {
      exactMatch: !1,
      suppressThrow: !1
    });
    return g;
  },
  /**
   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
   */
  toSlatePoint(e, t, n) {
    var {
      exactMatch: r,
      suppressThrow: a
    } = n, [o, i] = r ? t : Vk(t), s = o.parentNode, u = null, l = 0;
    if (s) {
      var c, f, p = ee.toDOMNode(e, e), m = s.closest('[data-slate-void="true"]'), v = m && p.contains(m) ? m : null, g = s.closest("[data-slate-leaf]"), h = null;
      if (g) {
        if (u = g.closest('[data-slate-node="text"]'), u) {
          var w = ee.getWindow(e), S = w.document.createRange();
          S.setStart(u, 0), S.setEnd(o, i);
          var x = S.cloneContents(), O = [...Array.prototype.slice.call(x.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(x.querySelectorAll("[contenteditable=false]"))];
          O.forEach((ae) => {
            if (jt && !r && ae.hasAttribute("data-slate-zero-width") && ae.textContent.length > 0 && ae.textContext !== "\uFEFF") {
              ae.textContent.startsWith("\uFEFF") && (ae.textContent = ae.textContent.slice(1));
              return;
            }
            ae.parentNode.removeChild(ae);
          }), l = x.textContent.length, h = u;
        }
      } else if (v) {
        for (var B = v.querySelectorAll("[data-slate-leaf]"), F = 0; F < B.length; F++) {
          var L = B[F];
          if (ee.hasDOMNode(e, L)) {
            g = L;
            break;
          }
        }
        g ? (u = g.closest('[data-slate-node="text"]'), h = g, l = h.textContent.length, h.querySelectorAll("[data-slate-zero-width]").forEach((ae) => {
          l -= ae.textContent.length;
        })) : l = 1;
      }
      h && l === h.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      jt && h.getAttribute("data-slate-zero-width") === "z" && (c = h.textContent) !== null && c !== void 0 && c.startsWith("\uFEFF") && (s.hasAttribute("data-slate-zero-width") || Yo && (f = h.textContent) !== null && f !== void 0 && f.endsWith(`

`)) && l--;
    }
    if (jt && !u && !r) {
      var j = s.hasAttribute("data-slate-node") ? s : s.closest("[data-slate-node]");
      if (j && ee.hasDOMNode(e, j, {
        editable: !0
      })) {
        var I = ee.toSlateNode(e, j), {
          path: N,
          offset: q
        } = b.start(e, ee.findPath(e, I));
        return j.querySelector("[data-slate-leaf]") || (q = i), {
          path: N,
          offset: q
        };
      }
    }
    if (!u) {
      if (a)
        return null;
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
    }
    var J = ee.toSlateNode(e, u), R = ee.findPath(e, J);
    return {
      path: R,
      offset: l
    };
  },
  /**
   * Find a Slate range from a DOM range or selection.
   */
  toSlateRange(e, t, n) {
    var {
      exactMatch: r,
      suppressThrow: a
    } = n, o = fu(t) ? t.anchorNode : t.startContainer, i, s, u, l, c;
    if (o && (fu(t) ? (i = t.anchorNode, s = t.anchorOffset, u = t.focusNode, l = t.focusOffset, nm && zk(i) ? c = t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : c = t.isCollapsed) : (i = t.startContainer, s = t.startOffset, u = t.endContainer, l = t.endOffset, c = t.collapsed)), i == null || u == null || s == null || l == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
    var f = ee.toSlatePoint(e, [i, s], {
      exactMatch: r,
      suppressThrow: a
    });
    if (!f)
      return null;
    var p = c ? f : ee.toSlatePoint(e, [u, l], {
      exactMatch: r,
      suppressThrow: a
    });
    if (!p)
      return null;
    if (Yo && !c && i !== u) {
      var m = b.isEnd(e, f, f.path), v = b.isStart(e, p, p.path);
      if (m) {
        var g = b.after(e, f);
        f = g || f;
      }
      if (v) {
        var h = b.before(e, p);
        p = h || p;
      }
    }
    var w = {
      anchor: f,
      focus: p
    };
    return Y.isExpanded(w) && Y.isForward(w) && Mt(u) && b.void(e, {
      at: w.focus,
      mode: "highest"
    }) && (w = b.unhangRange(e, w, {
      voids: !0
    })), w;
  },
  hasRange(e, t) {
    var {
      anchor: n,
      focus: r
    } = t;
    return b.hasPath(e, n.path) && b.hasPath(e, r.path);
  },
  /**
   * Check if the target is in the editor.
   */
  hasTarget(e, t) {
    return un(t) && ee.hasDOMNode(e, t);
  },
  /**
   * Check if the target is editable and in the editor.
   */
  hasEditableTarget(e, t) {
    return un(t) && ee.hasDOMNode(e, t, {
      editable: !0
    });
  },
  /**
   * Check if the target can be selectable
   */
  hasSelectableTarget(e, t) {
    return ee.hasEditableTarget(e, t) || ee.isTargetInsideNonReadonlyVoid(e, t);
  },
  /**
   * Check if the target is inside void and in an non-readonly editor.
   */
  isTargetInsideNonReadonlyVoid(e, t) {
    if (cu.get(e))
      return !1;
    var n = ee.hasTarget(e, t) && ee.toSlateNode(e, t);
    return fe.isElement(n) && b.isVoid(e, n);
  },
  /**
   * Experimental and android specific: Flush all pending diffs and cancel composition at the next possible time.
   */
  androidScheduleFlush(e) {
    var t;
    (t = Ml.get(e)) === null || t === void 0 || t();
  },
  /**
   * Experimental and android specific: Get pending diffs
   */
  androidPendingDiffs(e) {
    return bt.get(e);
  }
}, en = go ? Oa : je, r4 = ["anchor", "focus"], n4 = ["anchor", "focus"], a4 = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), am = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], a = t[n], o = Yn(r, r4), i = Yn(a, n4);
    if (!Y.equals(r, a) || r[Vn] !== a[Vn] || !a4(o, i))
      return !1;
  }
  return !0;
}, o4 = (e) => {
  var {
    isLast: t,
    leaf: n,
    parent: r,
    text: a
  } = e, o = jr(), i = ee.findPath(o, a), s = A.parent(i), u = n[Jv] === !0;
  return o.isVoid(r) ? /* @__PURE__ */ d.createElement(ms, {
    length: ie.string(r).length
  }) : n.text === "" && r.children[r.children.length - 1] === a && !o.isInline(r) && b.string(o, s) === "" ? /* @__PURE__ */ d.createElement(ms, {
    isLineBreak: !0,
    isMarkPlaceholder: u
  }) : n.text === "" ? /* @__PURE__ */ d.createElement(ms, {
    isMarkPlaceholder: u
  }) : t && n.text.slice(-1) === `
` ? /* @__PURE__ */ d.createElement(Tf, {
    isTrailing: !0,
    text: n.text
  }) : /* @__PURE__ */ d.createElement(Tf, {
    text: n.text
  });
}, Tf = (e) => {
  var {
    text: t,
    isTrailing: n = !1
  } = e, r = ve(null), a = () => "".concat(t ?? "").concat(n ? `
` : "");
  return en(() => {
    var o = a();
    r.current && r.current.textContent !== o && (r.current.textContent = o);
  }), r.current ? /* @__PURE__ */ d.createElement("span", {
    "data-slate-string": !0,
    ref: r
  }) : /* @__PURE__ */ d.createElement("span", {
    "data-slate-string": !0,
    ref: r
  }, a());
}, ms = (e) => {
  var {
    length: t = 0,
    isLineBreak: n = !1,
    isMarkPlaceholder: r = !1
  } = e, a = {
    "data-slate-zero-width": n ? "n" : "z",
    "data-slate-length": t
  };
  return r && (a["data-slate-mark-placeholder"] = !0), /* @__PURE__ */ d.createElement("span", Object.assign({}, a), !jt || !n ? "\uFEFF" : null, n ? /* @__PURE__ */ d.createElement("br", null) : null);
}, _l = /* @__PURE__ */ Ir(null), jr = () => {
  var e = mr(_l);
  if (!e)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return e;
}, i4 = (e) => {
  var {
    leaf: t,
    isLast: n,
    text: r,
    parent: a,
    renderPlaceholder: o,
    renderLeaf: i = (v) => /* @__PURE__ */ d.createElement(u4, Object.assign({}, v))
  } = e, s = ve(null), u = ve(null), l = jr(), c = ve(null);
  je(() => () => {
    c.current && c.current.disconnect();
  }, []), je(() => {
    var v = u == null ? void 0 : u.current;
    if (v ? Ea.set(l, v) : Ea.delete(l), c.current)
      c.current.disconnect(), v && c.current.observe(v);
    else if (v) {
      var g = window.ResizeObserver || Mk;
      c.current = new g(() => {
        var w = Wo.get(l);
        w == null || w();
      }), c.current.observe(v);
    }
    if (!v && s.current) {
      var h = Wo.get(l);
      h == null || h();
    }
    return s.current = u.current, () => {
      Ea.delete(l);
    };
  }, [u, t]);
  var f = /* @__PURE__ */ d.createElement(o4, {
    isLast: n,
    leaf: t,
    parent: a,
    text: r
  });
  if (t[Vn]) {
    var p = {
      children: t.placeholder,
      attributes: {
        "data-slate-placeholder": !0,
        style: {
          position: "absolute",
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none"
        },
        contentEditable: !1,
        ref: u
      }
    };
    f = /* @__PURE__ */ d.createElement(d.Fragment, null, o(p), f);
  }
  var m = {
    "data-slate-leaf": !0
  };
  return i({
    attributes: m,
    children: f,
    leaf: t,
    text: r
  });
}, s4 = /* @__PURE__ */ d.memo(i4, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && he.equals(t.leaf, e.leaf) && t.leaf[Vn] === e.leaf[Vn]), u4 = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return /* @__PURE__ */ d.createElement("span", Object.assign({}, t), n);
}, l4 = (e) => {
  for (var {
    decorations: t,
    isLast: n,
    parent: r,
    renderPlaceholder: a,
    renderLeaf: o,
    text: i
  } = e, s = jr(), u = ve(null), l = he.decorations(i, t), c = ee.findKey(s, i), f = [], p = 0; p < l.length; p++) {
    var m = l[p];
    f.push(/* @__PURE__ */ d.createElement(s4, {
      isLast: n && p === l.length - 1,
      key: "".concat(c.id, "-").concat(p),
      renderPlaceholder: a,
      leaf: m,
      text: i,
      parent: r,
      renderLeaf: o
    }));
  }
  return en(() => {
    var v = gi.get(s);
    u.current ? (v == null || v.set(c, u.current), Hn.set(i, u.current), mi.set(u.current, i)) : (v == null || v.delete(c), Hn.delete(i));
  }), /* @__PURE__ */ d.createElement("span", {
    "data-slate-node": "text",
    ref: u
  }, f);
}, om = /* @__PURE__ */ d.memo(l4, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.text === e.text && am(t.decorations, e.decorations)), c4 = (e) => {
  var {
    decorations: t,
    element: n,
    renderElement: r = (S) => /* @__PURE__ */ d.createElement(f4, Object.assign({}, S)),
    renderPlaceholder: a,
    renderLeaf: o,
    selection: i
  } = e, s = jr(), u = v4(), l = s.isInline(n), c = ee.findKey(s, n), f = Le((S) => {
    var x = gi.get(s);
    S ? (x == null || x.set(c, S), Hn.set(n, S), mi.set(S, n)) : (x == null || x.delete(c), Hn.delete(n));
  }, [s, c, n]), p = sm({
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: a,
    renderLeaf: o,
    selection: i
  }), m = {
    "data-slate-node": "element",
    ref: f
  };
  if (l && (m["data-slate-inline"] = !0), !l && b.hasInlines(s, n)) {
    var v = ie.string(n), g = _v(v);
    g === "rtl" && (m.dir = g);
  }
  if (b.isVoid(s, n)) {
    m["data-slate-void"] = !0, !u && l && (m.contentEditable = !1);
    var h = l ? "span" : "div", [[w]] = ie.texts(n);
    p = /* @__PURE__ */ d.createElement(h, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ d.createElement(om, {
      renderPlaceholder: a,
      decorations: [],
      isLast: !1,
      parent: n,
      text: w
    })), Al.set(w, 0), Pl.set(w, n);
  }
  return r({
    attributes: m,
    children: p,
    element: n
  });
}, d4 = /* @__PURE__ */ d.memo(c4, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && am(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && Y.equals(e.selection, t.selection))), f4 = (e) => {
  var {
    attributes: t,
    children: n,
    element: r
  } = e, a = jr(), o = a.isInline(r) ? "span" : "div";
  return /* @__PURE__ */ d.createElement(o, Object.assign({}, t, {
    style: {
      position: "relative"
    }
  }), n);
}, im = /* @__PURE__ */ Ir(() => []), p4 = () => mr(im), h4 = /* @__PURE__ */ Ir(!1), sm = (e) => {
  for (var {
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: a,
    renderLeaf: o,
    selection: i
  } = e, s = p4(), u = jr(), l = ee.findPath(u, n), c = [], f = fe.isElement(n) && !u.isInline(n) && b.hasInlines(u, n), p = 0; p < n.children.length; p++) {
    var m = l.concat(p), v = n.children[p], g = ee.findKey(u, v), h = b.range(u, m), w = i && Y.intersection(h, i), S = s([v, m]);
    for (var x of t) {
      var O = Y.intersection(x, h);
      O && S.push(O);
    }
    fe.isElement(v) ? c.push(/* @__PURE__ */ d.createElement(h4.Provider, {
      key: "provider-".concat(g.id),
      value: !!w
    }, /* @__PURE__ */ d.createElement(d4, {
      decorations: S,
      element: v,
      key: g.id,
      renderElement: r,
      renderPlaceholder: a,
      renderLeaf: o,
      selection: w
    }))) : c.push(/* @__PURE__ */ d.createElement(om, {
      decorations: S,
      key: g.id,
      isLast: f && p === n.children.length - 1,
      parent: n,
      renderPlaceholder: a,
      renderLeaf: o,
      text: v
    })), Al.set(v, p), Pl.set(v, n);
  }
  return c;
}, um = /* @__PURE__ */ Ir(!1), v4 = () => mr(um), lm = /* @__PURE__ */ Ir(null), Va = () => {
  var e = mr(lm);
  if (!e)
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  var {
    editor: t
  } = e;
  return t;
}, m4 = 3, g4 = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
}, y4 = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, b4 = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, Ue = (e) => {
  var t = g4[e], n = y4[e], r = b4[e], a = t && hs(t), o = n && hs(n), i = r && hs(r);
  return (s) => !!(a && a(s) || Bf && o && o(s) || !Bf && i && i(s));
}, Xe = {
  isBold: Ue("bold"),
  isCompose: Ue("compose"),
  isMoveBackward: Ue("moveBackward"),
  isMoveForward: Ue("moveForward"),
  isDeleteBackward: Ue("deleteBackward"),
  isDeleteForward: Ue("deleteForward"),
  isDeleteLineBackward: Ue("deleteLineBackward"),
  isDeleteLineForward: Ue("deleteLineForward"),
  isDeleteWordBackward: Ue("deleteWordBackward"),
  isDeleteWordForward: Ue("deleteWordForward"),
  isExtendBackward: Ue("extendBackward"),
  isExtendForward: Ue("extendForward"),
  isExtendLineBackward: Ue("extendLineBackward"),
  isExtendLineForward: Ue("extendLineForward"),
  isItalic: Ue("italic"),
  isMoveLineBackward: Ue("moveLineBackward"),
  isMoveLineForward: Ue("moveLineForward"),
  isMoveWordBackward: Ue("moveWordBackward"),
  isMoveWordForward: Ue("moveWordForward"),
  isRedo: Ue("redo"),
  isSoftBreak: Ue("insertSoftBreak"),
  isSplitBlock: Ue("splitBlock"),
  isTransposeCharacter: Ue("transposeCharacter"),
  isUndo: Ue("undo")
}, w4 = (e, t) => {
  var n = [], r = () => {
    n = [];
  }, a = (i) => {
    if (t.current) {
      var s = i.filter((u) => Rl(e, u, i));
      n.push(...s);
    }
  };
  function o() {
    n.reverse().forEach((i) => {
      if (i.type === "characterData") {
        i.target.textContent = i.oldValue;
        return;
      }
      i.removedNodes.forEach((s) => {
        i.target.insertBefore(s, i.nextSibling);
      }), i.addedNodes.forEach((s) => {
        i.target.removeChild(s);
      });
    }), r();
  }
  return {
    registerMutations: a,
    restoreDOM: o,
    clear: r
  };
}, D4 = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0
};
class cm extends Pp {
  constructor() {
    super(...arguments), this.context = null, this.manager = null, this.mutationObserver = null;
  }
  observe() {
    var t, {
      node: n
    } = this.props;
    if (!n.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    (t = this.mutationObserver) === null || t === void 0 || t.observe(n.current, D4);
  }
  componentDidMount() {
    var {
      receivedUserInput: t
    } = this.props, n = this.context;
    this.manager = w4(n, t), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
  }
  getSnapshotBeforeUpdate() {
    var t, n, r, a = (t = this.mutationObserver) === null || t === void 0 ? void 0 : t.takeRecords();
    if (a != null && a.length) {
      var o;
      (o = this.manager) === null || o === void 0 || o.registerMutations(a);
    }
    return (n = this.mutationObserver) === null || n === void 0 || n.disconnect(), (r = this.manager) === null || r === void 0 || r.restoreDOM(), null;
  }
  componentDidUpdate() {
    var t;
    (t = this.manager) === null || t === void 0 || t.clear(), this.observe();
  }
  componentWillUnmount() {
    var t;
    (t = this.mutationObserver) === null || t === void 0 || t.disconnect();
  }
  render() {
    return this.props.children;
  }
}
cm.contextType = _l;
var C4 = jt ? cm : (e) => {
  var {
    children: t
  } = e;
  return /* @__PURE__ */ d.createElement(d.Fragment, null, t);
};
function E4(e, t) {
  var {
    path: n,
    diff: r
  } = t;
  if (!b.hasPath(e, n))
    return !1;
  var a = ie.get(e, n);
  if (!he.isText(a))
    return !1;
  if (r.start !== a.text.length || r.text.length === 0)
    return a.text.slice(r.start, r.start + r.text.length) === r.text;
  var o = A.next(n);
  if (!b.hasPath(e, o))
    return !1;
  var i = ie.get(e, o);
  return he.isText(i) && i.text.startsWith(r.text);
}
function x4(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return n.reduce((a, o) => a.slice(0, o.start) + o.text + a.slice(o.end), e);
}
function S4(e, t) {
  for (var n = Math.min(e.length, t.length), r = 0; r < n; r++)
    if (e.charAt(r) !== t.charAt(r))
      return r;
  return n;
}
function $4(e, t, n) {
  for (var r = Math.min(e.length, t.length, n), a = 0; a < r; a++)
    if (e.charAt(e.length - a - 1) !== t.charAt(t.length - a - 1))
      return a;
  return r;
}
function dm(e, t) {
  var {
    start: n,
    end: r,
    text: a
  } = t, o = e.slice(n, r), i = S4(o, a), s = Math.min(o.length - i, a.length - i), u = $4(o, a, s), l = {
    start: n + i,
    end: r - u,
    text: a.slice(i, a.length - u)
  };
  return l.start === l.end && l.text.length === 0 ? null : l;
}
function k4(e, t, n) {
  var r = Math.min(t.start, n.start), a = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), o = x4(e, t, n), i = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - a), s = o.slice(r, i), u = Math.max(t.end, n.end - t.text.length + (t.end - t.start));
  return dm(e, {
    start: r,
    end: u,
    text: s
  });
}
function O4(e) {
  var {
    path: t,
    diff: n
  } = e;
  return {
    anchor: {
      path: t,
      offset: n.start
    },
    focus: {
      path: t,
      offset: n.end
    }
  };
}
function pu(e, t) {
  var {
    path: n,
    offset: r
  } = t;
  if (!b.hasPath(e, n))
    return null;
  var a = ie.get(e, n);
  if (!he.isText(a))
    return null;
  var o = b.above(e, {
    match: (s) => fe.isElement(s) && b.isBlock(e, s),
    at: n
  });
  if (!o)
    return null;
  for (; r > a.text.length; ) {
    var i = b.next(e, {
      at: n,
      match: he.isText
    });
    if (!i || !A.isDescendant(i[1], o[1]))
      return null;
    r -= a.text.length, a = i[0], n = i[1];
  }
  return {
    path: n,
    offset: r
  };
}
function Af(e, t) {
  var n = pu(e, t.anchor);
  if (!n)
    return null;
  if (Y.isCollapsed(t))
    return {
      anchor: n,
      focus: n
    };
  var r = pu(e, t.focus);
  return r ? {
    anchor: n,
    focus: r
  } : null;
}
function hu(e, t, n) {
  var r = bt.get(e), a = r == null ? void 0 : r.find((c) => {
    var {
      path: f
    } = c;
    return A.equals(f, t.path);
  });
  if (!a || t.offset <= a.diff.start)
    return De.transform(t, n, {
      affinity: "backward"
    });
  var {
    diff: o
  } = a;
  if (t.offset <= o.start + o.text.length) {
    var i = {
      path: t.path,
      offset: o.start
    }, s = De.transform(i, n, {
      affinity: "backward"
    });
    return s ? {
      path: s.path,
      offset: s.offset + t.offset - o.start
    } : null;
  }
  var u = {
    path: t.path,
    offset: t.offset - o.text.length + o.end - o.start
  }, l = De.transform(u, n, {
    affinity: "backward"
  });
  return l ? n.type === "split_node" && A.equals(n.path, t.path) && u.offset < n.position && o.start < n.position ? l : {
    path: l.path,
    offset: l.offset + o.text.length - o.end + o.start
  } : null;
}
function Pf(e, t, n) {
  var r = hu(e, t.anchor, n);
  if (!r)
    return null;
  if (Y.isCollapsed(t))
    return {
      anchor: r,
      focus: r
    };
  var a = hu(e, t.focus, n);
  return a ? {
    anchor: r,
    focus: a
  } : null;
}
function B4(e, t) {
  var {
    path: n,
    diff: r,
    id: a
  } = e;
  switch (t.type) {
    case "insert_text":
      return !A.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
        diff: {
          start: t.text.length + r.start,
          end: t.text.length + r.end,
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end + t.text.length,
          text: r.text
        },
        id: a,
        path: n
      };
    case "remove_text":
      return !A.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
        diff: {
          start: r.start - t.text.length,
          end: r.end - t.text.length,
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end - t.text.length,
          text: r.text
        },
        id: a,
        path: n
      };
    case "split_node":
      return !A.equals(t.path, n) || t.position >= r.end ? {
        diff: r,
        id: a,
        path: A.transform(n, t, {
          affinity: "backward"
        })
      } : t.position > r.start ? {
        diff: {
          start: r.start,
          end: Math.min(t.position, r.end),
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start - t.position,
          end: r.end - t.position,
          text: r.text
        },
        id: a,
        path: A.transform(n, t, {
          affinity: "forward"
        })
      };
    case "merge_node":
      return A.equals(t.path, n) ? {
        diff: {
          start: r.start + t.position,
          end: r.end + t.position,
          text: r.text
        },
        id: a,
        path: A.transform(n, t)
      } : {
        diff: r,
        id: a,
        path: A.transform(n, t)
      };
  }
  var o = A.transform(n, t);
  return o ? {
    diff: r,
    path: o,
    id: a
  } : null;
}
function Mf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function io(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mf(Object(n), !0).forEach(function(r) {
      vi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var T4 = 25, A4 = 200, P4 = function() {
};
function M4(e) {
  var {
    editor: t,
    scheduleOnDOMSelectionChange: n,
    onDOMSelectionChange: r
  } = e, a = !1, o = null, i = null, s = null, u = 0, l = !1, c = () => {
    var J = $r.get(t);
    if ($r.delete(t), J) {
      var {
        selection: R
      } = t, ae = Af(t, J);
      ae && (!R || !Y.equals(ae, R)) && re.select(t, ae);
    }
  }, f = () => {
    var J = Sr.get(t);
    if (Sr.delete(t), !!J) {
      if (J.at) {
        var R = De.isPoint(J.at) ? pu(t, J.at) : Af(t, J.at);
        if (!R)
          return;
        var ae = b.range(t, R);
        (!t.selection || !Y.equals(t.selection, ae)) && re.select(t, R);
      }
      J.run();
    }
  }, p = () => {
    var J;
    if (i && (clearTimeout(i), i = null), s && (clearTimeout(s), s = null), !O() && !x()) {
      c();
      return;
    }
    a || (a = !0, setTimeout(() => a = !1)), x() && (a = "action");
    var R = t.selection && b.rangeRef(t, t.selection, {
      affinity: "forward"
    });
    fr.set(t, t.marks), P4("flush", Sr.get(t), bt.get(t));
    for (var ae = !!((J = bt.get(t)) !== null && J !== void 0 && J.length), H; H = (oe = bt.get(t)) === null || oe === void 0 ? void 0 : oe[0]; ) {
      var oe, ue, me = Lt.get(t);
      me !== void 0 && (Lt.delete(t), t.marks = me), me && l === !1 && (l = null);
      var V = O4(H);
      (!t.selection || !Y.equals(t.selection, V)) && re.select(t, V), H.diff.text ? b.insertText(t, H.diff.text) : b.deleteFragment(t), bt.set(t, (ue = bt.get(t)) === null || ue === void 0 ? void 0 : ue.filter((M) => {
        var {
          id: P
        } = M;
        return P !== H.id;
      })), E4(t, H) || (ae = !1, Sr.delete(t), fr.delete(t), a = "action", $r.delete(t), n.cancel(), r.cancel(), R == null || R.unref());
    }
    var T = R == null ? void 0 : R.unref();
    if (T && !$r.get(t) && (!t.selection || !Y.equals(T, t.selection)) && re.select(t, T), x()) {
      f();
      return;
    }
    ae && n(), n.flush(), r.flush(), c();
    var C = fr.get(t);
    fr.delete(t), C !== void 0 && (t.marks = C, t.onChange());
  }, m = (J) => {
    o && clearTimeout(o), o = setTimeout(() => {
      Xr.set(t, !1), p();
    }, T4);
  }, v = (J) => {
    Xr.set(t, !0), o && (clearTimeout(o), o = null);
  }, g = function() {
    var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, ae = Ea.get(t);
    if (ae) {
      if (O() || R) {
        ae.style.display = "none";
        return;
      }
      ae.style.removeProperty("display");
    }
  }, h = (J, R) => {
    var ae, H = (ae = bt.get(t)) !== null && ae !== void 0 ? ae : [];
    bt.set(t, H);
    var oe = ie.leaf(t, J), ue = H.findIndex((T) => A.equals(T.path, J));
    if (ue < 0) {
      var me = dm(oe.text, R);
      me && H.push({
        path: J,
        diff: R,
        id: u++
      }), g();
      return;
    }
    var V = k4(oe.text, H[ue].diff, R);
    if (!V) {
      H.splice(ue, 1), g();
      return;
    }
    H[ue] = io(io({}, H[ue]), {}, {
      diff: V
    });
  }, w = function(R) {
    var {
      at: ae
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    l = !1, $r.delete(t), n.cancel(), r.cancel(), x() && p(), Sr.set(t, {
      at: ae,
      run: R
    }), s = setTimeout(p);
  }, S = (J) => {
    var R;
    i && (clearTimeout(i), i = null);
    var {
      inputType: ae
    } = J, H = null, oe = J.dataTransfer || J.data || void 0;
    l !== !1 && ae !== "insertText" && ae !== "insertCompositionText" && (l = !1);
    var [ue] = J.getTargetRanges();
    ue && (H = ee.toSlateRange(t, ue, {
      exactMatch: !1,
      suppressThrow: !0
    }));
    var me = ee.getWindow(t), V = me.getSelection();
    if (!H && V && (ue = V, H = ee.toSlateRange(t, V, {
      exactMatch: !1,
      suppressThrow: !0
    })), H = (R = H) !== null && R !== void 0 ? R : t.selection, !!H) {
      if (Y.isExpanded(H) && ae.startsWith("delete")) {
        var [T, C] = Y.edges(H), M = ie.leaf(t, T.path);
        if (M.text.length === T.offset && C.offset === 0) {
          var P = b.next(t, {
            at: T.path,
            match: he.isText
          });
          P && A.equals(P[1], C.path) && (H = {
            anchor: C,
            focus: C
          });
        }
      }
      if (Y.isExpanded(H) && ae.startsWith("delete")) {
        if (A.equals(H.anchor.path, H.focus.path)) {
          var [W, z] = Y.edges(H);
          return h(H.anchor.path, {
            text: "",
            end: z.offset,
            start: W.offset
          });
        }
        var K = ae.endsWith("Backward") ? "backward" : "forward";
        return w(() => b.deleteFragment(t, {
          direction: K
        }), {
          at: H
        });
      }
      switch (ae) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag":
          return w(() => b.deleteFragment(t), {
            at: H
          });
        case "deleteContent":
        case "deleteContentForward": {
          var {
            anchor: X
          } = H;
          if (Y.isCollapsed(H)) {
            var G = ie.leaf(t, X.path);
            if (X.offset < G.text.length)
              return h(X.path, {
                text: "",
                start: X.offset,
                end: X.offset + 1
              });
          }
          return w(() => b.deleteForward(t), {
            at: H
          });
        }
        case "deleteContentBackward": {
          var te, {
            anchor: se
          } = H, Z = fu(ue) ? ue.isCollapsed : !!((te = ue) !== null && te !== void 0 && te.collapsed);
          return Z && Y.isCollapsed(H) && se.offset > 0 ? h(se.path, {
            text: "",
            start: se.offset - 1,
            end: se.offset
          }) : w(() => b.deleteBackward(t), {
            at: H
          });
        }
        case "deleteEntireSoftLine":
          return w(() => {
            b.deleteBackward(t, {
              unit: "line"
            }), b.deleteForward(t, {
              unit: "line"
            });
          }, {
            at: H
          });
        case "deleteHardLineBackward":
          return w(() => b.deleteBackward(t, {
            unit: "block"
          }), {
            at: H
          });
        case "deleteSoftLineBackward":
          return w(() => b.deleteBackward(t, {
            unit: "line"
          }), {
            at: H
          });
        case "deleteHardLineForward":
          return w(() => b.deleteForward(t, {
            unit: "block"
          }), {
            at: H
          });
        case "deleteSoftLineForward":
          return w(() => b.deleteForward(t, {
            unit: "line"
          }), {
            at: H
          });
        case "deleteWordBackward":
          return w(() => b.deleteBackward(t, {
            unit: "word"
          }), {
            at: H
          });
        case "deleteWordForward":
          return w(() => b.deleteForward(t, {
            unit: "word"
          }), {
            at: H
          });
        case "insertLineBreak":
          return w(() => b.insertSoftBreak(t), {
            at: H
          });
        case "insertParagraph":
          return w(() => b.insertBreak(t), {
            at: H
          });
        case "insertCompositionText":
        case "deleteCompositionText":
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          if ((oe == null ? void 0 : oe.constructor.name) === "DataTransfer")
            return w(() => ee.insertData(t, oe), {
              at: H
            });
          if (typeof oe == "string" && oe.includes(`
`))
            return w(() => b.insertSoftBreak(t), {
              at: Y.end(H)
            });
          var ne = oe ?? "";
          if (Lt.get(t) && (ne = ne.replace("\uFEFF", "")), A.equals(H.anchor.path, H.focus.path)) {
            var [be, Pe] = Y.edges(H), Ve = {
              start: be.offset,
              end: Pe.offset,
              text: ne
            };
            if (ne && l && ae === "insertCompositionText") {
              var Et = l.start + l.text.search(/\S|$/), Ze = Ve.start + Ve.text.search(/\S|$/);
              Ze === Et + 1 && Ve.end === l.start + l.text.length ? (Ve.start -= 1, l = null, N()) : l = !1;
            } else
              ae === "insertText" ? l === null ? l = Ve : l && Y.isCollapsed(H) && l.end + l.text.length === be.offset ? l = io(io({}, l), {}, {
                text: l.text + ne
              }) : l = !1 : l = !1;
            h(be.path, Ve);
            return;
          }
          return w(() => b.insertText(t, ne), {
            at: H
          });
        }
      }
    }
  }, x = () => !!Sr.get(t), O = () => {
    var J;
    return !!((J = bt.get(t)) !== null && J !== void 0 && J.length);
  }, B = () => x() || O(), F = () => a, L = (J) => {
    $r.set(t, J), i && (clearTimeout(i), i = null);
    var {
      selection: R
    } = t;
    if (J) {
      var ae = !R || !A.equals(R.anchor.path, J.anchor.path), H = !R || !A.equals(R.anchor.path.slice(0, -1), J.anchor.path.slice(0, -1));
      (ae && l || H) && (l = !1), (ae || !O()) && (i = setTimeout(p, A4));
    }
  }, j = () => {
    (x() || !O()) && p();
  }, I = (J) => {
    O() || (g(!0), setTimeout(g));
  }, N = () => {
    x() || (s = setTimeout(p));
  }, q = (J) => {
    if (!(O() || x()) && J.some((ae) => Rl(t, ae, J))) {
      var R;
      (R = Wo.get(t)) === null || R === void 0 || R();
    }
  };
  return {
    flush: p,
    scheduleFlush: N,
    hasPendingDiffs: O,
    hasPendingAction: x,
    hasPendingChanges: B,
    isFlushing: F,
    handleUserSelect: L,
    handleCompositionEnd: m,
    handleCompositionStart: v,
    handleDOMBeforeInput: S,
    handleKeyDown: I,
    handleDomMutations: q,
    handleInput: j
  };
}
function F4() {
  var e = ve(!1);
  return je(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e.current;
}
function R4(e, t, n) {
  var [r] = Ne(() => new MutationObserver(t));
  en(() => {
    r.takeRecords();
  }), je(() => {
    if (!e.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    return r.observe(e.current, n), () => r.disconnect();
  }, []);
}
var _4 = ["node"];
function Ff(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function N4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ff(Object(n), !0).forEach(function(r) {
      vi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ff(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var I4 = {
  subtree: !0,
  childList: !0,
  characterData: !0
};
function L4(e) {
  var {
    node: t
  } = e, n = Yn(e, _4);
  if (!jt)
    return null;
  var r = jr(), a = F4(), [o] = Ne(() => M4(N4({
    editor: r
  }, n)));
  return R4(t, o.handleDomMutations, I4), Ml.set(r, o.scheduleFlush), a && o.flush(), o;
}
function j4() {
  var e = jr(), t = ve(!1), n = ve(0), r = Le(() => {
    if (!t.current) {
      t.current = !0;
      var a = ee.getWindow(e);
      a.cancelAnimationFrame(n.current), n.current = a.requestAnimationFrame(() => {
        t.current = !1;
      });
    }
  }, []);
  return je(() => () => cancelAnimationFrame(n.current), []), {
    receivedUserInput: t,
    onUserInput: r
  };
}
var W4 = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], Y4 = ["text"];
function Rf(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rf(Object(n), !0).forEach(function(r) {
      vi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rf(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var H4 = (e) => /* @__PURE__ */ d.createElement(d.Fragment, null, sm(e)), V4 = (e) => {
  var t, n, {
    autoFocus: r,
    decorate: a = K4,
    onDOMBeforeInput: o,
    placeholder: i,
    readOnly: s = !1,
    renderElement: u,
    renderLeaf: l,
    renderPlaceholder: c = (C) => /* @__PURE__ */ d.createElement(z4, Object.assign({}, C)),
    scrollSelectionIntoView: f = U4,
    style: p = {},
    as: m = "div",
    disableDefaultStyles: v = !1
  } = e, g = Yn(e, W4), h = Va(), [w, S] = Ne(!1), x = ve(null), O = ve([]), {
    onUserInput: B,
    receivedUserInput: F
  } = j4(), [, L] = R0((C) => C + 1, 0);
  Wo.set(h, L), cu.set(h, s);
  var j = Nn(() => ({
    isDraggingInternally: !1,
    isUpdatingSelection: !1,
    latestElement: null,
    hasMarkPlaceholder: !1
  }), []);
  je(() => {
    x.current && r && x.current.focus();
  }, [r]);
  var I = Le(lk(() => {
    if ((jt || !ee.isComposing(h)) && (!j.isUpdatingSelection || q != null && q.isFlushing()) && !j.isDraggingInternally) {
      var C = ee.findDocumentOrShadowRoot(h), {
        activeElement: M
      } = C, P = ee.toDOMNode(h, h), W = C.getSelection();
      if (M === P ? (j.latestElement = M, qr.set(h, !0)) : qr.delete(h), !W)
        return re.deselect(h);
      var {
        anchorNode: z,
        focusNode: K
      } = W, X = ee.hasEditableTarget(h, z) || ee.isTargetInsideNonReadonlyVoid(h, z), G = ee.hasEditableTarget(h, K) || ee.isTargetInsideNonReadonlyVoid(h, K);
      if (X && G) {
        var te = ee.toSlateRange(h, W, {
          exactMatch: !1,
          suppressThrow: !0
        });
        te && (!ee.isComposing(h) && !(q != null && q.hasPendingChanges()) && !(q != null && q.isFlushing()) ? re.select(h, te) : q == null || q.handleUserSelect(te));
      }
      s && (!X || !G) && re.deselect(h);
    }
  }, 100), [s]), N = Nn(() => nk(I, 0), [I]), q = L4({
    node: x,
    onDOMSelectionChange: I,
    scheduleOnDOMSelectionChange: N
  });
  en(() => {
    var C;
    x.current && (C = Fl(x.current)) ? (Zv.set(h, C), uu.set(h, x.current), Hn.set(h, x.current), mi.set(x.current, h)) : Hn.delete(h);
    var {
      selection: M
    } = h, P = ee.findDocumentOrShadowRoot(h), W = P.getSelection();
    if (!(!W || !ee.isFocused(h) || q != null && q.hasPendingAction())) {
      var z = (se) => {
        var Z = W.type !== "None";
        if (!(!M && !Z)) {
          var ne = uu.get(h), be = !1;
          if (ne.contains(W.anchorNode) && ne.contains(W.focusNode) && (be = !0), Z && be && M && !se) {
            var Pe = ee.toSlateRange(h, W, {
              exactMatch: !0,
              // domSelection is not necessarily a valid Slate range
              // (e.g. when clicking on contentEditable:false element)
              suppressThrow: !0
            });
            if (Pe && Y.equals(Pe, M)) {
              var Ve;
              if (!j.hasMarkPlaceholder)
                return;
              var {
                anchorNode: Et
              } = W;
              if (Et != null && (Ve = Et.parentElement) !== null && Ve !== void 0 && Ve.hasAttribute("data-slate-mark-placeholder"))
                return;
            }
          }
          if (M && !ee.hasRange(h, M)) {
            h.selection = ee.toSlateRange(h, W, {
              exactMatch: !1,
              suppressThrow: !0
            });
            return;
          }
          j.isUpdatingSelection = !0;
          var Ze = M && ee.toDOMRange(h, M);
          return Ze ? (Y.isBackward(M) ? W.setBaseAndExtent(Ze.endContainer, Ze.endOffset, Ze.startContainer, Ze.startOffset) : W.setBaseAndExtent(Ze.startContainer, Ze.startOffset, Ze.endContainer, Ze.endOffset), f(h, Ze)) : W.removeAllRanges(), Ze;
        }
      }, K = z(), X = (q == null ? void 0 : q.isFlushing()) === "action";
      if (!jt || !X) {
        setTimeout(() => {
          if (K && Yo) {
            var se = ee.toDOMNode(h, h);
            se.focus();
          }
          j.isUpdatingSelection = !1;
        });
        return;
      }
      var G = null, te = requestAnimationFrame(() => {
        if (X) {
          var se = (Z) => {
            try {
              var ne = ee.toDOMNode(h, h);
              ne.focus(), z(Z);
            } catch {
            }
          };
          se(), G = setTimeout(() => {
            se(!0), j.isUpdatingSelection = !1;
          });
        }
      });
      return () => {
        cancelAnimationFrame(te), G && clearTimeout(G);
      };
    }
  });
  var J = Le((C) => {
    if (B(), !s && ee.hasEditableTarget(h, C.target) && !q4(C, o)) {
      var M;
      if (q)
        return q.handleDOMBeforeInput(C);
      N.flush(), I.flush();
      var {
        selection: P
      } = h, {
        inputType: W
      } = C, z = C.dataTransfer || C.data || void 0, K = W === "insertCompositionText" || W === "deleteCompositionText";
      if (K && ee.isComposing(h))
        return;
      var X = !1;
      if (W === "insertText" && P && Y.isCollapsed(P) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      C.data && C.data.length === 1 && /[a-z ]/i.test(C.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      P.anchor.offset !== 0) {
        var G, te;
        X = !0, h.marks && (X = !1);
        var {
          anchor: se
        } = P, [Z, ne] = ee.toDOMPoint(h, se), be = (G = Z.parentElement) === null || G === void 0 ? void 0 : G.closest("a"), Pe = ee.getWindow(h);
        if (X && be && ee.hasDOMNode(h, be)) {
          var Ve, Et = Pe == null ? void 0 : Pe.document.createTreeWalker(be, NodeFilter.SHOW_TEXT).lastChild();
          Et === Z && ((Ve = Et.textContent) === null || Ve === void 0 ? void 0 : Ve.length) === ne && (X = !1);
        }
        if (X && Z.parentElement && (Pe == null || (te = Pe.getComputedStyle(Z.parentElement)) === null || te === void 0 ? void 0 : te.whiteSpace) === "pre") {
          var Ze = b.above(h, {
            at: se.path,
            match: (wr) => fe.isElement(wr) && b.isBlock(h, wr)
          });
          Ze && ie.string(Ze[0]).includes("	") && (X = !1);
        }
      }
      if (!W.startsWith("delete") || W.startsWith("deleteBy")) {
        var [Yr] = C.getTargetRanges();
        if (Yr) {
          var bn = ee.toSlateRange(h, Yr, {
            exactMatch: !1,
            suppressThrow: !1
          });
          if (!P || !Y.equals(P, bn)) {
            X = !1;
            var gt = !K && h.selection && b.rangeRef(h, h.selection);
            re.select(h, bn), gt && xa.set(h, gt);
          }
        }
      }
      if (K)
        return;
      if (X || C.preventDefault(), P && Y.isExpanded(P) && W.startsWith("delete")) {
        var zt = W.endsWith("Backward") ? "backward" : "forward";
        b.deleteFragment(h, {
          direction: zt
        });
        return;
      }
      switch (W) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          b.deleteFragment(h);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          b.deleteForward(h);
          break;
        }
        case "deleteContentBackward": {
          b.deleteBackward(h);
          break;
        }
        case "deleteEntireSoftLine": {
          b.deleteBackward(h, {
            unit: "line"
          }), b.deleteForward(h, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          b.deleteBackward(h, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          b.deleteBackward(h, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          b.deleteForward(h, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          b.deleteForward(h, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          b.deleteBackward(h, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          b.deleteForward(h, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          b.insertSoftBreak(h);
          break;
        case "insertParagraph": {
          b.insertBreak(h);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          W === "insertFromComposition" && ee.isComposing(h) && (S(!1), Xr.set(h, !1)), (z == null ? void 0 : z.constructor.name) === "DataTransfer" ? ee.insertData(h, z) : typeof z == "string" && (X ? O.current.push(() => b.insertText(h, z)) : b.insertText(h, z));
          break;
        }
      }
      var xt = (M = xa.get(h)) === null || M === void 0 ? void 0 : M.unref();
      xa.delete(h), xt && (!h.selection || !Y.equals(h.selection, xt)) && re.select(h, xt);
    }
  }, [s, o]);
  en(() => (x.current && Cr && x.current.addEventListener("beforeinput", J), () => {
    x.current && Cr && x.current.removeEventListener("beforeinput", J);
  }), [J]), en(() => {
    var C = ee.getWindow(h);
    return C.document.addEventListener("selectionchange", N), () => {
      C.document.removeEventListener("selectionchange", N);
    };
  }, [N]);
  var R = a([h, []]);
  if (i && h.children.length === 1 && Array.from(ie.texts(h)).length === 1 && ie.string(h) === "" && !w) {
    var ae = b.start(h, []);
    R.push({
      [Vn]: !0,
      placeholder: i,
      anchor: ae,
      focus: ae
    });
  }
  var {
    marks: H
  } = h;
  if (j.hasMarkPlaceholder = !1, h.selection && Y.isCollapsed(h.selection) && H) {
    var {
      anchor: oe
    } = h.selection, ue = ie.leaf(h, oe.path), me = Yn(ue, Y4);
    if (!he.equals(ue, H, {
      loose: !0
    })) {
      j.hasMarkPlaceholder = !0;
      var V = Object.fromEntries(Object.keys(me).map((C) => [C, null]));
      R.push(Sn(Sn(Sn({
        [Jv]: !0
      }, V), H), {}, {
        anchor: oe,
        focus: oe
      }));
    }
  }
  je(() => {
    setTimeout(() => {
      var {
        selection: C
      } = h;
      if (C) {
        var {
          anchor: M
        } = C, P = ie.leaf(h, M.path);
        if (H && !he.equals(P, H, {
          loose: !0
        })) {
          Lt.set(h, H);
          return;
        }
      }
      Lt.delete(h);
    });
  });
  var T = (t = Ea.get(h)) === null || t === void 0 || (n = t.getBoundingClientRect()) === null || n === void 0 ? void 0 : n.height;
  return /* @__PURE__ */ d.createElement(um.Provider, {
    value: s
  }, /* @__PURE__ */ d.createElement(im.Provider, {
    value: a
  }, /* @__PURE__ */ d.createElement(C4, {
    node: x,
    receivedUserInput: F
  }, /* @__PURE__ */ d.createElement(m, Object.assign({
    role: s ? void 0 : "textbox",
    "aria-multiline": s ? void 0 : !0
  }, g, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: Cr || !go ? g.spellCheck : !1,
    autoCorrect: Cr || !go ? g.autoCorrect : "false",
    autoCapitalize: Cr || !go ? g.autoCapitalize : "false",
    "data-slate-editor": !0,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !s,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: !0,
    ref: x,
    style: Sn(Sn({}, v ? {} : Sn({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Prevent the default outline styles.
      outline: "none",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, T ? {
      minHeight: T
    } : {})), p),
    onBeforeInput: Le((C) => {
      if (!Cr && !s && !yt(C, g.onBeforeInput) && ee.hasSelectableTarget(h, C.target) && (C.preventDefault(), !ee.isComposing(h))) {
        var M = C.data;
        b.insertText(h, M);
      }
    }, [s]),
    onInput: Le((C) => {
      if (q) {
        q.handleInput();
        return;
      }
      for (var M of O.current)
        M();
      O.current = [];
    }, []),
    onBlur: Le((C) => {
      if (!(s || j.isUpdatingSelection || !ee.hasSelectableTarget(h, C.target) || yt(C, g.onBlur))) {
        var M = ee.findDocumentOrShadowRoot(h);
        if (j.latestElement !== M.activeElement) {
          var {
            relatedTarget: P
          } = C, W = ee.toDOMNode(h, h);
          if (P !== W && !(Mt(P) && P.hasAttribute("data-slate-spacer"))) {
            if (P != null && un(P) && ee.hasDOMNode(h, P)) {
              var z = ee.toSlateNode(h, P);
              if (fe.isElement(z) && !h.isVoid(z))
                return;
            }
            if (vs) {
              var K = M.getSelection();
              K == null || K.removeAllRanges();
            }
            qr.delete(h);
          }
        }
      }
    }, [s, g.onBlur]),
    onClick: Le((C) => {
      if (ee.hasTarget(h, C.target) && !yt(C, g.onClick) && un(C.target)) {
        var M = ee.toSlateNode(h, C.target), P = ee.findPath(h, M);
        if (!b.hasPath(h, P) || ie.get(h, P) !== M)
          return;
        if (C.detail === m4 && P.length >= 1) {
          var W = P;
          if (!(fe.isElement(M) && b.isBlock(h, M))) {
            var z, K = b.above(h, {
              match: (be) => fe.isElement(be) && b.isBlock(h, be),
              at: P
            });
            W = (z = K == null ? void 0 : K[1]) !== null && z !== void 0 ? z : P.slice(0, 1);
          }
          var X = b.range(h, W);
          re.select(h, X);
          return;
        }
        if (s)
          return;
        var G = b.start(h, P), te = b.end(h, P), se = b.void(h, {
          at: G
        }), Z = b.void(h, {
          at: te
        });
        if (se && Z && A.equals(se[1], Z[1])) {
          var ne = b.range(h, G);
          re.select(h, ne);
        }
      }
    }, [s, g.onClick]),
    onCompositionEnd: Le((C) => {
      if (ee.hasSelectableTarget(h, C.target)) {
        if (ee.isComposing(h) && (S(!1), Xr.set(h, !1)), q == null || q.handleCompositionEnd(C), yt(C, g.onCompositionEnd) || jt)
          return;
        if (!vs && !Jk && !Gk && !t4 && !e4 && C.data) {
          var M = Lt.get(h);
          Lt.delete(h), M !== void 0 && (fr.set(h, h.marks), h.marks = M), b.insertText(h, C.data);
          var P = fr.get(h);
          fr.delete(h), P !== void 0 && (h.marks = P);
        }
      }
    }, [g.onCompositionEnd]),
    onCompositionUpdate: Le((C) => {
      ee.hasSelectableTarget(h, C.target) && !yt(C, g.onCompositionUpdate) && (ee.isComposing(h) || (S(!0), Xr.set(h, !0)));
    }, [g.onCompositionUpdate]),
    onCompositionStart: Le((C) => {
      if (ee.hasSelectableTarget(h, C.target)) {
        if (q == null || q.handleCompositionStart(C), yt(C, g.onCompositionStart) || jt)
          return;
        S(!0);
        var {
          selection: M
        } = h;
        if (M) {
          if (Y.isExpanded(M)) {
            b.deleteFragment(h);
            return;
          }
          var P = b.above(h, {
            match: (K) => fe.isElement(K) && b.isInline(h, K),
            mode: "highest"
          });
          if (P) {
            var [, W] = P;
            if (b.isEnd(h, M.anchor, W)) {
              var z = b.after(h, W);
              re.setSelection(h, {
                anchor: z,
                focus: z
              });
            }
          }
        }
      }
    }, [g.onCompositionStart]),
    onCopy: Le((C) => {
      ee.hasSelectableTarget(h, C.target) && !yt(C, g.onCopy) && (C.preventDefault(), ee.setFragmentData(h, C.clipboardData, "copy"));
    }, [g.onCopy]),
    onCut: Le((C) => {
      if (!s && ee.hasSelectableTarget(h, C.target) && !yt(C, g.onCut)) {
        C.preventDefault(), ee.setFragmentData(h, C.clipboardData, "cut");
        var {
          selection: M
        } = h;
        if (M)
          if (Y.isExpanded(M))
            b.deleteFragment(h);
          else {
            var P = ie.parent(h, M.anchor.path);
            b.isVoid(h, P) && re.delete(h);
          }
      }
    }, [s, g.onCut]),
    onDragOver: Le((C) => {
      if (ee.hasTarget(h, C.target) && !yt(C, g.onDragOver)) {
        var M = ee.toSlateNode(h, C.target);
        fe.isElement(M) && b.isVoid(h, M) && C.preventDefault();
      }
    }, [g.onDragOver]),
    onDragStart: Le((C) => {
      if (!s && ee.hasTarget(h, C.target) && !yt(C, g.onDragStart)) {
        var M = ee.toSlateNode(h, C.target), P = ee.findPath(h, M), W = fe.isElement(M) && b.isVoid(h, M) || b.void(h, {
          at: P,
          voids: !0
        });
        if (W) {
          var z = b.range(h, P);
          re.select(h, z);
        }
        j.isDraggingInternally = !0, ee.setFragmentData(h, C.dataTransfer, "drag");
      }
    }, [s, g.onDragStart]),
    onDrop: Le((C) => {
      if (!s && ee.hasTarget(h, C.target) && !yt(C, g.onDrop)) {
        C.preventDefault();
        var M = h.selection, P = ee.findEventRange(h, C), W = C.dataTransfer;
        re.select(h, P), j.isDraggingInternally && M && !Y.equals(M, P) && !b.void(h, {
          at: P,
          voids: !0
        }) && re.delete(h, {
          at: M
        }), ee.insertData(h, W), ee.isFocused(h) || ee.focus(h);
      }
      j.isDraggingInternally = !1;
    }, [s, g.onDrop]),
    onDragEnd: Le((C) => {
      !s && j.isDraggingInternally && g.onDragEnd && ee.hasTarget(h, C.target) && g.onDragEnd(C), j.isDraggingInternally = !1;
    }, [s, g.onDragEnd]),
    onFocus: Le((C) => {
      if (!s && !j.isUpdatingSelection && ee.hasEditableTarget(h, C.target) && !yt(C, g.onFocus)) {
        var M = ee.toDOMNode(h, h), P = ee.findDocumentOrShadowRoot(h);
        if (j.latestElement = P.activeElement, Yo && C.target !== M) {
          M.focus();
          return;
        }
        qr.set(h, !0);
      }
    }, [s, g.onFocus]),
    onKeyDown: Le((C) => {
      if (!s && ee.hasEditableTarget(h, C.target)) {
        q == null || q.handleKeyDown(C);
        var {
          nativeEvent: M
        } = C;
        if (ee.isComposing(h) && M.isComposing === !1 && (Xr.set(h, !1), S(!1)), yt(C, g.onKeyDown) || ee.isComposing(h))
          return;
        var {
          selection: P
        } = h, W = h.children[P !== null ? P.focus.path[0] : 0], z = _v(ie.string(W)) === "rtl";
        if (Xe.isRedo(M)) {
          C.preventDefault();
          var K = h;
          typeof K.redo == "function" && K.redo();
          return;
        }
        if (Xe.isUndo(M)) {
          C.preventDefault();
          var X = h;
          typeof X.undo == "function" && X.undo();
          return;
        }
        if (Xe.isMoveLineBackward(M)) {
          C.preventDefault(), re.move(h, {
            unit: "line",
            reverse: !0
          });
          return;
        }
        if (Xe.isMoveLineForward(M)) {
          C.preventDefault(), re.move(h, {
            unit: "line"
          });
          return;
        }
        if (Xe.isExtendLineBackward(M)) {
          C.preventDefault(), re.move(h, {
            unit: "line",
            edge: "focus",
            reverse: !0
          });
          return;
        }
        if (Xe.isExtendLineForward(M)) {
          C.preventDefault(), re.move(h, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (Xe.isMoveBackward(M)) {
          C.preventDefault(), P && Y.isCollapsed(P) ? re.move(h, {
            reverse: !z
          }) : re.collapse(h, {
            edge: "start"
          });
          return;
        }
        if (Xe.isMoveForward(M)) {
          C.preventDefault(), P && Y.isCollapsed(P) ? re.move(h, {
            reverse: z
          }) : re.collapse(h, {
            edge: "end"
          });
          return;
        }
        if (Xe.isMoveWordBackward(M)) {
          C.preventDefault(), P && Y.isExpanded(P) && re.collapse(h, {
            edge: "focus"
          }), re.move(h, {
            unit: "word",
            reverse: !z
          });
          return;
        }
        if (Xe.isMoveWordForward(M)) {
          C.preventDefault(), P && Y.isExpanded(P) && re.collapse(h, {
            edge: "focus"
          }), re.move(h, {
            unit: "word",
            reverse: z
          });
          return;
        }
        if (Cr) {
          if ((nm || vs) && P && (Xe.isDeleteBackward(M) || Xe.isDeleteForward(M)) && Y.isCollapsed(P)) {
            var G = ie.parent(h, P.anchor.path);
            if (fe.isElement(G) && b.isVoid(h, G) && (b.isInline(h, G) || b.isBlock(h, G))) {
              C.preventDefault(), b.deleteBackward(h, {
                unit: "block"
              });
              return;
            }
          }
        } else {
          if (Xe.isBold(M) || Xe.isItalic(M) || Xe.isTransposeCharacter(M)) {
            C.preventDefault();
            return;
          }
          if (Xe.isSoftBreak(M)) {
            C.preventDefault(), b.insertSoftBreak(h);
            return;
          }
          if (Xe.isSplitBlock(M)) {
            C.preventDefault(), b.insertBreak(h);
            return;
          }
          if (Xe.isDeleteBackward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "backward"
            }) : b.deleteBackward(h);
            return;
          }
          if (Xe.isDeleteForward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "forward"
            }) : b.deleteForward(h);
            return;
          }
          if (Xe.isDeleteLineBackward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "backward"
            }) : b.deleteBackward(h, {
              unit: "line"
            });
            return;
          }
          if (Xe.isDeleteLineForward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "forward"
            }) : b.deleteForward(h, {
              unit: "line"
            });
            return;
          }
          if (Xe.isDeleteWordBackward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "backward"
            }) : b.deleteBackward(h, {
              unit: "word"
            });
            return;
          }
          if (Xe.isDeleteWordForward(M)) {
            C.preventDefault(), P && Y.isExpanded(P) ? b.deleteFragment(h, {
              direction: "forward"
            }) : b.deleteForward(h, {
              unit: "word"
            });
            return;
          }
        }
      }
    }, [s, g.onKeyDown]),
    onPaste: Le((C) => {
      !s && ee.hasSelectableTarget(h, C.target) && !yt(C, g.onPaste) && (!Cr || Hk(C.nativeEvent)) && (C.preventDefault(), ee.insertData(h, C.clipboardData));
    }, [s, g.onPaste])
  }), /* @__PURE__ */ d.createElement(H4, {
    decorations: R,
    node: h,
    renderElement: u,
    renderPlaceholder: c,
    renderLeaf: l,
    selection: h.selection
  })))));
}, z4 = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ d.createElement("span", Object.assign({}, t), n, jt && /* @__PURE__ */ d.createElement("br", null))
  );
}, K4 = () => [], U4 = (e, t) => {
  if (t.getBoundingClientRect && (!e.selection || e.selection && Y.isCollapsed(e.selection))) {
    var n = t.startContainer.parentElement;
    n.getBoundingClientRect = t.getBoundingClientRect.bind(t), fk(n, {
      scrollMode: "if-needed"
    }), delete n.getBoundingClientRect;
  }
}, yt = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? (e.isDefaultPrevented() || e.isPropagationStopped());
}, q4 = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? e.defaultPrevented;
}, X4 = /* @__PURE__ */ Ir(!1), G4 = /* @__PURE__ */ Ir({});
function Q4(e) {
  var t = ve([]).current, n = ve({
    editor: e
  }).current, r = Le((o) => {
    n.editor = o, t.forEach((i) => i(o));
  }, []), a = Nn(() => ({
    getSlate: () => n.editor,
    addEventListener: (o) => (t.push(o), () => {
      t.splice(t.indexOf(o), 1);
    })
  }), [t, n]);
  return {
    selectorContext: a,
    onChange: r
  };
}
var Z4 = ["editor", "children", "onChange", "value"], J4 = (e) => {
  var {
    editor: t,
    children: n,
    onChange: r,
    value: a
  } = e, o = Yn(e, Z4), i = ve(!1), [s, u] = d.useState(() => {
    if (!ie.isNodeList(a))
      throw new Error("[Slate] value is invalid! Expected a list of elements but got: ".concat(nt.stringify(a)));
    if (!b.isEditor(t))
      throw new Error("[Slate] editor is invalid! You passed: ".concat(nt.stringify(t)));
    return t.children = a, Object.assign(t, o), {
      v: 0,
      editor: t
    };
  }), {
    selectorContext: l,
    onChange: c
  } = Q4(t), f = Le(() => {
    r && r(t.children), u((v) => ({
      v: v.v + 1,
      editor: t
    })), c(t);
  }, [r]);
  je(() => (du.set(t, f), () => {
    du.set(t, () => {
    }), i.current = !0;
  }), []);
  var [p, m] = Ne(ee.isFocused(t));
  return je(() => {
    m(ee.isFocused(t));
  }), en(() => {
    var v = () => m(ee.isFocused(t));
    return Xk ? (document.addEventListener("focusin", v), document.addEventListener("focusout", v), () => {
      document.removeEventListener("focusin", v), document.removeEventListener("focusout", v);
    }) : (document.addEventListener("focus", v, !0), document.addEventListener("blur", v, !0), () => {
      document.removeEventListener("focus", v, !0), document.removeEventListener("blur", v, !0);
    });
  }, []), /* @__PURE__ */ d.createElement(G4.Provider, {
    value: l
  }, /* @__PURE__ */ d.createElement(lm.Provider, {
    value: s
  }, /* @__PURE__ */ d.createElement(_l.Provider, {
    value: s.editor
  }, /* @__PURE__ */ d.createElement(X4.Provider, {
    value: p
  }, n))));
}, _f = (e, t) => {
  var n = (t.top + t.bottom) / 2;
  return e.top <= n && e.bottom >= n;
}, Nf = (e, t, n) => {
  var r = ee.toDOMRange(e, t).getBoundingClientRect(), a = ee.toDOMRange(e, n).getBoundingClientRect();
  return _f(r, a) && _f(a, r);
}, e7 = (e, t) => {
  var n = b.range(e, Y.end(t)), r = Array.from(b.positions(e, {
    at: t
  })), a = 0, o = r.length, i = Math.floor(o / 2);
  if (Nf(e, b.range(e, r[a]), n))
    return b.range(e, r[a], n);
  if (r.length < 2)
    return b.range(e, r[r.length - 1], n);
  for (; i !== r.length && i !== a; )
    Nf(e, b.range(e, r[i]), n) ? o = i : a = i, i = Math.floor((a + o) / 2);
  return b.range(e, r[o], n);
};
function If(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? If(Object(n), !0).forEach(function(r) {
      vi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : If(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var t7 = (e) => {
  var t = e, {
    apply: n,
    onChange: r,
    deleteBackward: a,
    addMark: o,
    removeMark: i
  } = t;
  return gi.set(t, /* @__PURE__ */ new WeakMap()), t.addMark = (s, u) => {
    var l, c;
    (l = Ml.get(t)) === null || l === void 0 || l(), !Lt.get(t) && (c = bt.get(t)) !== null && c !== void 0 && c.length && Lt.set(t, null), fr.delete(t), o(s, u);
  }, t.removeMark = (s) => {
    var u;
    !Lt.get(t) && (u = bt.get(t)) !== null && u !== void 0 && u.length && Lt.set(t, null), fr.delete(t), i(s);
  }, t.deleteBackward = (s) => {
    if (s !== "line")
      return a(s);
    if (t.selection && Y.isCollapsed(t.selection)) {
      var u = b.above(t, {
        match: (p) => fe.isElement(p) && b.isBlock(t, p),
        at: t.selection
      });
      if (u) {
        var [, l] = u, c = b.range(t, l, t.selection.anchor), f = e7(t, c);
        Y.isCollapsed(f) || re.delete(t, {
          at: f
        });
      }
    }
  }, t.apply = (s) => {
    var u = [], l = bt.get(t);
    if (l != null && l.length) {
      var c = l.map((O) => B4(O, s)).filter(Boolean);
      bt.set(t, c);
    }
    var f = $r.get(t);
    f && $r.set(t, Pf(t, f, s));
    var p = Sr.get(t);
    if (p != null && p.at) {
      var m = De.isPoint(p == null ? void 0 : p.at) ? hu(t, p.at, s) : Pf(t, p.at, s);
      Sr.set(t, m ? Lf(Lf({}, p), {}, {
        at: m
      }) : null);
    }
    switch (s.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        u.push(...so(t, s.path));
        break;
      }
      case "set_selection": {
        var v;
        (v = xa.get(t)) === null || v === void 0 || v.unref(), xa.delete(t);
        break;
      }
      case "insert_node":
      case "remove_node": {
        u.push(...so(t, A.parent(s.path)));
        break;
      }
      case "merge_node": {
        var g = A.previous(s.path);
        u.push(...so(t, g));
        break;
      }
      case "move_node": {
        var h = A.common(A.parent(s.path), A.parent(s.newPath));
        u.push(...so(t, h));
        break;
      }
    }
    n(s);
    for (var [w, S] of u) {
      var [x] = b.node(t, w);
      lu.set(x, S);
    }
  }, t.setFragmentData = (s) => {
    var {
      selection: u
    } = t;
    if (u) {
      var [l, c] = Y.edges(u), f = b.void(t, {
        at: l.path
      }), p = b.void(t, {
        at: c.path
      });
      if (!(Y.isCollapsed(u) && !f)) {
        var m = ee.toDOMRange(t, u), v = m.cloneContents(), g = v.childNodes[0];
        if (v.childNodes.forEach((j) => {
          j.textContent && j.textContent.trim() !== "" && (g = j);
        }), p) {
          var [h] = p, w = m.cloneRange(), S = ee.toDOMNode(t, h);
          w.setEndAfter(S), v = w.cloneContents();
        }
        if (f && (g = v.querySelector("[data-slate-spacer]")), Array.from(v.querySelectorAll("[data-slate-zero-width]")).forEach((j) => {
          var I = j.getAttribute("data-slate-zero-width") === "n";
          j.textContent = I ? `
` : "";
        }), em(g)) {
          var x = g.ownerDocument.createElement("span");
          x.style.whiteSpace = "pre", x.appendChild(g), v.appendChild(x), g = x;
        }
        var O = t.getFragment(), B = JSON.stringify(O), F = window.btoa(encodeURIComponent(B));
        g.setAttribute("data-slate-fragment", F), s.setData("application/x-slate-fragment", F);
        var L = v.ownerDocument.createElement("div");
        return L.appendChild(v), L.setAttribute("hidden", "true"), v.ownerDocument.body.appendChild(L), s.setData("text/html", L.innerHTML), s.setData("text/plain", rm(L)), v.ownerDocument.body.removeChild(L), s;
      }
    }
  }, t.insertData = (s) => {
    t.insertFragmentData(s) || t.insertTextData(s);
  }, t.insertFragmentData = (s) => {
    var u = s.getData("application/x-slate-fragment") || qk(s);
    if (u) {
      var l = decodeURIComponent(window.atob(u)), c = JSON.parse(l);
      return t.insertFragment(c), !0;
    }
    return !1;
  }, t.insertTextData = (s) => {
    var u = s.getData("text/plain");
    if (u) {
      var l = u.split(/\r\n|\r|\n/), c = !1;
      for (var f of l)
        c && re.splitNodes(t, {
          always: !0
        }), t.insertText(f), c = !0;
      return !0;
    }
    return !1;
  }, t.onChange = () => {
    Tu.unstable_batchedUpdates(() => {
      var s = du.get(t);
      s && s(), r();
    });
  }, t;
}, so = (e, t) => {
  var n = [];
  for (var [r, a] of b.levels(e, {
    at: t
  })) {
    var o = ee.findKey(e, r);
    n.push([a, o]);
  }
  return n;
}, r7 = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(e) {
    return ut(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || Or.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || Or.isOperationList(e.undos[0].operations));
  }
}, gs = /* @__PURE__ */ new WeakMap(), ys = /* @__PURE__ */ new WeakMap(), An = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(e) {
    return r7.isHistory(e.history) && b.isEditor(e);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(e) {
    return ys.get(e);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(e) {
    return gs.get(e);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(e) {
    e.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(e) {
    e.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(e, t) {
    var n = An.isMerging(e);
    ys.set(e, !1), t(), ys.set(e, n);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(e, t) {
    var n = An.isSaving(e);
    gs.set(e, !1), t(), gs.set(e, n);
  }
}, n7 = (e) => {
  var t = e, {
    apply: n
  } = t;
  return t.history = {
    undos: [],
    redos: []
  }, t.redo = () => {
    var {
      history: r
    } = t, {
      redos: a
    } = r;
    if (a.length > 0) {
      var o = a[a.length - 1];
      o.selectionBefore && re.setSelection(t, o.selectionBefore), An.withoutSaving(t, () => {
        b.withoutNormalizing(t, () => {
          for (var i of o.operations)
            t.apply(i);
        });
      }), r.redos.pop(), r.undos.push(o);
    }
  }, t.undo = () => {
    var {
      history: r
    } = t, {
      undos: a
    } = r;
    if (a.length > 0) {
      var o = a[a.length - 1];
      An.withoutSaving(t, () => {
        b.withoutNormalizing(t, () => {
          var i = o.operations.map(Or.inverse).reverse();
          for (var s of i)
            t.apply(s);
          o.selectionBefore && re.setSelection(t, o.selectionBefore);
        });
      }), r.redos.push(o), r.undos.pop();
    }
  }, t.apply = (r) => {
    var {
      operations: a,
      history: o
    } = t, {
      undos: i
    } = o, s = i[i.length - 1], u = s && s.operations[s.operations.length - 1], l = An.isSaving(t), c = An.isMerging(t);
    if (l == null && (l = o7(r)), l) {
      if (c == null && (s == null ? c = !1 : a.length !== 0 ? c = !0 : c = a7(r, u)), s && c)
        s.operations.push(r);
      else {
        var f = {
          operations: [r],
          selectionBefore: t.selection
        };
        i.push(f);
      }
      for (; i.length > 100; )
        i.shift();
      o.redos = [];
    }
    n(r);
  }, t;
}, a7 = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && A.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && A.equals(e.path, t.path)), o7 = (e, t) => e.type !== "set_selection", br = {};
Object.defineProperty(br, "__esModule", {
  value: !0
});
var i7 = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), bs = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, fm = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: i7 ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, Nl = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var uo = 1; uo < 20; uo++)
  Nl["f" + uo] = 111 + uo;
function yi(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(i) {
    return pm(i, t);
  }), a = function(s) {
    return r.some(function(u) {
      return hm(u, s);
    });
  }, o = n == null ? a : a(n);
  return o;
}
function s7(e, t) {
  return yi(e, t);
}
function u7(e, t) {
  return yi(e, { byKey: !0 }, t);
}
function pm(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var a = e.split("+"), o = a.length;
  for (var i in bs)
    r[bs[i]] = !1;
  var s = !0, u = !1, l = void 0;
  try {
    for (var c = a[Symbol.iterator](), f; !(s = (f = c.next()).done); s = !0) {
      var p = f.value, m = p.endsWith("?") && p.length > 1;
      m && (p = p.slice(0, -1));
      var v = Il(p), g = bs[v];
      if (p.length > 1 && !g && !fm[p] && !Nl[v])
        throw new TypeError('Unknown modifier: "' + p + '"');
      (o === 1 || !g) && (n ? r.key = v : r.which = vm(p)), g && (r[g] = m ? null : !0);
    }
  } catch (h) {
    u = !0, l = h;
  } finally {
    try {
      !s && c.return && c.return();
    } finally {
      if (u)
        throw l;
    }
  }
  return r;
}
function hm(e, t) {
  for (var n in e) {
    var r = e[n], a = void 0;
    if (r != null && (n === "key" && t.key != null ? a = t.key.toLowerCase() : n === "which" ? a = r === 91 && t.which === 93 ? 91 : t.which : a = t[n], !(a == null && r === !1) && a !== r))
      return !1;
  }
  return !0;
}
function vm(e) {
  e = Il(e);
  var t = Nl[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function Il(e) {
  return e = e.toLowerCase(), e = fm[e] || e, e;
}
var l7 = br.default = yi;
br.isHotkey = yi;
br.isCodeHotkey = s7;
br.isKeyHotkey = u7;
br.parseHotkey = pm;
br.compareHotkey = hm;
br.toKeyCode = vm;
br.toKeyName = Il;
var Wt = /* @__PURE__ */ ((e) => (e.PARAGRAPH = "paragraph", e.NUMBERED_LIST = "numbered-list", e.BULLETED_LIST = "bulleted-list", e.LIST_ITEM = "list-item", e.BLOCK_QUOTE = "block-quote", e))(Wt || {});
const c7 = D.blockquote`
  border-left: 2px solid #ddd;
  margin-left: 0;
  margin-right: 0;
  padding-left: 10px;
  color: #aaa;
  font-style: italic;
`, d7 = D.code`
  font-family: monospace;
  background-color: #eee;
  font-size: 13px;
  padding: 3px;
`, f7 = D.div`
  padding: 0;
  margin: 0;
`, mm = ({ children: e, leaf: t, attributes: n }) => {
  let r = e;
  return t.bold && (r = /* @__PURE__ */ d.createElement("strong", null, r)), t.code && (r = /* @__PURE__ */ d.createElement(d7, null, r)), t.italic && (r = /* @__PURE__ */ d.createElement("em", null, r)), t.underline && (r = /* @__PURE__ */ d.createElement("u", null, r)), t.link && (r = /* @__PURE__ */ d.createElement("a", { target: "_blank", rel: "noreferrer", href: t.url }, r)), /* @__PURE__ */ d.createElement("span", { ...n }, r);
}, gm = ({ children: e, element: t, attributes: n }) => {
  switch (t.type) {
    case Wt.BLOCK_QUOTE:
      return /* @__PURE__ */ d.createElement(c7, { ...n }, e);
    case Wt.BULLETED_LIST:
      return /* @__PURE__ */ d.createElement("ul", { ...n }, e);
    case Wt.NUMBERED_LIST:
      return /* @__PURE__ */ d.createElement("ol", { ...n }, e);
    case Wt.LIST_ITEM:
      return /* @__PURE__ */ d.createElement("li", { ...n }, e);
    default:
      return /* @__PURE__ */ d.createElement(f7, { ...n }, e);
  }
}, ym = (e) => !e || !e.length ? null : e.map((t, n) => {
  const r = () => p7(t);
  let a = n.toString();
  return "text" in t ? a += t.text : a += t.type, /* @__PURE__ */ d.createElement(r, { key: a });
}), p7 = (e) => {
  if ("text" in e)
    return /* @__PURE__ */ d.createElement(mm, { leaf: e }, e.text);
  const t = ym(e.children);
  return e.type ? /* @__PURE__ */ d.createElement(gm, { element: e }, t) : /* @__PURE__ */ d.createElement(d.Fragment, null, t);
}, Ll = (e) => e.map((t) => ie.string(t)).join(`
`), h7 = (e) => e.length === 0 ? null : ym(e), v7 = (e) => e.some((t) => {
  if (fe.isElement(t))
    return t.type !== "paragraph" || v7(t.children);
  if (he.isText(t)) {
    const n = t;
    if (Object.keys(n).some(
      (r) => (r.startsWith("bold") || r.startsWith("italic") || r.startsWith("underline") || r.startsWith("code") || r.startsWith("link") || r.startsWith("subscript") || r.startsWith("superscript")) && n[r] === !0
    ))
      return !0;
  }
  return !1;
}), jf = ["numbered-list", "bulleted-list"], Wf = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code"
}, Ho = (e, t) => {
  const { selection: n } = e;
  if (!n)
    return !1;
  const [r] = Array.from(
    b.nodes(e, {
      at: b.unhangRange(e, n),
      match: (a) => !b.isEditor(a) && fe.isElement(a) && a.type === t
    })
  );
  return !!r;
}, Pr = (e, t) => {
  const n = b.marks(e);
  return n ? n[t] === !0 : !1;
}, Yf = (e, t) => {
  const n = Ho(e, t), r = jf.includes(t);
  !e.selection && Ll(e.children).length === 0 && (e.selection = {
    anchor: {
      path: [0, 0],
      offset: 0
    },
    focus: {
      path: [0, 0],
      offset: 0
    }
  }), re.unwrapNodes(e, {
    match: (o) => !b.isEditor(o) && fe.isElement(o) && jf.includes(o.type),
    split: !0
  });
  const a = { type: t };
  if (n ? a.type = Wt.PARAGRAPH : r && (a.type = Wt.LIST_ITEM), re.setNodes(e, a), !n && r) {
    const o = { type: t, children: [] };
    re.wrapNodes(e, o);
  }
}, Vo = (e, t) => {
  const n = Pr(e, t);
  !e.selection && Ll(e.children).length === 0 && (e.selection = {
    anchor: {
      path: [0, 0],
      offset: 0
    },
    focus: {
      path: [0, 0],
      offset: 0
    }
  }), n ? b.removeMark(e, t) : b.addMark(e, t, !0);
}, m7 = (e, t) => {
  Object.keys(Wf).forEach((n) => {
    if (l7(n, e)) {
      e.preventDefault();
      const r = Wf[n];
      Vo(t, r);
    }
  });
};
var jl = {}, g7 = We, y7 = Ye;
Object.defineProperty(jl, "__esModule", {
  value: !0
});
var bm = jl.default = void 0, b7 = y7(d), w7 = g7(He()), D7 = (0, w7.default)(/* @__PURE__ */ b7.createElement("path", {
  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), "FormatBold");
bm = jl.default = D7;
var Wl = {}, C7 = We, E7 = Ye;
Object.defineProperty(Wl, "__esModule", {
  value: !0
});
var wm = Wl.default = void 0, x7 = E7(d), S7 = C7(He()), $7 = (0, S7.default)(/* @__PURE__ */ x7.createElement("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
}), "FormatItalic");
wm = Wl.default = $7;
var Yl = {}, k7 = We, O7 = Ye;
Object.defineProperty(Yl, "__esModule", {
  value: !0
});
var Dm = Yl.default = void 0, B7 = O7(d), T7 = k7(He()), A7 = (0, T7.default)(/* @__PURE__ */ B7.createElement("path", {
  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
}), "FormatUnderlined");
Dm = Yl.default = A7;
var Hl = {}, P7 = We, M7 = Ye;
Object.defineProperty(Hl, "__esModule", {
  value: !0
});
var Cm = Hl.default = void 0, F7 = M7(d), R7 = P7(He()), _7 = (0, R7.default)(/* @__PURE__ */ F7.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
}), "FormatQuote");
Cm = Hl.default = _7;
var Vl = {}, N7 = We, I7 = Ye;
Object.defineProperty(Vl, "__esModule", {
  value: !0
});
var Em = Vl.default = void 0, L7 = I7(d), j7 = N7(He()), W7 = (0, j7.default)(/* @__PURE__ */ L7.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
}), "Code");
Em = Vl.default = W7;
var zl = {}, Y7 = We, H7 = Ye;
Object.defineProperty(zl, "__esModule", {
  value: !0
});
var xm = zl.default = void 0, V7 = H7(d), z7 = Y7(He()), K7 = (0, z7.default)(/* @__PURE__ */ V7.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
}), "Link");
xm = zl.default = K7;
var Kl = {}, U7 = We, q7 = Ye;
Object.defineProperty(Kl, "__esModule", {
  value: !0
});
var Sm = Kl.default = void 0, X7 = q7(d), G7 = U7(He()), Q7 = (0, G7.default)(/* @__PURE__ */ X7.createElement("path", {
  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
}), "FormatListBulleted");
Sm = Kl.default = Q7;
var Ul = {}, Z7 = We, J7 = Ye;
Object.defineProperty(Ul, "__esModule", {
  value: !0
});
var $m = Ul.default = void 0, eO = J7(d), tO = Z7(He()), rO = (0, tO.default)(/* @__PURE__ */ eO.createElement("path", {
  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
}), "FormatListNumbered");
$m = Ul.default = rO;
const ql = D.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  ${({ active: e }) => e && _`
      background-color: ${y.grey300};
      border-radius: 3px;
    `}

  &:hover,
  &:focus {
    background-color: ${y.grey300};
    border-radius: 3px;
  }
`, Hf = D(lx)`
  margin-bottom: ${k.L};
`, nO = D.div`
  display: flex;
  justify-content: end;
  gap: ${k.XS};
`, aO = ({ icon: e, linkPreviewComponent: t, updateCurrentLinkData: n }) => {
  const r = Va(), [a, o] = Ne(!1), [i, s] = Ne(""), [u, l] = Ne(""), [c, f] = Ne(!1), [p, m] = Ne(r.selection), [v, g] = Ne(!1), h = r.selection ? b.string(r, r.selection) : "", w = () => {
    Pr(r, "link") ? Vo(r, "link") : (m(r.selection), o(!0), s(h));
  }, { keyboardProps: S } = Jn({
    onKeyDown: (L) => (L.key === "Enter" || L.key === " ") && w()
  }), x = () => {
    o(!1), s(""), l(""), f(!1), g(!1), m(null);
  }, O = (L) => L.startsWith("https://") || L.startsWith("http://") ? L : `https://${L}`, B = () => {
    re.insertFragment(r, [{ text: i, link: !0, url: O(u) }]), setTimeout(() => {
      p && (re.select(r, p), re.collapse(r, { edge: "start" }), i.includes(".") && re.move(r, { distance: 1, unit: "line" }), re.move(r, { distance: i.length + 1, unit: "offset" }));
    }, 50), x();
  }, F = () => /^https:\/\/[^\s/$.?#].[^\s]*$/.test(u) ? "" : "Länken har fel format. OBS: Den måste börja med https://";
  return /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(
    ql,
    {
      ...S,
      type: "button",
      "aria-label": "format-link",
      "aria-pressed": Pr(r, "link"),
      active: Pr(r, "link"),
      onMouseDown: (L) => {
        L.preventDefault(), w();
      }
    },
    e
  ), a && /* @__PURE__ */ d.createElement(tD, { onClose: () => o(!1), isDismissable: !0, heading: "Skapa länk" }, /* @__PURE__ */ d.createElement("div", null, t, /* @__PURE__ */ d.createElement(
    Hf,
    {
      value: i,
      onChange: (L) => {
        n && n({ url: u, text: L }), s(L);
      },
      label: "Länktext",
      isRequired: !0,
      placeholder: "Skriv en länktext",
      onBlur: () => f(!0),
      errorMessage: c && i.trim().length === 0 && "Skriv en länktext"
    }
  ), /* @__PURE__ */ d.createElement(
    Hf,
    {
      value: u,
      onChange: (L) => {
        n && n({ url: L, text: i }), l(L);
      },
      label: "Länk",
      isRequired: !0,
      placeholder: "Lägg till en länk, till exempel https://www.google.se",
      onBlur: () => g(!0),
      errorMessage: v && F()
    }
  ), /* @__PURE__ */ d.createElement(nO, null, /* @__PURE__ */ d.createElement(hd, { color: "outlinedBlue", onClick: x }, "Abryt"), /* @__PURE__ */ d.createElement(
    hd,
    {
      isDisabled: i.trim().length === 0 || F() !== "",
      color: "blue",
      onClick: B
    },
    "Skapa"
  )))));
}, oO = aO, iO = ({ format: e, icon: t }) => {
  const n = Va(), { keyboardProps: r } = Jn({
    onKeyDown: (a) => (a.key === "Enter" || a.key === " ") && Yf(n, e)
  });
  return /* @__PURE__ */ d.createElement(
    ql,
    {
      ...r,
      type: "button",
      "aria-label": `format-${e}`,
      "aria-pressed": Ho(n, e),
      active: Ho(n, e),
      onMouseDown: (a) => {
        a.preventDefault(), Yf(n, e);
      }
    },
    t
  );
}, sO = iO, uO = ({ format: e, icon: t }) => {
  const n = Va(), { keyboardProps: r } = Jn({
    onKeyDown: (a) => (a.key === "Enter" || a.key === " ") && Vo(n, e)
  });
  return /* @__PURE__ */ d.createElement(
    ql,
    {
      ...r,
      type: "button",
      "aria-label": `format-${e}`,
      "aria-pressed": Pr(n, e),
      active: Pr(n, e),
      onMouseDown: (a) => {
        a.preventDefault(), Vo(n, e);
      }
    },
    t
  );
}, lO = uO, cO = D.div`
  display: flex;
  align-items: center;
  gap: 0.125rem;
  padding: ${k.XXS};
  border-bottom: 2px solid ${y.grey200};
  background-color: ${y.grey50};
`, ws = (e, t) => e === "bold" ? /* @__PURE__ */ d.createElement(bm, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === "italic" ? /* @__PURE__ */ d.createElement(wm, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === "underline" ? /* @__PURE__ */ d.createElement(Dm, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === "code" ? /* @__PURE__ */ d.createElement(Em, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === "block-quote" ? /* @__PURE__ */ d.createElement(Cm, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === "link" ? /* @__PURE__ */ d.createElement(xm, { fontSize: "small", style: { color: t ? y.black : y.grey600 } }) : e === Wt.BULLETED_LIST ? /* @__PURE__ */ d.createElement(
  Sm,
  {
    fontSize: "small",
    style: { color: t ? y.black : y.grey600 }
  }
) : e === Wt.NUMBERED_LIST ? /* @__PURE__ */ d.createElement(
  $m,
  {
    fontSize: "small",
    style: { color: t ? y.black : y.grey600 }
  }
) : null, dO = ({ formats: e, linkPreviewComponent: t, updateCurrentLinkData: n }) => {
  const r = Va();
  return /* @__PURE__ */ d.createElement(cO, null, e.marks.map((a) => /* @__PURE__ */ d.createElement(
    lO,
    {
      key: a,
      format: a,
      icon: ws(a, Pr(r, a))
    }
  )), e.link && /* @__PURE__ */ d.createElement(
    oO,
    {
      key: "link",
      icon: ws("link", Pr(r, "link")),
      linkPreviewComponent: t,
      updateCurrentLinkData: n
    }
  ), e.blocks.map((a) => /* @__PURE__ */ d.createElement(
    sO,
    {
      key: a,
      format: a,
      icon: ws(a, Ho(r, a))
    }
  )));
}, fO = dO, pO = D.div`
  display: flex;
  flex-direction: column;
`, hO = D.div`
  margin-top: ${k.XXS};
  border: 2px solid ${y.grey200};
  border-radius: ${k.XXS};
  transition: border-color 0.1s cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    border-color: ${y.grey400};
  }

  &:focus-within {
    border-color: ${({ hasErrorMessage: e }) => e ? y.clownRed : y.black};
  }

  ${({ hasErrorMessage: e }) => e && _`
      border-color: ${y.clownRed};
    `};
`, vO = D(V4)`
  padding: 0.75rem;
  min-height: 7rem;
`, mO = D.label`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${y.grey900};
`, gO = D(hn)`
  display: inline-flex;
  align-items: center;
  font-size: ${k.S};
  color: ${y.clownRed};
`, yO = D(gn)`
  margin-top: -2px; /* Visual alignment */
  margin-right: ${k.XXS};
`, bO = ({
  formats: e,
  isRequired: t,
  errorMessage: n,
  id: r,
  label: a,
  onChange: o,
  onBlur: i,
  value: s,
  linkPreviewComponent: u,
  updateCurrentLinkData: l,
  name: c,
  className: f
}) => {
  const p = Nn(() => n7(t7(cS())), []);
  p.children = s, "type" in s[0] && s[0].type !== Wt.BULLETED_LIST && s[0].type !== Wt.NUMBERED_LIST && Ll(s).length === 0 && re.select(p, {
    anchor: { path: [0, 0], offset: 0 },
    focus: { path: [0, 0], offset: 0 }
  });
  const m = Le(
    ({ children: h, ...w }) => /* @__PURE__ */ d.createElement(gm, { ...w }, h),
    []
  ), v = Le(
    ({ children: h, ...w }) => /* @__PURE__ */ d.createElement(mm, { ...w }, h),
    []
  ), g = (h) => {
    o(h);
  };
  return /* @__PURE__ */ d.createElement(J4, { editor: p, value: s, onChange: g }, /* @__PURE__ */ d.createElement(pO, { className: f }, a && /* @__PURE__ */ d.createElement(mO, { htmlFor: r }, `${a}${t ? "*" : ""}`), /* @__PURE__ */ d.createElement(hO, { hasErrorMessage: !!n }, /* @__PURE__ */ d.createElement(
    fO,
    {
      formats: e,
      linkPreviewComponent: u,
      updateCurrentLinkData: l
    }
  ), /* @__PURE__ */ d.createElement(
    vO,
    {
      id: r,
      onBlur: i,
      renderElement: m,
      renderLeaf: v,
      onKeyDown: (h) => m7(h, p),
      name: c
    }
  )), n && /* @__PURE__ */ d.createElement(gO, null, /* @__PURE__ */ d.createElement(yO, { fontSize: "inherit" }), " ", n)));
}, bM = bO;
var km = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], a = 0; a < arguments.length; a++) {
        var o = arguments[a];
        if (o) {
          var i = typeof o;
          if (i === "string" || i === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (i === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var u in o)
              t.call(o, u) && o[u] && r.push(u);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(km);
var wO = km.exports;
const pt = /* @__PURE__ */ gr(wO);
function ce(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function bi(e) {
  return ce(1, arguments), e instanceof Date || ht(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function pe(e) {
  ce(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ht(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Fa(e) {
  if (ce(1, arguments), !bi(e) && typeof e != "number")
    return !1;
  var t = pe(e);
  return !isNaN(Number(t));
}
function Ce(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Xl(e, t) {
  ce(2, arguments);
  var n = pe(e).getTime(), r = Ce(t);
  return new Date(n + r);
}
function Om(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Xl(e, -n);
}
var DO = 864e5;
function CO(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), a = n - r;
  return Math.floor(a / DO) + 1;
}
function zn(e) {
  ce(1, arguments);
  var t = 1, n = pe(e), r = n.getUTCDay(), a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function Bm(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = zn(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = zn(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function EO(e) {
  ce(1, arguments);
  var t = Bm(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = zn(n);
  return r;
}
var xO = 6048e5;
function Tm(e) {
  ce(1, arguments);
  var t = pe(e), n = zn(t).getTime() - EO(t).getTime();
  return Math.round(n / xO) + 1;
}
var SO = {};
function yn() {
  return SO;
}
function ln(e, t) {
  var n, r, a, o, i, s, u, l;
  ce(1, arguments);
  var c = yn(), f = Ce((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = pe(e), m = p.getUTCDay(), v = (m < f ? 7 : 0) + m - f;
  return p.setUTCDate(p.getUTCDate() - v), p.setUTCHours(0, 0, 0, 0), p;
}
function Gl(e, t) {
  var n, r, a, o, i, s, u, l;
  ce(1, arguments);
  var c = pe(e), f = c.getUTCFullYear(), p = yn(), m = Ce((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(f + 1, 0, m), v.setUTCHours(0, 0, 0, 0);
  var g = ln(v, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, m), h.setUTCHours(0, 0, 0, 0);
  var w = ln(h, t);
  return c.getTime() >= g.getTime() ? f + 1 : c.getTime() >= w.getTime() ? f : f - 1;
}
function $O(e, t) {
  var n, r, a, o, i, s, u, l;
  ce(1, arguments);
  var c = yn(), f = Ce((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = Gl(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(p, 0, f), m.setUTCHours(0, 0, 0, 0);
  var v = ln(m, t);
  return v;
}
var kO = 6048e5;
function Am(e, t) {
  ce(1, arguments);
  var n = pe(e), r = ln(n, t).getTime() - $O(n, t).getTime();
  return Math.round(r / kO) + 1;
}
function Me(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var OO = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return Me(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Me(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return Me(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return Me(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return Me(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return Me(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return Me(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, a = t.getUTCMilliseconds(), o = Math.floor(a * Math.pow(10, r - 3));
    return Me(o, n.length);
  }
};
const Er = OO;
var $n = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, BO = {
  // Era
  G: function(t, n, r) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var a = t.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return Er.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, a) {
    var o = Gl(t, a), i = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var s = i % 100;
      return Me(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : Me(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = Bm(t);
    return Me(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return Me(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return Me(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return Me(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Er.M(t, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return Me(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, a) {
    var o = Am(t, a);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Me(o, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var a = Tm(t);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : Me(a, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Er.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var a = CO(t);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : Me(a, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var a = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return Me(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return Me(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var a = t.getUTCDay(), o = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return Me(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var a = t.getUTCHours(), o = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a === 12 ? o = $n.noon : a === 0 ? o = $n.midnight : o = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a >= 17 ? o = $n.evening : a >= 12 ? o = $n.afternoon : a >= 4 ? o = $n.morning : o = $n.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Er.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Er.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var a = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : Me(a, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : Me(a, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Er.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Er.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Er.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return zf(i);
      case "XXXX":
      case "XX":
        return Kr(i);
      case "XXXXX":
      case "XXX":
      default:
        return Kr(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return zf(i);
      case "xxxx":
      case "xx":
        return Kr(i);
      case "xxxxx":
      case "xxx":
      default:
        return Kr(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Vf(i, ":");
      case "OOOO":
      default:
        return "GMT" + Kr(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Vf(i, ":");
      case "zzzz":
      default:
        return "GMT" + Kr(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, a) {
    var o = a._originalDate || t, i = Math.floor(o.getTime() / 1e3);
    return Me(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTime();
    return Me(i, n.length);
  }
};
function Vf(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(a);
  var i = t || "";
  return n + String(a) + i + Me(o, 2);
}
function zf(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Me(Math.abs(e) / 60, 2);
  }
  return Kr(e, t);
}
function Kr(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", a = Math.abs(e), o = Me(Math.floor(a / 60), 2), i = Me(a % 60, 2);
  return r + o + n + i;
}
var Kf = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Pm = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, TO = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return Kf(t, n);
  var i;
  switch (a) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Kf(a, n)).replace("{{time}}", Pm(o, n));
}, vu = {
  p: Pm,
  P: TO
};
function zo(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var AO = ["D", "DD"], PO = ["YY", "YYYY"];
function Mm(e) {
  return AO.indexOf(e) !== -1;
}
function Fm(e) {
  return PO.indexOf(e) !== -1;
}
function Ko(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var MO = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, FO = function(t, n, r) {
  var a, o = MO[t];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
const RO = FO;
function _n(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var _O = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, NO = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, IO = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, LO = {
  date: _n({
    formats: _O,
    defaultWidth: "full"
  }),
  time: _n({
    formats: NO,
    defaultWidth: "full"
  }),
  dateTime: _n({
    formats: IO,
    defaultWidth: "full"
  })
};
const jO = LO;
var WO = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, YO = function(t, n, r, a) {
  return WO[t];
};
const HO = YO;
function Gt(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[u] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[l];
  };
}
var VO = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, zO = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, KO = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, UO = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, qO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, XO = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, GO = function(t, n) {
  var r = Number(t), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, QO = {
  ordinalNumber: GO,
  era: Gt({
    values: VO,
    defaultWidth: "wide"
  }),
  quarter: Gt({
    values: zO,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Gt({
    values: KO,
    defaultWidth: "wide"
  }),
  day: Gt({
    values: UO,
    defaultWidth: "wide"
  }),
  dayPeriod: Gt({
    values: qO,
    defaultWidth: "wide",
    formattingValues: XO,
    defaultFormattingWidth: "wide"
  })
};
const ZO = QO;
function Qt(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    var i = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? eB(s, function(f) {
      return f.test(i);
    }) : JO(s, function(f) {
      return f.test(i);
    }), l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = n.valueCallback ? n.valueCallback(l) : l;
    var c = t.slice(i.length);
    return {
      value: l,
      rest: c
    };
  };
}
function JO(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function eB(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Rm(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var a = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var s = t.slice(a.length);
    return {
      value: i,
      rest: s
    };
  };
}
var tB = /^(\d+)(th|st|nd|rd)?/i, rB = /\d+/i, nB = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, aB = {
  any: [/^b/i, /^(a|c)/i]
}, oB = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, iB = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sB = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, uB = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, lB = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, cB = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, dB = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fB = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, pB = {
  ordinalNumber: Rm({
    matchPattern: tB,
    parsePattern: rB,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Qt({
    matchPatterns: nB,
    defaultMatchWidth: "wide",
    parsePatterns: aB,
    defaultParseWidth: "any"
  }),
  quarter: Qt({
    matchPatterns: oB,
    defaultMatchWidth: "wide",
    parsePatterns: iB,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Qt({
    matchPatterns: sB,
    defaultMatchWidth: "wide",
    parsePatterns: uB,
    defaultParseWidth: "any"
  }),
  day: Qt({
    matchPatterns: lB,
    defaultMatchWidth: "wide",
    parsePatterns: cB,
    defaultParseWidth: "any"
  }),
  dayPeriod: Qt({
    matchPatterns: dB,
    defaultMatchWidth: "any",
    parsePatterns: fB,
    defaultParseWidth: "any"
  })
};
const hB = pB;
var vB = {
  code: "en-US",
  formatDistance: RO,
  formatLong: jO,
  formatRelative: HO,
  localize: ZO,
  match: hB,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const _m = vB;
var mB = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gB = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yB = /^'([^]*?)'?$/, bB = /''/g, wB = /[a-zA-Z]/;
function Uf(e, t, n) {
  var r, a, o, i, s, u, l, c, f, p, m, v, g, h, w, S, x, O;
  ce(2, arguments);
  var B = String(t), F = yn(), L = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : F.locale) !== null && r !== void 0 ? r : _m, j = Ce((o = (i = (s = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (l = n.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : F.firstWeekContainsDate) !== null && i !== void 0 ? i : (f = F.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = Ce((m = (v = (g = (h = n == null ? void 0 : n.weekStartsOn) !== null && h !== void 0 ? h : n == null || (w = n.locale) === null || w === void 0 || (S = w.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && g !== void 0 ? g : F.weekStartsOn) !== null && v !== void 0 ? v : (x = F.locale) === null || x === void 0 || (O = x.options) === null || O === void 0 ? void 0 : O.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!L.localize)
    throw new RangeError("locale must contain localize property");
  if (!L.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var N = pe(e);
  if (!Fa(N))
    throw new RangeError("Invalid time value");
  var q = zo(N), J = Om(N, q), R = {
    firstWeekContainsDate: j,
    weekStartsOn: I,
    locale: L,
    _originalDate: N
  }, ae = B.match(gB).map(function(H) {
    var oe = H[0];
    if (oe === "p" || oe === "P") {
      var ue = vu[oe];
      return ue(H, L.formatLong);
    }
    return H;
  }).join("").match(mB).map(function(H) {
    if (H === "''")
      return "'";
    var oe = H[0];
    if (oe === "'")
      return DB(H);
    var ue = BO[oe];
    if (ue)
      return !(n != null && n.useAdditionalWeekYearTokens) && Fm(H) && Ko(H, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Mm(H) && Ko(H, t, String(e)), ue(J, H, L.localize, R);
    if (oe.match(wB))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
    return H;
  }).join("");
  return ae;
}
function DB(e) {
  var t = e.match(yB);
  return t ? t[1].replace(bB, "'") : e;
}
var CB = 6e4;
function mu(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Xl(e, n * CB);
}
var EB = 36e5;
function xB(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Xl(e, n * EB);
}
function na(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Ql(e, t) {
  ce(2, arguments);
  var n = Ce(t), r = n * 7;
  return na(e, r);
}
function Vt(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), o = new Date(n.getTime());
  o.setMonth(n.getMonth() + r + 1, 0);
  var i = o.getDate();
  return a >= i ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), a), n);
}
function Nm(e, t) {
  ce(2, arguments);
  var n = Ce(t), r = n * 3;
  return Vt(e, r);
}
function Kn(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Vt(e, n * 12);
}
function SB(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return na(e, -n);
}
function $B(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Ql(e, -n);
}
function Un(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Vt(e, -n);
}
function kB(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Nm(e, -n);
}
function Ra(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  return Kn(e, -n);
}
function Ds(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getSeconds();
  return n;
}
function Yt(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getMinutes();
  return n;
}
function Ht(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getHours();
  return n;
}
function OB(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getDay();
  return n;
}
function qf(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getDate();
  return n;
}
function Im(e, t) {
  var n, r, a, o, i, s, u, l;
  ce(1, arguments);
  var c = yn(), f = Ce((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = pe(e), m = p.getDay(), v = (m < f ? 7 : 0) + m - f;
  return p.setDate(p.getDate() - v), p.setHours(0, 0, 0, 0), p;
}
function Uo(e) {
  return ce(1, arguments), Im(e, {
    weekStartsOn: 1
  });
}
function BB(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = Uo(r), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  var i = Uo(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function TB(e) {
  ce(1, arguments);
  var t = BB(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Uo(n);
  return r;
}
var AB = 6048e5;
function PB(e) {
  ce(1, arguments);
  var t = pe(e), n = Uo(t).getTime() - TB(t).getTime();
  return Math.round(n / AB) + 1;
}
function ct(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getMonth();
  return n;
}
function Pn(e) {
  ce(1, arguments);
  var t = pe(e), n = Math.floor(t.getMonth() / 3) + 1;
  return n;
}
function Ee(e) {
  return ce(1, arguments), pe(e).getFullYear();
}
function gu(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getTime();
  return n;
}
function MB(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  return n.setSeconds(r), n;
}
function yo(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  return n.setMinutes(r), n;
}
function bo(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  return n.setHours(r), n;
}
function FB(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getFullYear(), r = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function dt(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t), a = n.getFullYear(), o = n.getDate(), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, r, 15), i.setHours(0, 0, 0, 0);
  var s = FB(i);
  return n.setMonth(r, Math.min(o, s)), n;
}
function kn(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t), a = Math.floor(n.getMonth() / 3) + 1, o = r - a;
  return dt(n, n.getMonth() + o * 3);
}
function dr(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function Xf(e) {
  ce(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (ht(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = pe(r);
    (n === void 0 || n > a || isNaN(a.getDate())) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Gf(e) {
  ce(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (ht(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = pe(r);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function tr(e) {
  ce(1, arguments);
  var t = pe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var RB = 864e5;
function qo(e, t) {
  ce(2, arguments);
  var n = tr(e), r = tr(t), a = n.getTime() - zo(n), o = r.getTime() - zo(r);
  return Math.round((a - o) / RB);
}
function Xo(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t), a = n.getFullYear() - r.getFullYear(), o = n.getMonth() - r.getMonth();
  return a * 12 + o;
}
function Go(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getFullYear() - r.getFullYear();
}
function Lm(e) {
  ce(1, arguments);
  var t = pe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function yu(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function jm(e) {
  ce(1, arguments);
  var t = pe(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function bu(e) {
  ce(1, arguments);
  var t = pe(e);
  return t.setHours(23, 59, 59, 999), t;
}
function _B(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function NB(e) {
  ce(1, arguments);
  var t = pe(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function IB(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getTime() === r.getTime();
}
function LB(e, t) {
  ce(2, arguments);
  var n = tr(e), r = tr(t);
  return n.getTime() === r.getTime();
}
function jB(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function WB(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getFullYear() === r.getFullYear();
}
function YB(e, t) {
  ce(2, arguments);
  var n = yu(e), r = yu(t);
  return n.getTime() === r.getTime();
}
function Nr(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getTime() > r.getTime();
}
function Br(e, t) {
  ce(2, arguments);
  var n = pe(e), r = pe(t);
  return n.getTime() < r.getTime();
}
function _a(e, t) {
  ce(2, arguments);
  var n = pe(e).getTime(), r = pe(t.start).getTime(), a = pe(t.end).getTime();
  if (!(r <= a))
    throw new RangeError("Invalid interval");
  return n >= r && n <= a;
}
function Qf(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Ch(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = !0, i = !1, s;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return o = l.done, l;
    },
    e: function(l) {
      i = !0, s = l;
    },
    f: function() {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw s;
      }
    }
  };
}
function HB(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function ke(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && So(e, t);
}
function Qo(e) {
  return Qo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Qo(e);
}
function VB() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zB(e, t) {
  if (t && (ht(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return de(e);
}
function Oe(e) {
  var t = VB();
  return function() {
    var r = Qo(e), a;
    if (t) {
      var o = Qo(this).constructor;
      a = Reflect.construct(r, arguments, o);
    } else
      a = r.apply(this, arguments);
    return zB(this, a);
  };
}
var KB = 10, Wm = /* @__PURE__ */ function() {
  function e() {
    $e(this, e), le(this, "priority", void 0), le(this, "subPriority", 0);
  }
  return Se(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), UB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n(r, a, o, i, s) {
    var u;
    return $e(this, n), u = t.call(this), u.value = r, u.validateValue = a, u.setValue = o, u.priority = i, s && (u.subPriority = s), u;
  }
  return Se(n, [{
    key: "validate",
    value: function(a, o) {
      return this.validateValue(a, this.value, o);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return this.setValue(a, o, this.value, i);
    }
  }]), n;
}(Wm), qB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", KB), le(de(r), "subPriority", -1), r;
  }
  return Se(n, [{
    key: "set",
    value: function(a, o) {
      if (o.timestampIsSet)
        return a;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), i.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), i;
    }
  }]), n;
}(Wm), Be = /* @__PURE__ */ function() {
  function e() {
    $e(this, e), le(this, "incompatibleTokens", void 0), le(this, "priority", void 0), le(this, "subPriority", void 0);
  }
  return Se(e, [{
    key: "run",
    value: function(n, r, a, o) {
      var i = this.parse(n, r, a, o);
      return i ? {
        setter: new UB(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, a) {
      return !0;
    }
  }]), e;
}(), XB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 140), le(de(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(a, {
            width: "abbreviated"
          }) || i.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(a, {
            width: "wide"
          }) || i.era(a, {
            width: "abbreviated"
          }) || i.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return o.era = i, a.setUTCFullYear(i, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), Zl = 6e4, Jl = 36e5, GB = 1e3, Je = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Zt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function et(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ge(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Jt(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, o = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * Jl + o * Zl + i * GB),
    rest: t.slice(n[0].length)
  };
}
function Ym(e) {
  return Ge(Je.anyDigitsSigned, e);
}
function Qe(e, t) {
  switch (e) {
    case 1:
      return Ge(Je.singleDigit, t);
    case 2:
      return Ge(Je.twoDigits, t);
    case 3:
      return Ge(Je.threeDigits, t);
    case 4:
      return Ge(Je.fourDigits, t);
    default:
      return Ge(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Zo(e, t) {
  switch (e) {
    case 1:
      return Ge(Je.singleDigitSigned, t);
    case 2:
      return Ge(Je.twoDigitsSigned, t);
    case 3:
      return Ge(Je.threeDigitsSigned, t);
    case 4:
      return Ge(Je.fourDigitsSigned, t);
    default:
      return Ge(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function ec(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Hm(e, t) {
  var n = t > 0, r = n ? t : 1 - t, a;
  if (r <= 50)
    a = e || 100;
  else {
    var o = r + 50, i = Math.floor(o / 100) * 100, s = e >= o % 100;
    a = e + i - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function Vm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var QB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 130), le(de(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: o === "yy"
        };
      };
      switch (o) {
        case "y":
          return et(Qe(4, a), s);
        case "yo":
          return et(i.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return et(Qe(o.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      var s = a.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var u = Hm(i.year, s);
        return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var l = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), ZB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 130), le(de(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: o === "YY"
        };
      };
      switch (o) {
        case "Y":
          return et(Qe(4, a), s);
        case "Yo":
          return et(i.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return et(Qe(o.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o.isTwoDigitYear || o.year > 0;
    }
  }, {
    key: "set",
    value: function(a, o, i, s) {
      var u = Gl(a, s);
      if (i.isTwoDigitYear) {
        var l = Hm(i.year, u);
        return a.setUTCFullYear(l, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), ln(a, s);
      }
      var c = !("era" in o) || o.era === 1 ? i.year : 1 - i.year;
      return a.setUTCFullYear(c, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), ln(a, s);
    }
  }]), n;
}(Be), JB = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 130), le(de(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o) {
      return Zo(o === "R" ? 4 : o.length, a);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(i, 0, 4), s.setUTCHours(0, 0, 0, 0), zn(s);
    }
  }]), n;
}(Be), e8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 130), le(de(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o) {
      return Zo(o === "u" ? 4 : o.length, a);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCFullYear(i, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), t8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 120), le(de(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "Q":
        case "QQ":
          return Qe(o.length, a);
        case "Qo":
          return i.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMonth((i - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), r8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 120), le(de(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "q":
        case "qq":
          return Qe(o.length, a);
        case "qo":
          return i.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 4;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMonth((i - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), n8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), le(de(r), "priority", 110), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      var s = function(l) {
        return l - 1;
      };
      switch (o) {
        case "M":
          return et(Ge(Je.month, a), s);
        case "MM":
          return et(Qe(2, a), s);
        case "Mo":
          return et(i.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return i.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(a, {
            width: "wide",
            context: "formatting"
          }) || i.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMonth(i, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), a8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 110), le(de(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      var s = function(l) {
        return l - 1;
      };
      switch (o) {
        case "L":
          return et(Ge(Je.month, a), s);
        case "LL":
          return et(Qe(2, a), s);
        case "Lo":
          return et(i.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return i.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(a, {
            width: "wide",
            context: "standalone"
          }) || i.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMonth(i, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be);
function o8(e, t, n) {
  ce(2, arguments);
  var r = pe(e), a = Ce(t), o = Am(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - o * 7), r;
}
var i8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 100), le(de(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "w":
          return Ge(Je.week, a);
        case "wo":
          return i.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(a, o, i, s) {
      return ln(o8(a, i, s), s);
    }
  }]), n;
}(Be);
function s8(e, t) {
  ce(2, arguments);
  var n = pe(e), r = Ce(t), a = Tm(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var u8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 100), le(de(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "I":
          return Ge(Je.week, a);
        case "Io":
          return i.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 53;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return zn(s8(a, i));
    }
  }]), n;
}(Be), l8 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], c8 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], d8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "subPriority", 1), le(de(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "d":
          return Ge(Je.date, a);
        case "do":
          return i.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      var i = a.getUTCFullYear(), s = Vm(i), u = a.getUTCMonth();
      return s ? o >= 1 && o <= c8[u] : o >= 1 && o <= l8[u];
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCDate(i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), f8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "subpriority", 1), le(de(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "D":
        case "DD":
          return Ge(Je.dayOfYear, a);
        case "Do":
          return i.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      var i = a.getUTCFullYear(), s = Vm(i);
      return s ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMonth(0, i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be);
function tc(e, t, n) {
  var r, a, o, i, s, u, l, c;
  ce(2, arguments);
  var f = yn(), p = Ce((r = (a = (o = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (s = n.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && o !== void 0 ? o : f.weekStartsOn) !== null && a !== void 0 ? a : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var m = pe(e), v = Ce(t), g = m.getUTCDay(), h = v % 7, w = (h + 7) % 7, S = (w < p ? 7 : 0) + v - g;
  return m.setUTCDate(m.getUTCDate() + S), m;
}
var p8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(a, o, i, s) {
      return a = tc(a, i, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), h8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i, s) {
      var u = function(c) {
        var f = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + f;
      };
      switch (o) {
        case "e":
        case "ee":
          return et(Qe(o.length, a), u);
        case "eo":
          return et(i.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "eee":
          return i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(a, o, i, s) {
      return a = tc(a, i, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), v8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i, s) {
      var u = function(c) {
        var f = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + f;
      };
      switch (o) {
        case "c":
        case "cc":
          return et(Qe(o.length, a), u);
        case "co":
          return et(i.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "ccc":
          return i.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(a, {
            width: "wide",
            context: "standalone"
          }) || i.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(a, {
            width: "short",
            context: "standalone"
          }) || i.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 6;
    }
  }, {
    key: "set",
    value: function(a, o, i, s) {
      return a = tc(a, i, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be);
function m8(e, t) {
  ce(2, arguments);
  var n = Ce(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = pe(e), o = a.getUTCDay(), i = n % 7, s = (i + 7) % 7, u = (s < r ? 7 : 0) + n - o;
  return a.setUTCDate(a.getUTCDate() + u), a;
}
var g8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 90), le(de(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      var s = function(l) {
        return l === 0 ? 7 : l;
      };
      switch (o) {
        case "i":
        case "ii":
          return Qe(o.length, a);
        case "io":
          return i.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return et(i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return et(i.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return et(i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return et(i.day(a, {
            width: "wide",
            context: "formatting"
          }) || i.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(a, {
            width: "short",
            context: "formatting"
          }) || i.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 7;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a = m8(a, i), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Be), y8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 80), le(de(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCHours(ec(i), 0, 0, 0), a;
    }
  }]), n;
}(Be), b8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 80), le(de(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCHours(ec(i), 0, 0, 0), a;
    }
  }]), n;
}(Be), w8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 80), le(de(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCHours(ec(i), 0, 0, 0), a;
    }
  }]), n;
}(Be), D8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 70), le(de(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "h":
          return Ge(Je.hour12h, a);
        case "ho":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 12;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      var s = a.getUTCHours() >= 12;
      return s && i < 12 ? a.setUTCHours(i + 12, 0, 0, 0) : !s && i === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(Be), C8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 70), le(de(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "H":
          return Ge(Je.hour23h, a);
        case "Ho":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 23;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(Be), E8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 70), le(de(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "K":
          return Ge(Je.hour11h, a);
        case "Ko":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 11;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      var s = a.getUTCHours() >= 12;
      return s && i < 12 ? a.setUTCHours(i + 12, 0, 0, 0) : a.setUTCHours(i, 0, 0, 0), a;
    }
  }]), n;
}(Be), x8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 70), le(de(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "k":
          return Ge(Je.hour24h, a);
        case "ko":
          return i.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 1 && o <= 24;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      var s = i <= 24 ? i % 24 : i;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), n;
}(Be), S8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 60), le(de(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "m":
          return Ge(Je.minute, a);
        case "mo":
          return i.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMinutes(i, 0, 0), a;
    }
  }]), n;
}(Be), $8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 50), le(de(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o, i) {
      switch (o) {
        case "s":
          return Ge(Je.second, a);
        case "so":
          return i.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return Qe(o.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, o) {
      return o >= 0 && o <= 59;
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCSeconds(i, 0), a;
    }
  }]), n;
}(Be), k8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 30), le(de(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o) {
      var i = function(u) {
        return Math.floor(u * Math.pow(10, -o.length + 3));
      };
      return et(Qe(o.length, a), i);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return a.setUTCMilliseconds(i), a;
    }
  }]), n;
}(Be), O8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 10), le(de(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o) {
      switch (o) {
        case "X":
          return Jt(Zt.basicOptionalMinutes, a);
        case "XX":
          return Jt(Zt.basic, a);
        case "XXXX":
          return Jt(Zt.basicOptionalSeconds, a);
        case "XXXXX":
          return Jt(Zt.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return Jt(Zt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return o.timestampIsSet ? a : new Date(a.getTime() - i);
    }
  }]), n;
}(Be), B8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 10), le(de(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a, o) {
      switch (o) {
        case "x":
          return Jt(Zt.basicOptionalMinutes, a);
        case "xx":
          return Jt(Zt.basic, a);
        case "xxxx":
          return Jt(Zt.basicOptionalSeconds, a);
        case "xxxxx":
          return Jt(Zt.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return Jt(Zt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return o.timestampIsSet ? a : new Date(a.getTime() - i);
    }
  }]), n;
}(Be), T8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 40), le(de(r), "incompatibleTokens", "*"), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a) {
      return Ym(a);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Be), A8 = /* @__PURE__ */ function(e) {
  ke(n, e);
  var t = Oe(n);
  function n() {
    var r;
    $e(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(o)), le(de(r), "priority", 20), le(de(r), "incompatibleTokens", "*"), r;
  }
  return Se(n, [{
    key: "parse",
    value: function(a) {
      return Ym(a);
    }
  }, {
    key: "set",
    value: function(a, o, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Be), P8 = {
  G: new XB(),
  y: new QB(),
  Y: new ZB(),
  R: new JB(),
  u: new e8(),
  Q: new t8(),
  q: new r8(),
  M: new n8(),
  L: new a8(),
  w: new i8(),
  I: new u8(),
  d: new d8(),
  D: new f8(),
  E: new p8(),
  e: new h8(),
  c: new v8(),
  i: new g8(),
  a: new y8(),
  b: new b8(),
  B: new w8(),
  h: new D8(),
  H: new C8(),
  K: new E8(),
  k: new x8(),
  m: new S8(),
  s: new $8(),
  S: new k8(),
  X: new O8(),
  x: new B8(),
  t: new T8(),
  T: new A8()
}, M8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, F8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, R8 = /^'([^]*?)'?$/, _8 = /''/g, N8 = /\S/, I8 = /[a-zA-Z]/;
function Cs(e, t, n, r) {
  var a, o, i, s, u, l, c, f, p, m, v, g, h, w, S, x, O, B;
  ce(3, arguments);
  var F = String(e), L = String(t), j = yn(), I = (a = (o = r == null ? void 0 : r.locale) !== null && o !== void 0 ? o : j.locale) !== null && a !== void 0 ? a : _m;
  if (!I.match)
    throw new RangeError("locale must contain match property");
  var N = Ce((i = (s = (u = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (c = r.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && u !== void 0 ? u : j.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = j.locale) === null || p === void 0 || (m = p.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var q = Ce((v = (g = (h = (w = r == null ? void 0 : r.weekStartsOn) !== null && w !== void 0 ? w : r == null || (S = r.locale) === null || S === void 0 || (x = S.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : j.weekStartsOn) !== null && g !== void 0 ? g : (O = j.locale) === null || O === void 0 || (B = O.options) === null || B === void 0 ? void 0 : B.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(q >= 0 && q <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (L === "")
    return F === "" ? pe(n) : /* @__PURE__ */ new Date(NaN);
  var J = {
    firstWeekContainsDate: N,
    weekStartsOn: q,
    locale: I
  }, R = [new qB()], ae = L.match(F8).map(function(G) {
    var te = G[0];
    if (te in vu) {
      var se = vu[te];
      return se(G, I.formatLong);
    }
    return G;
  }).join("").match(M8), H = [], oe = Qf(ae), ue;
  try {
    var me = function() {
      var te = ue.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Fm(te) && Ko(te, L, e), !(r != null && r.useAdditionalDayOfYearTokens) && Mm(te) && Ko(te, L, e);
      var se = te[0], Z = P8[se];
      if (Z) {
        var ne = Z.incompatibleTokens;
        if (Array.isArray(ne)) {
          var be = H.find(function(Ve) {
            return ne.includes(Ve.token) || Ve.token === se;
          });
          if (be)
            throw new RangeError("The format string mustn't contain `".concat(be.fullToken, "` and `").concat(te, "` at the same time"));
        } else if (Z.incompatibleTokens === "*" && H.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(te, "` and any other token at the same time"));
        H.push({
          token: se,
          fullToken: te
        });
        var Pe = Z.run(F, te, I.match, J);
        if (!Pe)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        R.push(Pe.setter), F = Pe.rest;
      } else {
        if (se.match(I8))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + se + "`");
        if (te === "''" ? te = "'" : se === "'" && (te = L8(te)), F.indexOf(te) === 0)
          F = F.slice(te.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (oe.s(); !(ue = oe.n()).done; ) {
      var V = me();
      if (ht(V) === "object")
        return V.v;
    }
  } catch (G) {
    oe.e(G);
  } finally {
    oe.f();
  }
  if (F.length > 0 && N8.test(F))
    return /* @__PURE__ */ new Date(NaN);
  var T = R.map(function(G) {
    return G.priority;
  }).sort(function(G, te) {
    return te - G;
  }).filter(function(G, te, se) {
    return se.indexOf(G) === te;
  }).map(function(G) {
    return R.filter(function(te) {
      return te.priority === G;
    }).sort(function(te, se) {
      return se.subPriority - te.subPriority;
    });
  }).map(function(G) {
    return G[0];
  }), C = pe(n);
  if (isNaN(C.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var M = Om(C, zo(C)), P = {}, W = Qf(T), z;
  try {
    for (W.s(); !(z = W.n()).done; ) {
      var K = z.value;
      if (!K.validate(M, J))
        return /* @__PURE__ */ new Date(NaN);
      var X = K.set(M, P, J);
      Array.isArray(X) ? (M = X[0], HB(P, X[1])) : M = X;
    }
  } catch (G) {
    W.e(G);
  } finally {
    W.f();
  }
  return M;
}
function L8(e) {
  return e.match(R8)[1].replace(_8, "'");
}
function j8(e, t) {
  var n;
  ce(1, arguments);
  var r = Ce((n = t == null ? void 0 : t.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = V8(e), o;
  if (a.date) {
    var i = z8(a.date, r);
    o = K8(i.restDateString, i.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = o.getTime(), u = 0, l;
  if (a.time && (u = U8(a.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (l = q8(a.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var c = new Date(s + u), f = /* @__PURE__ */ new Date(0);
    return f.setFullYear(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()), f.setHours(c.getUTCHours(), c.getUTCMinutes(), c.getUTCSeconds(), c.getUTCMilliseconds()), f;
  }
  return new Date(s + u + l);
}
var lo = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, W8 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Y8 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, H8 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function V8(e) {
  var t = {}, n = e.split(lo.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], lo.timeZoneDelimiter.test(t.date) && (t.date = e.split(lo.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var a = lo.timezone.exec(r);
    a ? (t.time = r.replace(a[1], ""), t.timezone = a[1]) : t.time = r;
  }
  return t;
}
function z8(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function K8(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(W8);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = da(n[1]), o = da(n[2]) - 1, i = da(n[3]), s = da(n[4]), u = da(n[5]) - 1;
  if (r)
    return J8(t, s, u) ? X8(t, s, u) : /* @__PURE__ */ new Date(NaN);
  var l = /* @__PURE__ */ new Date(0);
  return !Q8(t, o, i) || !Z8(t, a) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(t, o, Math.max(a, i)), l);
}
function da(e) {
  return e ? parseInt(e) : 1;
}
function U8(e) {
  var t = e.match(Y8);
  if (!t)
    return NaN;
  var n = Es(t[1]), r = Es(t[2]), a = Es(t[3]);
  return e6(n, r, a) ? n * Jl + r * Zl + a * 1e3 : NaN;
}
function Es(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function q8(e) {
  if (e === "Z")
    return 0;
  var t = e.match(H8);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return t6(r, a) ? n * (r * Jl + a * Zl) : NaN;
}
function X8(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var a = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var G8 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function zm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Q8(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (G8[t] || (zm(e) ? 29 : 28));
}
function Z8(e, t) {
  return t >= 1 && t <= (zm(e) ? 366 : 365);
}
function J8(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function e6(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function t6(e, t) {
  return t >= 0 && t <= 59;
}
function r6(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, wu(e, t);
}
function wu(e, t) {
  return wu = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, wu(e, t);
}
function n6(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Zf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function a6(e, t, n) {
  return e === t ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n);
}
function o6(e, t, n) {
  if (e === t)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && a6(e, t, n))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function i6(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var s6 = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var t = !1, n = Object.defineProperty({}, "passive", {
      get: function() {
        t = !0;
      }
    }), r = function() {
    };
    return window.addEventListener("testPassiveEventSupport", r, n), window.removeEventListener("testPassiveEventSupport", r, n), t;
  }
};
function u6(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var l6 = u6(), Du, co = {}, xs = {}, c6 = ["touchstart", "touchmove"], d6 = "ignore-react-onclickoutside";
function Jf(e, t) {
  var n = {}, r = c6.indexOf(t) !== -1;
  return r && Du && (n.passive = !e.props.preventDefault), n;
}
function wi(e, t) {
  var n, r, a = e.displayName || e.name || "Component";
  return r = n = /* @__PURE__ */ function(o) {
    r6(i, o);
    function i(u) {
      var l;
      return l = o.call(this, u) || this, l.__outsideClickHandler = function(c) {
        if (typeof l.__clickOutsideHandlerProp == "function") {
          l.__clickOutsideHandlerProp(c);
          return;
        }
        var f = l.getInstance();
        if (typeof f.props.handleClickOutside == "function") {
          f.props.handleClickOutside(c);
          return;
        }
        if (typeof f.handleClickOutside == "function") {
          f.handleClickOutside(c);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, l.__getComponentNode = function() {
        var c = l.getInstance();
        return t && typeof t.setClickOutsideRef == "function" ? t.setClickOutsideRef()(c) : typeof c.setClickOutsideRef == "function" ? c.setClickOutsideRef() : tg(c);
      }, l.enableOnClickOutside = function() {
        if (!(typeof document > "u" || xs[l._uid])) {
          typeof Du > "u" && (Du = s6()), xs[l._uid] = !0;
          var c = l.props.eventTypes;
          c.forEach || (c = [c]), co[l._uid] = function(f) {
            if (l.componentNode !== null && (l.props.preventDefault && f.preventDefault(), l.props.stopPropagation && f.stopPropagation(), !(l.props.excludeScrollbar && i6(f)))) {
              var p = f.composed && f.composedPath && f.composedPath().shift() || f.target;
              o6(p, l.componentNode, l.props.outsideClickIgnoreClass) === document && l.__outsideClickHandler(f);
            }
          }, c.forEach(function(f) {
            document.addEventListener(f, co[l._uid], Jf(Zf(l), f));
          });
        }
      }, l.disableOnClickOutside = function() {
        delete xs[l._uid];
        var c = co[l._uid];
        if (c && typeof document < "u") {
          var f = l.props.eventTypes;
          f.forEach || (f = [f]), f.forEach(function(p) {
            return document.removeEventListener(p, c, Jf(Zf(l), p));
          }), delete co[l._uid];
        }
      }, l.getRef = function(c) {
        return l.instanceRef = c;
      }, l._uid = l6(), l;
    }
    var s = i.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, s.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var l = this.getInstance();
        if (t && typeof t.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = t.handleClickOutside(l), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + a + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var c = n6(l, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, _0(e, c);
    }, i;
  }(Pp), n.displayName = "OnClickOutside(" + a + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: t && t.excludeScrollbar || !1,
    outsideClickIgnoreClass: d6,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, r;
}
var Km = U.createContext(), Um = U.createContext();
function f6(e) {
  var t = e.children, n = U.useState(null), r = n[0], a = n[1], o = U.useRef(!1);
  U.useEffect(function() {
    return function() {
      o.current = !0;
    };
  }, []);
  var i = U.useCallback(function(s) {
    o.current || a(s);
  }, []);
  return /* @__PURE__ */ U.createElement(Km.Provider, {
    value: r
  }, /* @__PURE__ */ U.createElement(Um.Provider, {
    value: i
  }, t));
}
var qm = function(t) {
  return Array.isArray(t) ? t[0] : t;
}, Xm = function(t) {
  if (typeof t == "function") {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    return t.apply(void 0, r);
  }
}, Cu = function(t, n) {
  if (typeof t == "function")
    return Xm(t, n);
  t != null && (t.current = n);
}, ep = function(t) {
  return t.reduce(function(n, r) {
    var a = r[0], o = r[1];
    return n[a] = o, n;
  }, {});
}, tp = typeof window < "u" && window.document && window.document.createElement ? U.useLayoutEffect : U.useEffect, wt = "top", Rt = "bottom", _t = "right", Dt = "left", rc = "auto", za = [wt, Rt, _t, Dt], qn = "start", Na = "end", p6 = "clippingParents", Gm = "viewport", fa = "popper", h6 = "reference", rp = /* @__PURE__ */ za.reduce(function(e, t) {
  return e.concat([t + "-" + qn, t + "-" + Na]);
}, []), Qm = /* @__PURE__ */ [].concat(za, [rc]).reduce(function(e, t) {
  return e.concat([t, t + "-" + qn, t + "-" + Na]);
}, []), v6 = "beforeRead", m6 = "read", g6 = "afterRead", y6 = "beforeMain", b6 = "main", w6 = "afterMain", D6 = "beforeWrite", C6 = "write", E6 = "afterWrite", x6 = [v6, m6, g6, y6, b6, w6, D6, C6, E6];
function ar(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ot(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function cn(e) {
  var t = Ot(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ft(e) {
  var t = Ot(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function nc(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ot(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function S6(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, o = t.elements[n];
    !Ft(o) || !ar(o) || (Object.assign(o.style, r), Object.keys(a).forEach(function(i) {
      var s = a[i];
      s === !1 ? o.removeAttribute(i) : o.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function $6(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], o = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = i.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !Ft(a) || !ar(a) || (Object.assign(a.style, s), Object.keys(o).forEach(function(u) {
        a.removeAttribute(u);
      }));
    });
  };
}
const k6 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: S6,
  effect: $6,
  requires: ["computeStyles"]
};
function rr(e) {
  return e.split("-")[0];
}
var tn = Math.max, Jo = Math.min, Xn = Math.round;
function Eu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Zm() {
  return !/^((?!chrome|android).)*safari/i.test(Eu());
}
function Gn(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, o = 1;
  t && Ft(e) && (a = e.offsetWidth > 0 && Xn(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Xn(r.height) / e.offsetHeight || 1);
  var i = cn(e) ? Ot(e) : window, s = i.visualViewport, u = !Zm() && n, l = (r.left + (u && s ? s.offsetLeft : 0)) / a, c = (r.top + (u && s ? s.offsetTop : 0)) / o, f = r.width / a, p = r.height / o;
  return {
    width: f,
    height: p,
    top: c,
    right: l + f,
    bottom: c + p,
    left: l,
    x: l,
    y: c
  };
}
function ac(e) {
  var t = Gn(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Jm(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && nc(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function vr(e) {
  return Ot(e).getComputedStyle(e);
}
function O6(e) {
  return ["table", "td", "th"].indexOf(ar(e)) >= 0;
}
function Wr(e) {
  return ((cn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Di(e) {
  return ar(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (nc(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Wr(e)
  );
}
function np(e) {
  return !Ft(e) || // https://github.com/popperjs/popper-core/issues/837
  vr(e).position === "fixed" ? null : e.offsetParent;
}
function B6(e) {
  var t = /firefox/i.test(Eu()), n = /Trident/i.test(Eu());
  if (n && Ft(e)) {
    var r = vr(e);
    if (r.position === "fixed")
      return null;
  }
  var a = Di(e);
  for (nc(a) && (a = a.host); Ft(a) && ["html", "body"].indexOf(ar(a)) < 0; ) {
    var o = vr(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Ka(e) {
  for (var t = Ot(e), n = np(e); n && O6(n) && vr(n).position === "static"; )
    n = np(n);
  return n && (ar(n) === "html" || ar(n) === "body" && vr(n).position === "static") ? t : n || B6(e) || t;
}
function oc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Sa(e, t, n) {
  return tn(e, Jo(t, n));
}
function T6(e, t, n) {
  var r = Sa(e, t, n);
  return r > n ? n : r;
}
function e0() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function t0(e) {
  return Object.assign({}, e0(), e);
}
function r0(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var A6 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, t0(typeof t != "number" ? t : r0(t, za));
};
function P6(e) {
  var t, n = e.state, r = e.name, a = e.options, o = n.elements.arrow, i = n.modifiersData.popperOffsets, s = rr(n.placement), u = oc(s), l = [Dt, _t].indexOf(s) >= 0, c = l ? "height" : "width";
  if (!(!o || !i)) {
    var f = A6(a.padding, n), p = ac(o), m = u === "y" ? wt : Dt, v = u === "y" ? Rt : _t, g = n.rects.reference[c] + n.rects.reference[u] - i[u] - n.rects.popper[c], h = i[u] - n.rects.reference[u], w = Ka(o), S = w ? u === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, x = g / 2 - h / 2, O = f[m], B = S - p[c] - f[v], F = S / 2 - p[c] / 2 + x, L = Sa(O, F, B), j = u;
    n.modifiersData[r] = (t = {}, t[j] = L, t.centerOffset = L - F, t);
  }
}
function M6(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Jm(t.elements.popper, a) && (t.elements.arrow = a));
}
const F6 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: P6,
  effect: M6,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Qn(e) {
  return e.split("-")[1];
}
var R6 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function _6(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: Xn(n * a) / a || 0,
    y: Xn(r * a) / a || 0
  };
}
function ap(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, o = e.variation, i = e.offsets, s = e.position, u = e.gpuAcceleration, l = e.adaptive, c = e.roundOffsets, f = e.isFixed, p = i.x, m = p === void 0 ? 0 : p, v = i.y, g = v === void 0 ? 0 : v, h = typeof c == "function" ? c({
    x: m,
    y: g
  }) : {
    x: m,
    y: g
  };
  m = h.x, g = h.y;
  var w = i.hasOwnProperty("x"), S = i.hasOwnProperty("y"), x = Dt, O = wt, B = window;
  if (l) {
    var F = Ka(n), L = "clientHeight", j = "clientWidth";
    if (F === Ot(n) && (F = Wr(n), vr(F).position !== "static" && s === "absolute" && (L = "scrollHeight", j = "scrollWidth")), F = F, a === wt || (a === Dt || a === _t) && o === Na) {
      O = Rt;
      var I = f && F === B && B.visualViewport ? B.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        F[L]
      );
      g -= I - r.height, g *= u ? 1 : -1;
    }
    if (a === Dt || (a === wt || a === Rt) && o === Na) {
      x = _t;
      var N = f && F === B && B.visualViewport ? B.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        F[j]
      );
      m -= N - r.width, m *= u ? 1 : -1;
    }
  }
  var q = Object.assign({
    position: s
  }, l && R6), J = c === !0 ? _6({
    x: m,
    y: g
  }, Ot(n)) : {
    x: m,
    y: g
  };
  if (m = J.x, g = J.y, u) {
    var R;
    return Object.assign({}, q, (R = {}, R[O] = S ? "0" : "", R[x] = w ? "0" : "", R.transform = (B.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + g + "px)" : "translate3d(" + m + "px, " + g + "px, 0)", R));
  }
  return Object.assign({}, q, (t = {}, t[O] = S ? g + "px" : "", t[x] = w ? m + "px" : "", t.transform = "", t));
}
function N6(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, o = n.adaptive, i = o === void 0 ? !0 : o, s = n.roundOffsets, u = s === void 0 ? !0 : s, l = {
    placement: rr(t.placement),
    variation: Qn(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ap(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ap(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const I6 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: N6,
  data: {}
};
var fo = {
  passive: !0
};
function L6(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, o = a === void 0 ? !0 : a, i = r.resize, s = i === void 0 ? !0 : i, u = Ot(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && l.forEach(function(c) {
    c.addEventListener("scroll", n.update, fo);
  }), s && u.addEventListener("resize", n.update, fo), function() {
    o && l.forEach(function(c) {
      c.removeEventListener("scroll", n.update, fo);
    }), s && u.removeEventListener("resize", n.update, fo);
  };
}
const j6 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: L6,
  data: {}
};
var W6 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function wo(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return W6[t];
  });
}
var Y6 = {
  start: "end",
  end: "start"
};
function op(e) {
  return e.replace(/start|end/g, function(t) {
    return Y6[t];
  });
}
function ic(e) {
  var t = Ot(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function sc(e) {
  return Gn(Wr(e)).left + ic(e).scrollLeft;
}
function H6(e, t) {
  var n = Ot(e), r = Wr(e), a = n.visualViewport, o = r.clientWidth, i = r.clientHeight, s = 0, u = 0;
  if (a) {
    o = a.width, i = a.height;
    var l = Zm();
    (l || !l && t === "fixed") && (s = a.offsetLeft, u = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s + sc(e),
    y: u
  };
}
function V6(e) {
  var t, n = Wr(e), r = ic(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, o = tn(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = tn(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + sc(e), u = -r.scrollTop;
  return vr(a || n).direction === "rtl" && (s += tn(n.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: s,
    y: u
  };
}
function uc(e) {
  var t = vr(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function n0(e) {
  return ["html", "body", "#document"].indexOf(ar(e)) >= 0 ? e.ownerDocument.body : Ft(e) && uc(e) ? e : n0(Di(e));
}
function $a(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = n0(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Ot(r), i = a ? [o].concat(o.visualViewport || [], uc(r) ? r : []) : r, s = t.concat(i);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat($a(Di(i)))
  );
}
function xu(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function z6(e, t) {
  var n = Gn(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ip(e, t, n) {
  return t === Gm ? xu(H6(e, n)) : cn(t) ? z6(t, n) : xu(V6(Wr(e)));
}
function K6(e) {
  var t = $a(Di(e)), n = ["absolute", "fixed"].indexOf(vr(e).position) >= 0, r = n && Ft(e) ? Ka(e) : e;
  return cn(r) ? t.filter(function(a) {
    return cn(a) && Jm(a, r) && ar(a) !== "body";
  }) : [];
}
function U6(e, t, n, r) {
  var a = t === "clippingParents" ? K6(e) : [].concat(t), o = [].concat(a, [n]), i = o[0], s = o.reduce(function(u, l) {
    var c = ip(e, l, r);
    return u.top = tn(c.top, u.top), u.right = Jo(c.right, u.right), u.bottom = Jo(c.bottom, u.bottom), u.left = tn(c.left, u.left), u;
  }, ip(e, i, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function a0(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? rr(r) : null, o = r ? Qn(r) : null, i = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, u;
  switch (a) {
    case wt:
      u = {
        x: i,
        y: t.y - n.height
      };
      break;
    case Rt:
      u = {
        x: i,
        y: t.y + t.height
      };
      break;
    case _t:
      u = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Dt:
      u = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var l = a ? oc(a) : null;
  if (l != null) {
    var c = l === "y" ? "height" : "width";
    switch (o) {
      case qn:
        u[l] = u[l] - (t[c] / 2 - n[c] / 2);
        break;
      case Na:
        u[l] = u[l] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return u;
}
function Ia(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, o = n.strategy, i = o === void 0 ? e.strategy : o, s = n.boundary, u = s === void 0 ? p6 : s, l = n.rootBoundary, c = l === void 0 ? Gm : l, f = n.elementContext, p = f === void 0 ? fa : f, m = n.altBoundary, v = m === void 0 ? !1 : m, g = n.padding, h = g === void 0 ? 0 : g, w = t0(typeof h != "number" ? h : r0(h, za)), S = p === fa ? h6 : fa, x = e.rects.popper, O = e.elements[v ? S : p], B = U6(cn(O) ? O : O.contextElement || Wr(e.elements.popper), u, c, i), F = Gn(e.elements.reference), L = a0({
    reference: F,
    element: x,
    strategy: "absolute",
    placement: a
  }), j = xu(Object.assign({}, x, L)), I = p === fa ? j : F, N = {
    top: B.top - I.top + w.top,
    bottom: I.bottom - B.bottom + w.bottom,
    left: B.left - I.left + w.left,
    right: I.right - B.right + w.right
  }, q = e.modifiersData.offset;
  if (p === fa && q) {
    var J = q[a];
    Object.keys(N).forEach(function(R) {
      var ae = [_t, Rt].indexOf(R) >= 0 ? 1 : -1, H = [wt, Rt].indexOf(R) >= 0 ? "y" : "x";
      N[R] += J[H] * ae;
    });
  }
  return N;
}
function q6(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, o = n.rootBoundary, i = n.padding, s = n.flipVariations, u = n.allowedAutoPlacements, l = u === void 0 ? Qm : u, c = Qn(r), f = c ? s ? rp : rp.filter(function(v) {
    return Qn(v) === c;
  }) : za, p = f.filter(function(v) {
    return l.indexOf(v) >= 0;
  });
  p.length === 0 && (p = f);
  var m = p.reduce(function(v, g) {
    return v[g] = Ia(e, {
      placement: g,
      boundary: a,
      rootBoundary: o,
      padding: i
    })[rr(g)], v;
  }, {});
  return Object.keys(m).sort(function(v, g) {
    return m[v] - m[g];
  });
}
function X6(e) {
  if (rr(e) === rc)
    return [];
  var t = wo(e);
  return [op(e), t, op(t)];
}
function G6(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, o = a === void 0 ? !0 : a, i = n.altAxis, s = i === void 0 ? !0 : i, u = n.fallbackPlacements, l = n.padding, c = n.boundary, f = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, v = m === void 0 ? !0 : m, g = n.allowedAutoPlacements, h = t.options.placement, w = rr(h), S = w === h, x = u || (S || !v ? [wo(h)] : X6(h)), O = [h].concat(x).reduce(function(W, z) {
      return W.concat(rr(z) === rc ? q6(t, {
        placement: z,
        boundary: c,
        rootBoundary: f,
        padding: l,
        flipVariations: v,
        allowedAutoPlacements: g
      }) : z);
    }, []), B = t.rects.reference, F = t.rects.popper, L = /* @__PURE__ */ new Map(), j = !0, I = O[0], N = 0; N < O.length; N++) {
      var q = O[N], J = rr(q), R = Qn(q) === qn, ae = [wt, Rt].indexOf(J) >= 0, H = ae ? "width" : "height", oe = Ia(t, {
        placement: q,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: l
      }), ue = ae ? R ? _t : Dt : R ? Rt : wt;
      B[H] > F[H] && (ue = wo(ue));
      var me = wo(ue), V = [];
      if (o && V.push(oe[J] <= 0), s && V.push(oe[ue] <= 0, oe[me] <= 0), V.every(function(W) {
        return W;
      })) {
        I = q, j = !1;
        break;
      }
      L.set(q, V);
    }
    if (j)
      for (var T = v ? 3 : 1, C = function(z) {
        var K = O.find(function(X) {
          var G = L.get(X);
          if (G)
            return G.slice(0, z).every(function(te) {
              return te;
            });
        });
        if (K)
          return I = K, "break";
      }, M = T; M > 0; M--) {
        var P = C(M);
        if (P === "break")
          break;
      }
    t.placement !== I && (t.modifiersData[r]._skip = !0, t.placement = I, t.reset = !0);
  }
}
const Q6 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: G6,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function sp(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function up(e) {
  return [wt, _t, Rt, Dt].some(function(t) {
    return e[t] >= 0;
  });
}
function Z6(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, o = t.modifiersData.preventOverflow, i = Ia(t, {
    elementContext: "reference"
  }), s = Ia(t, {
    altBoundary: !0
  }), u = sp(i, r), l = sp(s, a, o), c = up(u), f = up(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: l,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const J6 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Z6
};
function eT(e, t, n) {
  var r = rr(e), a = [Dt, wt].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = o[0], s = o[1];
  return i = i || 0, s = (s || 0) * a, [Dt, _t].indexOf(r) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function tT(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, o = a === void 0 ? [0, 0] : a, i = Qm.reduce(function(c, f) {
    return c[f] = eT(f, t.rects, o), c;
  }, {}), s = i[t.placement], u = s.x, l = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = i;
}
const rT = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: tT
};
function nT(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = a0({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const aT = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: nT,
  data: {}
};
function oT(e) {
  return e === "x" ? "y" : "x";
}
function iT(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, o = a === void 0 ? !0 : a, i = n.altAxis, s = i === void 0 ? !1 : i, u = n.boundary, l = n.rootBoundary, c = n.altBoundary, f = n.padding, p = n.tether, m = p === void 0 ? !0 : p, v = n.tetherOffset, g = v === void 0 ? 0 : v, h = Ia(t, {
    boundary: u,
    rootBoundary: l,
    padding: f,
    altBoundary: c
  }), w = rr(t.placement), S = Qn(t.placement), x = !S, O = oc(w), B = oT(O), F = t.modifiersData.popperOffsets, L = t.rects.reference, j = t.rects.popper, I = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, N = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, J = {
    x: 0,
    y: 0
  };
  if (F) {
    if (o) {
      var R, ae = O === "y" ? wt : Dt, H = O === "y" ? Rt : _t, oe = O === "y" ? "height" : "width", ue = F[O], me = ue + h[ae], V = ue - h[H], T = m ? -j[oe] / 2 : 0, C = S === qn ? L[oe] : j[oe], M = S === qn ? -j[oe] : -L[oe], P = t.elements.arrow, W = m && P ? ac(P) : {
        width: 0,
        height: 0
      }, z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : e0(), K = z[ae], X = z[H], G = Sa(0, L[oe], W[oe]), te = x ? L[oe] / 2 - T - G - K - N.mainAxis : C - G - K - N.mainAxis, se = x ? -L[oe] / 2 + T + G + X + N.mainAxis : M + G + X + N.mainAxis, Z = t.elements.arrow && Ka(t.elements.arrow), ne = Z ? O === "y" ? Z.clientTop || 0 : Z.clientLeft || 0 : 0, be = (R = q == null ? void 0 : q[O]) != null ? R : 0, Pe = ue + te - be - ne, Ve = ue + se - be, Et = Sa(m ? Jo(me, Pe) : me, ue, m ? tn(V, Ve) : V);
      F[O] = Et, J[O] = Et - ue;
    }
    if (s) {
      var Ze, Yr = O === "x" ? wt : Dt, bn = O === "x" ? Rt : _t, gt = F[B], zt = B === "y" ? "height" : "width", xt = gt + h[Yr], wr = gt - h[bn], wn = [wt, Dt].indexOf(w) !== -1, Kt = (Ze = q == null ? void 0 : q[B]) != null ? Ze : 0, ur = wn ? xt : gt - L[zt] - j[zt] - Kt + N.altAxis, aa = wn ? gt + L[zt] + j[zt] - Kt - N.altAxis : wr, lr = m && wn ? T6(ur, gt, aa) : Sa(m ? ur : xt, gt, m ? aa : wr);
      F[B] = lr, J[B] = lr - gt;
    }
    t.modifiersData[r] = J;
  }
}
const sT = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: iT,
  requiresIfExists: ["offset"]
};
function uT(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function lT(e) {
  return e === Ot(e) || !Ft(e) ? ic(e) : uT(e);
}
function cT(e) {
  var t = e.getBoundingClientRect(), n = Xn(t.width) / e.offsetWidth || 1, r = Xn(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function dT(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ft(t), a = Ft(t) && cT(t), o = Wr(t), i = Gn(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ar(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  uc(o)) && (s = lT(t)), Ft(t) ? (u = Gn(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : o && (u.x = sc(o))), {
    x: i.left + s.scrollLeft - u.x,
    y: i.top + s.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function fT(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function a(o) {
    n.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(s) {
      if (!n.has(s)) {
        var u = t.get(s);
        u && a(u);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || a(o);
  }), r;
}
function pT(e) {
  var t = fT(e);
  return x6.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function hT(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function vT(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var lp = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function cp() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function mT(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, o = a === void 0 ? lp : a;
  return function(s, u, l) {
    l === void 0 && (l = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, lp, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, m = {
      state: c,
      setOptions: function(w) {
        var S = typeof w == "function" ? w(c.options) : w;
        g(), c.options = Object.assign({}, o, c.options, S), c.scrollParents = {
          reference: cn(s) ? $a(s) : s.contextElement ? $a(s.contextElement) : [],
          popper: $a(u)
        };
        var x = pT(vT([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = x.filter(function(O) {
          return O.enabled;
        }), v(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var w = c.elements, S = w.reference, x = w.popper;
          if (cp(S, x)) {
            c.rects = {
              reference: dT(S, Ka(x), c.options.strategy === "fixed"),
              popper: ac(x)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(N) {
              return c.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var O = 0; O < c.orderedModifiers.length; O++) {
              if (c.reset === !0) {
                c.reset = !1, O = -1;
                continue;
              }
              var B = c.orderedModifiers[O], F = B.fn, L = B.options, j = L === void 0 ? {} : L, I = B.name;
              typeof F == "function" && (c = F({
                state: c,
                options: j,
                name: I,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: hT(function() {
        return new Promise(function(h) {
          m.forceUpdate(), h(c);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!cp(s, u))
      return m;
    m.setOptions(l).then(function(h) {
      !p && l.onFirstUpdate && l.onFirstUpdate(h);
    });
    function v() {
      c.orderedModifiers.forEach(function(h) {
        var w = h.name, S = h.options, x = S === void 0 ? {} : S, O = h.effect;
        if (typeof O == "function") {
          var B = O({
            state: c,
            name: w,
            instance: m,
            options: x
          }), F = function() {
          };
          f.push(B || F);
        }
      });
    }
    function g() {
      f.forEach(function(h) {
        return h();
      }), f = [];
    }
    return m;
  };
}
var gT = [j6, aT, I6, k6, rT, Q6, sT, F6, J6], yT = /* @__PURE__ */ mT({
  defaultModifiers: gT
}), bT = typeof Element < "u", wT = typeof Map == "function", DT = typeof Set == "function", CT = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Do(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Do(e[r], t[r]))
          return !1;
      return !0;
    }
    var o;
    if (wT && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!Do(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (DT && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (CT && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    if (bT && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((a[r] === "_owner" || a[r] === "__v" || a[r] === "__o") && e.$$typeof) && !Do(e[a[r]], t[a[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var ET = function(t, n) {
  try {
    return Do(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const xT = /* @__PURE__ */ gr(ET);
var ST = [], $T = function(t, n, r) {
  r === void 0 && (r = {});
  var a = U.useRef(null), o = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || ST
  }, i = U.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = i[0], u = i[1], l = U.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(m) {
        var v = m.state, g = Object.keys(v.elements);
        zp.flushSync(function() {
          u({
            styles: ep(g.map(function(h) {
              return [h, v.styles[h] || {}];
            })),
            attributes: ep(g.map(function(h) {
              return [h, v.attributes[h]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = U.useMemo(function() {
    var p = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [l, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return xT(a.current, p) ? a.current || p : (a.current = p, p);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, l]), f = U.useRef();
  return tp(function() {
    f.current && f.current.setOptions(c);
  }, [c]), tp(function() {
    if (!(t == null || n == null)) {
      var p = r.createPopper || yT, m = p(t, n, c);
      return f.current = m, function() {
        m.destroy(), f.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
}, kT = function() {
}, OT = function() {
  return Promise.resolve(null);
}, BT = [];
function TT(e) {
  var t = e.placement, n = t === void 0 ? "bottom" : t, r = e.strategy, a = r === void 0 ? "absolute" : r, o = e.modifiers, i = o === void 0 ? BT : o, s = e.referenceElement, u = e.onFirstUpdate, l = e.innerRef, c = e.children, f = U.useContext(Km), p = U.useState(null), m = p[0], v = p[1], g = U.useState(null), h = g[0], w = g[1];
  U.useEffect(function() {
    Cu(l, m);
  }, [l, m]);
  var S = U.useMemo(function() {
    return {
      placement: n,
      strategy: a,
      onFirstUpdate: u,
      modifiers: [].concat(i, [{
        name: "arrow",
        enabled: h != null,
        options: {
          element: h
        }
      }])
    };
  }, [n, a, u, i, h]), x = $T(s || f, m, S), O = x.state, B = x.styles, F = x.forceUpdate, L = x.update, j = U.useMemo(function() {
    return {
      ref: v,
      style: B.popper,
      placement: O ? O.placement : n,
      hasPopperEscaped: O && O.modifiersData.hide ? O.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: O && O.modifiersData.hide ? O.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: B.arrow,
        ref: w
      },
      forceUpdate: F || kT,
      update: L || OT
    };
  }, [v, w, n, O, B, L, F]);
  return qm(c)(j);
}
var AT = process.env.NODE_ENV !== "production", o0 = function() {
};
if (AT) {
  var PT = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var o = 0, i = "Warning: " + t.replace(/%s/g, function() {
      return n[o++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  o0 = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || PT.apply(null, [t].concat(n));
  };
}
var MT = o0;
const FT = /* @__PURE__ */ gr(MT);
function RT(e) {
  var t = e.children, n = e.innerRef, r = U.useContext(Um), a = U.useCallback(function(o) {
    Cu(n, o), Xm(r, o);
  }, [n, r]);
  return U.useEffect(function() {
    return function() {
      return Cu(n, null);
    };
  }, []), U.useEffect(function() {
    FT(!!r, "`Reference` should not be used outside of a `Manager` component.");
  }, [r]), qm(t)({
    ref: a
  });
}
function _T(e, t) {
  if (ce(2, arguments), ht(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var n = pe(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = dt(n, t.month)), t.date != null && n.setDate(Ce(t.date)), t.hours != null && n.setHours(Ce(t.hours)), t.minutes != null && n.setMinutes(Ce(t.minutes)), t.seconds != null && n.setSeconds(Ce(t.seconds)), t.milliseconds != null && n.setMilliseconds(Ce(t.milliseconds)), n);
}
function dp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ei(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dp(Object(n), !0).forEach(function(r) {
      E(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Su(e) {
  return Su = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Su(e);
}
function at(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, i0(r.key), r);
  }
}
function ot(e, t, n) {
  return t && fp(e.prototype, t), n && fp(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function E(e, t, n) {
  return (t = i0(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function La() {
  return La = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, La.apply(this, arguments);
}
function it(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $u(e, t);
}
function ti(e) {
  return ti = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ti(e);
}
function $u(e, t) {
  return $u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, $u(e, t);
}
function $(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function st(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = ti(e);
    if (t) {
      var a = ti(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return function(o, i) {
      if (i && (typeof i == "object" || typeof i == "function"))
        return i;
      if (i !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return $(o);
    }(this, n);
  };
}
function ja(e) {
  return function(t) {
    if (Array.isArray(t))
      return Ss(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return Ss(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
        return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return Ss(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ss(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function i0(e) {
  var t = function(n, r) {
    if (typeof n != "object" || n === null)
      return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var o = a.call(n, r || "default");
      if (typeof o != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var pp = function(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, hp = function(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, NT = { p: hp, P: function(e, t) {
  var n, r = e.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return pp(e, t);
  switch (a) {
    case "P":
      n = t.dateTime({ width: "short" });
      break;
    case "PP":
      n = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      n = t.dateTime({ width: "long" });
      break;
    default:
      n = t.dateTime({ width: "full" });
  }
  return n.replace("{{date}}", pp(a, t)).replace("{{time}}", hp(o, t));
} }, ka = 12, IT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ie(e) {
  var t = e ? typeof e == "string" || e instanceof String ? j8(e) : pe(e) : /* @__PURE__ */ new Date();
  return kr(t) ? t : null;
}
function kr(e, t) {
  return t = t || /* @__PURE__ */ new Date("1/1/1000"), Fa(e) && !Br(e, t);
}
function qe(e, t, n) {
  if (n === "en")
    return Uf(e, t, { awareOfUnicodeTokens: !0 });
  var r = Fr(n);
  return n && !r && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !r && rn() && Fr(rn()) && (r = Fr(rn())), Uf(e, t, { locale: r || null, awareOfUnicodeTokens: !0 });
}
function Xt(e, t) {
  var n = t.dateFormat, r = t.locale;
  return e && qe(e, Array.isArray(n) ? n[0] : n, r) || "";
}
function vp(e, t) {
  var n = t.hour, r = n === void 0 ? 0 : n, a = t.minute, o = a === void 0 ? 0 : a, i = t.second;
  return bo(yo(MB(e, i === void 0 ? 0 : i), o), r);
}
function lc(e, t, n) {
  var r = Fr(t || rn());
  return Im(e, { locale: r, weekStartsOn: n });
}
function Mr(e) {
  return Lm(e);
}
function ga(e) {
  return jm(e);
}
function mp(e) {
  return yu(e);
}
function gp() {
  return tr(Ie());
}
function Tr(e, t) {
  return e && t ? WB(e, t) : !e && !t;
}
function It(e, t) {
  return e && t ? jB(e, t) : !e && !t;
}
function ri(e, t) {
  return e && t ? YB(e, t) : !e && !t;
}
function ft(e, t) {
  return e && t ? LB(e, t) : !e && !t;
}
function Gr(e, t) {
  return e && t ? IB(e, t) : !e && !t;
}
function Co(e, t, n) {
  var r, a = tr(t), o = bu(n);
  try {
    r = _a(e, { start: a, end: o });
  } catch {
    r = !1;
  }
  return r;
}
function rn() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function Fr(e) {
  if (typeof e == "string") {
    var t = typeof window < "u" ? window : globalThis;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function cc(e, t) {
  return qe(dt(Ie(), e), "LLLL", t);
}
function s0(e, t) {
  return qe(dt(Ie(), e), "LLL", t);
}
function Ci(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.excludeDateIntervals, i = t.includeDates, s = t.includeDateIntervals, u = t.filterDate;
  return Ei(e, { minDate: n, maxDate: r }) || a && a.some(function(l) {
    return ft(e, l);
  }) || o && o.some(function(l) {
    var c = l.start, f = l.end;
    return _a(e, { start: c, end: f });
  }) || i && !i.some(function(l) {
    return ft(e, l);
  }) || s && !s.some(function(l) {
    var c = l.start, f = l.end;
    return _a(e, { start: c, end: f });
  }) || u && !u(Ie(e)) || !1;
}
function dc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeDates, r = t.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(a) {
    var o = a.start, i = a.end;
    return _a(e, { start: o, end: i });
  }) : n && n.some(function(a) {
    return ft(e, a);
  }) || !1;
}
function u0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate;
  return Ei(e, { minDate: Lm(n), maxDate: _B(r) }) || a && a.some(function(s) {
    return It(e, s);
  }) || o && !o.some(function(s) {
    return It(e, s);
  }) || i && !i(Ie(e)) || !1;
}
function $s(e, t, n, r) {
  var a = Ee(e), o = ct(e), i = Ee(t), s = ct(t), u = Ee(r);
  return a === i && a === u ? o <= n && n <= s : a < i ? u === a && o <= n || u === i && s >= n || u < i && u > a : void 0;
}
function LT(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate;
  return Ei(e, { minDate: n, maxDate: r }) || a && a.some(function(s) {
    return ri(e, s);
  }) || o && !o.some(function(s) {
    return ri(e, s);
  }) || i && !i(Ie(e)) || !1;
}
function ks(e, t, n) {
  if (!Fa(t) || !Fa(n))
    return !1;
  var r = Ee(t), a = Ee(n);
  return r <= e && a >= e;
}
function l0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, o = t.includeDates, i = t.filterDate, s = new Date(e, 0, 1);
  return Ei(s, { minDate: jm(n), maxDate: NB(r) }) || a && a.some(function(u) {
    return Tr(s, u);
  }) || o && !o.some(function(u) {
    return Tr(s, u);
  }) || i && !i(Ie(s)) || !1;
}
function Os(e, t, n, r) {
  var a = Ee(e), o = Pn(e), i = Ee(t), s = Pn(t), u = Ee(r);
  return a === i && a === u ? o <= n && n <= s : a < i ? u === a && o <= n || u === i && s >= n || u < i && u > a : void 0;
}
function Ei(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate;
  return n && qo(e, n) < 0 || r && qo(e, r) > 0;
}
function yp(e, t) {
  return t.some(function(n) {
    return Ht(n) === Ht(e) && Yt(n) === Yt(e);
  });
}
function bp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeTimes, r = t.includeTimes, a = t.filterTime;
  return n && yp(e, n) || r && !yp(e, r) || a && !a(e) || !1;
}
function wp(e, t) {
  var n = t.minTime, r = t.maxTime;
  if (!n || !r)
    throw new Error("Both minTime and maxTime props required");
  var a, o = Ie(), i = bo(yo(o, Yt(e)), Ht(e)), s = bo(yo(o, Yt(n)), Ht(n)), u = bo(yo(o, Yt(r)), Ht(r));
  try {
    a = !_a(i, { start: s, end: u });
  } catch {
    a = !1;
  }
  return a;
}
function Dp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Un(e, 1);
  return n && Xo(n, a) > 0 || r && r.every(function(o) {
    return Xo(o, a) > 0;
  }) || !1;
}
function Cp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = Vt(e, 1);
  return n && Xo(a, n) > 0 || r && r.every(function(o) {
    return Xo(a, o) > 0;
  }) || !1;
}
function Ep(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Ra(e, 1);
  return n && Go(n, a) > 0 || r && r.every(function(o) {
    return Go(o, a) > 0;
  }) || !1;
}
function xp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = Kn(e, 1);
  return n && Go(a, n) > 0 || r && r.every(function(o) {
    return Go(a, o) > 0;
  }) || !1;
}
function c0(e) {
  var t = e.minDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return qo(a, t) >= 0;
    });
    return Xf(r);
  }
  return n ? Xf(n) : t;
}
function d0(e) {
  var t = e.maxDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return qo(a, t) <= 0;
    });
    return Gf(r);
  }
  return n ? Gf(n) : t;
}
function Sp() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), r = 0, a = e.length; r < a; r++) {
    var o = e[r];
    if (bi(o)) {
      var i = qe(o, "MM.dd.yyyy"), s = n.get(i) || [];
      s.includes(t) || (s.push(t), n.set(i, s));
    } else if (Su(o) === "object") {
      var u = Object.keys(o), l = u[0], c = o[u[0]];
      if (typeof l == "string" && c.constructor === Array)
        for (var f = 0, p = c.length; f < p; f++) {
          var m = qe(c[f], "MM.dd.yyyy"), v = n.get(m) || [];
          v.includes(l) || (v.push(l), n.set(m, v));
        }
    }
  }
  return n;
}
function jT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    var a = r.date, o = r.holidayName;
    if (bi(a)) {
      var i = qe(a, "MM.dd.yyyy"), s = n.get(i) || {};
      if (!("className" in s) || s.className !== t || (u = s.holidayNames, l = [o], u.length !== l.length || !u.every(function(f, p) {
        return f === l[p];
      }))) {
        var u, l;
        s.className = t;
        var c = s.holidayNames;
        s.holidayNames = c ? [].concat(ja(c), [o]) : [o], n.set(i, s);
      }
    }
  }), n;
}
function WT(e, t, n, r, a) {
  for (var o = a.length, i = [], s = 0; s < o; s++) {
    var u = mu(xB(e, Ht(a[s])), Yt(a[s])), l = mu(e, (n + 1) * r);
    Nr(u, t) && Br(u, l) && i.push(a[s]);
  }
  return i;
}
function $p(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Mn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ka, n = Math.ceil(Ee(e) / t) * t;
  return { startPeriod: n - (t - 1), endPeriod: n };
}
function kp(e) {
  var t = e.getSeconds(), n = e.getMilliseconds();
  return pe(e.getTime() - 1e3 * t - n);
}
function YT(e, t, n, r) {
  for (var a = [], o = 0; o < 2 * t + 1; o++) {
    var i = e + t - o, s = !0;
    n && (s = Ee(n) <= i), r && s && (s = Ee(r) >= i), s && a.push(i);
  }
  return a;
}
var HT = wi(function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    at(this, n), E($(a = t.call(this, r)), "renderOptions", function() {
      var u = a.props.year, l = a.state.yearsList.map(function(p) {
        return d.createElement("div", { className: u === p ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: p, onClick: a.onChange.bind($(a), p), "aria-selected": u === p ? "true" : void 0 }, u === p ? d.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", p);
      }), c = a.props.minDate ? Ee(a.props.minDate) : null, f = a.props.maxDate ? Ee(a.props.maxDate) : null;
      return f && a.state.yearsList.find(function(p) {
        return p === f;
      }) || l.unshift(d.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: a.incrementYears }, d.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), c && a.state.yearsList.find(function(p) {
        return p === c;
      }) || l.push(d.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: a.decrementYears }, d.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), l;
    }), E($(a), "onChange", function(u) {
      a.props.onChange(u);
    }), E($(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), E($(a), "shiftYears", function(u) {
      var l = a.state.yearsList.map(function(c) {
        return c + u;
      });
      a.setState({ yearsList: l });
    }), E($(a), "incrementYears", function() {
      return a.shiftYears(1);
    }), E($(a), "decrementYears", function() {
      return a.shiftYears(-1);
    });
    var o = r.yearDropdownItemNumber, i = r.scrollableYearDropdown, s = o || (i ? 10 : 5);
    return a.state = { yearsList: YT(a.props.year, s, a.props.minDate, a.props.maxDate) }, a.dropdownRef = N0(), a;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    var r = this.dropdownRef.current;
    if (r) {
      var a = r.children ? Array.from(r.children) : null, o = a ? a.find(function(i) {
        return i.ariaSelected;
      }) : null;
      r.scrollTop = o ? o.offsetTop + (o.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var r = pt({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return d.createElement("div", { className: r, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
}()), VT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), E($(r), "renderSelectOptions", function() {
      for (var s = r.props.minDate ? Ee(r.props.minDate) : 1900, u = r.props.maxDate ? Ee(r.props.maxDate) : 2100, l = [], c = s; c <= u; c++)
        l.push(d.createElement("option", { key: c, value: c }, c));
      return l;
    }), E($(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), E($(r), "renderSelectMode", function() {
      return d.createElement("select", { value: r.props.year, className: "react-datepicker__year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), E($(r), "renderReadView", function(s) {
      return d.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(u) {
        return r.toggleDropdown(u);
      } }, d.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), d.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, r.props.year));
    }), E($(r), "renderDropdown", function() {
      return d.createElement(HT, { key: "dropdown", year: r.props.year, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableYearDropdown: r.props.scrollableYearDropdown, yearDropdownItemNumber: r.props.yearDropdownItemNumber });
    }), E($(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, u = [r.renderReadView(!s)];
      return s && u.unshift(r.renderDropdown()), u;
    }), E($(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.year && r.props.onChange(s);
    }), E($(r), "toggleDropdown", function(s) {
      r.setState({ dropdownVisible: !r.state.dropdownVisible }, function() {
        r.props.adjustDateOnChange && r.handleYearChange(r.props.date, s);
      });
    }), E($(r), "handleYearChange", function(s, u) {
      r.onSelect(s, u), r.setOpen();
    }), E($(r), "onSelect", function(s, u) {
      r.props.onSelect && r.props.onSelect(s, u);
    }), E($(r), "setOpen", function() {
      r.props.setOpen && r.props.setOpen(!0);
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return d.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), zT = wi(function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "isSelectedMonth", function(s) {
      return r.props.month === s;
    }), E($(r), "renderOptions", function() {
      return r.props.monthNames.map(function(s, u) {
        return d.createElement("div", { className: r.isSelectedMonth(u) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: r.onChange.bind($(r), u), "aria-selected": r.isSelectedMonth(u) ? "true" : void 0 }, r.isSelectedMonth(u) ? d.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), E($(r), "onChange", function(s) {
      return r.props.onChange(s);
    }), E($(r), "handleClickOutside", function() {
      return r.props.onCancel();
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    return d.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
}()), KT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), E($(r), "renderSelectOptions", function(s) {
      return s.map(function(u, l) {
        return d.createElement("option", { key: l, value: l }, u);
      });
    }), E($(r), "renderSelectMode", function(s) {
      return d.createElement("select", { value: r.props.month, className: "react-datepicker__month-select", onChange: function(u) {
        return r.onChange(u.target.value);
      } }, r.renderSelectOptions(s));
    }), E($(r), "renderReadView", function(s, u) {
      return d.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: r.toggleDropdown }, d.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), d.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, u[r.props.month]));
    }), E($(r), "renderDropdown", function(s) {
      return d.createElement(zT, { key: "dropdown", month: r.props.month, monthNames: s, onChange: r.onChange, onCancel: r.toggleDropdown });
    }), E($(r), "renderScrollMode", function(s) {
      var u = r.state.dropdownVisible, l = [r.renderReadView(!u, s)];
      return u && l.unshift(r.renderDropdown(s)), l;
    }), E($(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.month && r.props.onChange(s);
    }), E($(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    var r, a = this, o = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(i) {
      return s0(i, a.props.locale);
    } : function(i) {
      return cc(i, a.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode(o);
        break;
      case "select":
        r = this.renderSelectMode(o);
    }
    return d.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}();
function UT(e, t) {
  for (var n = [], r = Mr(e), a = Mr(t); !Nr(r, a); )
    n.push(Ie(r)), r = Vt(r, 1);
  return n;
}
var po, qT = wi(function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "renderOptions", function() {
      return a.state.monthYearsList.map(function(o) {
        var i = gu(o), s = Tr(a.props.date, o) && It(a.props.date, o);
        return d.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: i, onClick: a.onChange.bind($(a), i), "aria-selected": s ? "true" : void 0 }, s ? d.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", qe(o, a.props.dateFormat, a.props.locale));
      });
    }), E($(a), "onChange", function(o) {
      return a.props.onChange(o);
    }), E($(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), a.state = { monthYearsList: UT(a.props.minDate, a.props.maxDate) }, a;
  }
  return ot(n, [{ key: "render", value: function() {
    var r = pt({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return d.createElement("div", { className: r }, this.renderOptions());
  } }]), n;
}()), XT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "state", { dropdownVisible: !1 }), E($(r), "renderSelectOptions", function() {
      for (var s = Mr(r.props.minDate), u = Mr(r.props.maxDate), l = []; !Nr(s, u); ) {
        var c = gu(s);
        l.push(d.createElement("option", { key: c, value: c }, qe(s, r.props.dateFormat, r.props.locale))), s = Vt(s, 1);
      }
      return l;
    }), E($(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), E($(r), "renderSelectMode", function() {
      return d.createElement("select", { value: gu(Mr(r.props.date)), className: "react-datepicker__month-year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), E($(r), "renderReadView", function(s) {
      var u = qe(r.props.date, r.props.dateFormat, r.props.locale);
      return d.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(l) {
        return r.toggleDropdown(l);
      } }, d.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), d.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, u));
    }), E($(r), "renderDropdown", function() {
      return d.createElement(qT, { key: "dropdown", date: r.props.date, dateFormat: r.props.dateFormat, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown, locale: r.props.locale });
    }), E($(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, u = [r.renderReadView(!s)];
      return s && u.unshift(r.renderDropdown()), u;
    }), E($(r), "onChange", function(s) {
      r.toggleDropdown();
      var u = Ie(parseInt(s));
      Tr(r.props.date, u) && It(r.props.date, u) || r.props.onChange(u);
    }), E($(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return d.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), GT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "dayEl", d.createRef()), E($(r), "handleClick", function(s) {
      !r.isDisabled() && r.props.onClick && r.props.onClick(s);
    }), E($(r), "handleMouseEnter", function(s) {
      !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(s);
    }), E($(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), E($(r), "isSameDay", function(s) {
      return ft(r.props.day, s);
    }), E($(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !r.isSameDay(r.props.selected) && r.isSameDay(r.props.preSelection);
    }), E($(r), "isDisabled", function() {
      return Ci(r.props.day, r.props);
    }), E($(r), "isExcluded", function() {
      return dc(r.props.day, r.props);
    }), E($(r), "getHighLightedClass", function() {
      var s = r.props, u = s.day, l = s.highlightDates;
      if (!l)
        return !1;
      var c = qe(u, "MM.dd.yyyy");
      return l.get(c);
    }), E($(r), "getHolidaysClass", function() {
      var s = r.props, u = s.day, l = s.holidays;
      if (!l)
        return !1;
      var c = qe(u, "MM.dd.yyyy");
      return l.has(c) ? [l.get(c).className] : void 0;
    }), E($(r), "isInRange", function() {
      var s = r.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && Co(u, l, c);
    }), E($(r), "isInSelectingRange", function() {
      var s, u = r.props, l = u.day, c = u.selectsStart, f = u.selectsEnd, p = u.selectsRange, m = u.selectsDisabledDaysInRange, v = u.startDate, g = u.endDate, h = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return !(!(c || f || p) || !h || !m && r.isDisabled()) && (c && g && (Br(h, g) || Gr(h, g)) ? Co(l, h, g) : (f && v && (Nr(h, v) || Gr(h, v)) || !(!p || !v || g || !Nr(h, v) && !Gr(h, v))) && Co(l, v, h));
    }), E($(r), "isSelectingRangeStart", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var u = r.props, l = u.day, c = u.startDate, f = u.selectsStart, p = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return ft(l, f ? p : c);
    }), E($(r), "isSelectingRangeEnd", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var u = r.props, l = u.day, c = u.endDate, f = u.selectsEnd, p = u.selectsRange, m = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return ft(l, f || p ? m : c);
    }), E($(r), "isRangeStart", function() {
      var s = r.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && ft(l, u);
    }), E($(r), "isRangeEnd", function() {
      var s = r.props, u = s.day, l = s.startDate, c = s.endDate;
      return !(!l || !c) && ft(c, u);
    }), E($(r), "isWeekend", function() {
      var s = OB(r.props.day);
      return s === 0 || s === 6;
    }), E($(r), "isAfterMonth", function() {
      return r.props.month !== void 0 && (r.props.month + 1) % 12 === ct(r.props.day);
    }), E($(r), "isBeforeMonth", function() {
      return r.props.month !== void 0 && (ct(r.props.day) + 1) % 12 === r.props.month;
    }), E($(r), "isCurrentDay", function() {
      return r.isSameDay(Ie());
    }), E($(r), "isSelected", function() {
      return r.isSameDay(r.props.selected);
    }), E($(r), "getClassNames", function(s) {
      var u, l = r.props.dayClassName ? r.props.dayClassName(s) : void 0;
      return pt("react-datepicker__day", l, "react-datepicker__day--" + qe(r.props.day, "ddd", u), { "react-datepicker__day--disabled": r.isDisabled(), "react-datepicker__day--excluded": r.isExcluded(), "react-datepicker__day--selected": r.isSelected(), "react-datepicker__day--keyboard-selected": r.isKeyboardSelected(), "react-datepicker__day--range-start": r.isRangeStart(), "react-datepicker__day--range-end": r.isRangeEnd(), "react-datepicker__day--in-range": r.isInRange(), "react-datepicker__day--in-selecting-range": r.isInSelectingRange(), "react-datepicker__day--selecting-range-start": r.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": r.isSelectingRangeEnd(), "react-datepicker__day--today": r.isCurrentDay(), "react-datepicker__day--weekend": r.isWeekend(), "react-datepicker__day--outside-month": r.isAfterMonth() || r.isBeforeMonth() }, r.getHighLightedClass("react-datepicker__day--highlighted"), r.getHolidaysClass());
    }), E($(r), "getAriaLabel", function() {
      var s = r.props, u = s.day, l = s.ariaLabelPrefixWhenEnabled, c = l === void 0 ? "Choose" : l, f = s.ariaLabelPrefixWhenDisabled, p = f === void 0 ? "Not available" : f, m = r.isDisabled() || r.isExcluded() ? p : c;
      return "".concat(m, " ").concat(qe(u, "PPPP", r.props.locale));
    }), E($(r), "getTitle", function() {
      var s = r.props, u = s.day, l = s.holidays, c = l === void 0 ? /* @__PURE__ */ new Map() : l, f = qe(u, "MM.dd.yyyy");
      return c.has(f) && c.get(f).holidayNames.length > 0 ? c.get(f).holidayNames.join(", ") : "";
    }), E($(r), "getTabIndex", function(s, u) {
      var l = s || r.props.selected, c = u || r.props.preSelection;
      return r.isKeyboardSelected() || r.isSameDay(l) && ft(c, l) ? 0 : -1;
    }), E($(r), "handleFocusDay", function() {
      var s, u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      r.getTabIndex() === 0 && !u.isInputFocused && r.isSameDay(r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), r.props.inline && !r.props.shouldFocusDayInline && (l = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (l = !0), r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() && (l = !1), r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() && (l = !1)), l && ((s = r.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    }), E($(r), "renderDayContents", function() {
      return r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() || r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() ? null : r.props.renderDayContents ? r.props.renderDayContents(qf(r.props.day), r.props.day) : qf(r.props.day);
    }), E($(r), "render", function() {
      return d.createElement("div", { ref: r.dayEl, className: r.getClassNames(r.props.day), onKeyDown: r.handleOnKeyDown, onClick: r.handleClick, onMouseEnter: r.handleMouseEnter, tabIndex: r.getTabIndex(), "aria-label": r.getAriaLabel(), role: "option", title: r.getTitle(), "aria-disabled": r.isDisabled(), "aria-current": r.isCurrentDay() ? "date" : void 0, "aria-selected": r.isSelected() || r.isInRange() }, r.renderDayContents(), r.getTitle() !== "" && d.createElement("span", { className: "holiday-overlay" }, r.getTitle()));
    }), r;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusDay(r);
  } }]), n;
}(), QT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "handleClick", function(s) {
      r.props.onClick && r.props.onClick(s);
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    var r = this.props, a = r.weekNumber, o = r.ariaLabelPrefix, i = o === void 0 ? "week " : o, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!r.onClick };
    return d.createElement("div", { className: pt(s), "aria-label": "".concat(i, " ").concat(this.props.weekNumber), onClick: this.handleClick }, a);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), n;
}(), ZT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "handleDayClick", function(s, u) {
      r.props.onDayClick && r.props.onDayClick(s, u);
    }), E($(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), E($(r), "handleWeekClick", function(s, u, l) {
      typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(s, u, l), r.props.shouldCloseOnSelect && r.props.setOpen(!1);
    }), E($(r), "formatWeekNumber", function(s) {
      return r.props.formatWeekNumber ? r.props.formatWeekNumber(s) : function(u, l) {
        var c = l && Fr(l) || rn() && Fr(rn());
        return PB(u, c ? { locale: c } : null);
      }(s);
    }), E($(r), "renderDays", function() {
      var s = lc(r.props.day, r.props.locale, r.props.calendarStartDay), u = [], l = r.formatWeekNumber(s);
      if (r.props.showWeekNumber) {
        var c = r.props.onWeekSelect ? r.handleWeekClick.bind($(r), s, l) : void 0;
        u.push(d.createElement(QT, { key: "W", weekNumber: l, onClick: c, ariaLabelPrefix: r.props.ariaLabelPrefix }));
      }
      return u.concat([0, 1, 2, 3, 4, 5, 6].map(function(f) {
        var p = na(s, f);
        return d.createElement(GT, { ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix, key: p.valueOf(), day: p, month: r.props.month, onClick: r.handleDayClick.bind($(r), p), onMouseEnter: r.handleDayMouseEnter.bind($(r), p), minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, renderDayContents: r.props.renderDayContents, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart, locale: r.props.locale });
      }));
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    return d.createElement("div", { className: "react-datepicker__week" }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
}(), f0 = "two_columns", p0 = "three_columns", h0 = "four_columns", Bs = (E(po = {}, f0, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), E(po, p0, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), E(po, h0, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 }), po);
function Op(e, t) {
  return e ? h0 : t ? f0 : p0;
}
var JT = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "MONTH_REFS", ja(Array(12)).map(function() {
      return d.createRef();
    })), E($(r), "QUARTER_REFS", ja(Array(4)).map(function() {
      return d.createRef();
    })), E($(r), "isDisabled", function(s) {
      return Ci(s, r.props);
    }), E($(r), "isExcluded", function(s) {
      return dc(s, r.props);
    }), E($(r), "handleDayClick", function(s, u) {
      r.props.onDayClick && r.props.onDayClick(s, u, r.props.orderInDisplay);
    }), E($(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), E($(r), "handleMouseLeave", function() {
      r.props.onMouseLeave && r.props.onMouseLeave();
    }), E($(r), "isRangeStartMonth", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate;
      return !(!c || !f) && It(dt(l, s), c);
    }), E($(r), "isRangeStartQuarter", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate;
      return !(!c || !f) && ri(kn(l, s), c);
    }), E($(r), "isRangeEndMonth", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate;
      return !(!c || !f) && It(dt(l, s), f);
    }), E($(r), "isRangeEndQuarter", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate;
      return !(!c || !f) && ri(kn(l, s), f);
    }), E($(r), "isInSelectingRangeMonth", function(s) {
      var u, l = r.props, c = l.day, f = l.selectsStart, p = l.selectsEnd, m = l.selectsRange, v = l.startDate, g = l.endDate, h = (u = r.props.selectingDate) !== null && u !== void 0 ? u : r.props.preSelection;
      return !(!(f || p || m) || !h) && (f && g ? $s(h, g, s, c) : (p && v || !(!m || !v || g)) && $s(v, h, s, c));
    }), E($(r), "isSelectingMonthRangeStart", function(s) {
      var u;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var l = r.props, c = l.day, f = l.startDate, p = l.selectsStart, m = dt(c, s), v = (u = r.props.selectingDate) !== null && u !== void 0 ? u : r.props.preSelection;
      return It(m, p ? v : f);
    }), E($(r), "isSelectingMonthRangeEnd", function(s) {
      var u;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var l = r.props, c = l.day, f = l.endDate, p = l.selectsEnd, m = l.selectsRange, v = dt(c, s), g = (u = r.props.selectingDate) !== null && u !== void 0 ? u : r.props.preSelection;
      return It(v, p || m ? g : f);
    }), E($(r), "isInSelectingRangeQuarter", function(s) {
      var u, l = r.props, c = l.day, f = l.selectsStart, p = l.selectsEnd, m = l.selectsRange, v = l.startDate, g = l.endDate, h = (u = r.props.selectingDate) !== null && u !== void 0 ? u : r.props.preSelection;
      return !(!(f || p || m) || !h) && (f && g ? Os(h, g, s, c) : (p && v || !(!m || !v || g)) && Os(v, h, s, c));
    }), E($(r), "isWeekInMonth", function(s) {
      var u = r.props.day, l = na(s, 6);
      return It(s, u) || It(l, u);
    }), E($(r), "isCurrentMonth", function(s, u) {
      return Ee(s) === Ee(Ie()) && u === ct(Ie());
    }), E($(r), "isCurrentQuarter", function(s, u) {
      return Ee(s) === Ee(Ie()) && u === Pn(Ie());
    }), E($(r), "isSelectedMonth", function(s, u, l) {
      return ct(l) === u && Ee(s) === Ee(l);
    }), E($(r), "isSelectedQuarter", function(s, u, l) {
      return Pn(s) === u && Ee(s) === Ee(l);
    }), E($(r), "renderWeeks", function() {
      for (var s = [], u = r.props.fixedHeight, l = 0, c = !1, f = lc(Mr(r.props.day), r.props.locale, r.props.calendarStartDay); s.push(d.createElement(ZT, { ariaLabelPrefix: r.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, key: l, day: f, month: ct(r.props.day), onDayClick: r.handleDayClick, onDayMouseEnter: r.handleDayMouseEnter, onWeekSelect: r.props.onWeekSelect, formatWeekNumber: r.props.formatWeekNumber, locale: r.props.locale, minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showWeekNumber: r.props.showWeekNumbers, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, setOpen: r.props.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, renderDayContents: r.props.renderDayContents, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, calendarStartDay: r.props.calendarStartDay, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart })), !c; ) {
        l++, f = Ql(f, 1);
        var p = u && l >= 6, m = !u && !r.isWeekInMonth(f);
        if (p || m) {
          if (!r.props.peekNextMonth)
            break;
          c = !0;
        }
      }
      return s;
    }), E($(r), "onMonthClick", function(s, u) {
      r.handleDayClick(Mr(dt(r.props.day, u)), s);
    }), E($(r), "onMonthMouseEnter", function(s) {
      r.handleDayMouseEnter(Mr(dt(r.props.day, s)));
    }), E($(r), "handleMonthNavigation", function(s, u) {
      r.isDisabled(u) || r.isExcluded(u) || (r.props.setPreSelection(u), r.MONTH_REFS[s].current && r.MONTH_REFS[s].current.focus());
    }), E($(r), "onMonthKeyDown", function(s, u) {
      var l = r.props, c = l.selected, f = l.preSelection, p = l.disabledKeyboardNavigation, m = l.showTwoColumnMonthYearPicker, v = l.showFourColumnMonthYearPicker, g = l.setPreSelection, h = s.key;
      if (h !== "Tab" && s.preventDefault(), !p) {
        var w = Op(v, m), S = Bs[w].verticalNavigationOffset, x = Bs[w].grid;
        switch (h) {
          case "Enter":
            r.onMonthClick(s, u), g(c);
            break;
          case "ArrowRight":
            r.handleMonthNavigation(u === 11 ? 0 : u + 1, Vt(f, 1));
            break;
          case "ArrowLeft":
            r.handleMonthNavigation(u === 0 ? 11 : u - 1, Un(f, 1));
            break;
          case "ArrowUp":
            r.handleMonthNavigation(x[0].includes(u) ? u + 12 - S : u - S, Un(f, S));
            break;
          case "ArrowDown":
            r.handleMonthNavigation(x[x.length - 1].includes(u) ? u - 12 + S : u + S, Vt(f, S));
        }
      }
    }), E($(r), "onQuarterClick", function(s, u) {
      r.handleDayClick(mp(kn(r.props.day, u)), s);
    }), E($(r), "onQuarterMouseEnter", function(s) {
      r.handleDayMouseEnter(mp(kn(r.props.day, s)));
    }), E($(r), "handleQuarterNavigation", function(s, u) {
      r.isDisabled(u) || r.isExcluded(u) || (r.props.setPreSelection(u), r.QUARTER_REFS[s - 1].current && r.QUARTER_REFS[s - 1].current.focus());
    }), E($(r), "onQuarterKeyDown", function(s, u) {
      var l = s.key;
      if (!r.props.disabledKeyboardNavigation)
        switch (l) {
          case "Enter":
            r.onQuarterClick(s, u), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleQuarterNavigation(u === 4 ? 1 : u + 1, Nm(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleQuarterNavigation(u === 1 ? 4 : u - 1, kB(r.props.preSelection, 1));
        }
    }), E($(r), "getMonthClassNames", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate, p = u.selected, m = u.minDate, v = u.maxDate, g = u.preSelection, h = u.monthClassName, w = u.excludeDates, S = u.includeDates, x = h ? h(dt(l, s)) : void 0, O = dt(l, s);
      return pt("react-datepicker__month-text", "react-datepicker__month-".concat(s), x, { "react-datepicker__month-text--disabled": (m || v || w || S) && u0(O, r.props), "react-datepicker__month-text--selected": r.isSelectedMonth(l, s, p), "react-datepicker__month-text--keyboard-selected": !r.props.disabledKeyboardNavigation && ct(g) === s, "react-datepicker__month-text--in-selecting-range": r.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": $s(c, f, s, l), "react-datepicker__month-text--range-start": r.isRangeStartMonth(s), "react-datepicker__month-text--range-end": r.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": r.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": r.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": r.isCurrentMonth(l, s) });
    }), E($(r), "getTabIndex", function(s) {
      var u = ct(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== u ? "-1" : "0";
    }), E($(r), "getQuarterTabIndex", function(s) {
      var u = Pn(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== u ? "-1" : "0";
    }), E($(r), "getAriaLabel", function(s) {
      var u = r.props, l = u.chooseDayAriaLabelPrefix, c = l === void 0 ? "Choose" : l, f = u.disabledDayAriaLabelPrefix, p = f === void 0 ? "Not available" : f, m = u.day, v = dt(m, s), g = r.isDisabled(v) || r.isExcluded(v) ? p : c;
      return "".concat(g, " ").concat(qe(v, "MMMM yyyy"));
    }), E($(r), "getQuarterClassNames", function(s) {
      var u = r.props, l = u.day, c = u.startDate, f = u.endDate, p = u.selected, m = u.minDate, v = u.maxDate, g = u.preSelection;
      return pt("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (m || v) && LT(kn(l, s), r.props), "react-datepicker__quarter-text--selected": r.isSelectedQuarter(l, s, p), "react-datepicker__quarter-text--keyboard-selected": Pn(g) === s, "react-datepicker__quarter-text--in-selecting-range": r.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": Os(c, f, s, l), "react-datepicker__quarter-text--range-start": r.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": r.isRangeEndQuarter(s) });
    }), E($(r), "getMonthContent", function(s) {
      var u = r.props, l = u.showFullMonthYearPicker, c = u.renderMonthContent, f = u.locale, p = s0(s, f), m = cc(s, f);
      return c ? c(s, p, m) : l ? m : p;
    }), E($(r), "getQuarterContent", function(s) {
      var u = r.props, l = u.renderQuarterContent, c = function(f, p) {
        return qe(kn(Ie(), f), "QQQ", p);
      }(s, u.locale);
      return l ? l(s, c) : c;
    }), E($(r), "renderMonths", function() {
      var s = r.props, u = s.showTwoColumnMonthYearPicker, l = s.showFourColumnMonthYearPicker, c = s.day, f = s.selected;
      return Bs[Op(l, u)].grid.map(function(p, m) {
        return d.createElement("div", { className: "react-datepicker__month-wrapper", key: m }, p.map(function(v, g) {
          return d.createElement("div", { ref: r.MONTH_REFS[v], key: g, onClick: function(h) {
            r.onMonthClick(h, v);
          }, onKeyDown: function(h) {
            r.onMonthKeyDown(h, v);
          }, onMouseEnter: function() {
            return r.onMonthMouseEnter(v);
          }, tabIndex: r.getTabIndex(v), className: r.getMonthClassNames(v), role: "option", "aria-label": r.getAriaLabel(v), "aria-current": r.isCurrentMonth(c, v) ? "date" : void 0, "aria-selected": r.isSelectedMonth(c, v, f) }, r.getMonthContent(v));
        }));
      });
    }), E($(r), "renderQuarters", function() {
      var s = r.props, u = s.day, l = s.selected;
      return d.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(c, f) {
        return d.createElement("div", { key: f, ref: r.QUARTER_REFS[f], role: "option", onClick: function(p) {
          r.onQuarterClick(p, c);
        }, onKeyDown: function(p) {
          r.onQuarterKeyDown(p, c);
        }, onMouseEnter: function() {
          return r.onQuarterMouseEnter(c);
        }, className: r.getQuarterClassNames(c), "aria-selected": r.isSelectedQuarter(u, c, l), tabIndex: r.getQuarterTabIndex(c), "aria-current": r.isCurrentQuarter(u, c) ? "date" : void 0 }, r.getQuarterContent(c));
      }));
    }), E($(r), "getClassNames", function() {
      var s = r.props, u = s.selectingDate, l = s.selectsStart, c = s.selectsEnd, f = s.showMonthYearPicker, p = s.showQuarterYearPicker;
      return pt("react-datepicker__month", { "react-datepicker__month--selecting-range": u && (l || c) }, { "react-datepicker__monthPicker": f }, { "react-datepicker__quarterPicker": p });
    }), r;
  }
  return ot(n, [{ key: "render", value: function() {
    var r = this.props, a = r.showMonthYearPicker, o = r.showQuarterYearPicker, i = r.day, s = r.ariaLabelPrefix, u = s === void 0 ? "month " : s;
    return d.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(u, " ").concat(qe(i, "yyyy-MM")), role: "listbox" }, a ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
}(), v0 = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    var r;
    at(this, n);
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return E($(r = t.call.apply(t, [this].concat(o))), "state", { height: null }), E($(r), "handleClick", function(s) {
      (r.props.minTime || r.props.maxTime) && wp(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && bp(s, r.props) || r.props.onChange(s);
    }), E($(r), "isSelectedTime", function(s) {
      return r.props.selected && (u = r.props.selected, l = s, kp(u).getTime() === kp(l).getTime());
      var u, l;
    }), E($(r), "liClasses", function(s) {
      var u = ["react-datepicker__time-list-item", r.props.timeClassName ? r.props.timeClassName(s) : void 0];
      return r.isSelectedTime(s) && u.push("react-datepicker__time-list-item--selected"), ((r.props.minTime || r.props.maxTime) && wp(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && bp(s, r.props)) && u.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (60 * Ht(s) + Yt(s)) % r.props.intervals != 0 && u.push("react-datepicker__time-list-item--injected"), u.join(" ");
    }), E($(r), "handleOnKeyDown", function(s, u) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && r.handleClick(u), r.props.handleOnKeyDown(s);
    }), E($(r), "renderTimes", function() {
      for (var s = [], u = r.props.format ? r.props.format : "p", l = r.props.intervals, c = r.props.selected || r.props.openToDate || Ie(), f = tr(c), p = r.props.injectTimes && r.props.injectTimes.sort(function(x, O) {
        return x - O;
      }), m = 60 * function(x) {
        var O = new Date(x.getFullYear(), x.getMonth(), x.getDate()), B = new Date(x.getFullYear(), x.getMonth(), x.getDate(), 24);
        return Math.round((+B - +O) / 36e5);
      }(c), v = m / l, g = 0; g < v; g++) {
        var h = mu(f, g * l);
        if (s.push(h), p) {
          var w = WT(f, h, g, l, p);
          s = s.concat(w);
        }
      }
      var S = s.reduce(function(x, O) {
        return O.getTime() <= c.getTime() ? O : x;
      }, s[0]);
      return s.map(function(x, O) {
        return d.createElement("li", { key: O, onClick: r.handleClick.bind($(r), x), className: r.liClasses(x), ref: function(B) {
          x === S && (r.centerLi = B);
        }, onKeyDown: function(B) {
          r.handleOnKeyDown(B, x);
        }, tabIndex: x === S ? 0 : -1, role: "option", "aria-selected": r.isSelectedTime(x) ? "true" : void 0 }, qe(x, u, r.props.locale));
      });
    }), r;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    this.list.scrollTop = this.centerLi && n.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var r = this, a = this.state.height;
    return d.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, d.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
      r.header = o;
    } }, d.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), d.createElement("div", { className: "react-datepicker__time" }, d.createElement("div", { className: "react-datepicker__time-box" }, d.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
      r.list = o;
    }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
}();
E(v0, "calcCenterPosition", function(e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var eA = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "YEAR_REFS", ja(Array(a.props.yearItemNumber)).map(function() {
      return d.createRef();
    })), E($(a), "isDisabled", function(o) {
      return Ci(o, a.props);
    }), E($(a), "isExcluded", function(o) {
      return dc(o, a.props);
    }), E($(a), "selectingDate", function() {
      var o;
      return (o = a.props.selectingDate) !== null && o !== void 0 ? o : a.props.preSelection;
    }), E($(a), "updateFocusOnPaginate", function(o) {
      var i = (function() {
        this.YEAR_REFS[o].current.focus();
      }).bind($(a));
      window.requestAnimationFrame(i);
    }), E($(a), "handleYearClick", function(o, i) {
      a.props.onDayClick && a.props.onDayClick(o, i);
    }), E($(a), "handleYearNavigation", function(o, i) {
      var s = a.props, u = s.date, l = s.yearItemNumber, c = Mn(u, l).startPeriod;
      a.isDisabled(i) || a.isExcluded(i) || (a.props.setPreSelection(i), o - c == -1 ? a.updateFocusOnPaginate(l - 1) : o - c === l ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[o - c].current.focus());
    }), E($(a), "isSameDay", function(o, i) {
      return ft(o, i);
    }), E($(a), "isCurrentYear", function(o) {
      return o === Ee(Ie());
    }), E($(a), "isRangeStart", function(o) {
      return a.props.startDate && a.props.endDate && Tr(dr(Ie(), o), a.props.startDate);
    }), E($(a), "isRangeEnd", function(o) {
      return a.props.startDate && a.props.endDate && Tr(dr(Ie(), o), a.props.endDate);
    }), E($(a), "isInRange", function(o) {
      return ks(o, a.props.startDate, a.props.endDate);
    }), E($(a), "isInSelectingRange", function(o) {
      var i = a.props, s = i.selectsStart, u = i.selectsEnd, l = i.selectsRange, c = i.startDate, f = i.endDate;
      return !(!(s || u || l) || !a.selectingDate()) && (s && f ? ks(o, a.selectingDate(), f) : (u && c || !(!l || !c || f)) && ks(o, c, a.selectingDate()));
    }), E($(a), "isSelectingRangeStart", function(o) {
      if (!a.isInSelectingRange(o))
        return !1;
      var i = a.props, s = i.startDate, u = i.selectsStart, l = dr(Ie(), o);
      return Tr(l, u ? a.selectingDate() : s);
    }), E($(a), "isSelectingRangeEnd", function(o) {
      if (!a.isInSelectingRange(o))
        return !1;
      var i = a.props, s = i.endDate, u = i.selectsEnd, l = i.selectsRange, c = dr(Ie(), o);
      return Tr(c, u || l ? a.selectingDate() : s);
    }), E($(a), "isKeyboardSelected", function(o) {
      var i = ga(dr(a.props.date, o));
      return !a.props.disabledKeyboardNavigation && !a.props.inline && !ft(i, ga(a.props.selected)) && ft(i, ga(a.props.preSelection));
    }), E($(a), "onYearClick", function(o, i) {
      var s = a.props.date;
      a.handleYearClick(ga(dr(s, i)), o);
    }), E($(a), "onYearKeyDown", function(o, i) {
      var s = o.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (s) {
          case "Enter":
            a.onYearClick(o, i), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleYearNavigation(i + 1, Kn(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleYearNavigation(i - 1, Ra(a.props.preSelection, 1));
        }
    }), E($(a), "getYearClassNames", function(o) {
      var i = a.props, s = i.minDate, u = i.maxDate, l = i.selected, c = i.excludeDates, f = i.includeDates, p = i.filterDate;
      return pt("react-datepicker__year-text", { "react-datepicker__year-text--selected": o === Ee(l), "react-datepicker__year-text--disabled": (s || u || c || f || p) && l0(o, a.props), "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(o), "react-datepicker__year-text--range-start": a.isRangeStart(o), "react-datepicker__year-text--range-end": a.isRangeEnd(o), "react-datepicker__year-text--in-range": a.isInRange(o), "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(o), "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(o), "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(o), "react-datepicker__year-text--today": a.isCurrentYear(o) });
    }), E($(a), "getYearTabIndex", function(o) {
      return a.props.disabledKeyboardNavigation ? "-1" : o === Ee(a.props.preSelection) ? "0" : "-1";
    }), E($(a), "getYearContainerClassNames", function() {
      var o = a.props, i = o.selectingDate, s = o.selectsStart, u = o.selectsEnd, l = o.selectsRange;
      return pt("react-datepicker__year", { "react-datepicker__year--selecting-range": i && (s || u || l) });
    }), E($(a), "getYearContent", function(o) {
      return a.props.renderYearContent ? a.props.renderYearContent(o) : o;
    }), a;
  }
  return ot(n, [{ key: "render", value: function() {
    for (var r = this, a = [], o = this.props, i = o.date, s = o.yearItemNumber, u = o.onYearMouseEnter, l = o.onYearMouseLeave, c = Mn(i, s), f = c.startPeriod, p = c.endPeriod, m = function(g) {
      a.push(d.createElement("div", { ref: r.YEAR_REFS[g - f], onClick: function(h) {
        r.onYearClick(h, g);
      }, onKeyDown: function(h) {
        r.onYearKeyDown(h, g);
      }, tabIndex: r.getYearTabIndex(g), className: r.getYearClassNames(g), onMouseEnter: function(h) {
        return u(h, g);
      }, onMouseLeave: function(h) {
        return l(h, g);
      }, key: g, "aria-current": r.isCurrentYear(g) ? "date" : void 0 }, r.getYearContent(g)));
    }, v = f; v <= p; v++)
      m(v);
    return d.createElement("div", { className: this.getYearContainerClassNames() }, d.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, a));
  } }]), n;
}(), tA = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "onTimeChange", function(o) {
      a.setState({ time: o });
      var i = /* @__PURE__ */ new Date();
      i.setHours(o.split(":")[0]), i.setMinutes(o.split(":")[1]), a.props.onChange(i);
    }), E($(a), "renderTimeInput", function() {
      var o = a.state.time, i = a.props, s = i.date, u = i.timeString, l = i.customTimeInput;
      return l ? d.cloneElement(l, { date: s, value: o, onChange: a.onTimeChange }) : d.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: o, onChange: function(c) {
        a.onTimeChange(c.target.value || u);
      } });
    }), a.state = { time: a.props.timeString }, a;
  }
  return ot(n, [{ key: "render", value: function() {
    return d.createElement("div", { className: "react-datepicker__input-time-container" }, d.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), d.createElement("div", { className: "react-datepicker-time__input-container" }, d.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(r, a) {
    return r.timeString !== a.time ? { time: r.timeString } : null;
  } }]), n;
}();
function rA(e) {
  var t = e.className, n = e.children, r = e.showPopperArrow, a = e.arrowProps, o = a === void 0 ? {} : a;
  return d.createElement("div", { className: t }, r && d.createElement("div", La({ className: "react-datepicker__triangle" }, o)), n);
}
var nA = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], aA = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "handleClickOutside", function(o) {
      a.props.onClickOutside(o);
    }), E($(a), "setClickOutsideRef", function() {
      return a.containerRef.current;
    }), E($(a), "handleDropdownFocus", function(o) {
      (function() {
        var i = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return nA.some(function(s) {
          return i.indexOf(s) >= 0;
        });
      })(o.target) && a.props.onDropdownFocus();
    }), E($(a), "getDateInView", function() {
      var o = a.props, i = o.preSelection, s = o.selected, u = o.openToDate, l = c0(a.props), c = d0(a.props), f = Ie(), p = u || s || i;
      return p || (l && Br(f, l) ? l : c && Nr(f, c) ? c : f);
    }), E($(a), "increaseMonth", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Vt(i, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), E($(a), "decreaseMonth", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Un(i, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), E($(a), "handleDayClick", function(o, i, s) {
      a.props.onSelect(o, i, s), a.props.setPreSelection && a.props.setPreSelection(o);
    }), E($(a), "handleDayMouseEnter", function(o) {
      a.setState({ selectingDate: o }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(o);
    }), E($(a), "handleMonthMouseLeave", function() {
      a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
    }), E($(a), "handleYearMouseEnter", function(o, i) {
      a.setState({ selectingDate: dr(Ie(), i) }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(o, i);
    }), E($(a), "handleYearMouseLeave", function(o, i) {
      a.props.onYearMouseLeave && a.props.onYearMouseLeave(o, i);
    }), E($(a), "handleYearChange", function(o) {
      a.props.onYearChange && (a.props.onYearChange(o), a.setState({ isRenderAriaLiveMessage: !0 })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(o), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(o);
    }), E($(a), "handleMonthChange", function(o) {
      a.handleCustomMonthChange(o), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(o), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(o);
    }), E($(a), "handleCustomMonthChange", function(o) {
      a.props.onMonthChange && (a.props.onMonthChange(o), a.setState({ isRenderAriaLiveMessage: !0 }));
    }), E($(a), "handleMonthYearChange", function(o) {
      a.handleYearChange(o), a.handleMonthChange(o);
    }), E($(a), "changeYear", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: dr(s, o) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), E($(a), "changeMonth", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: dt(s, o) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), E($(a), "changeMonthYear", function(o) {
      a.setState(function(i) {
        var s = i.date;
        return { date: dr(dt(s, ct(o)), Ee(o)) };
      }, function() {
        return a.handleMonthYearChange(a.state.date);
      });
    }), E($(a), "header", function() {
      var o = lc(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), i = [];
      return a.props.showWeekNumbers && i.push(d.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
        var u = na(o, s), l = a.formatWeekday(u, a.props.locale), c = a.props.weekDayClassName ? a.props.weekDayClassName(u) : void 0;
        return d.createElement("div", { key: s, className: pt("react-datepicker__day-name", c) }, l);
      }));
    }), E($(a), "formatWeekday", function(o, i) {
      return a.props.formatWeekDay ? function(s, u, l) {
        return u(qe(s, "EEEE", l));
      }(o, a.props.formatWeekDay, i) : a.props.useWeekdaysShort ? function(s, u) {
        return qe(s, "EEE", u);
      }(o, i) : function(s, u) {
        return qe(s, "EEEEEE", u);
      }(o, i);
    }), E($(a), "decreaseYear", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Ra(i, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), E($(a), "clearSelectingDate", function() {
      a.setState({ selectingDate: null });
    }), E($(a), "renderPreviousButton", function() {
      if (!a.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case a.props.showMonthYearPicker:
            o = Ep(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            o = function(w) {
              var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = S.minDate, O = S.yearItemNumber, B = O === void 0 ? ka : O, F = Mn(ga(Ra(w, B)), B).endPeriod, L = x && Ee(x);
              return L && L > F || !1;
            }(a.state.date, a.props);
            break;
          default:
            o = Dp(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !o) && !a.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = a.decreaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.decreaseYear), o && a.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), s = null);
          var u = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, l = a.props, c = l.previousMonthButtonLabel, f = l.previousYearButtonLabel, p = a.props, m = p.previousMonthAriaLabel, v = m === void 0 ? typeof c == "string" ? c : "Previous Month" : m, g = p.previousYearAriaLabel, h = g === void 0 ? typeof f == "string" ? f : "Previous Year" : g;
          return d.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": u ? h : v }, d.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, u ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
        }
      }
    }), E($(a), "increaseYear", function() {
      a.setState(function(o) {
        var i = o.date;
        return { date: Kn(i, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), E($(a), "renderNextButton", function() {
      if (!a.props.renderCustomHeader) {
        var o;
        switch (!0) {
          case a.props.showMonthYearPicker:
            o = xp(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            o = function(w) {
              var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = S.maxDate, O = S.yearItemNumber, B = O === void 0 ? ka : O, F = Mn(Kn(w, B), B).startPeriod, L = x && Ee(x);
              return L && L < F || !1;
            }(a.state.date, a.props);
            break;
          default:
            o = Cp(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !o) && !a.props.showTimeSelectOnly) {
          var i = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
          var s = a.increaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.increaseYear), o && a.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), s = null);
          var u = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, l = a.props, c = l.nextMonthButtonLabel, f = l.nextYearButtonLabel, p = a.props, m = p.nextMonthAriaLabel, v = m === void 0 ? typeof c == "string" ? c : "Next Month" : m, g = p.nextYearAriaLabel, h = g === void 0 ? typeof f == "string" ? f : "Next Year" : g;
          return d.createElement("button", { type: "button", className: i.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": u ? h : v }, d.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, u ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
        }
      }
    }), E($(a), "renderCurrentMonth", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, i = ["react-datepicker__current-month"];
      return a.props.showYearDropdown && i.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && i.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && i.push("react-datepicker__current-month--hasMonthYearDropdown"), d.createElement("div", { className: i.join(" ") }, qe(o, a.props.dateFormat, a.props.locale));
    }), E($(a), "renderYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showYearDropdown && !o)
        return d.createElement(VT, { adjustDateOnChange: a.props.adjustDateOnChange, date: a.state.date, onSelect: a.props.onSelect, setOpen: a.props.setOpen, dropdownMode: a.props.dropdownMode, onChange: a.changeYear, minDate: a.props.minDate, maxDate: a.props.maxDate, year: Ee(a.state.date), scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), E($(a), "renderMonthDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthDropdown && !o)
        return d.createElement(KT, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, onChange: a.changeMonth, month: ct(a.state.date), useShortMonthInDropdown: a.props.useShortMonthInDropdown });
    }), E($(a), "renderMonthYearDropdown", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthYearDropdown && !o)
        return d.createElement(XT, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, dateFormat: a.props.dateFormat, onChange: a.changeMonthYear, minDate: a.props.minDate, maxDate: a.props.maxDate, date: a.state.date, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown });
    }), E($(a), "handleTodayButtonClick", function(o) {
      a.props.onSelect(gp(), o), a.props.setPreSelection && a.props.setPreSelection(gp());
    }), E($(a), "renderTodayButton", function() {
      if (a.props.todayButton && !a.props.showTimeSelectOnly)
        return d.createElement("div", { className: "react-datepicker__today-button", onClick: function(o) {
          return a.handleTodayButtonClick(o);
        } }, a.props.todayButton);
    }), E($(a), "renderDefaultHeader", function(o) {
      var i = o.monthDate, s = o.i;
      return d.createElement("div", { className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a.renderCurrentMonth(i), d.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode), onFocus: a.handleDropdownFocus }, a.renderMonthDropdown(s !== 0), a.renderMonthYearDropdown(s !== 0), a.renderYearDropdown(s !== 0)), d.createElement("div", { className: "react-datepicker__day-names" }, a.header(i)));
    }), E($(a), "renderCustomHeader", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = o.monthDate, s = o.i;
      if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly)
        return null;
      var u = Dp(a.state.date, a.props), l = Cp(a.state.date, a.props), c = Ep(a.state.date, a.props), f = xp(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
      return d.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a.props.onDropdownFocus }, a.props.renderCustomHeader(ei(ei({}, a.state), {}, { customHeaderCount: s, monthDate: i, changeMonth: a.changeMonth, changeYear: a.changeYear, decreaseMonth: a.decreaseMonth, increaseMonth: a.increaseMonth, decreaseYear: a.decreaseYear, increaseYear: a.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: l, prevYearButtonDisabled: c, nextYearButtonDisabled: f })), p && d.createElement("div", { className: "react-datepicker__day-names" }, a.header(i)));
    }), E($(a), "renderYearHeader", function() {
      var o = a.state.date, i = a.props, s = i.showYearPicker, u = Mn(o, i.yearItemNumber), l = u.startPeriod, c = u.endPeriod;
      return d.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(l, " - ").concat(c) : Ee(o));
    }), E($(a), "renderHeader", function(o) {
      switch (!0) {
        case a.props.renderCustomHeader !== void 0:
          return a.renderCustomHeader(o);
        case (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker):
          return a.renderYearHeader(o);
        default:
          return a.renderDefaultHeader(o);
      }
    }), E($(a), "renderMonths", function() {
      var o;
      if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
        for (var i = [], s = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, u = Un(a.state.date, s), l = (o = a.props.monthSelectedIn) !== null && o !== void 0 ? o : s, c = 0; c < a.props.monthsShown; ++c) {
          var f = Vt(u, c - l + s), p = "month-".concat(c), m = c < a.props.monthsShown - 1, v = c > 0;
          i.push(d.createElement("div", { key: p, ref: function(g) {
            a.monthContainer = g;
          }, className: "react-datepicker__month-container" }, a.renderHeader({ monthDate: f, i: c }), d.createElement(JT, { chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, ariaLabelPrefix: a.props.monthAriaLabelPrefix, onChange: a.changeMonthYear, day: f, dayClassName: a.props.dayClassName, calendarStartDay: a.props.calendarStartDay, monthClassName: a.props.monthClassName, onDayClick: a.handleDayClick, handleOnKeyDown: a.props.handleOnDayKeyDown, onDayMouseEnter: a.handleDayMouseEnter, onMouseLeave: a.handleMonthMouseLeave, onWeekSelect: a.props.onWeekSelect, orderInDisplay: c, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.state.selectingDate, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, fixedHeight: a.props.fixedHeight, filterDate: a.props.filterDate, preSelection: a.props.preSelection, setPreSelection: a.props.setPreSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumbers: a.props.showWeekNumbers, startDate: a.props.startDate, endDate: a.props.endDate, peekNextMonth: a.props.peekNextMonth, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, isInputFocused: a.props.isInputFocused, containerRef: a.containerRef, monthShowsDuplicateDaysEnd: m, monthShowsDuplicateDaysStart: v })));
        }
        return i;
      }
    }), E($(a), "renderYears", function() {
      if (!a.props.showTimeSelectOnly)
        return a.props.showYearPicker ? d.createElement("div", { className: "react-datepicker__year--container" }, a.renderHeader(), d.createElement(eA, La({ onDayClick: a.handleDayClick, selectingDate: a.state.selectingDate, clearSelectingDate: a.clearSelectingDate, date: a.state.date }, a.props, { onYearMouseEnter: a.handleYearMouseEnter, onYearMouseLeave: a.handleYearMouseLeave }))) : void 0;
    }), E($(a), "renderTimeSection", function() {
      if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
        return d.createElement(v0, { selected: a.props.selected, openToDate: a.props.openToDate, onChange: a.props.onTimeChange, timeClassName: a.props.timeClassName, format: a.props.timeFormat, includeTimes: a.props.includeTimes, intervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, todayButton: a.props.todayButton, showMonthDropdown: a.props.showMonthDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, monthRef: a.state.monthContainer, injectTimes: a.props.injectTimes, locale: a.props.locale, handleOnKeyDown: a.props.handleOnKeyDown, showTimeSelectOnly: a.props.showTimeSelectOnly });
    }), E($(a), "renderInputTimeSection", function() {
      var o = new Date(a.props.selected), i = kr(o) && a.props.selected ? "".concat($p(o.getHours()), ":").concat($p(o.getMinutes())) : "";
      if (a.props.showTimeInput)
        return d.createElement(tA, { date: o, timeString: i, timeInputLabel: a.props.timeInputLabel, onChange: a.props.onTimeChange, customTimeInput: a.props.customTimeInput });
    }), E($(a), "renderAriaLiveRegion", function() {
      var o, i = Mn(a.state.date, a.props.yearItemNumber), s = i.startPeriod, u = i.endPeriod;
      return o = a.props.showYearPicker ? "".concat(s, " - ").concat(u) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? Ee(a.state.date) : "".concat(cc(ct(a.state.date), a.props.locale), " ").concat(Ee(a.state.date)), d.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, a.state.isRenderAriaLiveMessage && o);
    }), E($(a), "renderChildren", function() {
      if (a.props.children)
        return d.createElement("div", { className: "react-datepicker__children-container" }, a.props.children);
    }), a.containerRef = d.createRef(), a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, a;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void r.setState({ monthContainer: r.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(r) {
    var a = this;
    if (!this.props.preSelection || ft(this.props.preSelection, r.preSelection) && this.props.monthSelectedIn === r.monthSelectedIn)
      this.props.openToDate && !ft(this.props.openToDate, r.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var o = !It(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return o && a.handleCustomMonthChange(a.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var r = this.props.container || rA;
    return d.createElement("div", { ref: this.containerRef }, d.createElement(r, { className: pt("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: ka };
  } }]), n;
}(), m0 = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), (a = t.call(this, r)).el = document.createElement("div"), a;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return Tu.createPortal(this.props.children, this.el);
  } }]), n;
}(), oA = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, g0 = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "getTabChildren", function() {
      return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(oA);
    }), E($(a), "handleFocusStart", function() {
      var o = a.getTabChildren();
      o && o.length > 1 && o[o.length - 1].focus();
    }), E($(a), "handleFocusEnd", function() {
      var o = a.getTabChildren();
      o && o.length > 1 && o[0].focus();
    }), a.tabLoopRef = d.createRef(), a;
  }
  return ot(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? d.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, d.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, d.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
}(), iA = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n() {
    return at(this, n), t.apply(this, arguments);
  }
  return ot(n, [{ key: "render", value: function() {
    var r, a = this.props, o = a.className, i = a.wrapperClassName, s = a.hidePopper, u = a.popperComponent, l = a.popperModifiers, c = a.popperPlacement, f = a.popperProps, p = a.targetComponent, m = a.enableTabLoop, v = a.popperOnKeyDown, g = a.portalId, h = a.portalHost;
    if (!s) {
      var w = pt("react-datepicker-popper", o);
      r = d.createElement(TT, La({ modifiers: l, placement: c }, f), function(x) {
        var O = x.ref, B = x.style, F = x.placement, L = x.arrowProps;
        return d.createElement(g0, { enableTabLoop: m }, d.createElement("div", { ref: O, style: B, className: w, "data-placement": F, onKeyDown: v }, d.cloneElement(u, { arrowProps: L })));
      });
    }
    this.props.popperContainer && (r = d.createElement(this.props.popperContainer, {}, r)), g && !s && (r = d.createElement(m0, { portalId: g, portalHost: h }, r));
    var S = pt("react-datepicker-wrapper", i);
    return d.createElement(f6, { className: "react-datepicker-manager" }, d.createElement(RT, null, function(x) {
      var O = x.ref;
      return d.createElement("div", { ref: O, className: S }, p);
    }), r);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
}(), Bp = "react-datepicker-ignore-onclickoutside", sA = wi(aA), Ts = "Date input not valid.", uA = function(e) {
  it(n, d.Component);
  var t = st(n);
  function n(r) {
    var a;
    return at(this, n), E($(a = t.call(this, r)), "getPreSelection", function() {
      return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Ie();
    }), E($(a), "calcInitialState", function() {
      var o, i, s = (o = a.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(p, m) {
        var v = new Date(m.date);
        return Fa(v) ? [].concat(ja(p), [ei(ei({}, m), {}, { date: v })]) : p;
      }, []), u = a.getPreSelection(), l = c0(a.props), c = d0(a.props), f = l && Br(u, tr(l)) ? l : c && Nr(u, bu(c)) ? c : u;
      return { open: a.props.startOpen || !1, preventFocus: !1, preSelection: (i = a.props.selectsRange ? a.props.startDate : a.props.selected) !== null && i !== void 0 ? i : f, highlightDates: Sp(a.props.highlightDates), holidays: jT(s), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), E($(a), "clearPreventFocusTimeout", function() {
      a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
    }), E($(a), "setFocus", function() {
      a.input && a.input.focus && a.input.focus({ preventScroll: !0 });
    }), E($(a), "setBlur", function() {
      a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
    }), E($(a), "setOpen", function(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      a.setState({ open: o, preSelection: o && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection, lastPreSelectChange: As }, function() {
        o || a.setState(function(s) {
          return { focused: !!i && s.focused };
        }, function() {
          !i && a.setBlur(), a.setState({ inputValue: null });
        });
      });
    }), E($(a), "inputOk", function() {
      return bi(a.state.preSelection);
    }), E($(a), "isCalendarOpen", function() {
      return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
    }), E($(a), "handleFocus", function(o) {
      a.state.preventFocus || (a.props.onFocus(o), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({ focused: !0 });
    }), E($(a), "cancelFocusInput", function() {
      clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
    }), E($(a), "deferFocusInput", function() {
      a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
        return a.setFocus();
      }, 1);
    }), E($(a), "handleDropdownFocus", function() {
      a.cancelFocusInput();
    }), E($(a), "handleBlur", function(o) {
      (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(o), a.setState({ focused: !1 });
    }), E($(a), "handleCalendarClickOutside", function(o) {
      a.props.inline || a.setOpen(!1), a.props.onClickOutside(o), a.props.withPortal && o.preventDefault();
    }), E($(a), "handleChange", function() {
      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      var u = i[0];
      if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply($(a), i), typeof u.isDefaultPrevented == "function" && !u.isDefaultPrevented())) {
        a.setState({ inputValue: u.target.value, lastPreSelectChange: lA });
        var l, c, f, p, m, v, g, h, w = (l = u.target.value, c = a.props.dateFormat, f = a.props.locale, p = a.props.strictParsing, m = a.props.minDate, v = null, g = Fr(f) || Fr(rn()), h = !0, Array.isArray(c) ? (c.forEach(function(S) {
          var x = Cs(l, S, /* @__PURE__ */ new Date(), { locale: g });
          p && (h = kr(x, m) && l === qe(x, S, f)), kr(x, m) && h && (v = x);
        }), v) : (v = Cs(l, c, /* @__PURE__ */ new Date(), { locale: g }), p ? h = kr(v) && l === qe(v, c, f) : kr(v) || (c = c.match(IT).map(function(S) {
          var x = S[0];
          return x === "p" || x === "P" ? g ? (0, NT[x])(S, g.formatLong) : x : S;
        }).join(""), l.length > 0 && (v = Cs(l, c.slice(0, l.length), /* @__PURE__ */ new Date())), kr(v) || (v = new Date(l))), kr(v) && h ? v : null));
        a.props.showTimeSelectOnly && a.props.selected && !ft(w, a.props.selected) && (w = _T(a.props.selected, w == null ? { hours: Ht(a.props.selected), minutes: Yt(a.props.selected), seconds: Ds(a.props.selected) } : { hours: Ht(w), minutes: Yt(w), seconds: Ds(w) })), !w && u.target.value || a.setSelected(w, u, !0);
      }
    }), E($(a), "handleSelect", function(o, i, s) {
      if (a.setState({ preventFocus: !0 }, function() {
        return a.preventFocusTimeout = setTimeout(function() {
          return a.setState({ preventFocus: !1 });
        }, 50), a.preventFocusTimeout;
      }), a.props.onChangeRaw && a.props.onChangeRaw(i), a.setSelected(o, i, !1, s), a.props.showDateSelect && a.setState({ isRenderAriaLiveMessage: !0 }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect)
        a.setPreSelection(o);
      else if (!a.props.inline) {
        a.props.selectsRange || a.setOpen(!1);
        var u = a.props, l = u.startDate, c = u.endDate;
        !l || c || Br(o, l) || a.setOpen(!1);
      }
    }), E($(a), "setSelected", function(o, i, s, u) {
      var l = o;
      if (a.props.showYearPicker) {
        if (l !== null && l0(Ee(l), a.props))
          return;
      } else if (a.props.showMonthYearPicker) {
        if (l !== null && u0(l, a.props))
          return;
      } else if (l !== null && Ci(l, a.props))
        return;
      var c = a.props, f = c.onChange, p = c.selectsRange, m = c.startDate, v = c.endDate;
      if (!Gr(a.props.selected, l) || a.props.allowSameDay || p)
        if (l !== null && (!a.props.selected || s && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (l = vp(l, { hour: Ht(a.props.selected), minute: Yt(a.props.selected), second: Ds(a.props.selected) })), a.props.inline || a.setState({ preSelection: l }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: u })), p) {
          var g = m && !v, h = m && v;
          !m && !v ? f([l, null], i) : g && (Br(l, m) ? f([l, null], i) : f([m, l], i)), h && f([l, null], i);
        } else
          f(l, i);
      s || (a.props.onSelect(l, i), a.setState({ inputValue: null }));
    }), E($(a), "setPreSelection", function(o) {
      var i = a.props.minDate !== void 0, s = a.props.maxDate !== void 0, u = !0;
      if (o) {
        var l = tr(o);
        if (i && s)
          u = Co(o, a.props.minDate, a.props.maxDate);
        else if (i) {
          var c = tr(a.props.minDate);
          u = Nr(o, c) || Gr(l, c);
        } else if (s) {
          var f = bu(a.props.maxDate);
          u = Br(o, f) || Gr(l, f);
        }
      }
      u && a.setState({ preSelection: o });
    }), E($(a), "handleTimeChange", function(o) {
      var i = a.props.selected ? a.props.selected : a.getPreSelection(), s = a.props.selected ? o : vp(i, { hour: Ht(o), minute: Yt(o) });
      a.setState({ preSelection: s }), a.props.onChange(s), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({ isRenderAriaLiveMessage: !0 }), a.setState({ inputValue: null });
    }), E($(a), "onInputClick", function() {
      a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
    }), E($(a), "onInputKeyDown", function(o) {
      a.props.onKeyDown(o);
      var i = o.key;
      if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
        if (a.state.open) {
          if (i === "ArrowDown" || i === "ArrowUp") {
            o.preventDefault();
            var s = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
            return void (s && s.focus({ preventScroll: !0 }));
          }
          var u = Ie(a.state.preSelection);
          i === "Enter" ? (o.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === As ? (a.handleSelect(u, o), !a.props.shouldCloseOnSelect && a.setPreSelection(u)) : a.setOpen(!1)) : i === "Escape" ? (o.preventDefault(), a.setOpen(!1)) : i === "Tab" && a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: Ts });
        }
      } else
        i !== "ArrowDown" && i !== "ArrowUp" && i !== "Enter" || a.onInputClick();
    }), E($(a), "onPortalKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), E($(a), "onDayKeyDown", function(o) {
      a.props.onKeyDown(o);
      var i = o.key, s = Ie(a.state.preSelection);
      if (i === "Enter")
        o.preventDefault(), a.handleSelect(s, o), !a.props.shouldCloseOnSelect && a.setPreSelection(s);
      else if (i === "Escape")
        o.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: Ts });
      else if (!a.props.disabledKeyboardNavigation) {
        var u;
        switch (i) {
          case "ArrowLeft":
            u = SB(s, 1);
            break;
          case "ArrowRight":
            u = na(s, 1);
            break;
          case "ArrowUp":
            u = $B(s, 1);
            break;
          case "ArrowDown":
            u = Ql(s, 1);
            break;
          case "PageUp":
            u = Un(s, 1);
            break;
          case "PageDown":
            u = Vt(s, 1);
            break;
          case "Home":
            u = Ra(s, 1);
            break;
          case "End":
            u = Kn(s, 1);
        }
        if (!u)
          return void (a.props.onInputError && a.props.onInputError({ code: 1, msg: Ts }));
        if (o.preventDefault(), a.setState({ lastPreSelectChange: As }), a.props.adjustDateOnChange && a.setSelected(u), a.setPreSelection(u), a.props.inline) {
          var l = ct(s), c = ct(u), f = Ee(s), p = Ee(u);
          l !== c || f !== p ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), E($(a), "onPopperKeyDown", function(o) {
      o.key === "Escape" && (o.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), E($(a), "onClearClick", function(o) {
      o && o.preventDefault && o.preventDefault(), a.props.selectsRange ? a.props.onChange([null, null], o) : a.props.onChange(null, o), a.setState({ inputValue: null });
    }), E($(a), "clear", function() {
      a.onClearClick();
    }), E($(a), "onScroll", function(o) {
      typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? o.target !== document && o.target !== document.documentElement && o.target !== document.body || a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(o) && a.setOpen(!1);
    }), E($(a), "renderCalendar", function() {
      return a.props.inline || a.isCalendarOpen() ? d.createElement(sA, { ref: function(o) {
        a.calendar = o;
      }, locale: a.props.locale, calendarStartDay: a.props.calendarStartDay, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, monthAriaLabelPrefix: a.props.monthAriaLabelPrefix, adjustDateOnChange: a.props.adjustDateOnChange, setOpen: a.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, dateFormat: a.props.dateFormatCalendar, useWeekdaysShort: a.props.useWeekdaysShort, formatWeekDay: a.props.formatWeekDay, dropdownMode: a.props.dropdownMode, selected: a.props.selected, preSelection: a.state.preSelection, onSelect: a.handleSelect, onWeekSelect: a.props.onWeekSelect, openToDate: a.props.openToDate, minDate: a.props.minDate, maxDate: a.props.maxDate, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, startDate: a.props.startDate, endDate: a.props.endDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, filterDate: a.props.filterDate, onClickOutside: a.handleCalendarClickOutside, formatWeekNumber: a.props.formatWeekNumber, highlightDates: a.state.highlightDates, holidays: a.state.holidays, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, includeTimes: a.props.includeTimes, injectTimes: a.props.injectTimes, inline: a.props.inline, shouldFocusDayInline: a.state.shouldFocusDayInline, peekNextMonth: a.props.peekNextMonth, showMonthDropdown: a.props.showMonthDropdown, showPreviousMonths: a.props.showPreviousMonths, useShortMonthInDropdown: a.props.useShortMonthInDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showWeekNumbers: a.props.showWeekNumbers, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, forceShowMonthNavigation: a.props.forceShowMonthNavigation, showDisabledMonthNavigation: a.props.showDisabledMonthNavigation, scrollableYearDropdown: a.props.scrollableYearDropdown, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, todayButton: a.props.todayButton, weekLabel: a.props.weekLabel, outsideClickIgnoreClass: Bp, fixedHeight: a.props.fixedHeight, monthsShown: a.props.monthsShown, monthSelectedIn: a.state.monthSelectedIn, onDropdownFocus: a.handleDropdownFocus, onMonthChange: a.props.onMonthChange, onYearChange: a.props.onYearChange, dayClassName: a.props.dayClassName, weekDayClassName: a.props.weekDayClassName, monthClassName: a.props.monthClassName, timeClassName: a.props.timeClassName, showDateSelect: a.props.showDateSelect, showTimeSelect: a.props.showTimeSelect, showTimeSelectOnly: a.props.showTimeSelectOnly, onTimeChange: a.handleTimeChange, timeFormat: a.props.timeFormat, timeIntervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, className: a.props.calendarClassName, container: a.props.calendarContainer, yearItemNumber: a.props.yearItemNumber, yearDropdownItemNumber: a.props.yearDropdownItemNumber, previousMonthAriaLabel: a.props.previousMonthAriaLabel, previousMonthButtonLabel: a.props.previousMonthButtonLabel, nextMonthAriaLabel: a.props.nextMonthAriaLabel, nextMonthButtonLabel: a.props.nextMonthButtonLabel, previousYearAriaLabel: a.props.previousYearAriaLabel, previousYearButtonLabel: a.props.previousYearButtonLabel, nextYearAriaLabel: a.props.nextYearAriaLabel, nextYearButtonLabel: a.props.nextYearButtonLabel, timeInputLabel: a.props.timeInputLabel, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderCustomHeader: a.props.renderCustomHeader, popperProps: a.props.popperProps, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, onDayMouseEnter: a.props.onDayMouseEnter, onMonthMouseLeave: a.props.onMonthMouseLeave, onYearMouseEnter: a.props.onYearMouseEnter, onYearMouseLeave: a.props.onYearMouseLeave, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showTimeInput: a.props.showTimeInput, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showPopperArrow: a.props.showPopperArrow, excludeScrollbar: a.props.excludeScrollbar, handleOnKeyDown: a.props.onKeyDown, handleOnDayKeyDown: a.onDayKeyDown, isInputFocused: a.state.focused, customTimeInput: a.props.customTimeInput, setPreSelection: a.setPreSelection }, a.props.children) : null;
    }), E($(a), "renderAriaLiveRegion", function() {
      var o, i = a.props, s = i.dateFormat, u = i.locale, l = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
      return o = a.props.selectsRange ? "Selected start date: ".concat(Xt(a.props.startDate, { dateFormat: l, locale: u }), ". ").concat(a.props.endDate ? "End date: " + Xt(a.props.endDate, { dateFormat: l, locale: u }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Xt(a.props.selected, { dateFormat: s, locale: u })) : a.props.showYearPicker ? "Selected year: ".concat(Xt(a.props.selected, { dateFormat: "yyyy", locale: u })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Xt(a.props.selected, { dateFormat: "MMMM yyyy", locale: u })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Xt(a.props.selected, { dateFormat: "yyyy, QQQ", locale: u })) : "Selected date: ".concat(Xt(a.props.selected, { dateFormat: l, locale: u })), d.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, o);
    }), E($(a), "renderDateInput", function() {
      var o, i = pt(a.props.className, E({}, Bp, a.state.open)), s = a.props.customInput || d.createElement("input", { type: "text" }), u = a.props.customInputRef || "ref", l = typeof a.props.value == "string" ? a.props.value : typeof a.state.inputValue == "string" ? a.state.inputValue : a.props.selectsRange ? function(c, f, p) {
        if (!c)
          return "";
        var m = Xt(c, p), v = f ? Xt(f, p) : "";
        return "".concat(m, " - ").concat(v);
      }(a.props.startDate, a.props.endDate, a.props) : Xt(a.props.selected, a.props);
      return d.cloneElement(s, (E(o = {}, u, function(c) {
        a.input = c;
      }), E(o, "value", l), E(o, "onBlur", a.handleBlur), E(o, "onChange", a.handleChange), E(o, "onClick", a.onInputClick), E(o, "onFocus", a.handleFocus), E(o, "onKeyDown", a.onInputKeyDown), E(o, "id", a.props.id), E(o, "name", a.props.name), E(o, "form", a.props.form), E(o, "autoFocus", a.props.autoFocus), E(o, "placeholder", a.props.placeholderText), E(o, "disabled", a.props.disabled), E(o, "autoComplete", a.props.autoComplete), E(o, "className", pt(s.props.className, i)), E(o, "title", a.props.title), E(o, "readOnly", a.props.readOnly), E(o, "required", a.props.required), E(o, "tabIndex", a.props.tabIndex), E(o, "aria-describedby", a.props.ariaDescribedBy), E(o, "aria-invalid", a.props.ariaInvalid), E(o, "aria-labelledby", a.props.ariaLabelledBy), E(o, "aria-required", a.props.ariaRequired), o));
    }), E($(a), "renderClearButton", function() {
      var o = a.props, i = o.isClearable, s = o.selected, u = o.startDate, l = o.endDate, c = o.clearButtonTitle, f = o.clearButtonClassName, p = f === void 0 ? "" : f, m = o.ariaLabelClose, v = m === void 0 ? "Close" : m;
      return !i || s == null && u == null && l == null ? null : d.createElement("button", { type: "button", className: "react-datepicker__close-icon ".concat(p).trim(), "aria-label": v, onClick: a.onClearClick, title: c, tabIndex: -1 });
    }), a.state = a.calcInitialState(), a;
  }
  return ot(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(r, a) {
    var o, i;
    r.inline && (o = r.selected, i = this.props.selected, o && i ? ct(o) !== ct(i) || Ee(o) !== Ee(i) : o !== i) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), r.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: Sp(this.props.highlightDates) }), a.focused || Gr(r.selected, this.props.selected) || this.setState({ inputValue: null }), a.open !== this.state.open && (a.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), a.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var r = this.props.showIcon;
    return d.createElement("div", { className: "react-datepicker__input-container".concat(r ? " react-datepicker__view-calendar-icon" : "") }, r && d.createElement("svg", { className: "react-datepicker__calendar-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512" }, d.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var r = this.renderCalendar();
    if (this.props.inline)
      return r;
    if (this.props.withPortal) {
      var a = this.state.open ? d.createElement(g0, { enableTabLoop: this.props.enableTabLoop }, d.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, r)) : null;
      return this.state.open && this.props.portalId && (a = d.createElement(m0, { portalId: this.props.portalId, portalHost: this.props.portalHost }, a)), d.createElement("div", null, this.renderInputContainer(), a);
    }
    return d.createElement(iA, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: r, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: ka, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0 };
  } }]), n;
}(), lA = "input", As = "navigate", cA = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, dA = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], fA = function(t, n, r) {
  var a, o = cA[t];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : r && r.onlyNumeric ? a = o.other.replace("{{count}}", String(n)) : a = o.other.replace("{{count}}", n < 13 ? dA[n] : String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + a : a + " sedan" : a;
};
const pA = fA;
var hA = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, vA = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, mA = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, gA = {
  date: _n({
    formats: hA,
    defaultWidth: "full"
  }),
  time: _n({
    formats: vA,
    defaultWidth: "full"
  }),
  dateTime: _n({
    formats: mA,
    defaultWidth: "full"
  })
};
const yA = gA;
var bA = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, wA = function(t, n, r, a) {
  return bA[t];
};
const DA = wA;
var CA = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, EA = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, xA = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, SA = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, $A = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, kA = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, OA = function(t, n) {
  var r = Number(t), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, BA = {
  ordinalNumber: OA,
  era: Gt({
    values: CA,
    defaultWidth: "wide"
  }),
  quarter: Gt({
    values: EA,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Gt({
    values: xA,
    defaultWidth: "wide"
  }),
  day: Gt({
    values: SA,
    defaultWidth: "wide"
  }),
  dayPeriod: Gt({
    values: $A,
    defaultWidth: "wide",
    formattingValues: kA,
    defaultFormattingWidth: "wide"
  })
};
const TA = BA;
var AA = /^(\d+)(:a|:e)?/i, PA = /\d+/i, MA = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, FA = {
  any: [/^f/i, /^[ev]/i]
}, RA = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, _A = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, NA = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, IA = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, LA = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, jA = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, WA = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, YA = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, HA = {
  ordinalNumber: Rm({
    matchPattern: AA,
    parsePattern: PA,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Qt({
    matchPatterns: MA,
    defaultMatchWidth: "wide",
    parsePatterns: FA,
    defaultParseWidth: "any"
  }),
  quarter: Qt({
    matchPatterns: RA,
    defaultMatchWidth: "wide",
    parsePatterns: _A,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Qt({
    matchPatterns: NA,
    defaultMatchWidth: "wide",
    parsePatterns: IA,
    defaultParseWidth: "any"
  }),
  day: Qt({
    matchPatterns: LA,
    defaultMatchWidth: "wide",
    parsePatterns: jA,
    defaultParseWidth: "any"
  }),
  dayPeriod: Qt({
    matchPatterns: WA,
    defaultMatchWidth: "any",
    parsePatterns: YA,
    defaultParseWidth: "any"
  })
};
const VA = HA;
var zA = {
  code: "sv",
  formatDistance: pA,
  formatLong: yA,
  formatRelative: DA,
  localize: TA,
  match: VA,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const KA = zA, UA = D.div`
  display: flex;
  align-items: center;
  height: 2.5rem;
  border: 2px solid ${y.grey200};
  border-radius: ${k.XXS};
  padding: 0;
  background-color: ${y.white};
  transition: border-color 0.1s ${mt};
  margin-top: ${k.XXS};

  &:hover {
    border-color: ${y.grey400};
  }
  &:active,
  &:focus,
  &:focus-within {
    border-color: ${y.black};
  }

  ${({ hasErrorMessage: e }) => e ? _`
          && {
            border-color: ${y.clownRed};
          }
        ` : null};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      background-color: ${y.grey50};
    `};
`, qA = D.input`
  ${vn.Body1};
  width: 100%;
  padding: ${k.XS} 0 ${k.XS} ${k.S};
  border: 0;
  outline: 0;
  margin-right: ${k.XXS};
  background-color: transparent;

  &:disabled {
    ::placeholder {
      color: ${y.grey400};
    }
  }
`, XA = D.div`
  display: flex;
  flex-direction: column;

  .syntax-override-styling {
    font: unset;
    border: 2px solid ${y.grey200};
  }
`, GA = D.label`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: #121214;
`, QA = D(hn)`
  display: inline-flex;
  align-items: center;
  font-size: ${k.S};
  color: ${y.clownRed};
`, ZA = D(gn)`
  margin-top: -2px; /* Visual alignment */
  margin-right: ${k.XXS};
`, JA = I0(
  ({
    value: e,
    onClick: t,
    onChange: n,
    onFocus: r,
    handleBlur: a,
    hasErrorMessage: o,
    isDisabled: i,
    CustomInputComponent: s
  }, u) => s ? /* @__PURE__ */ d.createElement(
    s,
    {
      hasErrorMessage: o,
      isDisabled: i,
      value: e,
      onClick: t,
      onChange: n,
      onFocus: r,
      ref: u
    }
  ) : /* @__PURE__ */ d.createElement(UA, { hasErrorMessage: o, isDisabled: i }, /* @__PURE__ */ d.createElement(
    qA,
    {
      value: e,
      type: "text",
      onClick: t,
      onChange: n,
      onFocus: r,
      onBlur: a,
      ref: u
    }
  ))
), e9 = ({
  disabled: e,
  errorMessage: t,
  id: n,
  isRequired: r,
  isTimePicker: a,
  label: o,
  onBlur: i,
  onChange: s,
  timeCaption: u,
  value: l,
  customInputComponent: c
}) => {
  const [f, p] = Ne(l);
  je(() => {
    p(l);
  }, [l]);
  const m = (v) => {
    p(v), s(v);
  };
  return /* @__PURE__ */ d.createElement(XA, null, o && /* @__PURE__ */ d.createElement(GA, { htmlFor: n }, `${o}${r ? "*" : ""}`), /* @__PURE__ */ d.createElement(
    uA,
    {
      calendarClassName: "syntax-override-styling",
      showPopperArrow: !1,
      id: n,
      selected: f,
      onChange: m,
      locale: KA,
      dateFormat: a ? "HH:mm" : "yyyy-MM-dd",
      showTimeSelect: a,
      showTimeSelectOnly: a,
      scrollableMonthYearDropdown: !0,
      timeIntervals: 60,
      timeCaption: u,
      customInput: d.createElement(JA, {
        hasErrorMessage: !!t,
        isDisabled: e ?? !1,
        CustomInputComponent: c,
        handleBlur: i
      })
    }
  ), t && /* @__PURE__ */ d.createElement(QA, null, /* @__PURE__ */ d.createElement(ZA, { fontSize: "inherit" }), " ", t));
}, wM = e9;
var fc = {}, t9 = We, r9 = Ye;
Object.defineProperty(fc, "__esModule", {
  value: !0
});
var y0 = fc.default = void 0, n9 = r9(d), a9 = t9(He()), o9 = (0, a9.default)(/* @__PURE__ */ n9.createElement("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), "InfoOutlined");
y0 = fc.default = o9;
const i9 = D.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${k.M} 0;
  background-color: ${(e) => e.backgroundColor};
  color: ${y.white};
  font-size: ${k.M};
  line-height: ${k.L};

  @media (${Fe.mediumMin}) {
    padding-left: ${k.L};
  }
`, s9 = D.div`
  display: flex;
`, u9 = D.div`
  max-width: 1136px;
  margin-right: ${k.XL};
  margin-left: ${k.XL};

  @media (${Fe.smallMax}) {
    margin-left: ${k.L};
  }
`, l9 = D(y0)`
  margin-right: 0.5rem;
`, c9 = D.p`
  margin: 0;
  font-weight: 400;

  > div {
    display: inline;
  }
`, d9 = D.span`
  font-weight: 600;
`, f9 = D.div`
  max-width: 1136px;
  margin-right: ${k.XL};
  margin-left: ${k.XL};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 600;
`, p9 = D.div`
  text-align: right;
`, h9 = D.a`
  color: ${y.white};
  text-decoration: none;
  font-weight: 600;

  &:visited {
    color: ${y.white};
  }

  &:hover {
    color: ${y.white};
    text-decoration: underline;
  }
`, v9 = D.button`
  position: absolute;
  width: 2rem;
  right: 1.5rem;
  margin-right: 0;
  padding: 0;
  border: none;
  background: none;
  color: ${y.white};
  cursor: pointer;
`, m9 = ({
  title: e,
  description: t,
  link: n,
  handleDismissBanner: r,
  ariaLabel: a,
  backgroundColor: o,
  verification: i,
  isMaintenanceBanner: s
}) => /* @__PURE__ */ d.createElement(
  i9,
  {
    backgroundColor: o,
    id: s ? "maintenance-banner" : void 0
  },
  t && /* @__PURE__ */ d.createElement(u9, null, /* @__PURE__ */ d.createElement(s9, null, /* @__PURE__ */ d.createElement(l9, null), /* @__PURE__ */ d.createElement(c9, null, /* @__PURE__ */ d.createElement(d9, null, e), " ", h7(t))), n && /* @__PURE__ */ d.createElement(p9, null, /* @__PURE__ */ d.createElement(h9, { href: n }, "Läs mer"))),
  i && /* @__PURE__ */ d.createElement(f9, null, i),
  /* @__PURE__ */ d.createElement(v9, { "aria-label": a, onClick: r }, /* @__PURE__ */ d.createElement(_r, null))
), DM = m9, g9 = () => /* @__PURE__ */ d.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ d.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V9H13V7H11ZM11 11V17H13V11H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z",
    fill: y.frenchBlue
  }
)), Tp = g9, y9 = () => /* @__PURE__ */ d.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ d.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21.5L12 2.5L23 21.5H1ZM19.53 19.5L12 6.49L4.47 19.5H19.53ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z",
    fill: y.plannerOrange
  }
)), b9 = y9, w9 = () => /* @__PURE__ */ d.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ d.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM13 13V7H11V13H13ZM13 17V15H11V17H13ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12Z",
    fill: y.lavaRed
  }
)), D9 = w9, C9 = () => /* @__PURE__ */ d.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ d.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.17L16.59 7.58L18 9L10 17L6 13L7.41 11.59L10 14.17Z",
    fill: y.fokusGrassGreen
  }
)), E9 = C9, St = 28, b0 = 6, x9 = D.div`
  position: relative;
  height: ${St}px;
  width: ${St}px;
  text-align: center;
`, S9 = D.svg`
  position: absolute;
  top: 0;
  right: 0;
  width: ${St}px;
  height: ${St}px;
  transform: rotateY(-180deg) rotateZ(-90deg);
`, $9 = D.svg`
  position: absolute;
  top: 0;
  right: 0;
  width: ${St}px;
  height: ${St}px;
`, pc = Math.PI * St, k9 = L0`
  from {
    stroke-dashoffset: 0px;
  }
  to {
    stroke-dashoffset: ${pc}px;
  }
`, O9 = D.circle`
  stroke-dasharray: ${pc}px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: ${y.grey100};
  fill: none;
  animation: ${k9} ${b0}s linear 1 forwards;
  animation-play-state: ${(e) => e.isPaused ? "paused" : "running"};
`, B9 = D.circle`
  stroke-dasharray: ${pc}px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: ${y.grey300};
  fill: none;
`, T9 = ({ isPaused: e, onClick: t }) => {
  const n = b0 * 1e3, [r, a] = Ne(n);
  return je(() => {
    r === 0 && t();
  }, [r]), je(() => {
    let o;
    return e || (o = window.setInterval(() => {
      a((i) => i <= 100 ? 0 : i - 100);
    }, 100)), () => window.clearInterval(o);
  }, [e]), /* @__PURE__ */ d.createElement("div", null, /* @__PURE__ */ d.createElement($9, null, /* @__PURE__ */ d.createElement(B9, { className: "empty-circle", r: St * 0.45, cx: St * 0.5, cy: St * 0.5 })), /* @__PURE__ */ d.createElement(x9, null, /* @__PURE__ */ d.createElement(S9, null, /* @__PURE__ */ d.createElement(
    O9,
    {
      className: "countdown-circle",
      r: St * 0.45,
      cx: St * 0.5,
      cy: St * 0.5,
      isPaused: !!e
    }
  ))));
}, A9 = T9, P9 = D.div`
  visibility: ${(e) => e.isCloseHidden ? "hidden" : "initial"};
  margin-left: auto;
`, M9 = D.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`, F9 = D(A9)`
  position: relative;
  z-index: 1;
`, R9 = D(_r)`
  z-index: 2;
`, _9 = D.button`
  position: absolute;
  cursor: pointer;
  z-index: 2;
  border: none;
  border-radius: 50%;
  height: ${k.L};
  width: ${k.L};
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${y.grey50};
  }

  &:active {
    background-color: ${y.grey200};
  }

  && > svg {
    fill: ${y.grey700};
    width: 1.375rem;
    height: 1.375rem;
  }
`, N9 = ({
  onClick: e,
  onMouseEnter: t,
  onMouseLeave: n,
  isPaused: r,
  isCloseHidden: a
}) => /* @__PURE__ */ d.createElement(P9, { isCloseHidden: a }, /* @__PURE__ */ d.createElement(M9, { onMouseEnter: t, onMouseLeave: n }, /* @__PURE__ */ d.createElement(F9, { isPaused: r, onClick: e }), /* @__PURE__ */ d.createElement(_9, { "aria-label": "Stäng", className: "syntax-toast-close-btn", onClick: e }, /* @__PURE__ */ d.createElement(R9, null)))), I9 = D.div`
  width: 28.125rem;
  border-left: 8px solid ${(e) => e.cardColor};
  border-radius: 8px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  padding: ${k.M} ${k.S};
  background-color: ${y.white};
  z-index: 1000;
  position: fixed;
  bottom: ${k.L};
  left: ${(e) => e.isVisible ? "43px" : "-28.125rem"};
  animation: ${(e) => e.isVisible ? "slideIn" : "isVisible"} 0.4s forwards;

  @media (prefers-reduced-motion: no-preference) {
    @keyframes slideIn {
      0% {
        left: -28.125rem;
      }
      100% {
        left: 43px;
      }
    }

    @keyframes isVisible {
      0% {
        left: 43px;
      }
      100% {
        left: calc(-28.125rem - 8px);
      }
    }

    @media (${Fe.smallMax}) {
      margin: 0 auto;
      width: 98%;
      left: 50%;
      bottom: ${k.XXXXL};
      transform: translateX(-50%);

      @keyframes slideIn {
        0% {
          transform: translateX(-150%);
        }
        100% {
          transform: translateX(-50%);
        }
      }

      @keyframes isVisible {
        0% {
          transform: translateX(-50%);
        }
        100% {
          transform: translateX(-155%);
        }
      }
    }
  }
`, L9 = D.div`
  display: ${(e) => e.isTitle ? "flex" : "grid"};
  grid-template-columns: minmax(auto, 30px) auto auto;

  ${({ isTitle: e }) => e && _`
      align-items: center;
    `}
`, j9 = D.div`
  justify-content: center;
  align-items: center;
  margin-right: 6px;
  display: ${(e) => e.isTitle ? "flex" : "inline"};
  margin-top: ${(e) => e.isTitle ? "0" : "2px"};
`, W9 = D(Uu)`
  white-space: normal;
`, Ap = D.div`
  margin: ${(e) => e.isTitle ? "8px 0" : "0"};
  margin-right: 16px;
  font-weight: 400;
  font-size: 14px;
`, Y9 = D.div`
  display: flex;
  justify-content: end;
  > a:last-child {
    margin-left: ${k.M};
  }
`, w0 = ({
  type: e,
  isCloseHidden: t,
  title: n,
  text: r,
  button1: a,
  button2: o,
  className: i,
  onHide: s
}) => {
  const [u, l] = Ne(!1), [c, f] = Ne(!0);
  je(() => {
    let S;
    return s && !c && (S = setTimeout(() => {
      s();
    }, 400)), () => {
      S && clearTimeout(S);
    };
  }, [c]);
  const p = {
    info: {
      cardColor: y.frenchBlue,
      IconComponent: /* @__PURE__ */ d.createElement(Tp, null)
    },
    warning: {
      cardColor: y.plannerOrange,
      IconComponent: /* @__PURE__ */ d.createElement(b9, null)
    },
    error: {
      cardColor: y.lavaRed,
      IconComponent: /* @__PURE__ */ d.createElement(D9, null)
    },
    success: {
      cardColor: y.fokusGrassGreen,
      IconComponent: /* @__PURE__ */ d.createElement(E9, null)
    }
  }, { cardColor: m, IconComponent: v } = p[e] || {
    cardColor: y.frenchBlue,
    IconComponent: /* @__PURE__ */ d.createElement(Tp, null)
  }, g = () => {
    l(!0);
  }, h = () => {
    l(!1);
  }, w = () => {
    f(!1);
  };
  return /* @__PURE__ */ d.createElement(
    I9,
    {
      cardColor: m,
      isVisible: c,
      className: `syntax-toast ${i}`,
      "aria-live": "polite"
    },
    /* @__PURE__ */ d.createElement(L9, { isTitle: !!n }, /* @__PURE__ */ d.createElement(j9, { isTitle: !!n }, v), n ? /* @__PURE__ */ d.createElement(W9, { className: "title" }, n) : /* @__PURE__ */ d.createElement(Ap, { className: "message", isTitle: !!n }, r), /* @__PURE__ */ d.createElement(
      N9,
      {
        isPaused: u,
        onClick: w,
        onMouseEnter: g,
        onMouseLeave: h,
        isCloseHidden: t
      }
    )),
    n && r && /* @__PURE__ */ d.createElement(Ap, { className: "message", isTitle: !!n }, r),
    /* @__PURE__ */ d.createElement(Y9, null, a, o)
  );
}, CM = (e) => (n) => Tu.createPortal(/* @__PURE__ */ d.createElement(w0, { ...n }), e), EM = w0;
var hc = {}, H9 = We, V9 = Ye;
Object.defineProperty(hc, "__esModule", {
  value: !0
});
var D0 = hc.default = void 0, z9 = V9(d), K9 = H9(He()), U9 = (0, K9.default)(/* @__PURE__ */ z9.createElement("path", {
  d: "M7 14l5-5 5 5H7z"
}), "ArrowDropUpOutlined");
D0 = hc.default = U9;
var vc = {}, q9 = We, X9 = Ye;
Object.defineProperty(vc, "__esModule", {
  value: !0
});
var C0 = vc.default = void 0, G9 = X9(d), Q9 = q9(He()), Z9 = (0, Q9.default)(/* @__PURE__ */ G9.createElement("path", {
  d: "M7 10l5 5 5-5H7z"
}), "ArrowDropDownOutlined");
C0 = vc.default = Z9;
const J9 = D.div`
  display: flex;
  flex-direction: column;
`, eP = D.div`
  display: flex;
  justify-content: space-between;
`, tP = D.label`
  ${ui.Heading5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, rP = D.button`
  ${vn.Body2};
  margin: 0;
  padding: 0;
  border: 0;
  color: ${y.frenchBlue};
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
  text-align: right;

  &:hover {
    color: ${y.yaleBlue};
  }

  &:focus {
    color: ${y.midnightBlue};
  }
`, nP = D(ci)`
  color: ${y.grey600};
  margin-top: ${k.XXS};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isDisabled: e }) => e && _`
      color: ${y.grey400};
    `};
`, aP = D.div`
  display: flex;
  align-items: center;
  height: 2.5rem;
  border: 2px solid ${y.grey200};
  border-radius: 0.25rem;
  padding: 0;
  background-color: ${y.white};
  transition: border-color 0.1s ${mt};
  margin-top: ${k.XXS};

  ${tt};

  ${({ isFocused: e }) => e ? _`
          border-color: ${y.black};
        ` : _`
          &:hover {
            border-color: ${y.grey400};
          }
        `};

  ${({ isDisabled: e }) => e && _`
      pointer-events: none;
      background-color: ${y.grey50};
    `};

  ${({ hasErrorMessage: e, hasPositiveMessage: t }) => e ? _`
          && {
            border-color: ${y.clownRed};
          }
        ` : t ? _`
            && {
              border-color: ${y.fokusGrassGreen};
            }
          ` : null};
`, oP = D.input`
  ${vn.Body1};
  width: 100%;
  padding: ${k.XS} 0 ${k.XS} ${k.S};
  border: 0;
  outline: 0;
  margin-right: ${k.XXS};
  background-color: transparent;

  &:disabled {
    ::placeholder {
      color: ${y.grey400};
    }
    color: ${y.grey400};
  }
  &:autofill {
    padding: 0.375rem 0.75rem;
    margin: 0;
  }
`, iP = D.div`
  display: flex;
`, E0 = _`
  && {
    font-size: inherit;
    margin-top: -2px; /* Visual alignment */
    margin-right: ${k.XXS};
  }
`, sP = D(gn)`
  ${E0};
`, mc = D(hn)`
  display: inline-flex;
  align-items: center;
`, uP = D(mc)`
  color: ${y.clownRed};
`, lP = D(mc)`
  color: ${y.fokusGrassGreen};
`, cP = D(mc)`
  color: ${y.grey600};
`, dP = D(pi)`
  ${E0};
`, fP = ({
  description: e,
  errorMessage: t,
  positiveMessage: n,
  neutralMessage: r,
  helpButtonLabel: a,
  helpButtonOnClick: o,
  alertRoleOnError: i,
  className: s,
  label: u,
  defaultValue: l,
  minValue: c,
  handleUpdate: f,
  showIncrementDecrementButtons: p = !0,
  ...m
}) => {
  const [v, g] = Ne(l), h = ug({ locale: "sv-SE" }), w = ve(null), {
    labelProps: S,
    descriptionProps: x,
    groupProps: O,
    inputProps: B,
    incrementButtonProps: F,
    decrementButtonProps: L,
    errorMessageProps: j
  } = J0(m, h, w), { isRequired: I, isDisabled: N } = m, q = ni(), { isFocused: J, focusProps: R, isFocusVisible: ae } = vt({
    isTextInput: !0
  }), H = t ? xe(B, { "aria-describedby": q, "aria-invalid": !0 }) : B;
  return /* @__PURE__ */ d.createElement(J9, { className: s }, /* @__PURE__ */ d.createElement(eP, null, /* @__PURE__ */ d.createElement(tP, { ...S, isDisabled: N }, u, I && "*"), a && o && /* @__PURE__ */ d.createElement(rP, { type: "button", onClick: o }, a)), e && /* @__PURE__ */ d.createElement(nP, { as: "span", ...x, isDisabled: N }, e), /* @__PURE__ */ d.createElement(
    aP,
    {
      isFocused: J,
      isFocusVisible: ae,
      hasErrorMessage: !!t,
      hasPositiveMessage: !!n,
      isDisabled: N,
      ...O
    },
    /* @__PURE__ */ d.createElement(
      oP,
      {
        ...xe(R, H, { disabled: N }),
        ref: w,
        value: v,
        onChange: (oe) => {
          oe.target.value === "" ? (g(0), f(0)) : (g(parseInt(oe.target.value)), f(parseInt(oe.target.value)));
        }
      }
    ),
    p && /* @__PURE__ */ d.createElement(iP, null, /* @__PURE__ */ d.createElement(
      pr,
      {
        isSmall: !0,
        icon: /* @__PURE__ */ d.createElement(C0, null),
        color: "blue",
        type: "button",
        ...L,
        onClick: () => {
          v > c && (g(v - 1), f(v - 1));
        }
      }
    ), /* @__PURE__ */ d.createElement(
      pr,
      {
        isSmall: !0,
        icon: /* @__PURE__ */ d.createElement(D0, null),
        color: "blue",
        type: "button",
        ...F,
        onClick: () => {
          g(v + 1), f(v + 1);
        }
      }
    ))
  ), t ? /* @__PURE__ */ d.createElement(
    uP,
    {
      ...xe(j, {
        id: H["aria-describedby"],
        role: i ? "alert" : void 0
      })
    },
    /* @__PURE__ */ d.createElement(sP, null),
    " ",
    t
  ) : n ? /* @__PURE__ */ d.createElement(lP, null, /* @__PURE__ */ d.createElement(dP, null), n) : r ? /* @__PURE__ */ d.createElement(cP, null, r) : null);
}, xM = fP, pP = D.svg`
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
`, xi = pP, hP = (e) => /* @__PURE__ */ d.createElement(
  xi,
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ d.createElement("rect", { x: "5", y: "5", width: "14", height: "14", rx: "1", stroke: "currentColor", strokeWidth: "2" }),
  /* @__PURE__ */ d.createElement("path", { d: "M10 15.9953V8H11.6953V14.5953H14.9383V15.9953H10Z", fill: "currentColor" })
), vP = hP, mP = (e) => /* @__PURE__ */ d.createElement(
  xi,
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ d.createElement(
    "path",
    {
      d: "M14.6109 16H10.0062V8.00469H14.6109V9.39375H11.7016V11.1492H14.4086V12.5383H11.7016V14.6H14.6109V16Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.createElement("rect", { x: "5", y: "5", width: "14", height: "14", rx: "1", stroke: "currentColor", strokeWidth: "2" })
), gP = mP, yP = (e) => /* @__PURE__ */ d.createElement(
  xi,
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ d.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 4H6C4.9 4 4 4.9 4 6V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM18 18H6.00001V6H18V18ZM16 10.2858H12V11.4286H16V10.2858ZM12 12.5713H16V13.7142H12V12.5713ZM11 10.2858H8.00001V13.7143H11V10.2858ZM8.00001 14.8572H16V16H8.00001V14.8572ZM16 7.99996H8.00001V9.14282H16V7.99996Z",
      fill: "currentColor"
    }
  )
), bP = yP, wP = (e) => /* @__PURE__ */ d.createElement(
  xi,
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ d.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.99995 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H7.99995C6.89995 18 5.99995 17.1 5.99995 16V4C5.99995 2.9 6.89995 2 7.99995 2ZM2 5.99996H4V20H18V22H4C2.9 22 2 21.1 2 20V5.99996ZM20 16H7.99996V4H20V16ZM17.9999 8.28577H13.9999V9.42863H17.9999V8.28577ZM13.9999 10.5713H17.9999V11.7142H13.9999V10.5713ZM13 8.28577H9.99996V11.7143H13V8.28577ZM9.99996 12.8572H18V14H9.99996V12.8572ZM18 5.99996H9.99996V7.14282H18V5.99996Z",
      fill: "currentColor"
    }
  )
), DP = wP, CP = {
  TeacherIcon: vP,
  StudentIcon: gP,
  EducationalMaterialIcon: bP,
  EducationalMaterialNewTabIcon: DP
}, SM = CP, $M = Mp`
  body {
    font-family: ${eh.fontFamily};
    color: ${y.black};
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  html {
    text-size-adjust: 100%;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    line-height: inherit;
  }
`, kM = Mp`

/**
   * Colors
   */
 :root {
  --hue-french-blue: ${y.frenchBlue};
  --hue-yale-blue: ${y.yaleBlue};
  --hue-midnight-blue: ${y.midnightBlue};
  --hue-slate-purple: ${y.slatePurple};
  --hue-purple-rain: ${y.purpleRain};
  --hue-lily-white: ${y.lilyWhite};
  --hue-paradiso-green: ${y.paradisoGreen};
  --hue-supernova-yellow: ${y.supernovaYellow};
  --hue-yellow-sea: ${y.yellowSea};
  --hue-clown-red: ${y.clownRed};
  --hue-lava-red: ${y.lavaRed};
  --hue-piglet-pink: ${y.pigletPink};
  --hue-planner-blue: ${y.plannerBlue};
  --hue-planner-orange: ${y.plannerOrange};

  --hue-white: ${y.white};
  --hue-grey50: ${y.grey50};
  --hue-grey100: ${y.grey100};
  --hue-grey200: ${y.grey200};
  --hue-grey300: ${y.grey300};
  --hue-grey400: ${y.grey400};
  --hue-grey500: ${y.grey500};
  --hue-grey600: ${y.grey600};
  --hue-grey700: ${y.grey700};
  --hue-grey800: ${y.grey800};
  --hue-grey900: ${y.grey900};
  --hue-black: ${y.black};

  --hue-fokus-red: ${y.fokusRed};
  --hue-fokus-pink: ${y.fokusPink};
  --hue-fokus-grass-green: ${y.fokusGrassGreen};
  --hue-fokus-green: ${y.fokusGreen};
  --hue-fokus-orange: ${y.fokusOrange};
  --hue-fokus-purple: ${y.fokusPurple};

  --hue-student: ${y.paradisoGreen};
  --hue-student-dark: ${y.paradisoGreenDark};
  --hue-teacher: ${y.slatePurple};
  --hue-teacher-dark: ${y.purpleRain};
}
`;
export {
  mM as Accordion,
  r5 as Avatar,
  tM as AvatarButton,
  Jh as Badge,
  At as BasicTooltip,
  Wt as BlockType,
  Vh as Body1,
  ci as Body2,
  vn as BodyCSS,
  Fe as Breakpoint,
  hd as ButtonBig,
  IP as ButtonKids,
  NP as ButtonSmall,
  or as ButtonText,
  lw as Caption,
  oM as Card,
  JP as CardButton,
  iM as CardContent,
  lM as CardImage,
  cM as CardTitle,
  aM as Checkbox,
  mn as Chevron,
  y as Color,
  gM as ComboBox,
  yM as ComboBoxTriggerButtonPill,
  WP as ContextualModal,
  YP as ContextualTriggerButtonCircleTuneIcon,
  qP as CoverExpressiveSmall,
  wM as DatePicker,
  MP as Dropdown,
  RP as DropdownTriggerButtonCircleChevron,
  _P as DropdownTriggerButtonCircleMore,
  FP as DropdownTriggerButtonPill,
  eM as GleerupsLogo,
  JE as GleerupsLogoSmall,
  $M as GlobalStyles,
  uw as Heading1,
  TP as Heading2,
  Vu as Heading3,
  zu as Heading4,
  Ku as Heading5,
  ui as HeadingsCSS,
  pr as IconButton,
  rM as IllustratedMessage,
  XP as InfoBox,
  hn as InfoText,
  LP as Link,
  GP as Menu,
  $E as MenuListBox,
  QP as MenuTriggerButtonMore,
  DM as MessageBanner,
  PP as Modal,
  tD as ModalSmall,
  dM as Nav,
  xM as NumberField,
  hM as OnOffSwitch,
  TM as OverlayProvider,
  Uu as Overline,
  jP as PillGroup,
  sM as RATIO_16_9,
  uM as RATIO_4_3,
  ZP as RadioGroup,
  BP as ResultColor,
  bM as RichTextEditor,
  KP as Search,
  gw as SimpleTooltip,
  li as Small,
  pM as SmallScreenMenuItem,
  fM as SmallScreenNav,
  k as Spacing,
  nM as Spinner,
  Yh as Subheading,
  UP as Switch,
  SM as SyntaxIcon,
  zP as TableHeading,
  VP as TableHeadingButton,
  HP as Tabs,
  O2 as TabsCompact,
  vM as TextArea,
  bg as TextButton,
  lx as TextField,
  EM as Toast,
  eh as Typography,
  bw as boxShadowCSS,
  ww as clickableShadowDarkCSS,
  qu as clickableShadowLightCSS,
  CM as createToast,
  tt as focusVisibleCSS,
  kM as globalColorsStyles,
  vw as htmlDecode,
  v7 as isTextFormatted,
  mt as quinticEaseOut,
  h7 as renderRichText,
  Ll as serialize,
  ir as softBoxShadowCSS,
  AP as subtleClickableShadowDarkCSS,
  Xu as subtleClickableShadowLightCSS,
  yw as useSimpleTooltip
};
//# sourceMappingURL=index.js.map
